(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.h0.bi === region.gB.bi)
	{
		return 'on line ' + region.h0.bi;
	}
	return 'on lines ' + region.h0.bi + ' through ' + region.gB.bi;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.g2,
		impl.h9,
		impl.dZ,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		e3: func(record.e3),
		dX: record.dX,
		dO: record.dO
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.e3;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.dX;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.dO) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.g2,
		impl.h9,
		impl.dZ,
		function(sendToApp, initialModel) {
			var view = impl.$8;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.g2,
		impl.h9,
		impl.dZ,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.dU && impl.dU(sendToApp)
			var view = impl.$8;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.E);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.h7) && (_VirtualDom_doc.title = title = doc.h7);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.ho;
	var onUrlRequest = impl.hp;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		dU: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.fn === next.fn
							&& curr.eK === next.eK
							&& curr.fj.a === next.fj.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		g2: function(flags)
		{
			return A3(impl.g2, flags, _Browser_getUrl(), key);
		},
		$8: impl.$8,
		h9: impl.h9,
		dZ: impl.dZ
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { gY: 'hidden', gh: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { gY: 'mozHidden', gh: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { gY: 'msHidden', gh: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { gY: 'webkitHidden', gh: 'webkitvisibilitychange' }
		: { gY: 'hidden', gh: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		fC: _Browser_getScene(),
		ig: {
			C: _Browser_window.pageXOffset,
			D: _Browser_window.pageYOffset,
			ik: _Browser_doc.documentElement.clientWidth,
			gW: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		ik: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		gW: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			fC: {
				ik: node.scrollWidth,
				gW: node.scrollHeight
			},
			ig: {
				C: node.scrollLeft,
				D: node.scrollTop,
				ik: node.clientWidth,
				gW: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			fC: _Browser_getScene(),
			ig: {
				C: x,
				D: y,
				ik: _Browser_doc.documentElement.clientWidth,
				gW: _Browser_doc.documentElement.clientHeight
			},
			gA: {
				C: x + rect.left,
				D: y + rect.top,
				ik: rect.width,
				gW: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.q.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.q.b, xhr)); });
		$elm$core$Maybe$isJust(request.N) && _Http_track(router, xhr, request.N.a);

		try {
			xhr.open(request.I, request.t, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.t));
		}

		_Http_configureRequest(xhr, request);

		request.E.a && xhr.setRequestHeader('Content-Type', request.E.a);
		xhr.send(request.E.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.H; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.M.a || 0;
	xhr.responseType = request.q.d;
	xhr.withCredentials = request.f8;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		t: xhr.responseURL,
		c$: xhr.status,
		h2: xhr.statusText,
		H: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			hW: event.loaded,
			fI: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			hK: event.loaded,
			fI: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}



// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.hl) { flags += 'm'; }
	if (options.gf) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}

// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.l) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.m),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.m);
		} else {
			var treeLen = builder.l * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.n) : builder.n;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.l);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.m) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.m);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{n: nodeList, l: (len / $elm$core$Array$branchFactor) | 0, m: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {eG: fragment, eK: host, fg: path, fj: port_, fn: protocol, fo: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Types$GotCommonMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$UpdateTimeZone = function (a) {
	return {$: 9, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Types$LoadMasterData = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$BadBody = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Types$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$NetworkError = {$: 2};
var $author$project$Types$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Types$RailsError = function (errors) {
	return {eA: errors};
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Api$errorsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'errors',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Types$RailsError));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Api$expectJsonOrError = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$author$project$Types$BadUrl(url));
					case 1:
						return $elm$core$Result$Err($author$project$Types$Timeout);
					case 2:
						return $elm$core$Result$Err($author$project$Types$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						var _v1 = metadata.c$;
						if (_v1 === 304) {
							return $elm$core$Result$Err(
								A2(
									$author$project$Types$BadStatus,
									304,
									_List_fromArray(
										['Keine Änderungen'])));
						} else {
							var _v2 = A2($elm$json$Json$Decode$decodeString, $author$project$Api$errorsDecoder, body);
							if (!_v2.$) {
								var error_with_msgs = _v2.a;
								return $elm$core$Result$Err(
									A2($author$project$Types$BadStatus, metadata.c$, error_with_msgs.eA));
							} else {
								var err = _v2.a;
								return $elm$core$Result$Err(
									$author$project$Types$BadBody(
										$elm$json$Json$Decode$errorToString(err)));
							}
						}
					default:
						var metadata = response.a;
						var body = response.b;
						var _v3 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (!_v3.$) {
							var value = _v3.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v3.a;
							return $elm$core$Result$Err(
								$author$project$Types$BadBody(
									$elm$json$Json$Decode$errorToString(err)));
						}
				}
			});
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {ft: reqs, fN: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.N;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.ft));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.fN)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					f8: r.f8,
					E: r.E,
					q: A2(_Http_mapExpect, func, r.q),
					H: r.H,
					I: r.I,
					M: r.M,
					N: r.N,
					t: r.t
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{f8: false, E: r.E, q: r.q, H: r.H, I: r.I, M: r.M, N: r.N, t: r.t}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{E: $elm$http$Http$emptyBody, q: r.q, H: _List_Nil, I: 'GET', M: $elm$core$Maybe$Nothing, N: $elm$core$Maybe$Nothing, t: r.t});
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Types$MasterDataModel = F6(
	function (machines, processes, recipes, machine_process_mappings, machine_process_recipe_mappings, default_execution_params) {
		return {er: default_execution_params, dB: machine_process_mappings, dC: machine_process_recipe_mappings, dD: machines, dP: processes, dQ: recipes};
	});
var $author$project$Types$ExecutionParam = function (id) {
	return function (value_type) {
		return function (name) {
			return function (unit) {
				return function (description) {
					return function (default_values) {
						return function (allowed_values) {
							return function (readonly) {
								return function (values) {
									return function (operator_note) {
										return function (per_batch) {
											return function (required) {
												return function (style) {
													return function (properties) {
														return {ea: allowed_values, es: default_values, et: description, an: id, dG: name, cy: operator_note, hz: per_batch, hF: properties, fq: readonly, fv: required, fM: style, f$: unit, f1: value_type, f2: values};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$array = _Json_decodeArray;
var $author$project$Types$BoolValue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$DateValue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$DurationValue = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$FloatValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$IntValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$StringValue = function (a) {
	return {$: 2, a: a};
};
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Api$defaultValueDecoder = function (value_type) {
	switch (value_type) {
		case 'integer':
			return A2($elm$json$Json$Decode$map, $author$project$Types$IntValue, $elm$json$Json$Decode$int);
		case 'duration':
			return A2($elm$json$Json$Decode$map, $author$project$Types$DurationValue, $elm$json$Json$Decode$int);
		case 'float':
			return A2($elm$json$Json$Decode$map, $author$project$Types$FloatValue, $elm$json$Json$Decode$float);
		case 'boolean':
			return A2($elm$json$Json$Decode$map, $author$project$Types$BoolValue, $elm$json$Json$Decode$bool);
		case 'date':
			return A2($elm$json$Json$Decode$map, $author$project$Types$DateValue, $elm$json$Json$Decode$string);
		default:
			return A2($elm$json$Json$Decode$map, $author$project$Types$StringValue, $elm$json$Json$Decode$string);
	}
};
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Types$EmptyParamProperties = {$: 0};
var $author$project$Types$MaterialParamProperties = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$MaterialProperties = F2(
	function (withdrawals, filters) {
		return {gO: filters, dd: withdrawals};
	});
var $author$project$Types$MaterialFilter = F2(
	function (group_id, filter) {
		return {gL: filter, eH: group_id};
	});
var $author$project$Api$filterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'filter',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'group_id',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
		$elm$json$Json$Decode$succeed($author$project$Types$MaterialFilter)));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Types$MaterialWithdrawal = F5(
	function (group_id, quantity, lot, properties, url) {
		return {eH: group_id, hg: lot, hF: properties, hH: quantity, t: url};
	});
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Api$propertyDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
var $author$project$Api$withdrawalDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'properties',
		$elm$json$Json$Decode$list($author$project$Api$propertyDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lot',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'quantity',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'group_id',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
					$elm$json$Json$Decode$succeed($author$project$Types$MaterialWithdrawal))))));
var $author$project$Api$materialPropertiesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'filters',
	$elm$json$Json$Decode$list($author$project$Api$filterDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'withdrawals',
		$elm$json$Json$Decode$list($author$project$Api$withdrawalDecoder),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$Types$MaterialProperties)));
var $author$project$Api$paramPropertiesDecoder = function (value_type) {
	if (value_type === 'material') {
		return A2($elm$json$Json$Decode$map, $author$project$Types$MaterialParamProperties, $author$project$Api$materialPropertiesDecoder);
	} else {
		return $elm$json$Json$Decode$succeed($author$project$Types$EmptyParamProperties);
	}
};
var $author$project$Api$executionParamDecoderForType = function (value_type) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'properties',
		$author$project$Api$paramPropertiesDecoder(value_type),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'style',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'required',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'per_batch',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'operator_note',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'values',
							$elm$json$Json$Decode$array($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'readonly',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'allowed_values',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'default_values',
										$elm$json$Json$Decode$array(
											$elm$json$Json$Decode$maybe(
												$author$project$Api$defaultValueDecoder(value_type))),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'description',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'unit',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'name',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'value_type',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$int,
															$elm$json$Json$Decode$succeed($author$project$Types$ExecutionParam)))))))))))))));
};
var $author$project$Api$executionParamDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Api$executionParamDecoderForType,
	A2($elm$json$Json$Decode$field, 'value_type', $elm$json$Json$Decode$string));
var $author$project$Types$MachineProcessMapping = F2(
	function (machine_id, process_id) {
		return {hh: machine_id, hD: process_id};
	});
var $author$project$Api$machineProcessMappingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'process_id',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'machine_id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Types$MachineProcessMapping)));
var $author$project$Types$MachineProcessRecipeMapping = F5(
	function (machine_id, process_id, recipe_id, planning_params, execution_params) {
		return {gH: execution_params, hh: machine_id, hA: planning_params, hD: process_id, hM: recipe_id};
	});
var $author$project$Types$PlanningParam = function (id) {
	return function (value_type) {
		return function (name) {
			return function (unit) {
				return function (description) {
					return function (default_values) {
						return function (allowed_values) {
							return function (readonly) {
								return function (values) {
									return function (original_values) {
										return function (values_checked) {
											return function (operator_note) {
												return function (group_values) {
													return function (original_group_values) {
														return function (group_values_checked) {
															return function (required) {
																return function (style) {
																	return function (properties) {
																		return {ea: allowed_values, es: default_values, et: description, gT: group_values, gU: group_values_checked, an: id, dG: name, cy: operator_note, hu: original_group_values, hv: original_values, hF: properties, fq: readonly, fv: required, fM: style, f$: unit, f1: value_type, f2: values, ie: values_checked};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$groupValuesCheckedDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$array($elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
var $author$project$Api$groupValuesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$array($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
var $author$project$Api$planningParamDecoderForType = function (value_type) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'properties',
		$author$project$Api$paramPropertiesDecoder(value_type),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'style',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'required',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'group_values_checked',
					$elm$json$Json$Decode$list($author$project$Api$groupValuesCheckedDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'original_group_values',
						$elm$json$Json$Decode$maybe(
							$elm$json$Json$Decode$list($author$project$Api$groupValuesDecoder)),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'group_values',
							$elm$json$Json$Decode$list($author$project$Api$groupValuesDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'operator_note',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'values_checked',
									$elm$json$Json$Decode$array($elm$json$Json$Decode$bool),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'original_values',
										$elm$json$Json$Decode$maybe(
											$elm$json$Json$Decode$array($elm$json$Json$Decode$string)),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'values',
											$elm$json$Json$Decode$array($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'readonly',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'allowed_values',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'default_values',
														$elm$json$Json$Decode$array(
															$elm$json$Json$Decode$maybe(
																$author$project$Api$defaultValueDecoder(value_type))),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'description',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'unit',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'name',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'value_type',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$int,
																			$elm$json$Json$Decode$succeed($author$project$Types$PlanningParam)))))))))))))))))));
};
var $author$project$Api$planningParamDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Api$planningParamDecoderForType,
	A2($elm$json$Json$Decode$field, 'value_type', $elm$json$Json$Decode$string));
var $author$project$Api$machineProcessRecipeMappingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'execution_params',
	$elm$json$Json$Decode$list($author$project$Api$executionParamDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'planning_params',
		$elm$json$Json$Decode$list($author$project$Api$planningParamDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'recipe_id',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'process_id',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'machine_id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Types$MachineProcessRecipeMapping))))));
var $author$project$Types$Machine = F4(
	function (id, name, batch_size, deleted) {
		return {gc: batch_size, dn: deleted, an: id, dG: name};
	});
var $author$project$Api$machinesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deleted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'batch_size',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Types$Machine)))));
var $author$project$Types$Process = F5(
	function (id, name, estimated_time_rules, has_reservation_queue, deleted) {
		return {dn: deleted, eB: estimated_time_rules, gV: has_reservation_queue, an: id, dG: name};
	});
var $author$project$Api$processesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deleted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'has_reservation_queue',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'estimated_time_rules',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Types$Process))))));
var $author$project$Types$Recipe = F5(
	function (id, name, estimated_time_rules, comment, deleted) {
		return {gl: comment, dn: deleted, eB: estimated_time_rules, an: id, dG: name};
	});
var $author$project$Api$recipesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deleted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'comment',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'estimated_time_rules',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Types$Recipe))))));
var $author$project$Api$masterDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'default_execution_params',
	$elm$json$Json$Decode$list($author$project$Api$executionParamDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'machine_process_recipe_mappings',
		$elm$json$Json$Decode$list($author$project$Api$machineProcessRecipeMappingsDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'machine_process_mappings',
			$elm$json$Json$Decode$list($author$project$Api$machineProcessMappingsDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'recipes',
				$elm$json$Json$Decode$list($author$project$Api$recipesDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'processes',
					$elm$json$Json$Decode$list($author$project$Api$processesDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'machines',
						$elm$json$Json$Decode$list($author$project$Api$machinesDecoder),
						$elm$json$Json$Decode$succeed($author$project$Types$MasterDataModel)))))));
var $author$project$Api$fetchMasterData = function (endpoint) {
	return A2(
		$elm$core$Platform$Cmd$map,
		$author$project$Types$GotCommonMsg,
		$elm$http$Http$get(
			{
				q: A2($author$project$Api$expectJsonOrError, $author$project$Types$LoadMasterData, $author$project$Api$masterDataDecoder),
				t: endpoint
			}));
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $ChristophP$elm_i18next$I18Next$Translations = $elm$core$Basics$identity;
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslationsHelp = F3(
	function (initialValue, namespace, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, val, acc) {
					var newNamespace = function (currentKey) {
						return $elm$core$String$isEmpty(namespace) ? currentKey : (namespace + ('.' + currentKey));
					};
					if (val.$ === 1) {
						var str = val.a;
						return A3(
							$elm$core$Dict$insert,
							newNamespace(key),
							str,
							acc);
					} else {
						var children = val.a;
						return A3(
							$ChristophP$elm_i18next$I18Next$flattenTranslationsHelp,
							acc,
							newNamespace(key),
							children);
					}
				}),
			initialValue,
			dict);
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslations = A2($ChristophP$elm_i18next$I18Next$flattenTranslationsHelp, $elm$core$Dict$empty, '');
var $ChristophP$elm_i18next$I18Next$Branch = function (a) {
	return {$: 0, a: a};
};
var $ChristophP$elm_i18next$I18Next$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $ChristophP$elm_i18next$I18Next$Leaf, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$map,
						$ChristophP$elm_i18next$I18Next$Branch,
						$elm$json$Json$Decode$dict(
							$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder()));
				})
			]));
}
var $ChristophP$elm_i18next$I18Next$treeDecoder = $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder();
$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder = function () {
	return $ChristophP$elm_i18next$I18Next$treeDecoder;
};
var $ChristophP$elm_i18next$I18Next$translationsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $ChristophP$elm_i18next$I18Next$flattenTranslations, $elm$core$Basics$identity),
	$elm$json$Json$Decode$dict($ChristophP$elm_i18next$I18Next$treeDecoder));
var $author$project$RunEditor$init_i18n = function (model) {
	var _v0 = A2($elm$json$Json$Decode$decodeString, $ChristophP$elm_i18next$I18Next$translationsDecoder, model.a9.fZ);
	if (!_v0.$) {
		var translations = _v0.a;
		return _Utils_update(
			model,
			{fZ: translations});
	} else {
		var err = _v0.a;
		return _Utils_update(
			model,
			{
				dq: $elm$core$Maybe$Just(
					_Utils_Tuple2(
						_List_fromArray(
							['translation error!', model.a9.fZ]),
						false))
			});
	}
};
var $author$project$Types$History = function (states) {
	return {dW: states};
};
var $author$project$Types$NoCapture = {$: 0};
var $author$project$Types$NoGroupInEdit = {$: 0};
var $author$project$Types$NoneModal = {$: 3};
var $author$project$Types$NonePopup = {$: 5};
var $author$project$Types$DndMsg = function (a) {
	return {$: 8, a: a};
};
var $annaghi$dnd_list$DnDList$OnDrop = 1;
var $annaghi$dnd_list$DnDList$Rotate = 2;
var $annaghi$dnd_list$DnDList$Vertical = 2;
var $annaghi$dnd_list$DnDList$Model = $elm$core$Basics$identity;
var $annaghi$dnd_list$DnDList$GotDragElement = function (a) {
	return {$: 6, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $annaghi$dnd_list$DnDList$dragElementCommands = F2(
	function (stepMsg, state) {
		var _v0 = state.X;
		if (_v0.$ === 1) {
			return A2(
				$elm$core$Task$attempt,
				A2($elm$core$Basics$composeL, stepMsg, $annaghi$dnd_list$DnDList$GotDragElement),
				$elm$browser$Browser$Dom$getElement(state.aH));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $annaghi$dnd_list$DnDList$GotDropElement = function (a) {
	return {$: 7, a: a};
};
var $annaghi$dnd_list$DnDList$dropElementCommands = F2(
	function (stepMsg, state) {
		return (!state.x) ? A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeL, stepMsg, $annaghi$dnd_list$DnDList$GotDropElement),
			$elm$browser$Browser$Dom$getElement(state.aj)) : $elm$core$Platform$Cmd$none;
	});
var $annaghi$dnd_list$DnDList$commands = F2(
	function (stepMsg, _v0) {
		var model = _v0;
		if (model.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var state = model.a;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($annaghi$dnd_list$DnDList$dragElementCommands, stepMsg, state),
						A2($annaghi$dnd_list$DnDList$dropElementCommands, stepMsg, state)
					]));
		}
	});
var $annaghi$dnd_list$DnDList$DragStart = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $annaghi$dnd_list$Internal$Common$Utils$Position = F2(
	function (x, y) {
		return {C: x, D: y};
	});
var $annaghi$dnd_list$Internal$Common$Utils$clientX = A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float);
var $annaghi$dnd_list$Internal$Common$Utils$clientY = A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float);
var $annaghi$dnd_list$Internal$Common$Utils$decodeCoordinates = A3($elm$json$Json$Decode$map2, $annaghi$dnd_list$Internal$Common$Utils$Position, $annaghi$dnd_list$Internal$Common$Utils$clientX, $annaghi$dnd_list$Internal$Common$Utils$clientY);
var $annaghi$dnd_list$Internal$Common$Utils$decodeMainMouseButton = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (button) {
			return (!button) ? decoder : $elm$json$Json$Decode$fail('Event is only relevant when the main mouse button was pressed.');
		},
		A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
};
var $annaghi$dnd_list$Internal$Common$Utils$decodeCoordinatesWithButtonCheck = $annaghi$dnd_list$Internal$Common$Utils$decodeMainMouseButton($annaghi$dnd_list$Internal$Common$Utils$decodeCoordinates);
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $annaghi$dnd_list$DnDList$dragEvents = F3(
	function (stepMsg, dragIndex, dragElementId) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'mousedown',
				A2(
					$elm$json$Json$Decode$map,
					function (msg) {
						return _Utils_Tuple2(msg, true);
					},
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeL,
							stepMsg,
							A2($annaghi$dnd_list$DnDList$DragStart, dragIndex, dragElementId)),
						$annaghi$dnd_list$Internal$Common$Utils$decodeCoordinatesWithButtonCheck)))
			]);
	});
var $annaghi$dnd_list$DnDList$DragEnter = function (a) {
	return {$: 3, a: a};
};
var $annaghi$dnd_list$DnDList$DragLeave = {$: 4};
var $annaghi$dnd_list$DnDList$DragOver = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $annaghi$dnd_list$DnDList$dropEvents = F3(
	function (stepMsg, dropIndex, dropElementId) {
		return _List_fromArray(
			[
				$elm$html$Html$Events$onMouseOver(
				stepMsg(
					A2($annaghi$dnd_list$DnDList$DragOver, dropIndex, dropElementId))),
				$elm$html$Html$Events$onMouseEnter(
				stepMsg(
					$annaghi$dnd_list$DnDList$DragEnter(dropIndex))),
				$elm$html$Html$Events$onMouseLeave(
				stepMsg($annaghi$dnd_list$DnDList$DragLeave))
			]);
	});
var $annaghi$dnd_list$Internal$Common$Utils$px = function (n) {
	return $elm$core$String$fromInt(n) + 'px';
};
var $elm$core$Basics$round = _Basics_round;
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $annaghi$dnd_list$Internal$Common$Utils$translate = F2(
	function (x, y) {
		return 'translate3d(' + ($annaghi$dnd_list$Internal$Common$Utils$px(x) + (', ' + ($annaghi$dnd_list$Internal$Common$Utils$px(y) + ', 0)')));
	});
var $annaghi$dnd_list$DnDList$ghostStyles = F2(
	function (movement, _v0) {
		var model = _v0;
		if (model.$ === 1) {
			return _List_Nil;
		} else {
			var state = model.a;
			var _v2 = state.X;
			if (!_v2.$) {
				var element = _v2.a.gA;
				var viewport = _v2.a.ig;
				var transform = function () {
					switch (movement) {
						case 1:
							return A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$annaghi$dnd_list$Internal$Common$Utils$translate,
									$elm$core$Basics$round(((state.F.C - state.R.C) + element.C) - viewport.C),
									$elm$core$Basics$round(element.D - viewport.D)));
						case 2:
							return A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$annaghi$dnd_list$Internal$Common$Utils$translate,
									$elm$core$Basics$round(element.C - viewport.C),
									$elm$core$Basics$round(((state.F.D - state.R.D) + element.D) - viewport.D)));
						default:
							return A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$annaghi$dnd_list$Internal$Common$Utils$translate,
									$elm$core$Basics$round(((state.F.C - state.R.C) + element.C) - viewport.C),
									$elm$core$Basics$round(((state.F.D - state.R.D) + element.D) - viewport.D)));
					}
				}();
				var baseStyles = _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
						A2($elm$html$Html$Attributes$style, 'top', '0'),
						A2($elm$html$Html$Attributes$style, 'left', '0'),
						A2(
						$elm$html$Html$Attributes$style,
						'height',
						$annaghi$dnd_list$Internal$Common$Utils$px(
							$elm$core$Basics$round(element.gW))),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$annaghi$dnd_list$Internal$Common$Utils$px(
							$elm$core$Basics$round(element.ik))),
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
					]);
				return A2($elm$core$List$cons, transform, baseStyles);
			} else {
				return _List_Nil;
			}
		}
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $annaghi$dnd_list$DnDList$info = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		function (state) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (dragElement, dropElement) {
						return {F: state.F, X: dragElement, aH: state.aH, ew: state.ew, ai: dropElement, aj: state.aj, gz: state.gz, R: state.R};
					}),
				state.X,
				state.ai);
		},
		model);
};
var $annaghi$dnd_list$DnDList$Drag = function (a) {
	return {$: 1, a: a};
};
var $annaghi$dnd_list$DnDList$DragEnd = {$: 5};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {fh: pids, fN: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {eC: event, eY: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.fh,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.eY;
		var event = _v0.eC;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.fN);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, 0, 'mousemove');
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, 0, 'mouseup');
var $annaghi$dnd_list$DnDList$subscriptions = F2(
	function (stepMsg, _v0) {
		var model = _v0;
		if (model.$ === 1) {
			return $elm$core$Platform$Sub$none;
		} else {
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$elm$browser$Browser$Events$onMouseMove(
						A2(
							$elm$json$Json$Decode$map,
							A2($elm$core$Basics$composeL, stepMsg, $annaghi$dnd_list$DnDList$Drag),
							$annaghi$dnd_list$Internal$Common$Utils$decodeCoordinates)),
						$elm$browser$Browser$Events$onMouseUp(
						$elm$json$Json$Decode$succeed(
							stepMsg($annaghi$dnd_list$DnDList$DragEnd)))
					]));
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$splitAt = F2(
	function (i, list) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, i, list),
			A2($elm$core$List$drop, i, list));
	});
var $annaghi$dnd_list$Internal$Common$Operations$afterBackward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, j + 1, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, (i - j) - 1, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, end);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				head,
				_Utils_ap(middle, tail)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$afterForward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, i, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, (j - i) + 1, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, middle);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				tail,
				_Utils_ap(head, end)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$insertAfter = F3(
	function (dragIndex, dropIndex, list) {
		return (_Utils_cmp(dragIndex, dropIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$afterForward, dragIndex, dropIndex, list) : ((_Utils_cmp(dropIndex, dragIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$afterBackward, dragIndex, dropIndex, list) : list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$beforeBackward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, j, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, i - j, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, end);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				head,
				_Utils_ap(middle, tail)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$beforeForward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, i, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, j - i, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, middle);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				tail,
				_Utils_ap(head, end)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$insertBefore = F3(
	function (dragIndex, dropIndex, list) {
		return (_Utils_cmp(dragIndex, dropIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$beforeForward, dragIndex, dropIndex, list) : ((_Utils_cmp(dropIndex, dragIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$beforeBackward, dragIndex, dropIndex, list) : list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$rotate = F3(
	function (dragIndex, dropIndex, list) {
		return (_Utils_cmp(dragIndex, dropIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$afterForward, dragIndex, dropIndex, list) : ((_Utils_cmp(dropIndex, dragIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$beforeBackward, dragIndex, dropIndex, list) : list);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $annaghi$dnd_list$Internal$Common$Operations$swapAt = F3(
	function (i, j, list) {
		var item_j = A2(
			$elm$core$List$take,
			1,
			A2($elm$core$List$drop, j, list));
		var item_i = A2(
			$elm$core$List$take,
			1,
			A2($elm$core$List$drop, i, list));
		return $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return _Utils_eq(index, i) ? item_j : (_Utils_eq(index, j) ? item_i : _List_fromArray(
							[item]));
					}),
				list));
	});
var $annaghi$dnd_list$Internal$Common$Operations$swap = F3(
	function (dragIndex, dropIndex, list) {
		return (!_Utils_eq(dragIndex, dropIndex)) ? A3($annaghi$dnd_list$Internal$Common$Operations$swapAt, dragIndex, dropIndex, list) : list;
	});
var $annaghi$dnd_list$DnDList$listUpdate = F4(
	function (operation, dragIndex, dropIndex, list) {
		switch (operation) {
			case 0:
				return A3($annaghi$dnd_list$Internal$Common$Operations$insertAfter, dragIndex, dropIndex, list);
			case 1:
				return A3($annaghi$dnd_list$Internal$Common$Operations$insertBefore, dragIndex, dropIndex, list);
			case 2:
				return A3($annaghi$dnd_list$Internal$Common$Operations$rotate, dragIndex, dropIndex, list);
			case 3:
				return A3($annaghi$dnd_list$Internal$Common$Operations$swap, dragIndex, dropIndex, list);
			default:
				return list;
		}
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $annaghi$dnd_list$DnDList$stateUpdate = F3(
	function (operation, dropIndex, state) {
		switch (operation) {
			case 0:
				return _Utils_update(
					state,
					{
						x: 0,
						ew: (_Utils_cmp(dropIndex, state.ew) < 0) ? (dropIndex + 1) : dropIndex
					});
			case 1:
				return _Utils_update(
					state,
					{
						x: 0,
						ew: (_Utils_cmp(state.ew, dropIndex) < 0) ? (dropIndex - 1) : dropIndex
					});
			case 2:
				return _Utils_update(
					state,
					{x: 0, ew: dropIndex});
			case 3:
				return _Utils_update(
					state,
					{x: 0, ew: dropIndex});
			default:
				return _Utils_update(
					state,
					{x: 0});
		}
	});
var $annaghi$dnd_list$DnDList$update = F4(
	function (_v0, msg, _v1, list) {
		var beforeUpdate = _v0.ed;
		var listen = _v0.e0;
		var operation = _v0.fc;
		var model = _v1;
		switch (msg.$) {
			case 0:
				var dragIndex = msg.a;
				var dragElementId = msg.b;
				var xy = msg.c;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						{F: xy, x: 0, X: $elm$core$Maybe$Nothing, aH: dragElementId, ew: dragIndex, ai: $elm$core$Maybe$Nothing, aj: dragElementId, gz: dragIndex, R: xy}),
					list);
			case 1:
				var xy = msg.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$map,
						function (state) {
							return _Utils_update(
								state,
								{F: xy, x: state.x + 1});
						},
						model),
					list);
			case 2:
				var dropIndex = msg.a;
				var dropElementId = msg.b;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$map,
						function (state) {
							return _Utils_update(
								state,
								{aj: dropElementId, gz: dropIndex});
						},
						model),
					list);
			case 3:
				var dropIndex = msg.a;
				var _v3 = _Utils_Tuple2(model, listen);
				if ((!_v3.a.$) && (!_v3.b)) {
					var state = _v3.a.a;
					var _v4 = _v3.b;
					return ((state.x > 1) && (!_Utils_eq(state.ew, dropIndex))) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							A3($annaghi$dnd_list$DnDList$stateUpdate, operation, dropIndex, state)),
						A4(
							$annaghi$dnd_list$DnDList$listUpdate,
							operation,
							state.ew,
							dropIndex,
							A3(beforeUpdate, state.ew, dropIndex, list))) : _Utils_Tuple2(model, list);
				} else {
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_update(
									state,
									{x: 0});
							},
							model),
						list);
				}
			case 4:
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$map,
						function (state) {
							return _Utils_update(
								state,
								{gz: state.ew});
						},
						model),
					list);
			case 5:
				var _v5 = _Utils_Tuple2(model, listen);
				if ((!_v5.a.$) && (_v5.b === 1)) {
					var state = _v5.a.a;
					var _v6 = _v5.b;
					return (!_Utils_eq(state.ew, state.gz)) ? _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A4(
							$annaghi$dnd_list$DnDList$listUpdate,
							operation,
							state.ew,
							state.gz,
							A3(beforeUpdate, state.ew, state.gz, list))) : _Utils_Tuple2($elm$core$Maybe$Nothing, list);
				} else {
					return _Utils_Tuple2($elm$core$Maybe$Nothing, list);
				}
			case 6:
				if (msg.a.$ === 1) {
					return _Utils_Tuple2(model, list);
				} else {
					var dragElement = msg.a.a;
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_update(
									state,
									{
										X: $elm$core$Maybe$Just(dragElement),
										ai: $elm$core$Maybe$Just(dragElement)
									});
							},
							model),
						list);
				}
			default:
				if (msg.a.$ === 1) {
					return _Utils_Tuple2(model, list);
				} else {
					var dropElement = msg.a.a;
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_update(
									state,
									{
										ai: $elm$core$Maybe$Just(dropElement)
									});
							},
							model),
						list);
				}
		}
	});
var $annaghi$dnd_list$DnDList$create = F2(
	function (config, stepMsg) {
		return {
			gk: $annaghi$dnd_list$DnDList$commands(stepMsg),
			gx: $annaghi$dnd_list$DnDList$dragEvents(stepMsg),
			gy: $annaghi$dnd_list$DnDList$dropEvents(stepMsg),
			gQ: $annaghi$dnd_list$DnDList$ghostStyles(config.e7),
			eP: $annaghi$dnd_list$DnDList$info,
			e5: $elm$core$Maybe$Nothing,
			dZ: $annaghi$dnd_list$DnDList$subscriptions(stepMsg),
			h9: $annaghi$dnd_list$DnDList$update(config)
		};
	});
var $author$project$Common$dndSystem = A2(
	$annaghi$dnd_list$DnDList$create,
	{
		ed: F3(
			function (_v0, _v1, list) {
				return list;
			}),
		e0: 1,
		e7: 2,
		fc: 2
	},
	$author$project$Types$DndMsg);
var $owanturist$elm_queue$Queue$Empty = {$: 0};
var $owanturist$elm_queue$Queue$empty = $owanturist$elm_queue$Queue$Empty;
var $annaghi$dnd_list$DnDList$Free = 0;
var $author$project$Types$GroupDndMsg = function (a) {
	return {$: 11, a: a};
};
var $annaghi$dnd_list$DnDList$OnDrag = 0;
var $author$project$Common$groupDndSystem = A2(
	$annaghi$dnd_list$DnDList$create,
	{
		ed: F3(
			function (_v0, _v1, groups) {
				return groups;
			}),
		e0: 0,
		e7: 0,
		fc: 2
	},
	$author$project$Types$GroupDndMsg);
var $rundis$elm_bootstrap$Bootstrap$Tab$Showing = 2;
var $rundis$elm_bootstrap$Bootstrap$Tab$State = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Tab$initialState = {bE: $elm$core$Maybe$Nothing, bw: 2};
var $ChristophP$elm_i18next$I18Next$initialTranslations = $elm$core$Dict$empty;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$RunEditor$initialModel = function (flags) {
	return {
		a6: $elm$core$Maybe$Nothing,
		di: true,
		bS: 0,
		gj: _List_Nil,
		er: _List_Nil,
		ev: $author$project$Common$dndSystem.e5,
		p: $author$project$Types$NoGroupInEdit,
		dq: $elm$core$Maybe$Nothing,
		gM: '',
		gN: $elm$core$Maybe$Nothing,
		a9: flags,
		dv: $author$project$Common$groupDndSystem.e5,
		eI: _List_Nil,
		eJ: _List_Nil,
		i: $author$project$Types$History(_List_Nil),
		aR: $elm$core$Maybe$Nothing,
		cg: $elm$core$Maybe$Nothing,
		eW: $elm$core$Maybe$Nothing,
		P: $rundis$elm_bootstrap$Bootstrap$Tab$initialState,
		dz: _List_Nil,
		g8: '',
		ha: $elm$core$Maybe$Nothing,
		e1: $author$project$Types$NoCapture,
		he: -1,
		dB: _List_Nil,
		dC: _List_Nil,
		dD: _List_Nil,
		bk: $author$project$Types$NoneModal,
		fi: $elm$core$Dict$empty,
		cI: $author$project$Types$NonePopup,
		dP: _List_Nil,
		fq: flags.fq,
		dQ: _List_Nil,
		fA: _List_Nil,
		fE: $elm$core$Maybe$Nothing,
		fF: $elm$core$Maybe$Nothing,
		hV: $elm$core$Maybe$Nothing,
		aX: $owanturist$elm_queue$Queue$empty,
		dT: false,
		hZ: true,
		h$: _List_Nil,
		fO: $rundis$elm_bootstrap$Bootstrap$Tab$initialState,
		h6: $elm$core$Maybe$Nothing,
		fZ: $ChristophP$elm_i18next$I18Next$initialTranslations
	};
};
var $author$project$RunEditor$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$RunEditor$init_i18n(
			$author$project$RunEditor$initialModel(flags)),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Api$fetchMasterData(flags.ez),
					A2(
					$elm$core$Task$perform,
					function (zone) {
						return $author$project$Types$GotCommonMsg(
							$author$project$Types$UpdateTimeZone(zone));
					},
					$elm$time$Time$here)
				])));
};
var $author$project$Types$GotQueueMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$GotRunMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Refresh = {$: 7};
var $author$project$Types$RefreshWithdrawals = F2(
	function (a, b) {
		return {$: 53, a: a, b: b};
	});
var $author$project$Types$SetMaterialFilter = F3(
	function (a, b, c) {
		return {$: 54, a: a, b: b, c: c};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Ports$refresh = _Platform_incomingPort(
	'refresh',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$refreshWithdrawals = _Platform_incomingPort(
	'refreshWithdrawals',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$int)));
var $author$project$Ports$setMaterialFilter = _Platform_incomingPort(
	'setMaterialFilter',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v2) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple3(_v0, _v1, _v2));
						},
						A2(
							$elm$json$Json$Decode$index,
							2,
							A2(
								$elm$json$Json$Decode$andThen,
								function (group_id) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (filter) {
											return $elm$json$Json$Decode$succeed(
												{gL: filter, eH: group_id});
										},
										A2($elm$json$Json$Decode$field, 'filter', $elm$json$Json$Decode$string));
								},
								A2(
									$elm$json$Json$Decode$field,
									'group_id',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int)
											]))))));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$int)));
var $author$project$RunEditor$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$refresh(
				$elm$core$Basics$always(
					$author$project$Types$GotCommonMsg($author$project$Types$Refresh))),
				$author$project$Ports$refreshWithdrawals(
				function (_v0) {
					var item_id = _v0.a;
					var param_id = _v0.b;
					return $author$project$Types$GotRunMsg(
						A2($author$project$Types$RefreshWithdrawals, item_id, param_id));
				}),
				$author$project$Ports$setMaterialFilter(
				function (_v1) {
					var item_id = _v1.a;
					var param_id = _v1.b;
					var value = _v1.c;
					return $author$project$Types$GotRunMsg(
						A3($author$project$Types$SetMaterialFilter, item_id, param_id, value));
				}),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Types$GotQueueMsg,
				$author$project$Common$dndSystem.dZ(model.ev)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Types$GotRunMsg,
				$author$project$Common$groupDndSystem.dZ(model.dv))
			]));
};
var $author$project$Types$ConfirmPopup = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Types$EditItem = function (a) {
	return {$: 28, a: a};
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Ports$modalOpen = _Platform_outgoingPort('modalOpen', $elm$json$Json$Encode$bool);
var $author$project$Common$modalOpenPortCmd = function (model) {
	var open = (!_Utils_eq(model.bk, $author$project$Types$NoneModal)) || (!_Utils_eq(model.cI, $author$project$Types$NonePopup));
	return $author$project$Ports$modalOpen(open);
};
var $author$project$Common$closePopup = function (model) {
	var new_model = _Utils_update(
		model,
		{cI: $author$project$Types$NonePopup});
	return _Utils_Tuple2(
		new_model,
		$author$project$Common$modalOpenPortCmd(new_model));
};
var $author$project$Types$LoadWorkingData = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Types$WorkingDataModel = F5(
	function (runs, items, groups, lock_version, clipboard_queue_item_ids) {
		return {gj: clipboard_queue_item_ids, eI: groups, dz: items, he: lock_version, fA: runs};
	});
var $author$project$Types$Group = F6(
	function (id, run_id, shortname, name, wafer_count, wafer_labels) {
		return {an: id, dG: name, bp: run_id, hX: shortname, ih: wafer_count, ii: wafer_labels};
	});
var $author$project$Api$groupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'wafer_labels',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'wafer_count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'shortname',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'run_id',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Types$Group)))))));
var $author$project$Types$Item = function (id) {
	return function (run_id) {
		return function (is_add_on) {
			return function (user) {
				return function (process_id) {
					return function (machine_id) {
						return function (recipe_id) {
							return function (planning_params) {
								return function (execution_params) {
									return function (validation_errors) {
										return function (comment) {
											return function (title) {
												return function (bkm) {
													return function (highlight) {
														return function (estimated_time) {
															return function (group_ids) {
																return function (params_per_group) {
																	return function (show_group_attrs) {
																		return function (group_attr_list) {
																			return function (original_group_attr_list) {
																				return function (process_unprocessed_samples_of) {
																					return function (operator_note) {
																						return function (files) {
																							return function (state) {
																								return function (rating) {
																									return function (total_wafer_count) {
																										return function (reservation) {
																											return function (queue_item_id) {
																												return function (least_reservation_time) {
																													return function (reservation_queue_name) {
																														return function (invalid_warning) {
																															return function (reservation_warning) {
																																return function (recipe_change_warning) {
																																	return function (hidden) {
																																		return {gd: bkm, gl: comment, gF: estimated_time, gH: execution_params, gK: files, gR: group_attr_list, gS: group_ids, gY: hidden, gZ: highlight, an: id, g4: invalid_warning, g5: is_add_on, hc: least_reservation_time, hh: machine_id, cy: operator_note, ht: original_group_attr_list, hy: params_per_group, hA: planning_params, hD: process_id, hE: process_unprocessed_samples_of, hI: queue_item_id, hJ: rating, hL: recipe_change_warning, hM: recipe_id, hN: reservation, hO: reservation_queue_name, hP: reservation_warning, bp: run_id, hY: show_group_attrs, h1: state, h7: title, fV: total_wafer_count, ib: user, d1: validation_errors};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$GroupAttrs = F6(
	function (group_id, destructed_samples, destructed_samples_comment, destructed_samples_execution, unprocessed_samples, operator_note) {
		return {gt: destructed_samples, gu: destructed_samples_comment, gv: destructed_samples_execution, eH: group_id, cy: operator_note, h8: unprocessed_samples};
	});
var $author$project$Api$groupAttrsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'operator_note',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'unprocessed_samples',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'destructed_samples_execution',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'destructed_samples_comment',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'destructed_samples',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'group_id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Types$GroupAttrs)))))));
var $author$project$Api$groupAttrListDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$field, 'group_id', $elm$json$Json$Decode$int),
			$author$project$Api$groupAttrsDecoder)));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Types$ItemFile = F6(
	function (caption, filename, content_type, download_url, preview_url, update_delete_url) {
		return {dj: caption, go: content_type, b3: download_url, gJ: filename, hC: preview_url, f0: update_delete_url};
	});
var $author$project$Api$itemFileDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'update_delete_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'preview_url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'download_url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'content_type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'filename',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'caption',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Types$ItemFile)))))));
var $author$project$Types$BadRating = 2;
var $author$project$Types$GoodRating = 0;
var $author$project$Types$MediumRating = 1;
var $author$project$Api$itemRatingDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'good':
				return $elm$json$Json$Decode$succeed(0);
			case 'medium':
				return $elm$json$Json$Decode$succeed(1);
			case 'bad':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid item rating');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$Done = 2;
var $author$project$Types$Execution = 1;
var $author$project$Types$Planning = 0;
var $author$project$Api$itemStateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'planning':
				return $elm$json$Json$Decode$succeed(0);
			case 'execution':
				return $elm$json$Json$Decode$succeed(1);
			case 'done':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid item state');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$Reservation = F7(
	function (id, start, end, state, operator_id, is_today, children) {
		return {gi: children, gB: end, an: id, g6: is_today, hr: operator_id, h0: start, h1: state};
	});
var $author$project$Types$Reservations = $elm$core$Basics$identity;
function $author$project$Api$cyclic$reservationsDecoder() {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		$elm$json$Json$Decode$list(
			$author$project$Api$cyclic$reservationDecoder()));
}
function $author$project$Api$cyclic$reservationDecoder() {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'children',
		$elm$json$Json$Decode$lazy(
			function (_v0) {
				return $author$project$Api$cyclic$reservationsDecoder();
			}),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_today',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'operator_id',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'end',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'start',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Types$Reservation))))))));
}
var $author$project$Api$reservationsDecoder = $author$project$Api$cyclic$reservationsDecoder();
$author$project$Api$cyclic$reservationsDecoder = function () {
	return $author$project$Api$reservationsDecoder;
};
var $author$project$Api$reservationDecoder = $author$project$Api$cyclic$reservationDecoder();
$author$project$Api$cyclic$reservationDecoder = function () {
	return $author$project$Api$reservationDecoder;
};
var $author$project$Types$User = F4(
	function (id, firstname, lastname, username) {
		return {gP: firstname, an: id, hb: lastname, ic: username};
	});
var $author$project$Api$userDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'username',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lastname',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'firstname',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Types$User)))));
var $author$project$Api$itemDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	false,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		'',
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			'',
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				'',
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'reservation_queue_name',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'least_reservation_time',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'queue_item_id',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'reservation',
								$elm$json$Json$Decode$maybe($author$project$Api$reservationDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'total_wafer_count',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'rating',
										$elm$json$Json$Decode$maybe($author$project$Api$itemRatingDecoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'state',
											$author$project$Api$itemStateDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'files',
												$elm$json$Json$Decode$list($author$project$Api$itemFileDecoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'operator_note',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'process_unprocessed_samples_of',
														$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'original_group_attr_list',
															$elm$json$Json$Decode$maybe($author$project$Api$groupAttrListDecoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'group_attr_list',
																$author$project$Api$groupAttrListDecoder,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'show_group_attrs',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'params_per_group',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'group_ids',
																			$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'estimated_time',
																				$elm$json$Json$Decode$int,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'highlight',
																					$elm$json$Json$Decode$bool,
																					false,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'bkm',
																						$elm$json$Json$Decode$bool,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'title',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'comment',
																								$elm$json$Json$Decode$string,
																								A2(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																									_List_Nil,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'execution_params',
																										$elm$json$Json$Decode$list($author$project$Api$executionParamDecoder),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'planning_params',
																											$elm$json$Json$Decode$list($author$project$Api$planningParamDecoder),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'recipe_id',
																												$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'machine_id',
																													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'process_id',
																														$elm$json$Json$Decode$int,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'user',
																															$author$project$Api$userDecoder,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'is_add_on',
																																$elm$json$Json$Decode$bool,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'run_id',
																																	$elm$json$Json$Decode$int,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'id',
																																		$elm$json$Json$Decode$int,
																																		$elm$json$Json$Decode$succeed($author$project$Types$Item)))))))))))))))))))))))))))))))))));
var $author$project$Types$Run = F9(
	function (id, owner, mentor, proxies, number, state, name, show_url, notes) {
		return {an: id, e2: mentor, dG: name, hm: notes, hn: number, fd: owner, hG: proxies, h_: show_url, h1: state};
	});
var $author$project$Api$runsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'notes',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'show_url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'state',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'number',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'proxies',
						$elm$json$Json$Decode$list($author$project$Api$userDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'mentor',
							$author$project$Api$userDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'owner',
								$author$project$Api$userDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Types$Run))))))))));
var $author$project$Api$workingDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'clipboard_queue_item_ids',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lock_version',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'groups',
			$elm$json$Json$Decode$list($author$project$Api$groupDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'items',
				$elm$json$Json$Decode$list($author$project$Api$itemDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'runs',
					$elm$json$Json$Decode$list($author$project$Api$runsDecoder),
					$elm$json$Json$Decode$succeed($author$project$Types$WorkingDataModel))))));
var $author$project$Api$fetchItemsAndGroups = F2(
	function (endpoint, run_item_id) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotCommonMsg,
			$elm$http$Http$get(
				{
					q: A2(
						$author$project$Api$expectJsonOrError,
						$author$project$Types$LoadWorkingData(run_item_id),
						$author$project$Api$workingDataDecoder),
					t: endpoint
				}));
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Helper$getRecordById = F2(
	function (records, id) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (r) {
					return _Utils_eq(
						$elm$core$Maybe$Just(r.an),
						id);
				},
				records));
	});
var $author$project$Types$NoAction = {$: 8};
var $author$project$Helper$errorWithoutSrvMsg = F2(
	function (error, retry) {
		return 'Fehler beim ' + ((retry ? 'Senden' : 'Laden') + (' der Daten! (' + (function () {
			switch (error.$) {
				case 0:
					var url = error.a;
					return 'Fehlerhafte URL: ' + url;
				case 1:
					return 'Timeout';
				case 2:
					return 'Netzwerk-Fehler';
				case 3:
					if (!error.b.b) {
						var code = error.a;
						return 'Falscher Rückgabewert: ' + $elm$core$String$fromInt(code);
					} else {
						return 'THIS SHOULD NEVER HAPPEN!';
					}
				default:
					var errorMessage = error.a;
					return 'Fehlerhafte Daten: ' + errorMessage;
			}
		}() + ')')));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Helper$errorToStrings = F2(
	function (error, retry) {
		if (error.$ === 3) {
			var code = error.a;
			var errors = error.b;
			return $elm$core$List$isEmpty(errors) ? _List_fromArray(
				[
					A2($author$project$Helper$errorWithoutSrvMsg, error, retry)
				]) : errors;
		} else {
			return _List_fromArray(
				[
					A2($author$project$Helper$errorWithoutSrvMsg, error, retry)
				]);
		}
	});
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $ursi$elm_scroll$Scroll$roundFloat = A2($elm$core$Basics$composeR, $elm$core$Basics$round, $elm$core$Basics$toFloat);
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $ursi$elm_scroll$Scroll$scrollY = F3(
	function (id, outerPos, innerPos) {
		return A2(
			$elm$core$Task$andThen,
			$elm$core$Basics$identity,
			A3(
				$elm$core$Task$map2,
				F2(
					function (_v0, _v1) {
						var viewport = _v0.ig;
						var element = _v1.gA;
						return A2(
							$elm$browser$Browser$Dom$setViewport,
							viewport.C,
							$ursi$elm_scroll$Scroll$roundFloat((element.D + (element.gW * innerPos)) - (viewport.gW * outerPos)));
					}),
				$elm$browser$Browser$Dom$getViewport,
				$elm$browser$Browser$Dom$getElement(id)));
	});
var $author$project$Common$setError = F3(
	function (model, error, proposed_retry) {
		var scroll_action = A2(
			$elm$core$Task$attempt,
			function (_v1) {
				return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
			},
			A3($ursi$elm_scroll$Scroll$scrollY, 'error-box', 0.2, 0));
		var modal_action = (!_Utils_eq(model.bk, $author$project$Types$NoneModal)) ? $author$project$Ports$modalOpen(false) : $elm$core$Platform$Cmd$none;
		var final_retry = function () {
			if ((error.$ === 3) && (error.a === 409)) {
				return false;
			} else {
				return proposed_retry;
			}
		}();
		var err_msgs = A2($author$project$Helper$errorToStrings, error, proposed_retry);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					di: false,
					dq: $elm$core$Maybe$Just(
						_Utils_Tuple2(err_msgs, final_retry)),
					bk: $author$project$Types$NoneModal,
					fq: final_retry ? model.fq : true
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[scroll_action, modal_action])));
	});
var $author$project$Common$setInvalidWarningItem = F2(
	function (model, item) {
		var recipe = A2($author$project$Helper$getRecordById, model.dQ, item.hM);
		var process = A2(
			$author$project$Helper$getRecordById,
			model.dP,
			$elm$core$Maybe$Just(item.hD));
		var machine_process_recipe_mapping = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (mprm) {
					return _Utils_eq(mprm.hD, item.hD) && (_Utils_eq(
						$elm$core$Maybe$Just(mprm.hh),
						item.hh) && _Utils_eq(
						$elm$core$Maybe$Just(mprm.hM),
						item.hM));
				},
				model.dC));
		var machine_process_mapping = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (mpm) {
					return _Utils_eq(mpm.hD, item.hD) && _Utils_eq(
						$elm$core$Maybe$Just(mpm.hh),
						item.hh);
				},
				model.dB));
		var machine = A2($author$project$Helper$getRecordById, model.dD, item.hh);
		var machine_warning = function () {
			if (!machine.$) {
				var m = machine.a;
				return m.dn ? 'Gerät wurde deaktiviert' : '';
			} else {
				return '';
			}
		}();
		var process_warning = function () {
			if (!process.$) {
				var p = process.a;
				return p.dn ? 'Prozess wurde deaktiviert oder ist keinem Gerät mehr zugeordnet' : (((!_Utils_eq(machine, $elm$core$Maybe$Nothing)) && _Utils_eq(machine_process_mapping, $elm$core$Maybe$Nothing)) ? 'Prozess ist dem Gerät nicht mehr zugeordnet' : '');
			} else {
				return '';
			}
		}();
		var recipe_warning = function () {
			if (!recipe.$) {
				var r = recipe.a;
				return r.dn ? 'Rezept wurde deaktiviert oder ist keinem Geräteprozess mehr zugeordnet' : (((!_Utils_eq(machine, $elm$core$Maybe$Nothing)) && ((!_Utils_eq(process, $elm$core$Maybe$Nothing)) && _Utils_eq(machine_process_recipe_mapping, $elm$core$Maybe$Nothing))) ? 'Rezept ist dem Geräteprozess nicht mehr zugeordnet' : '');
			} else {
				return '';
			}
		}();
		var warning = (machine_warning !== '') ? machine_warning : ((process_warning !== '') ? process_warning : ((recipe_warning !== '') ? recipe_warning : ''));
		return _Utils_update(
			item,
			{g4: warning});
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{n: nodeList, l: nodeListSize, m: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$time$Time$Jan = 0;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {ep: d, e6: m, f5: y};
			}
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		dK: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		f5: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.f5, 0, date.dK);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.ep;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.e6;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.dK;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		f3: 1 + (((rd - week1Day1) / 7) | 0),
		f4: wy,
		ij: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.f3;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.f4;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.cm(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.dF(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.cm(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.dm(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.ay(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.ay(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.ay(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.d2(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.ay(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.ay(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {em: col, gp: contextStack, fl: problem, fy: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.fy, s.em, x, s.f));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.b, s.fy, s.em, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{em: newCol, f: s.f, g: s.g, b: newOffset, fy: newRow, a: s.a});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{em: 1, f: s.f, g: s.g, b: s.b + 1, fy: s.fy + 1, a: s.a}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{em: s.em + 1, f: s.f, g: s.g, b: newOffset, fy: s.fy, a: s.a}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{em: col, f: s0.f, g: s0.g, b: offset, fy: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.fy, s.em, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.b, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.a),
			s.b) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {em: col, fl: problem, fy: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.fy, p.em, p.fl);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{em: 1, f: _List_Nil, g: 1, b: 0, fy: 1, a: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	dm: $justinmimbs$date$Date$withOrdinalSuffix,
	dF: $justinmimbs$date$Date$monthToName,
	cm: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	d2: $justinmimbs$date$Date$weekdayToName,
	ay: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.fl;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Helper$secondsToDuration = function (seconds) {
	return A2(
		$elm$core$String$join,
		':',
		A2(
			$elm$core$List$map,
			A2($elm$core$String$padLeft, 2, '0'),
			A2(
				$elm$core$List$map,
				$elm$core$String$fromInt,
				_List_fromArray(
					[
						(seconds / 3600) | 0,
						A2($elm$core$Basics$modBy, 60, (seconds / 60) | 0),
						A2($elm$core$Basics$modBy, 60, seconds)
					]))));
};
var $author$project$Run$ItemHelper$getParamDefaultValueString = F2(
	function (param, index) {
		var default_value = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2($elm$core$Array$get, index, param.es));
		if (default_value.$ === 1) {
			return '';
		} else {
			switch (default_value.a.$) {
				case 5:
					var i = default_value.a.a;
					return $author$project$Helper$secondsToDuration(i);
				case 0:
					var i = default_value.a.a;
					return $elm$core$String$fromInt(i);
				case 1:
					var f = default_value.a.a;
					return A3(
						$elm$core$String$replace,
						'.',
						',',
						$elm$core$String$fromFloat(f));
				case 4:
					var date = default_value.a.a;
					var _v1 = $justinmimbs$date$Date$fromIsoString(date);
					if (_v1.$ === 1) {
						var err_msg = _v1.a;
						return err_msg;
					} else {
						var d = _v1.a;
						return A2($justinmimbs$date$Date$format, 'dd.MM.yyyy', d);
					}
				case 2:
					var str = default_value.a.a;
					return str;
				default:
					var b = default_value.a.a;
					return b ? 'Ja' : 'Nein';
			}
		}
	});
var $author$project$Run$ItemHelper$getParamInitValue = F2(
	function (param, index) {
		return (param.f1 === 'select_list') ? A2($author$project$Run$ItemHelper$getParamDefaultValueString, param, index) : '';
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Run$ItemHelper$getValueIndexRange = function (param) {
	return A2(
		$elm$core$List$range,
		0,
		$elm$core$Array$length(param.es) - 1);
};
var $author$project$Run$ItemHelper$getParamInitValues = function (param) {
	return $elm$core$Array$fromList(
		A2(
			$elm$core$List$map,
			$author$project$Run$ItemHelper$getParamInitValue(param),
			$author$project$Run$ItemHelper$getValueIndexRange(param)));
};
var $author$project$Run$ItemHelper$initParams = F4(
	function (model, process_id, machine_id, recipe_id) {
		var maybe_mapping = function () {
			var _v2 = _Utils_Tuple2(machine_id, recipe_id);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var mid = _v2.a.a;
				var rid = _v2.b.a;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (mprm) {
							return _Utils_eq(mprm.hh, mid) && (_Utils_eq(mprm.hD, process_id) && _Utils_eq(mprm.hM, rid));
						},
						model.dC));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = function () {
			if (maybe_mapping.$ === 1) {
				return _Utils_Tuple2(_List_Nil, _List_Nil);
			} else {
				var mapping = maybe_mapping.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$map,
						function (p) {
							return _Utils_update(
								p,
								{
									f2: $author$project$Run$ItemHelper$getParamInitValues(p)
								});
						},
						mapping.hA),
					A2(
						$elm$core$List$map,
						function (p) {
							return _Utils_update(
								p,
								{
									f2: $author$project$Run$ItemHelper$getParamInitValues(p)
								});
						},
						mapping.gH));
			}
		}();
		var planning_params = _v0.a;
		var execution_params = _v0.b;
		return _Utils_Tuple2(
			planning_params,
			_Utils_ap(model.er, execution_params));
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Common$isRecipeUnchanged = F4(
	function (old_planning_params, new_planning_params, old_exec_params, new_exec_params) {
		return (!_Utils_eq(
			$elm$core$List$length(old_planning_params),
			$elm$core$List$length(new_planning_params))) ? false : ((!$elm$core$List$length(old_planning_params)) ? true : (A3(
			$elm$core$List$foldl,
			$elm$core$Basics$and,
			true,
			A2(
				$elm$core$List$map,
				function (o) {
					var new_param = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (n) {
								return _Utils_eq(n.an, o.an);
							},
							new_planning_params));
					if (new_param.$ === 1) {
						return false;
					} else {
						var n = new_param.a;
						return _Utils_eq(o.dG, n.dG) && (_Utils_eq(o.f$, n.f$) && (_Utils_eq(o.fq, n.fq) && (_Utils_eq(o.fv, n.fv) && _Utils_eq(o.es, n.es))));
					}
				},
				old_planning_params)) && A3(
			$elm$core$List$foldl,
			$elm$core$Basics$and,
			true,
			A2(
				$elm$core$List$map,
				function (o) {
					var new_param = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (n) {
								return _Utils_eq(n.an, o.an);
							},
							new_exec_params));
					if (new_param.$ === 1) {
						return false;
					} else {
						var n = new_param.a;
						var old_default_values = o.hz ? $elm$core$Array$fromList(
							$elm$core$List$singleton(
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Maybe$Nothing,
									A2($elm$core$Array$get, 0, o.es)))) : o.es;
						return _Utils_eq(o.dG, n.dG) && (_Utils_eq(o.f$, n.f$) && (_Utils_eq(o.hz, n.hz) && (_Utils_eq(o.fv, n.fv) && _Utils_eq(old_default_values, n.es))));
					}
				},
				old_exec_params))));
	});
var $author$project$Common$setRecipeChangeWarningItem = F2(
	function (model, item) {
		var _v0 = A4($author$project$Run$ItemHelper$initParams, model, item.hD, item.hh, item.hM);
		var current_planning_params = _v0.a;
		var current_execution_params = _v0.b;
		return A4($author$project$Common$isRecipeUnchanged, item.hA, current_planning_params, item.gH, current_execution_params) ? item : _Utils_update(
			item,
			{hL: 'Rezept wurde geändert, seit dieser Prozessschritt erstellt wurde!'});
	});
var $author$project$Common$setInvalidWarnings = F2(
	function (items, model) {
		return A2(
			$elm$core$List$map,
			$author$project$Common$setRecipeChangeWarningItem(model),
			A2(
				$elm$core$List$map,
				$author$project$Common$setInvalidWarningItem(model),
				items));
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Ports$showReservation = _Platform_outgoingPort('showReservation', $elm$json$Json$Encode$int);
var $author$project$Common$update = F3(
	function (msg, model, main_update) {
		switch (msg.$) {
			case 1:
				var text = msg.a;
				var action = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cI: A2($author$project$Types$ConfirmPopup, text, action)
						}),
					$author$project$Ports$modalOpen(true));
			case 2:
				var action = msg.a;
				var _v1 = A2(main_update, action, model);
				var main_model = _v1.a;
				var main_cmd = _v1.b;
				var _v2 = $author$project$Common$closePopup(main_model);
				var common_model = _v2.a;
				var common_cmd = _v2.b;
				return _Utils_Tuple2(
					common_model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[common_cmd, main_cmd])));
			case 3:
				return $author$project$Common$closePopup(model);
			case 4:
				var new_model = _Utils_update(
					model,
					{bk: $author$project$Types$NoneModal});
				return _Utils_Tuple2(
					new_model,
					$author$project$Common$modalOpenPortCmd(new_model));
			case 0:
				var item = msg.a;
				var res_id = function () {
					var _v3 = item.hN;
					if (_v3.$ === 1) {
						return 0;
					} else {
						var res = _v3.a;
						return res.an;
					}
				}();
				return _Utils_Tuple2(
					model,
					$author$project$Ports$showReservation(res_id));
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{di: true}),
					A2($author$project$Api$fetchItemsAndGroups, model.a9.gE, $elm$core$Maybe$Nothing));
			case 5:
				if (!msg.a.$) {
					var master_data_model = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{er: master_data_model.er, dq: $elm$core$Maybe$Nothing, dB: master_data_model.dB, dC: master_data_model.dC, dD: master_data_model.dD, dP: master_data_model.dP, dQ: master_data_model.dQ}),
						A2($author$project$Api$fetchItemsAndGroups, model.a9.gE, model.a9.hS));
				} else {
					var error = msg.a.a;
					return A3($author$project$Common$setError, model, error, false);
				}
			case 6:
				if (!msg.b.$) {
					var item_id = msg.a;
					var run_model = msg.b.a;
					var new_model = _Utils_update(
						model,
						{
							di: false,
							gj: run_model.gj,
							dq: $elm$core$Maybe$Nothing,
							eI: run_model.eI,
							dz: A2($author$project$Common$setInvalidWarnings, run_model.dz, model),
							he: run_model.he,
							fA: run_model.fA
						});
					var maybe_item = A2($author$project$Helper$getRecordById, new_model.dz, item_id);
					if (maybe_item.$ === 1) {
						return _Utils_Tuple2(new_model, $elm$core$Platform$Cmd$none);
					} else {
						var item = maybe_item.a;
						return A2(
							main_update,
							$author$project$Types$GotRunMsg(
								$author$project$Types$EditItem(item)),
							new_model);
					}
				} else {
					var item_id = msg.a;
					var error = msg.b.a;
					return A3($author$project$Common$setError, model, error, false);
				}
			case 8:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var zone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: $elm$core$Maybe$Just(zone)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState = function (id) {
	return {
		bE: $elm$core$Maybe$Just(id),
		bw: 2
	};
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Helper$insertIfNotMember = F2(
	function (el, list) {
		if (el.$ === 1) {
			return list;
		} else {
			var e = el.a;
			return A2($elm$core$List$member, e, list) ? list : _Utils_ap(
				list,
				_List_fromArray(
					[e]));
		}
	});
var $author$project$Types$SendClipboardResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$expectNothingOrError = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$author$project$Types$BadUrl(url));
				case 1:
					return $elm$core$Result$Err($author$project$Types$Timeout);
				case 2:
					return $elm$core$Result$Err($author$project$Types$NetworkError);
				case 3:
					var metadata = response.a;
					var body = response.b;
					var _v1 = metadata.c$;
					if (_v1 === 304) {
						return $elm$core$Result$Ok(false);
					} else {
						var _v2 = A2($elm$json$Json$Decode$decodeString, $author$project$Api$errorsDecoder, body);
						if (!_v2.$) {
							var error_with_msgs = _v2.a;
							return $elm$core$Result$Err(
								A2($author$project$Types$BadStatus, metadata.c$, error_with_msgs.eA));
						} else {
							var err = _v2.a;
							return $elm$core$Result$Err(
								$author$project$Types$BadBody(
									$elm$json$Json$Decode$errorToString(err)));
						}
					}
				default:
					var metadata = response.a;
					var body = response.b;
					return $elm$core$Result$Ok(true);
			}
		});
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$sendClipboardItems = function (model) {
	return A2(
		$elm$core$Platform$Cmd$map,
		$author$project$Types$GotQueueMsg,
		$elm$http$Http$request(
			{
				E: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'clipboard_queue_item_ids',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, model.gj)),
								_Utils_Tuple2(
								'lock_version',
								$elm$json$Json$Encode$int(model.he))
							]))),
				q: $author$project$Api$expectNothingOrError($author$project$Types$SendClipboardResponse),
				H: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-Token', model.a9.dl)
					]),
				I: 'PUT',
				M: $elm$core$Maybe$Nothing,
				N: $elm$core$Maybe$Nothing,
				t: model.a9.gE
			}));
};
var $author$project$Queue$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{di: true}),
					A2($author$project$Api$fetchItemsAndGroups, model.a9.gE, $elm$core$Maybe$Nothing));
			case 10:
				var machine_id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fE: $elm$core$Maybe$Just(machine_id)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				if (!msg.a.$) {
					var saved = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								di: false,
								he: model.he + (saved ? 1 : 0)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return A3($author$project$Common$setError, model, error, true);
				}
			case 8:
				var dnd_msg = msg.a;
				var _v1 = A3($author$project$Common$dndSystem.h9, dnd_msg, model.ev, model.gj);
				var dnd_model = _v1.a;
				var clipboard_queue_item_ids = _v1.b;
				var new_model = _Utils_update(
					model,
					{gj: clipboard_queue_item_ids, ev: dnd_model});
				var commands = $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$cons,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$GotQueueMsg,
							$author$project$Common$dndSystem.gk(dnd_model)),
						_Utils_eq(model.gj, new_model.gj) ? _List_Nil : _List_fromArray(
							[
								$author$project$Api$sendClipboardItems(new_model)
							])));
				return _Utils_Tuple2(new_model, commands);
			case 1:
				var state = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: model.bS + 1, fF: $elm$core$Maybe$Nothing, fO: state}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var maybe_queue_item_id = msg.a;
				var clipboard_queue_item_ids = A2($author$project$Helper$insertIfNotMember, maybe_queue_item_id, model.gj);
				var new_model = _Utils_update(
					model,
					{gj: clipboard_queue_item_ids});
				return _Utils_Tuple2(
					new_model,
					$author$project$Api$sendClipboardItems(new_model));
			case 3:
				var maybe_queue_item_id = msg.a;
				var clipboard_queue_item_ids = function () {
					if (maybe_queue_item_id.$ === 1) {
						return model.gj;
					} else {
						var queue_item_id = maybe_queue_item_id.a;
						return A2(
							$elm$core$List$filter,
							function (id) {
								return !_Utils_eq(id, queue_item_id);
							},
							model.gj);
					}
				}();
				var new_model = _Utils_update(
					model,
					{gj: clipboard_queue_item_ids});
				return _Utils_Tuple2(
					new_model,
					$author$project$Api$sendClipboardItems(new_model));
			case 4:
				var new_model = _Utils_update(
					model,
					{
						gj: _List_Nil,
						fi: A2($elm$core$Dict$remove, 'clear-clipboard', model.fi)
					});
				return _Utils_Tuple2(
					new_model,
					$author$project$Api$sendClipboardItems(new_model));
			case 5:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: model.bS + 1,
							fE: item.hh,
							fF: item.hN,
							hV: $elm$core$Maybe$Just(item.bp),
							fO: $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('queue-calendar')
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date_string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gM: date_string}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var machine_id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gN: $elm$core$String$toInt(machine_id)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var key = msg.a;
				var state = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fi: A3($elm$core$Dict$insert, key, state, model.fi)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$AskRenewPopup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Async = 1;
var $author$project$Types$Blocking = 0;
var $commonmind$elm_csv_encode$Csv$Encode$Csv = F2(
	function (headers, records) {
		return {H: headers, fr: records};
	});
var $author$project$Types$DeleteGroup = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Types$EditItemFile = F4(
	function (a, b, c, d) {
		return {$: 63, a: a, b: b, c: c, d: d};
	});
var $author$project$Types$GroupAlter = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Types$GroupAttrOperatorNote = 4;
var $author$project$Types$GroupCopy = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Types$GroupModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$GroupNew = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$GroupSplit = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Types$ItemModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$MaterialListParams = F7(
	function (run_id, parameter_type, item_id, param_id, group_id, material_type_name, filter) {
		return {gL: filter, eH: group_id, g7: item_id, hj: material_type_name, hw: param_id, hx: parameter_type, bp: run_id};
	});
var $author$project$Types$MediumPopup = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Types$Modal = F2(
	function (title, body) {
		return {E: body, h7: title};
	});
var $author$project$Types$NewItemModal = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Types$PopupCancel = {$: 3};
var $author$project$Types$PopupOk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$SmallPopup = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Types$UpdateItemOperatorNote = F4(
	function (a, b, c, d) {
		return {$: 38, a: a, b: b, c: c, d: d};
	});
var $author$project$Types$UpdateItemStartExecution = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Types$UpdateItemStopExecution = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Types$UploadItemFile = F4(
	function (a, b, c, d) {
		return {$: 64, a: a, b: b, c: c, d: d};
	});
var $author$project$Types$UploadItemFiles = F3(
	function (a, b, c) {
		return {$: 65, a: a, b: b, c: c};
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Attrs = function (a) {
	return {$: 6, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Attrs(attrs_);
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$file$File$Download$bytes = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(
				_File_download,
				name,
				mime,
				_File_makeBytesSafeForInternetExplorer(content)));
	});
var $author$project$Helper$ceilInteger = F2(
	function (step, input) {
		var remainder = A2($elm$core$Basics$modBy, step, input);
		return (remainder > 0) ? ((input - remainder) + 30) : input;
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $author$project$Run$ItemHelper$filterGroupValues = function (id) {
	return $elm$core$List$filter(
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Basics$eq(id),
			$elm$core$Tuple$first));
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Run$ItemHelper$replaceGroupValues = function (id) {
	return $elm$core$List$map(
		$elm$core$Tuple$mapFirst(
			$elm$core$Basics$always(id)));
};
var $author$project$Run$ItemHelper$copyGroupValues = F3(
	function (old_id, new_id, param) {
		var group_values = _Utils_ap(
			param.gT,
			A2(
				$author$project$Run$ItemHelper$replaceGroupValues,
				new_id,
				A2($author$project$Run$ItemHelper$filterGroupValues, old_id, param.gT)));
		return _Utils_update(
			param,
			{gT: group_values});
	});
var $author$project$Run$Main$copyItemsAndPlanningParamValues = F4(
	function (cond, g, original_g, item) {
		var new_planning_params = A2(
			$elm$core$List$map,
			A2($author$project$Run$ItemHelper$copyGroupValues, original_g.an, g.an),
			item.hA);
		return (cond(item) && A2($elm$core$List$member, original_g.an, item.gS)) ? _Utils_update(
			item,
			{
				gS: A2($elm$core$List$cons, g.an, item.gS),
				hA: new_planning_params
			}) : _Utils_update(
			item,
			{hA: new_planning_params});
	});
var $author$project$Run$Main$createItemCopy = F3(
	function (model, item, next_id) {
		var planning_params = A2(
			$elm$core$List$map,
			function (p) {
				return _Utils_update(
					p,
					{
						hF: $author$project$Types$MaterialParamProperties(
							A2($author$project$Types$MaterialProperties, _List_Nil, _List_Nil))
					});
			},
			item.hA);
		var _v0 = A4($author$project$Run$ItemHelper$initParams, model, item.hD, item.hh, item.hM);
		var execution_params = _v0.b;
		return _Utils_update(
			item,
			{gH: execution_params, an: next_id, cy: '', hA: planning_params, hJ: $elm$core$Maybe$Nothing, hN: $elm$core$Maybe$Nothing, h1: 0});
	});
var $author$project$Types$ItemQueueElem = F3(
	function (id, api_reply, action) {
		return {f6: action, ga: api_reply, an: id};
	});
var $author$project$Types$RunSavedReplaceItems = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $elm$json$Json$Encode$array = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$Array$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$json$Json$Encode$float = _Json_wrap;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Api$defaultValueEncoder = function (default_value) {
	if (default_value.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		switch (default_value.a.$) {
			case 3:
				var b = default_value.a.a;
				return $elm$json$Json$Encode$bool(b);
			case 4:
				var s = default_value.a.a;
				return $elm$json$Json$Encode$string(s);
			case 5:
				var i = default_value.a.a;
				return $elm$json$Json$Encode$int(i);
			case 1:
				var f = default_value.a.a;
				return $elm$json$Json$Encode$float(f);
			case 0:
				var i = default_value.a.a;
				return $elm$json$Json$Encode$int(i);
			default:
				var s = default_value.a.a;
				return $elm$json$Json$Encode$string(s);
		}
	}
};
var $author$project$Api$executionParamEncoder = function (param) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(param.an)),
				_Utils_Tuple2(
				'value_type',
				$elm$json$Json$Encode$string(param.f1)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(param.dG)),
				_Utils_Tuple2(
				'unit',
				$elm$json$Json$Encode$string(param.f$)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(param.et)),
				_Utils_Tuple2(
				'default_values',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Api$defaultValueEncoder,
					$elm$core$Array$toList(param.es))),
				_Utils_Tuple2(
				'allowed_values',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, param.ea)),
				_Utils_Tuple2(
				'readonly',
				$elm$json$Json$Encode$bool(param.fq)),
				_Utils_Tuple2(
				'per_batch',
				$elm$json$Json$Encode$bool(param.hz)),
				_Utils_Tuple2(
				'required',
				$elm$json$Json$Encode$bool(param.fv)),
				_Utils_Tuple2(
				'style',
				$elm$json$Json$Encode$string(param.fM)),
				_Utils_Tuple2(
				'values',
				A2($elm$json$Json$Encode$array, $elm$json$Json$Encode$string, param.f2)),
				_Utils_Tuple2(
				'operator_note',
				$elm$json$Json$Encode$string(param.cy))
			]));
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Api$groupAttrsEncoder = function (group_attr_list) {
	return A2(
		$elm$json$Json$Encode$list,
		function (ga) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'group_id',
						$elm$json$Json$Encode$int(ga.eH)),
						_Utils_Tuple2(
						'destructed_samples',
						$elm$json$Json$Encode$int(ga.gt)),
						_Utils_Tuple2(
						'destructed_samples_comment',
						$elm$json$Json$Encode$string(ga.gu)),
						_Utils_Tuple2(
						'destructed_samples_execution',
						$elm$json$Json$Encode$int(ga.gv)),
						_Utils_Tuple2(
						'unprocessed_samples',
						$elm$json$Json$Encode$int(ga.h8)),
						_Utils_Tuple2(
						'operator_note',
						$elm$json$Json$Encode$string(ga.cy))
					]));
		},
		$elm$core$Dict$values(group_attr_list));
};
var $author$project$Api$maybeEncoder = F2(
	function (encoder_func, maybe) {
		if (maybe.$ === 1) {
			return $elm$json$Json$Encode$null;
		} else {
			var v = maybe.a;
			return encoder_func(v);
		}
	});
var $author$project$Api$itemRatingEncoder = function (item_rating) {
	return A2(
		$author$project$Api$maybeEncoder,
		$elm$json$Json$Encode$string,
		function () {
			if (item_rating.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				switch (item_rating.a) {
					case 0:
						var _v1 = item_rating.a;
						return $elm$core$Maybe$Just('good');
					case 1:
						var _v2 = item_rating.a;
						return $elm$core$Maybe$Just('medium');
					default:
						var _v3 = item_rating.a;
						return $elm$core$Maybe$Just('bad');
				}
			}
		}());
};
var $author$project$Api$itemStateEncoder = function (item_state) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (item_state) {
				case 0:
					return 'planning';
				case 1:
					return 'execution';
				default:
					return 'done';
			}
		}());
};
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Api$encodeGroupValue = function (_v0) {
	var key = _v0.a;
	var values = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$int(key)),
				_Utils_Tuple2(
				'values',
				A2($elm$json$Json$Encode$array, $elm$json$Json$Encode$string, values))
			]));
};
var $author$project$Api$encodeGroupValueChecked = function (_v0) {
	var key = _v0.a;
	var values = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$int(key)),
				_Utils_Tuple2(
				'values',
				A2($elm$json$Json$Encode$array, $elm$json$Json$Encode$bool, values))
			]));
};
var $author$project$Api$materialFilterEncoder = function (filter) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'group_id',
				A2($author$project$Api$maybeEncoder, $elm$json$Json$Encode$int, filter.eH)),
				_Utils_Tuple2(
				'filter',
				$elm$json$Json$Encode$string(filter.gL))
			]));
};
var $author$project$Api$paramPropertiesEncoder = function (param) {
	var _v0 = param.hF;
	if (_v0.$ === 1) {
		var properties = _v0.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'filters',
					$elm$json$Json$Encode$list($author$project$Api$materialFilterEncoder)(properties.gO))
				]));
	} else {
		return $elm$json$Json$Encode$object(_List_Nil);
	}
};
var $author$project$Api$planningParamEncoder = function (param) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(param.an)),
				_Utils_Tuple2(
				'value_type',
				$elm$json$Json$Encode$string(param.f1)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(param.dG)),
				_Utils_Tuple2(
				'unit',
				$elm$json$Json$Encode$string(param.f$)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(param.et)),
				_Utils_Tuple2(
				'default_values',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Api$defaultValueEncoder,
					$elm$core$Array$toList(param.es))),
				_Utils_Tuple2(
				'allowed_values',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, param.ea)),
				_Utils_Tuple2(
				'readonly',
				$elm$json$Json$Encode$bool(param.fq)),
				_Utils_Tuple2(
				'values',
				A2($elm$json$Json$Encode$array, $elm$json$Json$Encode$string, param.f2)),
				_Utils_Tuple2(
				'original_values',
				A2(
					$elm_community$json_extra$Json$Encode$Extra$maybe,
					$elm$json$Json$Encode$array($elm$json$Json$Encode$string),
					param.hv)),
				_Utils_Tuple2(
				'values_checked',
				A2($elm$json$Json$Encode$array, $elm$json$Json$Encode$bool, param.ie)),
				_Utils_Tuple2(
				'operator_note',
				$elm$json$Json$Encode$string(param.cy)),
				_Utils_Tuple2(
				'group_values',
				A2($elm$json$Json$Encode$list, $author$project$Api$encodeGroupValue, param.gT)),
				_Utils_Tuple2(
				'original_group_values',
				A2(
					$elm_community$json_extra$Json$Encode$Extra$maybe,
					$elm$json$Json$Encode$list($author$project$Api$encodeGroupValue),
					param.hu)),
				_Utils_Tuple2(
				'group_values_checked',
				A2($elm$json$Json$Encode$list, $author$project$Api$encodeGroupValueChecked, param.gU)),
				_Utils_Tuple2(
				'required',
				$elm$json$Json$Encode$bool(param.fv)),
				_Utils_Tuple2(
				'style',
				$elm$json$Json$Encode$string(param.fM)),
				_Utils_Tuple2(
				'properties',
				$author$project$Api$paramPropertiesEncoder(param))
			]));
};
var $author$project$Api$userEncoder = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(user.an)),
				_Utils_Tuple2(
				'firstname',
				$elm$json$Json$Encode$string(user.gP)),
				_Utils_Tuple2(
				'lastname',
				$elm$json$Json$Encode$string(user.hb)),
				_Utils_Tuple2(
				'username',
				$elm$json$Json$Encode$string(user.ic))
			]));
};
var $author$project$Api$itemEncoder = function (item) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(item.an)),
				_Utils_Tuple2(
				'is_add_on',
				$elm$json$Json$Encode$bool(item.g5)),
				_Utils_Tuple2(
				'user',
				$author$project$Api$userEncoder(item.ib)),
				_Utils_Tuple2(
				'process_id',
				$elm$json$Json$Encode$int(item.hD)),
				_Utils_Tuple2(
				'machine_id',
				A2($author$project$Api$maybeEncoder, $elm$json$Json$Encode$int, item.hh)),
				_Utils_Tuple2(
				'recipe_id',
				A2($author$project$Api$maybeEncoder, $elm$json$Json$Encode$int, item.hM)),
				_Utils_Tuple2(
				'planning_params',
				A2($elm$json$Json$Encode$list, $author$project$Api$planningParamEncoder, item.hA)),
				_Utils_Tuple2(
				'execution_params',
				A2($elm$json$Json$Encode$list, $author$project$Api$executionParamEncoder, item.gH)),
				_Utils_Tuple2(
				'comment',
				$elm$json$Json$Encode$string(item.gl)),
				_Utils_Tuple2(
				'bkm',
				$elm$json$Json$Encode$bool(item.gd)),
				_Utils_Tuple2(
				'highlight',
				$elm$json$Json$Encode$bool(item.gZ)),
				_Utils_Tuple2(
				'estimated_time',
				$elm$json$Json$Encode$int(item.gF)),
				_Utils_Tuple2(
				'group_ids',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, item.gS)),
				_Utils_Tuple2(
				'params_per_group',
				$elm$json$Json$Encode$bool(item.hy)),
				_Utils_Tuple2(
				'show_group_attrs',
				$elm$json$Json$Encode$bool(item.hY)),
				_Utils_Tuple2(
				'group_attr_list',
				$author$project$Api$groupAttrsEncoder(item.gR)),
				_Utils_Tuple2(
				'original_group_attr_list',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Api$groupAttrsEncoder, item.ht)),
				_Utils_Tuple2(
				'process_unprocessed_samples_of',
				A2($author$project$Api$maybeEncoder, $elm$json$Json$Encode$int, item.hE)),
				_Utils_Tuple2(
				'operator_note',
				$elm$json$Json$Encode$string(item.cy)),
				_Utils_Tuple2(
				'state',
				$author$project$Api$itemStateEncoder(item.h1)),
				_Utils_Tuple2(
				'rating',
				$author$project$Api$itemRatingEncoder(item.hJ))
			]));
};
var $author$project$Api$createItemsEncoder = F3(
	function (insert_index, items, lock_version) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'abstract_run',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'insert_index',
								$elm$json$Json$Encode$int(insert_index)),
								_Utils_Tuple2(
								'items',
								A2($elm$json$Json$Encode$list, $author$project$Api$itemEncoder, items)),
								_Utils_Tuple2(
								'lock_version',
								$elm$json$Json$Encode$int(lock_version))
							])))
				]));
	});
var $author$project$Api$createItems = F5(
	function (endpoint, csrf_token, insert_index, items, lock_version) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$request(
				{
					E: $elm$http$Http$jsonBody(
						A3($author$project$Api$createItemsEncoder, insert_index, items, lock_version)),
					q: A2(
						$author$project$Api$expectJsonOrError,
						$author$project$Types$RunSavedReplaceItems,
						$elm$json$Json$Decode$list($author$project$Api$itemDecoder)),
					H: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-Token', csrf_token)
						]),
					I: 'POST',
					M: $elm$core$Maybe$Nothing,
					N: $elm$core$Maybe$Nothing,
					t: endpoint
				}));
	});
var $owanturist$elm_queue$Queue$Queue = F5(
	function (a, b, c, d, e) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e};
	});
var $owanturist$elm_queue$Queue$enqueue = F2(
	function (element, queue) {
		if (!queue.$) {
			return A5($owanturist$elm_queue$Queue$Queue, element, 0, 0, _List_Nil, _List_Nil);
		} else {
			var peek = queue.a;
			var sizeIn = queue.b;
			var sizeOut = queue.c;
			var input = queue.d;
			var output = queue.e;
			return A5(
				$owanturist$elm_queue$Queue$Queue,
				peek,
				sizeIn + 1,
				sizeOut,
				A2($elm$core$List$cons, element, input),
				output);
		}
	});
var $owanturist$elm_queue$Queue$dequeue = function (queue) {
	if (!queue.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		if (!queue.e.b) {
			var peek = queue.a;
			var sizeIn = queue.b;
			var input = queue.d;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					peek,
					function () {
						var _v1 = $elm$core$List$reverse(input);
						if (!_v1.b) {
							return $owanturist$elm_queue$Queue$Empty;
						} else {
							var nextPeek = _v1.a;
							var nextOutStack = _v1.b;
							return A5($owanturist$elm_queue$Queue$Queue, nextPeek, 0, sizeIn - 1, _List_Nil, nextOutStack);
						}
					}()));
		} else {
			var peek = queue.a;
			var sizeIn = queue.b;
			var sizeOut = queue.c;
			var input = queue.d;
			var _v2 = queue.e;
			var nextPeek = _v2.a;
			var nextOutStack = _v2.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					peek,
					A5($owanturist$elm_queue$Queue$Queue, nextPeek, sizeIn, sizeOut - 1, input, nextOutStack)));
		}
	}
};
var $author$project$Run$Main$processItemsQueue = F2(
	function (model, other_actions) {
		var _v0 = function () {
			if (model.dT) {
				return _Utils_Tuple2(other_actions, model);
			} else {
				var _v1 = $owanturist$elm_queue$Queue$dequeue(model.aX);
				if (_v1.$ === 1) {
					return _Utils_Tuple2(other_actions, model);
				} else {
					var _v2 = _v1.a;
					var item_queue_element = _v2.a;
					var rest = _v2.b;
					return _Utils_Tuple2(
						A2(
							$elm$core$List$cons,
							item_queue_element.f6(model.he),
							other_actions),
						_Utils_update(
							model,
							{
								di: function () {
									var _v3 = item_queue_element.ga;
									if (!_v3) {
										return true;
									} else {
										return false;
									}
								}(),
								aX: rest,
								dT: true
							}));
				}
			}
		}();
		var actions = _v0.a;
		var new_model = _v0.b;
		return _Utils_Tuple2(
			new_model,
			$elm$core$Platform$Cmd$batch(actions));
	});
var $author$project$Run$Main$enqueueItemsAction = F3(
	function (model, new_action, other_actions) {
		return A2(
			$author$project$Run$Main$processItemsQueue,
			_Utils_update(
				model,
				{
					aX: A2($owanturist$elm_queue$Queue$enqueue, new_action, model.aX)
				}),
			other_actions);
	});
var $author$project$Run$Main$createItems = F4(
	function (model, insert_index, items, other_actions) {
		var new_action = A3(
			$author$project$Types$ItemQueueElem,
			-1,
			0,
			A4($author$project$Api$createItems, model.a9.dp, model.a9.dl, insert_index, items));
		return A3($author$project$Run$Main$enqueueItemsAction, model, new_action, other_actions);
	});
var $author$project$Types$RunSaved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$deleteItemEncoder = function (lock_version) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'abstract_run',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'lock_version',
							$elm$json$Json$Encode$int(lock_version))
						])))
			]));
};
var $author$project$Api$deleteItem = F4(
	function (endpoint, csrf_token, id, lock_version) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$request(
				{
					E: $elm$http$Http$jsonBody(
						$author$project$Api$deleteItemEncoder(lock_version)),
					q: $author$project$Api$expectNothingOrError($author$project$Types$RunSaved),
					H: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-Token', csrf_token)
						]),
					I: 'DELETE',
					M: $elm$core$Maybe$Nothing,
					N: $elm$core$Maybe$Nothing,
					t: endpoint + ('/' + $elm$core$String$fromInt(id))
				}));
	});
var $author$project$Run$Main$deleteItem = F3(
	function (model, id, other_actions) {
		var new_action = A3(
			$author$project$Types$ItemQueueElem,
			-1,
			0,
			A3($author$project$Api$deleteItem, model.a9.dp, model.a9.dl, id));
		return A3($author$project$Run$Main$enqueueItemsAction, model, new_action, other_actions);
	});
var $author$project$Types$LoadItemFiles = F2(
	function (a, b) {
		return {$: 67, a: a, b: b};
	});
var $author$project$Api$deleteItemFile = F3(
	function (model, item_id, item_file) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$request(
				{
					E: $elm$http$Http$emptyBody,
					q: A2(
						$author$project$Api$expectJsonOrError,
						$author$project$Types$LoadItemFiles(item_id),
						$elm$json$Json$Decode$list($author$project$Api$itemFileDecoder)),
					H: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-Token', model.a9.dl)
						]),
					I: 'DELETE',
					M: $elm$core$Maybe$Nothing,
					N: $elm$core$Maybe$Nothing,
					t: item_file.f0
				}));
	});
var $author$project$Run$Main$possiblyTakeOldParamValues = F2(
	function (new_param, old_params) {
		var old_param = A2(
			$author$project$Helper$getRecordById,
			old_params,
			$elm$core$Maybe$Just(new_param.an));
		var values = function () {
			if (old_param.$ === 1) {
				return new_param.f2;
			} else {
				var o = old_param.a;
				var is_value_invalid = ((o.f1 === 'select_list') && A3(
					$elm$core$List$foldl,
					$elm$core$Basics$or,
					false,
					A2(
						$elm$core$List$map,
						function (v) {
							return !A2($elm$core$List$member, v, new_param.ea);
						},
						$elm$core$Array$toList(o.f2)))) || (!_Utils_eq(
					$elm$core$Array$length(new_param.f2),
					$elm$core$Array$length(o.f2)));
				return is_value_invalid ? new_param.f2 : o.f2;
			}
		}();
		return _Utils_update(
			new_param,
			{f2: values});
	});
var $author$project$Run$Main$createItemCopyAndRenew = F3(
	function (model, item, next_id) {
		var _v0 = A4($author$project$Run$ItemHelper$initParams, model, item.hD, item.hh, item.hM);
		var new_planning_params = _v0.a;
		var new_execution_params = _v0.b;
		var execution_params = A2(
			$elm$core$List$map,
			function (p) {
				return A2($author$project$Run$Main$possiblyTakeOldParamValues, p, item.gH);
			},
			new_execution_params);
		var planning_params = A2(
			$elm$core$List$map,
			function (p) {
				return A2($author$project$Run$Main$possiblyTakeOldParamValues, p, item.hA);
			},
			new_planning_params);
		return _Utils_update(
			item,
			{gH: execution_params, an: next_id, cy: '', hA: planning_params, hJ: $elm$core$Maybe$Nothing, hL: '', hN: $elm$core$Maybe$Nothing, h1: 0});
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Helper$elemIndex = F2(
	function (elem, list) {
		return A2(
			$elm$core$Maybe$withDefault,
			-1,
			A2($elm_community$list_extra$List$Extra$elemIndex, elem, list));
	});
var $author$project$Helper$insertAt = F3(
	function (index, elem, list) {
		return _Utils_ap(
			A2($elm$core$List$take, index, list),
			_Utils_ap(
				_List_fromArray(
					[elem]),
				A2($elm$core$List$drop, index, list)));
	});
var $author$project$Types$HistoryState = F2(
	function (groups, items) {
		return {eI: groups, dz: items};
	});
var $author$project$Run$Main$newHistory = F3(
	function (history, groups, items) {
		return $author$project$Types$History(
			A2(
				$elm$core$List$cons,
				A2($author$project$Types$HistoryState, groups, items),
				history.dW));
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Helper$nextId = function (list) {
	return 1 + A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$maximum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.an;
				},
				list)));
};
var $author$project$Run$Main$doCopyItem = F4(
	function (model, old_item, renew, process_unprocessed_samples) {
		var new_item_index = A2($author$project$Helper$elemIndex, old_item, model.dz) + 1;
		var copied_item = renew ? A3(
			$author$project$Run$Main$createItemCopyAndRenew,
			model,
			old_item,
			$author$project$Helper$nextId(model.dz)) : A3(
			$author$project$Run$Main$createItemCopy,
			model,
			old_item,
			$author$project$Helper$nextId(model.dz));
		var new_item = function () {
			if (process_unprocessed_samples) {
				var planning_params = A2(
					$elm$core$List$map,
					function (p) {
						return _Utils_update(
							p,
							{hu: $elm$core$Maybe$Nothing, hv: $elm$core$Maybe$Nothing});
					},
					old_item.hA);
				var group_attr_list = $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (_v0) {
							var k = _v0.a;
							var v = _v0.b;
							return _Utils_Tuple2(
								k,
								_Utils_update(
									v,
									{h8: 0}));
						},
						$elm$core$Dict$toList(old_item.gR)));
				return _Utils_update(
					copied_item,
					{
						gR: group_attr_list,
						ht: $elm$core$Maybe$Nothing,
						hA: planning_params,
						hE: $elm$core$Maybe$Just(old_item.an),
						h1: 0
					});
			} else {
				return copied_item;
			}
		}();
		var new_model = _Utils_update(
			model,
			{
				i: A3($author$project$Run$Main$newHistory, model.i, model.eI, model.dz),
				aR: $elm$core$Maybe$Nothing,
				P: $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-item-planning-edit'),
				dz: A3($author$project$Helper$insertAt, new_item_index, new_item, model.dz),
				bk: $author$project$Types$ItemModal(new_item),
				cI: $author$project$Types$NonePopup
			});
		return A4(
			$author$project$Run$Main$createItems,
			new_model,
			new_item_index,
			_List_fromArray(
				[new_item]),
			_List_fromArray(
				[
					$author$project$Ports$modalOpen(true)
				]));
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Run$ItemHelper$unprocessedItem = F2(
	function (model, item) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (i) {
					return _Utils_eq(
						$elm$core$Maybe$Just(i.an),
						item.hE);
				},
				model.dz));
	});
var $author$project$Run$ItemHelper$totalWaferCountPerItem = F2(
	function (model, item) {
		var _v0 = A2($author$project$Run$ItemHelper$unprocessedItem, model, item);
		if (_v0.$ === 1) {
			var _v1 = item.fV;
			if (!_v1.$) {
				var c = _v1.a;
				return c;
			} else {
				return $elm$core$List$sum(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.ih;
						},
						A2(
							$elm$core$List$filter,
							function (g) {
								return A2($elm$core$List$member, g.an, item.gS);
							},
							model.eI))) - $elm$core$List$sum(
					A2(
						$elm$core$List$map,
						function (i) {
							return $elm$core$List$sum(
								A2(
									$elm$core$List$map,
									function (ga) {
										return ga.gv + (i.hY ? ga.gt : 0);
									},
									A2(
										$elm$core$List$filter,
										function (ga) {
											return A2($elm$core$List$member, ga.eH, item.gS);
										},
										A2(
											$elm$core$List$filter,
											function (ga) {
												return A2($elm$core$List$member, ga.eH, i.gS);
											},
											$elm$core$Dict$values(i.gR)))));
						},
						A2(
							$elm$core$List$take,
							A2($author$project$Helper$elemIndex, item, model.dz),
							model.dz)));
			}
		} else {
			var an_item = _v0.a;
			return $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.h8;
					},
					$elm$core$Dict$values(an_item.gR)));
		}
	});
var $author$project$Run$ItemHelper$correctBatchCount = F2(
	function (model, item) {
		var total_wafer_count = A2($author$project$Run$ItemHelper$totalWaferCountPerItem, model, item);
		var machine = A2($author$project$Helper$getRecordById, model.dD, item.hh);
		var batch_count = function () {
			var maybe_batch_size = function () {
				if (machine.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var m = machine.a;
					return m.gc;
				}
			}();
			if (maybe_batch_size.$ === 1) {
				return 1;
			} else {
				var batch_size = maybe_batch_size.a;
				return function (v) {
					return (v < 1) ? 1 : v;
				}(
					$elm$core$Basics$ceiling(total_wafer_count / batch_size));
			}
		}();
		var new_execution_params = A2(
			$elm$core$List$map,
			function (param) {
				if (param.hz) {
					var values = $elm$core$Array$fromList(
						A2(
							$elm$core$List$repeat,
							batch_count,
							A2($author$project$Run$ItemHelper$getParamInitValue, param, 0)));
					var default_values = $elm$core$Array$fromList(
						A2(
							$elm$core$List$repeat,
							batch_count,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Maybe$Nothing,
								A2($elm$core$Array$get, 0, param.es))));
					return _Utils_update(
						param,
						{es: default_values, f2: values});
				} else {
					return param;
				}
			},
			item.gH);
		return _Utils_update(
			item,
			{gH: new_execution_params});
	});
var $author$project$Run$ItemHelper$execParamsPerBatch = function (item) {
	return A2(
		$elm$core$List$filter,
		function ($) {
			return $.hz;
		},
		item.gH);
};
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Helper$replaceOldElemWithNewElem = F3(
	function (old_elem, new_elem, list) {
		var elem_index = A2($author$project$Helper$elemIndex, old_elem, list);
		return A3($elm_community$list_extra$List$Extra$setAt, elem_index, new_elem, list);
	});
var $author$project$Common$showModal = F2(
	function (model, modal) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bk: modal}),
			$author$project$Ports$modalOpen(true));
	});
var $author$project$Run$Main$editItem = F2(
	function (model, item) {
		var no_batch_values = A2(
			$elm$core$List$all,
			function (param) {
				return _Utils_eq(
					param.f2,
					$author$project$Run$ItemHelper$getParamInitValues(param));
			},
			$author$project$Run$ItemHelper$execParamsPerBatch(item));
		var new_item = no_batch_values ? A2($author$project$Run$ItemHelper$correctBatchCount, model, item) : item;
		var new_items = _Utils_eq(new_item, item) ? model.dz : A3($author$project$Helper$replaceOldElemWithNewElem, item, new_item, model.dz);
		var new_model = _Utils_update(
			model,
			{
				aR: $elm$core$Maybe$Just(item),
				P: $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-item-planning-edit'),
				dz: new_items
			});
		var _v0 = A2(
			$author$project$Common$showModal,
			new_model,
			$author$project$Types$ItemModal(new_item));
		var final_model = _v0.a;
		var actions = _v0.b;
		var final_actions = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					actions,
					A2(
					$elm$core$Task$attempt,
					function (_v1) {
						return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
					},
					A3(
						$ursi$elm_scroll$Scroll$scrollY,
						'item-' + $elm$core$String$fromInt(item.an),
						0.5,
						0))
				]));
		return _Utils_Tuple2(final_model, final_actions);
	});
var $elm$file$File$Select$files = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				var f = _v0.a;
				var fs = _v0.b;
				return A2(toMsg, f, fs);
			},
			_File_uploadOneOrMore(mimes));
	});
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.h0, posixMinutes) < 0) {
					return posixMinutes + era.b;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		ep: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		e6: month,
		f5: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ep;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).e6;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).f5;
	});
var $author$project$Helper$twoDigits = function (i) {
	return _Utils_ap(
		(i < 10) ? '0' : '',
		$elm$core$String$fromInt(i));
};
var $author$project$Helper$formatDateTime = F2(
	function (zone, time) {
		var time_str = $author$project$Helper$twoDigits(
			A2($elm$time$Time$toHour, zone, time)) + (':' + $author$project$Helper$twoDigits(
			A2($elm$time$Time$toMinute, zone, time)));
		var month = function () {
			var _v0 = A2($elm$time$Time$toMonth, zone, time);
			switch (_v0) {
				case 0:
					return 1;
				case 1:
					return 2;
				case 2:
					return 3;
				case 3:
					return 4;
				case 4:
					return 5;
				case 5:
					return 6;
				case 6:
					return 7;
				case 7:
					return 8;
				case 8:
					return 9;
				case 9:
					return 10;
				case 10:
					return 11;
				default:
					return 12;
			}
		}();
		var date_str = $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time)) + ('-' + ($author$project$Helper$twoDigits(month) + ('-' + $author$project$Helper$twoDigits(
			A2($elm$time$Time$toDay, zone, time)))));
		return _Utils_Tuple2(date_str, time_str);
	});
var $author$project$Run$ItemHelper$getGroupAttrsOrNew = F2(
	function (item, group_id) {
		var _v0 = A2($elm$core$Dict$get, group_id, item.gR);
		if (_v0.$ === 1) {
			return A6($author$project$Types$GroupAttrs, group_id, 0, '', 0, 0, '');
		} else {
			var ga = _v0.a;
			return ga;
		}
	});
var $author$project$Helper$getProcessCategory = function (process) {
	var _v0 = A2($elm$core$String$split, ':', process.dG);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var main = _v0.a;
		var _v1 = _v0.b;
		var sub = _v1.a;
		var _v2 = _v1.b;
		return _Utils_Tuple2(main, sub);
	} else {
		return _Utils_Tuple2('', '');
	}
};
var $author$project$Helper$groupChanged = F2(
	function (group, groups) {
		var _v0 = A2(
			$author$project$Helper$getRecordById,
			groups,
			$elm$core$Maybe$Just(group.an));
		if (_v0.$ === 1) {
			return false;
		} else {
			var old_group = _v0.a;
			return !_Utils_eq(group, old_group);
		}
	});
var $author$project$Run$ItemHelper$hasDoneReservation = function (item) {
	var _v0 = item.hN;
	if (_v0.$ === 1) {
		return false;
	} else {
		var res = _v0.a;
		return res.h1 === 'done';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Id = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$id = function (id_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Id(id_);
};
var $author$project$Helper$getRecordByName = F2(
	function (records, name) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (r) {
					return _Utils_eq(r.dG, name);
				},
				records));
	});
var $author$project$Run$ItemHelper$updateParam = F3(
	function (name, value, params) {
		var _v0 = A2($author$project$Helper$getRecordByName, params, name);
		if (_v0.$ === 1) {
			return params;
		} else {
			var param = _v0.a;
			var new_param = _Utils_update(
				param,
				{
					f2: $elm$core$Array$fromList(
						_List_fromArray(
							[value]))
				});
			return A3($author$project$Helper$replaceOldElemWithNewElem, param, new_param, params);
		}
	});
var $author$project$Run$ItemHelper$initOperatorAndDayParams = F3(
	function (model, item, time) {
		if (item.h1 === 1) {
			var operator = model.a9.gq;
			var operator_fullname = operator.gP + (' ' + operator.hb);
			var _v0 = function () {
				var _v1 = model.h6;
				if (_v1.$ === 1) {
					return _Utils_Tuple2('', '');
				} else {
					var zone = _v1.a;
					return A2($author$project$Helper$formatDateTime, zone, time);
				}
			}();
			var current_date = _v0.a;
			var current_time = _v0.b;
			return A3(
				$author$project$Run$ItemHelper$updateParam,
				'Prozessstart',
				current_time,
				A3(
					$author$project$Run$ItemHelper$updateParam,
					'Tag',
					current_date,
					A3($author$project$Run$ItemHelper$updateParam, 'Operator', operator_fullname, item.gH)));
		} else {
			return item.gH;
		}
	});
var $author$project$Helper$insertGroupAfter = F3(
	function (g0, g1, groups) {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$findIndex,
			function (x) {
				return _Utils_eq(x.an, g0.an);
			},
			groups);
		if (_v0.$ === 1) {
			return _Utils_ap(
				groups,
				_List_fromArray(
					[g1]));
		} else {
			var n = _v0.a;
			return _Utils_ap(
				A2($elm$core$List$take, n + 1, groups),
				_Utils_ap(
					_List_fromArray(
						[g1]),
					A2($elm$core$List$drop, n + 1, groups)));
		}
	});
var $author$project$Helper$insertManyAt = F3(
	function (index, elements, list) {
		return _Utils_ap(
			A2($elm$core$List$take, index, list),
			_Utils_ap(
				elements,
				A2($elm$core$List$drop, index, list)));
	});
var $author$project$Run$ItemHelper$isGroupUsed = F2(
	function (items, group) {
		return A2(
			$elm$core$List$any,
			$elm$core$List$member(group.an),
			A2(
				$elm$core$List$map,
				function ($) {
					return $.gS;
				},
				items));
	});
var $author$project$Helper$aget = F2(
	function (num, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Array$get, num, array));
	});
var $author$project$Run$ItemHelper$isParamEmpty = F2(
	function (params, name) {
		var _v0 = A2($author$project$Helper$getRecordByName, params, name);
		if (_v0.$ === 1) {
			return true;
		} else {
			var p = _v0.a;
			return A2($author$project$Helper$aget, 0, p.f2) === '';
		}
	});
var $author$project$Run$ItemHelper$isStopParamEmpty = function (item) {
	return A2($author$project$Run$ItemHelper$isParamEmpty, item.gH, 'Prozessende');
};
var $elm$core$String$lines = _String_lines;
var $author$project$Helper$listToggle = F2(
	function (elem, list) {
		return A2($elm$core$List$member, elem, list) ? A2(
			$elm$core$List$filter,
			function (e) {
				return !_Utils_eq(e, elem);
			},
			list) : _Utils_ap(
			list,
			_List_fromArray(
				[elem]));
	});
var $author$project$Helper$intersectLists = F2(
	function (list1, list2) {
		return A2(
			$elm$core$List$filter,
			function (el) {
				return A2($elm$core$List$member, el, list2);
			},
			list1);
	});
var $author$project$Run$ItemHelper$machineIdsForProcess = F2(
	function (machine_process_mappings, process_id) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.hh;
			},
			A2(
				$elm$core$List$filter,
				function (mpm) {
					return _Utils_eq(mpm.hD, process_id);
				},
				machine_process_mappings));
	});
var $author$project$Run$ItemHelper$machineIdsForProcessAndRecipe = F4(
	function (machine_process_mappings, machine_process_recipe_mappings, process_id, recipe_id) {
		var _v0 = A2($author$project$Run$ItemHelper$machineIdsForProcess, machine_process_mappings, process_id);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var ids = _v0;
			if (recipe_id.$ === 1) {
				return ids;
			} else {
				var rid = recipe_id.a;
				return A2(
					$author$project$Helper$intersectLists,
					ids,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.hh;
						},
						A2(
							$elm$core$List$filter,
							function (mprm) {
								return _Utils_eq(mprm.hM, rid) && _Utils_eq(mprm.hD, process_id);
							},
							machine_process_recipe_mappings)));
			}
		}
	});
var $author$project$Types$UpdateItemExecParamValue = F4(
	function (a, b, c, d) {
		return {$: 37, a: a, b: b, c: c, d: d};
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$Helper$onChange = function (msgCreator) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, msgCreator, $elm$html$Html$Events$targetValue));
};
var $author$project$Helper$passValueToRunMsg = function (run_msg) {
	return function (value) {
		return $author$project$Types$GotRunMsg(
			run_msg(value));
	};
};
var $author$project$Common$showPopup = F2(
	function (model, modal) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cI: modal}),
			$author$project$Ports$modalOpen(true));
	});
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Run$View$ExecutionParamsEdit$makeExecStartModal = F2(
	function (model, item) {
		var _v0 = A2($author$project$Helper$getRecordByName, item.gH, 'Prozessstart');
		if (_v0.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dq: $elm$core$Maybe$Just(
							_Utils_Tuple2(
								_List_fromArray(
									['Prozessstart-Parameter nicht gefunden!']),
								false))
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var param = _v0.a;
			var update_function = $author$project$Helper$passValueToRunMsg(
				A3($author$project$Types$UpdateItemExecParamValue, item, param.an, 0));
			var title = 'Startzeit der Durchführung';
			var content = A2(
				$author$project$Types$Modal,
				title,
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							A2($author$project$Helper$aget, 0, param.f2)),
							$author$project$Helper$onChange(update_function),
							$elm$html$Html$Attributes$type_('time'),
							$elm$html$Html$Attributes$class('form-control form-control-sm'),
							A2($elm$html$Html$Attributes$attribute, 'pattern', '^[0-2]?\\d:[0-5]?\\d?$')
						]),
					_List_Nil));
			return A2(
				$author$project$Common$showPopup,
				model,
				A2(
					$author$project$Types$SmallPopup,
					content,
					$author$project$Types$GotCommonMsg($author$project$Types$PopupCancel)));
		}
	});
var $author$project$Types$UpdateItemRating = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Attrs = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$attrs = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$Attrs = function (a) {
	return {$: 8, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Radio$Attrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$Checked = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$checked = function (isCheck) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Radio$Checked(isCheck);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$Radio = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$createAdvanced = F2(
	function (options, label_) {
		return {eZ: label_, hs: options};
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $rundis$elm_bootstrap$Bootstrap$Form$applyModifier = F2(
	function (modifier, options) {
		var value = modifier;
		return _Utils_update(
			options,
			{
				bN: _Utils_ap(options.bN, value)
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Form$defaultOptions = {bN: _List_Nil};
var $rundis$elm_bootstrap$Bootstrap$Form$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-group')
			]),
		options.bN);
};
var $rundis$elm_bootstrap$Bootstrap$Form$group = F2(
	function (options, children) {
		return A2(
			$elm$html$Html$div,
			$rundis$elm_bootstrap$Bootstrap$Form$toAttributes(options),
			children);
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$Id = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$id = function (theId) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Radio$Id(theId);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$Label = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$label = F2(
	function (attributes, children) {
		return {bN: attributes, gi: children};
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$OnClick = function (a) {
	return {$: 4, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$onClick = function (toMsg) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Radio$OnClick(toMsg);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$addOption = F2(
	function (opt, _v0) {
		var radio_ = _v0;
		var options = radio_.hs;
		return _Utils_update(
			radio_,
			{
				hs: A2($elm$core$List$cons, opt, options)
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$Name = function (a) {
	return {$: 3, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$name = function (name_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Radio$Name(name_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var val = modifier.a;
				return _Utils_update(
					options,
					{
						an: $elm$core$Maybe$Just(val)
					});
			case 1:
				var val = modifier.a;
				return _Utils_update(
					options,
					{bV: val});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{
						dG: $elm$core$Maybe$Just(val)
					});
			case 2:
				return _Utils_update(
					options,
					{bd: true});
			case 4:
				var toMsg = modifier.a;
				return _Utils_update(
					options,
					{
						cw: $elm$core$Maybe$Just(toMsg)
					});
			case 5:
				return _Utils_update(
					options,
					{w: true});
			case 6:
				var val = modifier.a;
				return _Utils_update(
					options,
					{b2: val});
			case 7:
				var validation = modifier.a;
				return _Utils_update(
					options,
					{
						db: $elm$core$Maybe$Just(validation)
					});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs_)
					});
		}
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$defaultOptions = {bN: _List_Nil, bV: false, w: false, b2: false, an: $elm$core$Maybe$Nothing, bd: false, dG: $elm$core$Maybe$Nothing, cw: $elm$core$Maybe$Nothing, db: $elm$core$Maybe$Nothing};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$toAttributes = function (options) {
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-check-input', !options.w),
						_Utils_Tuple2('custom-control-input', options.w)
					])),
				$elm$html$Html$Attributes$type_('radio'),
				$elm$html$Html$Attributes$disabled(options.b2),
				$elm$html$Html$Attributes$checked(options.bV)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, options.cw),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$name, options.dG),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, options.an)
					])),
			options.bN));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$view = function (_v0) {
	var radio_ = _v0;
	var opts = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$Radio$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$Radio$defaultOptions, radio_.hs);
	var _v1 = radio_.eZ;
	var label_ = _v1;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-check', !opts.w),
						_Utils_Tuple2('form-check-inline', (!opts.w) && opts.bd),
						_Utils_Tuple2('custom-control', opts.w),
						_Utils_Tuple2('custom-radio', opts.w),
						_Utils_Tuple2('custom-control-inline', opts.bd && opts.w)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				$rundis$elm_bootstrap$Bootstrap$Form$Radio$toAttributes(opts),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_Utils_ap(
					label_.bN,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('form-check-label', !opts.w),
										_Utils_Tuple2('custom-control-label', opts.w)
									]))
							]),
						function () {
							var _v2 = opts.an;
							if (!_v2.$) {
								var v = _v2.a;
								return _List_fromArray(
									[
										$elm$html$Html$Attributes$for(v)
									]);
							} else {
								return _List_Nil;
							}
						}())),
				label_.gi)
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Radio$radioList = F2(
	function (groupName, radios) {
		return A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				$rundis$elm_bootstrap$Bootstrap$Form$Radio$view,
				$rundis$elm_bootstrap$Bootstrap$Form$Radio$addOption(
					$rundis$elm_bootstrap$Bootstrap$Form$Radio$name(groupName))),
			radios);
	});
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Run$View$ExecutionParamsEdit$makeExecStopModal = F2(
	function (model, item) {
		var _v0 = A2($author$project$Helper$getRecordByName, item.gH, 'Prozessende');
		if (_v0.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dq: $elm$core$Maybe$Just(
							_Utils_Tuple2(
								_List_fromArray(
									['Start-Parameter nicht gefunden!']),
								false))
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var param = _v0.a;
			var update_stop_fct = $author$project$Helper$passValueToRunMsg(
				A3($author$project$Types$UpdateItemExecParamValue, item, param.an, 0));
			var title = 'Endzeit der Durchführung';
			var options = _List_fromArray(
				[
					_Utils_Tuple3('good', 'Erfolgreich', 0),
					_Utils_Tuple3('medium', 'Kommentare beachten', 1),
					_Utils_Tuple3('bad', 'Fehlgeschlagen', 2)
				]);
			var content = A2(
				$author$project$Types$Modal,
				title,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									A2($author$project$Helper$aget, 0, param.f2)),
									$author$project$Helper$onChange(update_stop_fct),
									$elm$html$Html$Attributes$type_('time'),
									$elm$html$Html$Attributes$class('form-control form-control-sm')
								]),
							_List_Nil),
							A2(
							$rundis$elm_bootstrap$Bootstrap$Form$group,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Form$attrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-3 item-rating')
										]))
								]),
							A2(
								$rundis$elm_bootstrap$Bootstrap$Form$Radio$radioList,
								'item-rating',
								A2(
									$elm$core$List$map,
									function (_v1) {
										var class_ = _v1.a;
										var caption = _v1.b;
										var rating = _v1.c;
										var checked = _Utils_eq(
											$elm$core$Maybe$Just(rating),
											item.hJ);
										return A2(
											$rundis$elm_bootstrap$Bootstrap$Form$Radio$createAdvanced,
											_List_fromArray(
												[
													$rundis$elm_bootstrap$Bootstrap$Form$Radio$attrs(
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(class_)
														])),
													$rundis$elm_bootstrap$Bootstrap$Form$Radio$id('item-rating-' + class_),
													$rundis$elm_bootstrap$Bootstrap$Form$Radio$onClick(
													$author$project$Types$GotRunMsg(
														A2($author$project$Types$UpdateItemRating, item, rating))),
													$rundis$elm_bootstrap$Bootstrap$Form$Radio$checked(checked)
												]),
											A2(
												$rundis$elm_bootstrap$Bootstrap$Form$Radio$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class(class_)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(caption)
													])));
									},
									options)))
						])));
			return A2(
				$author$project$Common$showPopup,
				model,
				A2(
					$author$project$Types$SmallPopup,
					content,
					$author$project$Types$GotCommonMsg($author$project$Types$PopupCancel)));
		}
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Run$ItemHelper$extractIntPartRec = F2(
	function (string, extracted_int) {
		extractIntPartRec:
		while (true) {
			var right = A2($elm$core$String$right, 1, string);
			var _v0 = $elm$core$String$toInt(right);
			if (_v0.$ === 1) {
				return _Utils_Tuple2(
					$elm$core$String$trim(string),
					extracted_int);
			} else {
				var i = _v0.a;
				var $temp$string = A2($elm$core$String$dropRight, 1, string),
					$temp$extracted_int = _Utils_ap(right, extracted_int);
				string = $temp$string;
				extracted_int = $temp$extracted_int;
				continue extractIntPartRec;
			}
		}
	});
var $author$project$Run$ItemHelper$extractIntPart = function (stringWithNumber) {
	return A2($author$project$Run$ItemHelper$extractIntPartRec, stringWithNumber, '');
};
var $author$project$Run$ItemHelper$newGroupName_ = F2(
	function (spacer, old_name) {
		var _v0 = $author$project$Run$ItemHelper$extractIntPart(old_name);
		var basename = _v0.a;
		var int_part = _v0.b;
		var new_number = $elm$core$String$fromInt(
			1 + A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(int_part)));
		return _Utils_ap(
			basename,
			_Utils_ap(spacer, new_number));
	});
var $author$project$Run$ItemHelper$newGroupName = function (old_name) {
	return A2($author$project$Run$ItemHelper$newGroupName_, ' ', old_name);
};
var $author$project$Run$ItemHelper$newGroupShortname = function (old_name) {
	return A2($author$project$Run$ItemHelper$newGroupName_, '', old_name);
};
var $author$project$Run$Main$newHistoryIf = F4(
	function (changed, history, groups, items) {
		return changed ? A3($author$project$Run$Main$newHistory, history, groups, items) : history;
	});
var $author$project$Helper$oneOrNothing = function (list) {
	return ($elm$core$List$length(list) === 1) ? $elm$core$List$head(list) : $elm$core$Maybe$Nothing;
};
var $author$project$Run$ItemHelper$recipeIdsForProcessAndMachine = F4(
	function (machine_process_mappings, machine_process_recipe_mappings, process_id, machine_id) {
		if (machine_id.$ === 1) {
			return _List_Nil;
		} else {
			var m_id = machine_id.a;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.hM;
				},
				A2(
					$elm$core$List$filter,
					function (mprm) {
						return _Utils_eq(mprm.hh, m_id) && _Utils_eq(mprm.hD, process_id);
					},
					machine_process_recipe_mappings));
		}
	});
var $author$project$Run$ItemHelper$newItem = F2(
	function (model, process_id) {
		var machine_id = $author$project$Helper$oneOrNothing(
			A2($author$project$Run$ItemHelper$machineIdsForProcess, model.dB, process_id));
		var recipe_id = $author$project$Helper$oneOrNothing(
			A4($author$project$Run$ItemHelper$recipeIdsForProcessAndMachine, model.dB, model.dC, process_id, machine_id));
		var _v0 = A4($author$project$Run$ItemHelper$initParams, model, process_id, machine_id, recipe_id);
		var planning_params = _v0.a;
		var execution_params = _v0.b;
		return {
			gd: false,
			gl: '',
			gF: 60,
			gH: execution_params,
			gK: _List_Nil,
			gR: $elm$core$Dict$empty,
			gS: _List_Nil,
			gY: false,
			gZ: false,
			an: $author$project$Helper$nextId(model.dz),
			g4: '',
			g5: model.a9.fz !== 'new',
			hc: $elm$core$Maybe$Nothing,
			hh: machine_id,
			cy: '',
			ht: $elm$core$Maybe$Nothing,
			hy: false,
			hA: planning_params,
			hD: process_id,
			hE: $elm$core$Maybe$Nothing,
			hI: $elm$core$Maybe$Nothing,
			hJ: $elm$core$Maybe$Nothing,
			hL: '',
			hM: recipe_id,
			hN: $elm$core$Maybe$Nothing,
			hO: $elm$core$Maybe$Nothing,
			hP: '',
			bp: model.a9.an,
			hY: false,
			h1: 0,
			h7: '',
			fV: $elm$core$Maybe$Nothing,
			ib: model.a9.gq,
			d1: _List_Nil
		};
	});
var $author$project$Run$Main$nextItemsQueue = F3(
	function (model, lock_version, other_actions) {
		return A2(
			$author$project$Run$Main$processItemsQueue,
			_Utils_update(
				model,
				{di: false, dq: $elm$core$Maybe$Nothing, he: lock_version, dT: false}),
			other_actions);
	});
var $author$project$Run$Main$nextOrRetryItemsQueue = function (model) {
	return A3($author$project$Run$Main$nextItemsQueue, model, model.he, _List_Nil);
};
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Helper$oneOrNothingIfNot = F2(
	function (element, list) {
		if (element.$ === 1) {
			return $author$project$Helper$oneOrNothing(list);
		} else {
			var e = element.a;
			return $elm$core$Maybe$Just(e);
		}
	});
var $author$project$Ports$openMaterialLot = _Platform_outgoingPort('openMaterialLot', $elm$json$Json$Encode$string);
var $author$project$Run$Main$parseWaferCount = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toInt,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$withDefault(0),
		$elm$core$Basics$max(0)));
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Run$ItemHelper$possiblyInitOriginalValues = function (item) {
	var already_initialised = function () {
		var _v0 = $elm$core$List$head(item.hA);
		if (_v0.$ === 1) {
			return true;
		} else {
			var param = _v0.a;
			return !_Utils_eq(param.hv, $elm$core$Maybe$Nothing);
		}
	}();
	if (already_initialised) {
		return item;
	} else {
		var new_planning_params = A2(
			$elm$core$List$map,
			function (param) {
				return _Utils_update(
					param,
					{
						hu: $elm$core$Maybe$Just(param.gT),
						hv: $elm$core$Maybe$Just(param.f2)
					});
			},
			item.hA);
		return _Utils_update(
			item,
			{
				ht: $elm$core$Maybe$Just(item.gR),
				hA: new_planning_params
			});
	}
};
var $author$project$Types$ValidationError = F4(
	function (param_id, group_id, index, message) {
		return {eH: group_id, g1: index, e3: message, hw: param_id};
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {g1: index, hi: match, hn: number, h3: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{gf: false, hl: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Run$ItemHelper$validateWithRegex = F6(
	function (param_id, group_id, index, value, regex_string, message) {
		var regex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString(regex_string));
		return A2($elm$regex$Regex$contains, regex, value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A4($author$project$Types$ValidationError, param_id, group_id, index, message));
	});
var $author$project$Run$ItemHelper$validateValue = F4(
	function (param, group_id, index, value) {
		if (value === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = param.f1;
			switch (_v0) {
				case 'integer':
					return A6($author$project$Run$ItemHelper$validateWithRegex, param.an, group_id, index, value, '^[-+]?\\d+$', 'Nur Zahlen erlaubt');
				case 'float':
					return A6($author$project$Run$ItemHelper$validateWithRegex, param.an, group_id, index, value, '^[-+]?\\d*[.,]?\\d+$', 'Nur Zahlen und Komma (oder Punkt) erlaubt');
				case 'duration':
					return A6($author$project$Run$ItemHelper$validateWithRegex, param.an, group_id, index, value, '^\\d+:[0-5]?\\d(:[0-5]?\\d)?$', 'Format HHH:MM:SS');
				default:
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Run$ItemHelper$validateItem = function (item) {
	var validation_errors = $elm_community$maybe_extra$Maybe$Extra$values(
		$elm$core$List$concat(
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (p) {
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (index) {
									return A4(
										$author$project$Run$ItemHelper$validateValue,
										p,
										$elm$core$Maybe$Nothing,
										index,
										A2($author$project$Helper$aget, index, p.f2));
								},
								$author$project$Run$ItemHelper$getValueIndexRange(p)),
							item.hy ? $elm$core$List$concat(
								A2(
									$elm$core$List$map,
									function (_v0) {
										var g_id = _v0.a;
										var values = _v0.b;
										return A2(
											$elm$core$List$map,
											function (index) {
												return A4(
													$author$project$Run$ItemHelper$validateValue,
													p,
													$elm$core$Maybe$Just(g_id),
													index,
													A2($author$project$Helper$aget, index, values));
											},
											$author$project$Run$ItemHelper$getValueIndexRange(p));
									},
									p.gT)) : _List_Nil);
					},
					item.hA),
				A2(
					$elm$core$List$map,
					function (p) {
						return A2(
							$elm$core$List$map,
							function (index) {
								return A4(
									$author$project$Run$ItemHelper$validateValue,
									p,
									$elm$core$Maybe$Nothing,
									index,
									A2($author$project$Helper$aget, index, p.f2));
							},
							$author$project$Run$ItemHelper$getValueIndexRange(p));
					},
					item.gH))));
	return _Utils_update(
		item,
		{d1: validation_errors});
};
var $author$project$Run$ItemHelper$isValid = function (item) {
	return $elm$core$List$isEmpty(
		$author$project$Run$ItemHelper$validateItem(item).d1);
};
var $owanturist$elm_queue$Queue$fromListReverser = F2(
	function (el, _v0) {
		var count = _v0.a;
		var acc = _v0.b;
		return _Utils_Tuple2(
			count + 1,
			A2($elm$core$List$cons, el, acc));
	});
var $owanturist$elm_queue$Queue$fromList = function (list) {
	var _v0 = A3(
		$elm$core$List$foldl,
		$owanturist$elm_queue$Queue$fromListReverser,
		_Utils_Tuple2(0, _List_Nil),
		list);
	if (_v0.b.b) {
		var size = _v0.a;
		var _v1 = _v0.b;
		var peek = _v1.a;
		var output = _v1.b;
		return A5($owanturist$elm_queue$Queue$Queue, peek, 0, size - 1, _List_Nil, output);
	} else {
		return $owanturist$elm_queue$Queue$Empty;
	}
};
var $owanturist$elm_queue$Queue$foldr = F3(
	function (fn, acc, queue) {
		if (!queue.$) {
			return acc;
		} else {
			var peek = queue.a;
			var input = queue.d;
			var output = queue.e;
			return A3(
				$elm$core$List$foldr,
				fn,
				A3(
					$elm$core$List$foldl,
					fn,
					A2(fn, peek, acc),
					output),
				input);
		}
	});
var $owanturist$elm_queue$Queue$toList = function (queue) {
	return A3($owanturist$elm_queue$Queue$foldr, $elm$core$List$cons, _List_Nil, queue);
};
var $author$project$Api$updateItemEncoder = F2(
	function (item, lock_version) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'abstract_run',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'items',
								A2(
									$elm$json$Json$Encode$list,
									$author$project$Api$itemEncoder,
									_List_fromArray(
										[item]))),
								_Utils_Tuple2(
								'lock_version',
								$elm$json$Json$Encode$int(lock_version))
							])))
				]));
	});
var $author$project$Api$updateItem = F4(
	function (endpoint, csrf_token, item, lock_version) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$request(
				{
					E: $elm$http$Http$jsonBody(
						A2($author$project$Api$updateItemEncoder, item, lock_version)),
					q: A2(
						$author$project$Api$expectJsonOrError,
						$author$project$Types$RunSavedReplaceItems,
						$elm$json$Json$Decode$list($author$project$Api$itemDecoder)),
					H: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-Token', csrf_token)
						]),
					I: 'PUT',
					M: $elm$core$Maybe$Nothing,
					N: $elm$core$Maybe$Nothing,
					t: endpoint + ('/' + $elm$core$String$fromInt(item.an))
				}));
	});
var $author$project$Types$ItemSavedReplaceInteractiveParams = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$updateItemAsync = F4(
	function (endpoint, csrf_token, item, lock_version) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$request(
				{
					E: $elm$http$Http$jsonBody(
						A2($author$project$Api$updateItemEncoder, item, lock_version)),
					q: A2(
						$author$project$Api$expectJsonOrError,
						$author$project$Types$ItemSavedReplaceInteractiveParams,
						$elm$json$Json$Decode$list($author$project$Api$itemDecoder)),
					H: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-Token', csrf_token)
						]),
					I: 'PUT',
					M: $elm$core$Maybe$Nothing,
					N: $elm$core$Maybe$Nothing,
					t: endpoint + ('/' + $elm$core$String$fromInt(item.an))
				}));
	});
var $author$project$Run$Main$updateItem = F4(
	function (api_reply, model, item, other_actions) {
		var new_model = _Utils_update(
			model,
			{
				aX: $owanturist$elm_queue$Queue$fromList(
					A2(
						$elm$core$List$filter,
						function (e) {
							return !_Utils_eq(e.an, item.an);
						},
						$owanturist$elm_queue$Queue$toList(model.aX)))
			});
		var api_action = function () {
			if (api_reply === 1) {
				return $author$project$Api$updateItemAsync;
			} else {
				return $author$project$Api$updateItem;
			}
		}();
		var new_action = A3(
			$author$project$Types$ItemQueueElem,
			item.an,
			api_reply,
			A3(api_action, model.a9.dp, model.a9.dl, item));
		return A3($author$project$Run$Main$enqueueItemsAction, new_model, new_action, other_actions);
	});
var $author$project$Run$Main$possiblySendItemChangeBase = F4(
	function (api_reply, item, model, close_modal) {
		var _v0 = A2(
			$author$project$Helper$getRecordById,
			model.dz,
			$elm$core$Maybe$Just(item.an));
		if (_v0.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						di: false,
						dq: $elm$core$Maybe$Just(
							_Utils_Tuple2(
								_List_fromArray(
									['Fehler: Zu sendender Prozessschritt nicht gefunden!']),
								false)),
						bk: $author$project$Types$NoneModal
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var old_item = _v0.a;
			var changed = !_Utils_eq(old_item, item);
			var new_items = changed ? A3($author$project$Helper$replaceOldElemWithNewElem, old_item, item, model.dz) : model.dz;
			var new_model = _Utils_update(
				model,
				{
					dz: new_items,
					bk: close_modal ? $author$project$Types$NoneModal : $author$project$Types$ItemModal(item)
				});
			var update_ok = changed && $author$project$Run$ItemHelper$isValid(item);
			return update_ok ? A4(
				$author$project$Run$Main$updateItem,
				api_reply,
				new_model,
				item,
				_List_fromArray(
					[
						$author$project$Ports$modalOpen(close_modal)
					])) : _Utils_Tuple2(
				new_model,
				$author$project$Ports$modalOpen(close_modal));
		}
	});
var $author$project$Run$Main$possiblySendItemChangeCloseModal = F2(
	function (item, model) {
		return A4($author$project$Run$Main$possiblySendItemChangeBase, 1, item, model, true);
	});
var $author$project$Run$Main$possiblySendItemChangeOpenModal = F3(
	function (api_reply, item, model) {
		return A4($author$project$Run$Main$possiblySendItemChangeBase, api_reply, item, model, false);
	});
var $author$project$Types$LoadWithdrawals = F3(
	function (a, b, c) {
		return {$: 55, a: a, b: b, c: c};
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $author$project$Api$refreshWithdrawals = F3(
	function (item_id, param_id, endpoint_base) {
		var endpoint = _Utils_ap(
			endpoint_base,
			$elm$url$Url$Builder$toQuery(
				_List_fromArray(
					[
						A2($elm$url$Url$Builder$int, 'item_id', item_id),
						A2($elm$url$Url$Builder$int, 'param_id', param_id)
					])));
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$get(
				{
					q: A2(
						$author$project$Api$expectJsonOrError,
						A2($author$project$Types$LoadWithdrawals, item_id, param_id),
						$elm$json$Json$Decode$list($author$project$Api$withdrawalDecoder)),
					t: endpoint
				}));
	});
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $author$project$Run$ItemHelper$replaceInteractiveValues = F2(
	function (old, _new) {
		var planning_params = A2(
			$elm$core$List$map,
			function (param) {
				var _v1 = param.f1;
				if (_v1 === 'interactive') {
					return A2(
						$elm$core$Maybe$withDefault,
						param,
						A2(
							$author$project$Helper$getRecordById,
							_new.hA,
							$elm$core$Maybe$Just(param.an)));
				} else {
					return param;
				}
			},
			old.hA);
		var execution_params = A2(
			$elm$core$List$map,
			function (param) {
				var _v0 = param.f1;
				if (_v0 === 'interactive') {
					return A2(
						$elm$core$Maybe$withDefault,
						param,
						A2(
							$author$project$Helper$getRecordById,
							_new.gH,
							$elm$core$Maybe$Just(param.an)));
				} else {
					return param;
				}
			},
			old.gH);
		return _Utils_update(
			old,
			{gH: execution_params, hA: planning_params});
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Rows = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$rows = function (rows_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Rows(rows_);
};
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$Api$sendItemFile = F5(
	function (model, item_id, caption, maybe_item_file, maybe_file) {
		var body = $elm$http$Http$multipartBody(
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$http$Http$stringPart,
						'run_item_file[run_item_id]',
						$elm$core$String$fromInt(item_id)),
						A2($elm$http$Http$stringPart, 'run_item_file[caption]', caption)
					]),
				function () {
					if (maybe_file.$ === 1) {
						return _List_Nil;
					} else {
						var file = maybe_file.a;
						return _List_fromArray(
							[
								A2($elm$http$Http$filePart, 'run_item_file[file]', file)
							]);
					}
				}()));
		var _v0 = function () {
			if (maybe_item_file.$ === 1) {
				return _Utils_Tuple2('POST', model.a9.gC);
			} else {
				var item_file = maybe_item_file.a;
				return _Utils_Tuple2('PUT', item_file.f0);
			}
		}();
		var method = _v0.a;
		var url = _v0.b;
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$request(
				{
					E: body,
					q: A2(
						$author$project$Api$expectJsonOrError,
						$author$project$Types$LoadItemFiles(item_id),
						$elm$json$Json$Decode$list($author$project$Api$itemFileDecoder)),
					H: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-Token', model.a9.dl)
						]),
					I: method,
					M: $elm$core$Maybe$Nothing,
					N: $elm$core$Maybe$Nothing,
					t: url
				}));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $author$project$Run$ItemHelper$updateWithdrawalsInProps = F2(
	function (props, withdrawals) {
		if (props.$ === 1) {
			var p = props.a;
			return $author$project$Types$MaterialParamProperties(
				_Utils_update(
					p,
					{dd: withdrawals}));
		} else {
			return props;
		}
	});
var $author$project$Run$ItemHelper$updateWithdrawals = F3(
	function (item, param_id, withdrawals) {
		var planning_params = A2(
			$elm$core$List$map,
			function (p) {
				return _Utils_eq(p.an, param_id) ? _Utils_update(
					p,
					{
						hF: A2($author$project$Run$ItemHelper$updateWithdrawalsInProps, p.hF, withdrawals)
					}) : p;
			},
			item.hA);
		var execution_params = A2(
			$elm$core$List$map,
			function (p) {
				return _Utils_eq(p.an, param_id) ? _Utils_update(
					p,
					{
						hF: A2($author$project$Run$ItemHelper$updateWithdrawalsInProps, p.hF, withdrawals)
					}) : p;
			},
			item.gH);
		return _Utils_update(
			item,
			{gH: execution_params, hA: planning_params});
	});
var $author$project$Run$Main$setWithdrawals = F4(
	function (model, item_id, param_id, withdrawals) {
		var _v0 = A2(
			$author$project$Helper$getRecordById,
			model.dz,
			$elm$core$Maybe$Just(item_id));
		if (_v0.$ === 1) {
			return model;
		} else {
			var item = _v0.a;
			var new_item = A3($author$project$Run$ItemHelper$updateWithdrawals, item, param_id, withdrawals);
			return _Utils_update(
				model,
				{
					dz: A3($author$project$Helper$replaceOldElemWithNewElem, item, new_item, model.dz),
					bk: $author$project$Types$ItemModal(new_item)
				});
		}
	});
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$Ports$showMaterialList = _Platform_outgoingPort(
	'showMaterialList',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'filter',
					$elm$json$Json$Encode$string($.gL)),
					_Utils_Tuple2(
					'group_id',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, $);
					}($.eH)),
					_Utils_Tuple2(
					'item_id',
					$elm$json$Json$Encode$int($.g7)),
					_Utils_Tuple2(
					'material_type_name',
					$elm$json$Json$Encode$string($.hj)),
					_Utils_Tuple2(
					'param_id',
					$elm$json$Json$Encode$int($.hw)),
					_Utils_Tuple2(
					'parameter_type',
					$elm$json$Json$Encode$string($.hx)),
					_Utils_Tuple2(
					'run_id',
					$elm$json$Json$Encode$int($.bp))
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Textarea = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$create = function (options) {
	return {hs: options};
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var id_ = modifier.a;
				return _Utils_update(
					options,
					{
						an: $elm$core$Maybe$Just(id_)
					});
			case 1:
				var rows_ = modifier.a;
				return _Utils_update(
					options,
					{
						hR: $elm$core$Maybe$Just(rows_)
					});
			case 2:
				return _Utils_update(
					options,
					{b2: true});
			case 3:
				var value_ = modifier.a;
				return _Utils_update(
					options,
					{
						id: $elm$core$Maybe$Just(value_)
					});
			case 4:
				var onInput_ = modifier.a;
				return _Utils_update(
					options,
					{
						cx: $elm$core$Maybe$Just(onInput_)
					});
			case 5:
				var validation = modifier.a;
				return _Utils_update(
					options,
					{
						db: $elm$core$Maybe$Just(validation)
					});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$defaultOptions = {bN: _List_Nil, b2: false, an: $elm$core$Maybe$Nothing, cx: $elm$core$Maybe$Nothing, hR: $elm$core$Maybe$Nothing, db: $elm$core$Maybe$Nothing, id: $elm$core$Maybe$Nothing};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $rundis$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString = function (validation) {
	if (!validation) {
		return 'is-valid';
	} else {
		return 'is-invalid';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$validationAttribute = function (validation) {
	return $elm$html$Html$Attributes$class(
		$rundis$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(validation));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-control'),
				$elm$html$Html$Attributes$disabled(options.b2)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, options.an),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$rows, options.hR),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$value, options.id),
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, options.cx),
						A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$validationAttribute, options.db)
					])),
			options.bN));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$view = function (_v0) {
	var options = _v0.hs;
	return A2(
		$elm$html$Html$textarea,
		$rundis$elm_bootstrap$Bootstrap$Form$Textarea$toAttributes(options),
		_List_Nil);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$textarea = A2($elm$core$Basics$composeL, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$view, $rundis$elm_bootstrap$Bootstrap$Form$Textarea$create);
var $commonmind$elm_csv_encode$Csv$Encode$defaultSettings = {de: true, b0: ','};
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $commonmind$elm_csv_encode$Csv$Encode$crlf = $elm$bytes$Bytes$Encode$string('\u000D\n');
var $commonmind$elm_csv_encode$Csv$Encode$escapeString = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split('\"'),
	$elm$core$String$join('\"\"'));
var $commonmind$elm_csv_encode$Csv$Encode$formatField = F2(
	function (_v0, s) {
		var alwaysQuoted = _v0.de;
		var delimiter = _v0.b0;
		return (alwaysQuoted || A2($elm$core$String$contains, delimiter, s)) ? ('\"' + ($commonmind$elm_csv_encode$Csv$Encode$escapeString(s) + '\"')) : $commonmind$elm_csv_encode$Csv$Encode$escapeString(s);
	});
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $commonmind$elm_csv_encode$Csv$Encode$formatRow = function (setts) {
	var delimiter = setts.b0;
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			$commonmind$elm_csv_encode$Csv$Encode$formatField(setts)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$intersperse(delimiter),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map($elm$bytes$Bytes$Encode$string),
				$elm$bytes$Bytes$Encode$sequence)));
};
var $commonmind$elm_csv_encode$Csv$Encode$formatLines = function (setts) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			$commonmind$elm_csv_encode$Csv$Encode$formatRow(setts)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$intersperse($commonmind$elm_csv_encode$Csv$Encode$crlf),
			$elm$bytes$Bytes$Encode$sequence));
};
var $commonmind$elm_csv_encode$Csv$Encode$toEncoderWith = F2(
	function (setts, _v0) {
		var headers = _v0.H;
		var records = _v0.fr;
		return $elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					A2(
					$commonmind$elm_csv_encode$Csv$Encode$formatLines,
					setts,
					A2($elm$core$List$cons, headers, records)),
					$commonmind$elm_csv_encode$Csv$Encode$crlf
				]));
	});
var $commonmind$elm_csv_encode$Csv$Encode$toBytesWith = function (setts) {
	return A2(
		$elm$core$Basics$composeR,
		$commonmind$elm_csv_encode$Csv$Encode$toEncoderWith(setts),
		$elm$bytes$Bytes$Encode$encode);
};
var $commonmind$elm_csv_encode$Csv$Encode$toBytes = $commonmind$elm_csv_encode$Csv$Encode$toBytesWith($commonmind$elm_csv_encode$Csv$Encode$defaultSettings);
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $author$project$Run$Main$togglePlanningParamChecked = F4(
	function (item, group_ids, index, param) {
		var new_planning_param = function () {
			if (!group_ids.b) {
				var old_checked = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Array$get, index, param.ie));
				var values_checked = A3($elm$core$Array$set, index, !old_checked, param.ie);
				return _Utils_update(
					param,
					{ie: values_checked});
			} else {
				var first_group_id = group_ids.a;
				var old_values = A2(
					$elm$core$Maybe$withDefault,
					A2(
						$elm$core$Array$repeat,
						$elm$core$Array$length(param.es),
						false),
					$elm$core$List$head(
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$second,
							A2(
								$elm$core$List$filter,
								function (kv) {
									return _Utils_eq(kv.a, first_group_id);
								},
								param.gU))));
				var old_checked = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Array$get, index, old_values));
				var new_values = A3($elm$core$Array$set, index, !old_checked, old_values);
				var group_values_checked = _Utils_ap(
					A2(
						$elm$core$List$map,
						function (g_id) {
							return _Utils_Tuple2(g_id, new_values);
						},
						group_ids),
					A2(
						$elm_community$list_extra$List$Extra$filterNot,
						function (_v1) {
							var id = _v1.a;
							return A2($elm$core$List$member, id, group_ids);
						},
						param.gU));
				return _Utils_update(
					param,
					{gU: group_values_checked});
			}
		}();
		var new_planning_params = A3($author$project$Helper$replaceOldElemWithNewElem, param, new_planning_param, item.hA);
		return _Utils_update(
			item,
			{hA: new_planning_params});
	});
var $author$project$Run$Main$updateGroup = F3(
	function (group, attr, new_value) {
		switch (attr) {
			case 'shortname':
				return _Utils_update(
					group,
					{hX: new_value});
			case 'name':
				return _Utils_update(
					group,
					{dG: new_value});
			case 'wafer_count':
				return _Utils_update(
					group,
					{
						ih: $author$project$Run$Main$parseWaferCount(new_value)
					});
			case 'wafer_labels':
				return _Utils_update(
					group,
					{ii: new_value});
			default:
				return group;
		}
	});
var $author$project$Run$Main$updateGroupAttr = F4(
	function (item, group_id, group_attr_field, value) {
		var old_group_attrs = A2($author$project$Run$ItemHelper$getGroupAttrsOrNew, item, group_id);
		var new_group_attrs = function () {
			switch (group_attr_field) {
				case 0:
					return _Utils_update(
						old_group_attrs,
						{
							gt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(value))
						});
				case 1:
					return _Utils_update(
						old_group_attrs,
						{gu: value});
				case 2:
					return _Utils_update(
						old_group_attrs,
						{
							gv: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(value))
						});
				case 3:
					return _Utils_update(
						old_group_attrs,
						{
							h8: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(value))
						});
				default:
					return _Utils_update(
						old_group_attrs,
						{cy: value});
			}
		}();
		var new_group_attr_list = A3($elm$core$Dict$insert, group_id, new_group_attrs, item.gR);
		return _Utils_update(
			item,
			{gR: new_group_attr_list});
	});
var $author$project$Api$groupEncoder = function (group) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(group.an)),
				_Utils_Tuple2(
				'shortname',
				$elm$json$Json$Encode$string(group.hX)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(group.dG)),
				_Utils_Tuple2(
				'wafer_count',
				$elm$json$Json$Encode$int(group.ih)),
				_Utils_Tuple2(
				'wafer_labels',
				$elm$json$Json$Encode$string(group.ii))
			]));
};
var $author$project$Api$groupsEncoder = F2(
	function (groups, lock_version) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'abstract_run',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'groups',
								A2($elm$json$Json$Encode$list, $author$project$Api$groupEncoder, groups)),
								_Utils_Tuple2(
								'lock_version',
								$elm$json$Json$Encode$int(lock_version))
							])))
				]));
	});
var $author$project$Api$updateGroups = F4(
	function (endpoint, csrf_token, groups, lock_version) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$request(
				{
					E: $elm$http$Http$jsonBody(
						A2($author$project$Api$groupsEncoder, groups, lock_version)),
					q: $author$project$Api$expectNothingOrError($author$project$Types$RunSaved),
					H: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-Token', csrf_token)
						]),
					I: 'PUT',
					M: $elm$core$Maybe$Nothing,
					N: $elm$core$Maybe$Nothing,
					t: endpoint
				}));
	});
var $author$project$Run$Main$updateGroups = F2(
	function (model, other_actions) {
		var new_action = A3(
			$author$project$Types$ItemQueueElem,
			-1,
			0,
			A3($author$project$Api$updateGroups, model.a9.gE, model.a9.dl, model.eI));
		return A3($author$project$Run$Main$enqueueItemsAction, model, new_action, other_actions);
	});
var $author$project$Api$groupsAndItemsEncoder = F3(
	function (groups, items, lock_version) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'abstract_run',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'groups',
								A2($elm$json$Json$Encode$list, $author$project$Api$groupEncoder, groups)),
								_Utils_Tuple2(
								'items',
								A2($elm$json$Json$Encode$list, $author$project$Api$itemEncoder, items)),
								_Utils_Tuple2(
								'lock_version',
								$elm$json$Json$Encode$int(lock_version))
							])))
				]));
	});
var $author$project$Api$updateGroupsAndItems = F5(
	function (endpoint, csrf_token, groups, items, lock_version) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$request(
				{
					E: $elm$http$Http$jsonBody(
						A3($author$project$Api$groupsAndItemsEncoder, groups, items, lock_version)),
					q: $author$project$Api$expectNothingOrError($author$project$Types$RunSaved),
					H: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-Token', csrf_token)
						]),
					I: 'PUT',
					M: $elm$core$Maybe$Nothing,
					N: $elm$core$Maybe$Nothing,
					t: endpoint
				}));
	});
var $author$project$Run$Main$updateGroupsAndItems = F2(
	function (model, other_actions) {
		var new_action = A3(
			$author$project$Types$ItemQueueElem,
			-1,
			0,
			A4($author$project$Api$updateGroupsAndItems, model.a9.gE, model.a9.dl, model.eI, model.dz));
		return A3($author$project$Run$Main$enqueueItemsAction, model, new_action, other_actions);
	});
var $author$project$Run$ItemHelper$updateProperties = F4(
	function (field, value, group_id, props) {
		if (!props.$) {
			return $author$project$Types$EmptyParamProperties;
		} else {
			var mprop = props.a;
			if (field === 'filters') {
				var filters = A2(
					$elm$core$List$filter,
					function (f) {
						return !_Utils_eq(f.eH, group_id);
					},
					mprop.gO);
				var new_filters = (value === '{}') ? filters : A2(
					$elm$core$List$cons,
					A2($author$project$Types$MaterialFilter, group_id, value),
					filters);
				return $author$project$Types$MaterialParamProperties(
					_Utils_update(
						mprop,
						{gO: new_filters}));
			} else {
				return $author$project$Types$MaterialParamProperties(mprop);
			}
		}
	});
var $author$project$Run$ItemHelper$updateItemParam = F6(
	function (params, id, group_id, field, pfield, value) {
		var _v0 = A2(
			$author$project$Helper$getRecordById,
			params,
			$elm$core$Maybe$Just(id));
		if (_v0.$ === 1) {
			return params;
		} else {
			var mparam = _v0.a;
			var new_param = function () {
				if (field === 'properties') {
					return _Utils_update(
						mparam,
						{
							hF: A4($author$project$Run$ItemHelper$updateProperties, pfield, value, group_id, mparam.hF)
						});
				} else {
					return mparam;
				}
			}();
			return A3($author$project$Helper$replaceOldElemWithNewElem, mparam, new_param, params);
		}
	});
var $author$project$Run$ItemHelper$updateItemParamProperty = F7(
	function (items, item_id, param_id, group_id, field, pfield, value) {
		var _v0 = A2(
			$author$project$Helper$getRecordById,
			items,
			$elm$core$Maybe$Just(item_id));
		if (_v0.$ === 1) {
			return items;
		} else {
			var item = _v0.a;
			var new_params = A6($author$project$Run$ItemHelper$updateItemParam, item.hA, param_id, group_id, field, pfield, value);
			var new_item = _Utils_update(
				item,
				{hA: new_params});
			return A3($author$project$Helper$replaceOldElemWithNewElem, item, new_item, items);
		}
	});
var $author$project$Api$updateItemsEncoder = F2(
	function (items, lock_version) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'abstract_run',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'items',
								A2($elm$json$Json$Encode$list, $author$project$Api$itemEncoder, items)),
								_Utils_Tuple2(
								'lock_version',
								$elm$json$Json$Encode$int(lock_version))
							])))
				]));
	});
var $author$project$Api$updateItems = F4(
	function (endpoint, csrf_token, items, lock_version) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Types$GotRunMsg,
			$elm$http$Http$request(
				{
					E: $elm$http$Http$jsonBody(
						A2($author$project$Api$updateItemsEncoder, items, lock_version)),
					q: $author$project$Api$expectNothingOrError($author$project$Types$RunSaved),
					H: _List_fromArray(
						[
							A2($elm$http$Http$header, 'X-CSRF-Token', csrf_token)
						]),
					I: 'PUT',
					M: $elm$core$Maybe$Nothing,
					N: $elm$core$Maybe$Nothing,
					t: endpoint
				}));
	});
var $author$project$Run$Main$updateItems = F2(
	function (model, other_actions) {
		var new_action = A3(
			$author$project$Types$ItemQueueElem,
			-1,
			0,
			A3($author$project$Api$updateItems, model.a9.gE, model.a9.dl, model.dz));
		return A3($author$project$Run$Main$enqueueItemsAction, model, new_action, other_actions);
	});
var $author$project$Helper$updateOrInsertGroup = F2(
	function (group, groups) {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$findIndex,
			function (x) {
				return _Utils_eq(x.an, group.an);
			},
			groups);
		if (_v0.$ === 1) {
			return _Utils_ap(
				groups,
				_List_fromArray(
					[group]));
		} else {
			var n = _v0.a;
			return _Utils_ap(
				A2($elm$core$List$take, n, groups),
				_Utils_ap(
					_List_fromArray(
						[group]),
					A2($elm$core$List$drop, n + 1, groups)));
		}
	});
var $author$project$Run$Main$updatePlanningParamValue = F5(
	function (item, group_id, index, param, value) {
		var new_planning_param = function () {
			if (group_id.$ === 1) {
				return _Utils_update(
					param,
					{
						f2: A3($elm$core$Array$set, index, value, param.f2)
					});
			} else {
				var g_id = group_id.a;
				var values = A3(
					$elm$core$Array$set,
					index,
					value,
					A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(
							g_id,
							A2(
								$elm$core$Array$repeat,
								$elm$core$Array$length(param.es),
								'')),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (kv) {
									return _Utils_eq(kv.a, g_id);
								},
								param.gT))).b);
				var group_values = A2(
					$elm$core$List$cons,
					_Utils_Tuple2(g_id, values),
					A2(
						$elm_community$list_extra$List$Extra$filterNot,
						function (v) {
							return _Utils_eq(v.a, g_id);
						},
						param.gT));
				return _Utils_update(
					param,
					{gT: group_values});
			}
		}();
		var new_planning_params = A3($author$project$Helper$replaceOldElemWithNewElem, param, new_planning_param, item.hA);
		return _Utils_update(
			item,
			{hA: new_planning_params});
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Value = function (a) {
	return {$: 3, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Textarea$value = function (value_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Textarea$Value(value_);
};
var $author$project$Run$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				if (!msg.a.$) {
					var saved = msg.a.a;
					return A3(
						$author$project$Run$Main$nextItemsQueue,
						model,
						model.he + (saved ? 1 : 0),
						_List_Nil);
				} else {
					var error = msg.a.a;
					return A3($author$project$Common$setError, model, error, true);
				}
			case 69:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						function (_v1) {
							return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
						},
						A3($ursi$elm_scroll$Scroll$scrollY, 'run-table-top', 0.05, 0)));
			case 70:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						function (_v2) {
							return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
						},
						A3($ursi$elm_scroll$Scroll$scrollY, 'run-table-bottom', 0, 0)));
			case 2:
				if (!msg.a.$) {
					var returned_items = msg.a.a;
					var new_modal = function () {
						var _v4 = _Utils_Tuple2(model.bk, returned_items);
						if (((!_v4.a.$) && _v4.b.b) && (!_v4.b.b.b)) {
							var _v5 = _v4.b;
							var item = _v5.a;
							return $author$project$Types$ItemModal(item);
						} else {
							return model.bk;
						}
					}();
					var new_items = A2(
						$elm$core$List$map,
						function (old_item) {
							var maybe_new_item = $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (i) {
										return _Utils_eq(i.an, old_item.an);
									},
									returned_items));
							if (maybe_new_item.$ === 1) {
								return old_item;
							} else {
								var item = maybe_new_item.a;
								return item;
							}
						},
						model.dz);
					var new_model = _Utils_update(
						model,
						{
							dz: A2($author$project$Common$setInvalidWarnings, new_items, model)
						});
					var lock_version = model.he + ($elm$core$List$isEmpty(returned_items) ? 0 : 1);
					return A3(
						$author$project$Run$Main$nextItemsQueue,
						_Utils_update(
							new_model,
							{bk: new_modal}),
						lock_version,
						_List_Nil);
				} else {
					var error = msg.a.a;
					if ((error.$ === 3) && (error.a === 304)) {
						return $author$project$Run$Main$nextOrRetryItemsQueue(model);
					} else {
						return A3($author$project$Common$setError, model, error, true);
					}
				}
			case 3:
				if (!msg.a.$) {
					var returned_items = msg.a.a;
					var returned_item = $elm$core$List$head(returned_items);
					var new_items = function () {
						if (returned_item.$ === 1) {
							return model.dz;
						} else {
							var item = returned_item.a;
							return A2(
								$elm$core$List$map,
								function (old_item) {
									var _v10 = _Utils_eq(old_item.an, item.an);
									if (_v10) {
										return A2($author$project$Run$ItemHelper$replaceInteractiveValues, old_item, item);
									} else {
										return old_item;
									}
								},
								model.dz);
						}
					}();
					var updated_item = function () {
						if (returned_item.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var item = returned_item.a;
							return A2(
								$author$project$Helper$getRecordById,
								new_items,
								$elm$core$Maybe$Just(item.an));
						}
					}();
					var new_modal = function () {
						var _v7 = _Utils_Tuple2(model.bk, updated_item);
						if ((!_v7.a.$) && (!_v7.b.$)) {
							var modal_item = _v7.a.a;
							var item = _v7.b.a;
							return _Utils_eq(modal_item.an, item.an) ? $author$project$Types$ItemModal(item) : model.bk;
						} else {
							return model.bk;
						}
					}();
					var lock_version = model.he + ($elm$core$List$isEmpty(returned_items) ? 0 : 1);
					return A3(
						$author$project$Run$Main$nextItemsQueue,
						_Utils_update(
							model,
							{dz: new_items, bk: new_modal}),
						lock_version,
						_List_Nil);
				} else {
					var error = msg.a.a;
					if ((error.$ === 3) && (error.a === 304)) {
						return $author$project$Run$Main$nextOrRetryItemsQueue(model);
					} else {
						return A3($author$project$Common$setError, model, error, true);
					}
				}
			case 48:
				var machine_id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fE: $elm$core$String$toInt(machine_id)
						}),
					$elm$core$Platform$Cmd$none);
			case 49:
				var machine_id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fE: $elm$core$Maybe$Just(machine_id)
						}),
					$elm$core$Platform$Cmd$none);
			case 50:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{di: true}),
					A2($author$project$Api$fetchItemsAndGroups, model.a9.gE, $elm$core$Maybe$Nothing));
			case 47:
				var state = $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-calendar');
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: model.bS + 1,
							i: $author$project$Types$History(_List_Nil),
							fF: $elm$core$Maybe$Nothing,
							fO: state
						}),
					$elm$core$Platform$Cmd$none);
			case 46:
				var state = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: model.bS + 1,
							i: $author$project$Types$History(_List_Nil),
							fF: $elm$core$Maybe$Nothing,
							fO: state
						}),
					$elm$core$Platform$Cmd$none);
			case 27:
				var item = msg.a;
				var state = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{P: state}),
					$elm$core$Platform$Cmd$none);
			case 45:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: model.bS + 1,
							fE: item.hh,
							fF: item.hN,
							hV: $elm$core$Maybe$Just(item.bp),
							fO: $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-calendar')
						}),
					$elm$core$Platform$Cmd$none);
			case 41:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cg: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none);
			case 42:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cg: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 43:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eW: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none);
			case 44:
				var target_item = msg.a;
				var new_items = function () {
					var _v12 = model.cg;
					if (!_v12.$) {
						var drag_item = _v12.a;
						if (!_Utils_eq(target_item.an, drag_item.an)) {
							var target_index = A2($author$project$Helper$elemIndex, target_item, model.dz);
							var source_index = A2($author$project$Helper$elemIndex, drag_item, model.dz);
							return A3(
								$author$project$Helper$insertAt,
								target_index,
								drag_item,
								A2($elm_community$list_extra$List$Extra$removeAt, source_index, model.dz));
						} else {
							return model.dz;
						}
					} else {
						return model.dz;
					}
				}();
				var changed = !_Utils_eq(model.dz, new_items);
				return A2(
					$author$project$Run$Main$updateItems,
					_Utils_update(
						model,
						{
							i: A4($author$project$Run$Main$newHistoryIf, changed, model.i, model.eI, model.dz),
							cg: $elm$core$Maybe$Nothing,
							eW: $elm$core$Maybe$Nothing,
							dz: new_items
						}),
					_List_Nil);
			case 16:
				var item = msg.a;
				return A3(
					$author$project$Run$Main$deleteItem,
					_Utils_update(
						model,
						{
							i: A3($author$project$Run$Main$newHistory, model.i, model.eI, model.dz),
							dz: A2(
								$elm$core$List$filter,
								function (i) {
									return !_Utils_eq(i.an, item.an);
								},
								model.dz)
						}),
					item.an,
					_List_Nil);
			case 24:
				var index = msg.a;
				var category = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ha: category,
							bk: A3($author$project$Types$NewItemModal, category, $elm$core$Maybe$Nothing, index)
						}),
					$elm$core$Platform$Cmd$none);
			case 25:
				var new_item_index = msg.a;
				var process_id_str = msg.b;
				var process = A2(
					$author$project$Helper$getRecordById,
					model.dP,
					$elm$core$String$toInt(process_id_str));
				var category = function () {
					if (process.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var p = process.a;
						return $elm$core$Maybe$Just(
							$author$project$Helper$getProcessCategory(p));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bk: A3($author$project$Types$NewItemModal, category, process, new_item_index)
						}),
					$elm$core$Platform$Cmd$none);
			case 26:
				var process_id = msg.a;
				var index = msg.b;
				var new_item = A2($author$project$Run$ItemHelper$newItem, model, process_id);
				var new_model = _Utils_update(
					model,
					{
						aR: $elm$core$Maybe$Nothing,
						P: $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-item-planning-edit'),
						dz: A3($author$project$Helper$insertAt, index, new_item, model.dz),
						bk: $author$project$Types$ItemModal(new_item)
					});
				return A4(
					$author$project$Run$Main$createItems,
					new_model,
					index,
					_List_fromArray(
						[new_item]),
					_List_fromArray(
						[
							$author$project$Ports$modalOpen(true)
						]));
			case 12:
				var item = msg.a;
				return (item.hL === '') ? A4($author$project$Run$Main$doCopyItem, model, item, false, false) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cI: $author$project$Types$AskRenewPopup(item)
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var item = msg.a;
				var renew = msg.b;
				return A4($author$project$Run$Main$doCopyItem, model, item, renew, false);
			case 14:
				var item = msg.a;
				return A4($author$project$Run$Main$doCopyItem, model, item, false, true);
			case 28:
				var item = msg.a;
				return A2($author$project$Run$Main$editItem, model, item);
			case 30:
				var item = msg.a;
				var state = msg.b;
				var new_item = function () {
					var item_with_new_state = _Utils_update(
						item,
						{h1: state});
					var _v16 = _Utils_Tuple2(item.h1, state);
					if ((!_v16.a) && (_v16.b === 1)) {
						var _v17 = _v16.a;
						var _v18 = _v16.b;
						return $author$project$Run$ItemHelper$possiblyInitOriginalValues(item_with_new_state);
					} else {
						return item_with_new_state;
					}
				}();
				var model_with_new_tab_state = _Utils_update(
					model,
					{
						P: function () {
							switch (state) {
								case 0:
									return $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-item-planning-edit');
								case 1:
									return $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-item-execution');
								default:
									return model.P;
							}
						}()
					});
				var empty_start_values = A2(
					$elm$core$List$all,
					function (param) {
						return _Utils_eq(
							param.f2,
							$elm$core$Array$fromList(
								_List_fromArray(
									[''])));
					},
					A2(
						$elm$core$List$filter,
						function (param) {
							return (param.dG === 'Operator') || (param.dG === 'Tag');
						},
						item.gH));
				var additional_commands = (empty_start_values && (state === 1)) ? _List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						$author$project$Helper$passValueToRunMsg(
							$author$project$Types$UpdateItemStartExecution(new_item)),
						$elm$time$Time$now)
					]) : ((state === 2) ? _List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						$author$project$Helper$passValueToRunMsg(
							$author$project$Types$UpdateItemStopExecution(new_item)),
						$elm$time$Time$now)
					]) : _List_Nil);
				var _v14 = A3($author$project$Run$Main$possiblySendItemChangeOpenModal, 0, new_item, model_with_new_tab_state);
				var new_model = _v14.a;
				var send_item_command = _v14.b;
				return _Utils_Tuple2(
					new_model,
					$elm$core$Platform$Cmd$batch(
						A2($elm$core$List$cons, send_item_command, additional_commands)));
			case 31:
				var item = msg.a;
				var rating = msg.b;
				return A3(
					$author$project$Run$Main$possiblySendItemChangeOpenModal,
					1,
					_Utils_update(
						item,
						{
							hJ: $elm$core$Maybe$Just(rating)
						}),
					model);
			case 32:
				var item = msg.a;
				var time = msg.b;
				var new_item = _Utils_update(
					item,
					{
						gH: A3($author$project$Run$ItemHelper$initOperatorAndDayParams, model, item, time)
					});
				var _v19 = A2(
					$author$project$Run$View$ExecutionParamsEdit$makeExecStartModal,
					_Utils_update(
						model,
						{
							P: $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-item-execution')
						}),
					new_item);
				var new_model = _v19.a;
				var first_command = _v19.b;
				var _v20 = A3($author$project$Run$Main$possiblySendItemChangeOpenModal, 0, new_item, new_model);
				var final_model = _v20.a;
				var second_command = _v20.b;
				return _Utils_Tuple2(
					final_model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[first_command, second_command])));
			case 33:
				var item = msg.a;
				var time = msg.b;
				var _v21 = function () {
					var _v22 = model.h6;
					if (_v22.$ === 1) {
						return _Utils_Tuple2('', '');
					} else {
						var zone = _v22.a;
						return A2($author$project$Helper$formatDateTime, zone, time);
					}
				}();
				var current_time = _v21.b;
				var new_item = $author$project$Run$ItemHelper$isStopParamEmpty(item) ? _Utils_update(
					item,
					{
						gH: A3($author$project$Run$ItemHelper$updateParam, 'Prozessende', current_time, item.gH)
					}) : item;
				var _v23 = A2(
					$author$project$Run$View$ExecutionParamsEdit$makeExecStopModal,
					_Utils_update(
						model,
						{
							P: $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-item-execution')
						}),
					new_item);
				var new_model = _v23.a;
				var first_command = _v23.b;
				var _v24 = A3($author$project$Run$Main$possiblySendItemChangeOpenModal, 0, new_item, new_model);
				var final_model = _v24.a;
				var second_command = _v24.b;
				return _Utils_Tuple2(
					final_model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[first_command, second_command])));
			case 34:
				var item = msg.a;
				var group_id = msg.b;
				var group_attr_field = msg.c;
				var value = msg.d;
				var new_item = A4($author$project$Run$Main$updateGroupAttr, item, group_id, group_attr_field, value);
				return A3($author$project$Run$Main$possiblySendItemChangeOpenModal, 1, new_item, model);
			case 29:
				var api_reply = msg.a;
				var item = msg.b;
				var attr = msg.c;
				var value = msg.d;
				var new_item = A2(
					$author$project$Common$setInvalidWarningItem,
					model,
					function () {
						switch (attr) {
							case 'comment':
								return _Utils_update(
									item,
									{gl: value});
							case 'estimated_time':
								return _Utils_update(
									item,
									{
										gF: A2(
											$author$project$Helper$ceilInteger,
											30,
											A2(
												$elm$core$Maybe$withDefault,
												60,
												$elm$core$String$toInt(value)))
									});
							case 'machine_id':
								var machine_id = $elm$core$String$toInt(value);
								var recipe_id = A2(
									$author$project$Helper$oneOrNothingIfNot,
									item.hM,
									A4($author$project$Run$ItemHelper$recipeIdsForProcessAndMachine, model.dB, model.dC, item.hD, machine_id));
								var _v26 = A4($author$project$Run$ItemHelper$initParams, model, item.hD, machine_id, recipe_id);
								var planning_params = _v26.a;
								var execution_params = _v26.b;
								return _Utils_update(
									item,
									{gH: execution_params, hh: machine_id, hA: planning_params, hM: recipe_id});
							case 'recipe_id':
								var recipe_id = $elm$core$String$toInt(value);
								var machine_id = A2(
									$author$project$Helper$oneOrNothingIfNot,
									item.hh,
									A4($author$project$Run$ItemHelper$machineIdsForProcessAndRecipe, model.dB, model.dC, item.hD, recipe_id));
								var _v27 = A4($author$project$Run$ItemHelper$initParams, model, item.hD, machine_id, recipe_id);
								var planning_params = _v27.a;
								var execution_params = _v27.b;
								return _Utils_update(
									item,
									{gH: execution_params, hh: machine_id, hA: planning_params, hM: recipe_id});
							case 'params_per_group':
								return _Utils_update(
									item,
									{hy: !item.hy});
							case 'show_group_attrs':
								return _Utils_update(
									item,
									{hY: !item.hY});
							case 'highlight':
								return _Utils_update(
									item,
									{gZ: !item.gZ});
							default:
								return item;
						}
					}());
				return A3($author$project$Run$Main$possiblySendItemChangeOpenModal, api_reply, new_item, model);
			case 35:
				var item = msg.a;
				var param_id = msg.b;
				var group_id = msg.c;
				var index = msg.d;
				var value = msg.e;
				var _v28 = A2(
					$author$project$Helper$getRecordById,
					item.hA,
					$elm$core$Maybe$Just(param_id));
				if (_v28.$ === 1) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dq: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										_List_fromArray(
											['Parameter nicht gefunden!']),
										false))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var param = _v28.a;
					return A3(
						$author$project$Run$Main$possiblySendItemChangeOpenModal,
						1,
						A5($author$project$Run$Main$updatePlanningParamValue, item, group_id, index, param, value),
						model);
				}
			case 36:
				var item = msg.a;
				var param_id = msg.b;
				var group_ids = msg.c;
				var index = msg.d;
				var _v29 = A2(
					$author$project$Helper$getRecordById,
					item.hA,
					$elm$core$Maybe$Just(param_id));
				if (_v29.$ === 1) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dq: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										_List_fromArray(
											['Parameter nicht gefunden!']),
										false))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var param = _v29.a;
					return A3(
						$author$project$Run$Main$possiblySendItemChangeOpenModal,
						1,
						A4($author$project$Run$Main$togglePlanningParamChecked, item, group_ids, index, param),
						model);
				}
			case 37:
				var item = msg.a;
				var param_id = msg.b;
				var index = msg.c;
				var value = msg.d;
				var _v30 = A2(
					$author$project$Helper$getRecordById,
					item.gH,
					$elm$core$Maybe$Just(param_id));
				if (_v30.$ === 1) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dq: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										_List_fromArray(
											['Parameter nicht gefunden!']),
										false))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var param = _v30.a;
					var new_param = _Utils_update(
						param,
						{
							f2: A3($elm$core$Array$set, index, value, param.f2)
						});
					var execution_params = A3($author$project$Helper$replaceOldElemWithNewElem, param, new_param, item.gH);
					return A3(
						$author$project$Run$Main$possiblySendItemChangeOpenModal,
						1,
						_Utils_update(
							item,
							{gH: execution_params}),
						model);
				}
			case 38:
				var item = msg.a;
				var object_id = msg.b;
				var object_type = msg.c;
				var value = msg.d;
				var new_item = function () {
					switch (object_type) {
						case 0:
							return _Utils_update(
								item,
								{cy: value});
						case 1:
							return A4($author$project$Run$Main$updateGroupAttr, item, object_id, 4, value);
						case 2:
							var _v32 = A2(
								$author$project$Helper$getRecordById,
								item.hA,
								$elm$core$Maybe$Just(object_id));
							if (_v32.$ === 1) {
								return item;
							} else {
								var param = _v32.a;
								var new_param = _Utils_update(
									param,
									{cy: value});
								var planning_params = A3($author$project$Helper$replaceOldElemWithNewElem, param, new_param, item.hA);
								return _Utils_update(
									item,
									{hA: planning_params});
							}
						default:
							var _v33 = A2(
								$author$project$Helper$getRecordById,
								item.gH,
								$elm$core$Maybe$Just(object_id));
							if (_v33.$ === 1) {
								return item;
							} else {
								var param = _v33.a;
								var new_param = _Utils_update(
									param,
									{cy: value});
								var execution_params = A3($author$project$Helper$replaceOldElemWithNewElem, param, new_param, item.gH);
								return _Utils_update(
									item,
									{gH: execution_params});
							}
					}
				}();
				return A3($author$project$Run$Main$possiblySendItemChangeOpenModal, 1, new_item, model);
			case 39:
				var item = msg.a;
				var object_id = msg.b;
				var object_type = msg.c;
				var value = function () {
					switch (object_type) {
						case 0:
							return item.cy;
						case 1:
							return A2($author$project$Run$ItemHelper$getGroupAttrsOrNew, item, object_id).cy;
						case 2:
							var _v35 = A2(
								$author$project$Helper$getRecordById,
								item.hA,
								$elm$core$Maybe$Just(object_id));
							if (_v35.$ === 1) {
								return '';
							} else {
								var p = _v35.a;
								return p.cy;
							}
						default:
							var _v36 = A2(
								$author$project$Helper$getRecordById,
								item.gH,
								$elm$core$Maybe$Just(object_id));
							if (_v36.$ === 1) {
								return '';
							} else {
								var p = _v36.a;
								return p.cy;
							}
					}
				}();
				var on_change_action = $author$project$Helper$passValueToRunMsg(
					A3($author$project$Types$UpdateItemOperatorNote, item, object_id, object_type));
				var content = A2(
					$author$project$Types$Modal,
					'Anmerkung bearbeiten',
					$rundis$elm_bootstrap$Bootstrap$Form$Textarea$textarea(
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$id('operator-note-input'),
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$rows(7),
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$value(value),
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$attrs(
								_List_fromArray(
									[
										$author$project$Helper$onChange(on_change_action)
									]))
							])));
				return A2(
					$author$project$Common$showPopup,
					model,
					A2(
						$author$project$Types$SmallPopup,
						content,
						$author$project$Types$GotCommonMsg($author$project$Types$PopupCancel)));
			case 40:
				var item = msg.a;
				var planning_params = A2(
					$elm$core$List$map,
					function (p) {
						return _Utils_update(
							p,
							{
								gT: _List_Nil,
								f2: $author$project$Run$ItemHelper$getParamInitValues(p)
							});
					},
					item.hA);
				var new_item = _Utils_update(
					item,
					{hA: planning_params});
				return A3($author$project$Run$Main$possiblySendItemChangeOpenModal, 0, new_item, model);
			case 18:
				var item = msg.a;
				var _v37 = model.aR;
				if (_v37.$ === 1) {
					return A3(
						$author$project$Run$Main$deleteItem,
						_Utils_update(
							model,
							{
								dz: A2(
									$elm$core$List$filter,
									function (i) {
										return !_Utils_eq(i.an, item.an);
									},
									model.dz),
								bk: $author$project$Types$NoneModal
							}),
						item.an,
						_List_fromArray(
							[
								$author$project$Ports$modalOpen(false)
							]));
				} else {
					var i = _v37.a;
					return A2($author$project$Run$Main$possiblySendItemChangeCloseModal, i, model);
				}
			case 60:
				var live_capture = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e1: live_capture}),
					$elm$core$Platform$Cmd$none);
			case 61:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e1: $author$project$Types$NoCapture}),
					$elm$core$Platform$Cmd$none);
			case 62:
				var mime_type = msg.a;
				var item_id = msg.b;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							[mime_type]),
						function (file) {
							return function (files) {
								return $author$project$Types$GotRunMsg(
									A3(
										$author$project$Types$UploadItemFiles,
										item_id,
										'',
										A2($elm$core$List$cons, file, files)));
							};
						}));
			case 63:
				var item_id = msg.a;
				var caption = msg.b;
				var maybe_item_file = msg.c;
				var maybe_file = msg.d;
				var send_msg = $author$project$Types$GotCommonMsg(
					$author$project$Types$PopupOk(
						$author$project$Types$GotRunMsg(
							A4($author$project$Types$UploadItemFile, item_id, caption, maybe_item_file, maybe_file))));
				var content = A2(
					$author$project$Types$Modal,
					'Datei ' + function () {
						if (maybe_item_file.$ === 1) {
							return 'hochladen';
						} else {
							return 'bearbeiten';
						}
					}(),
					$rundis$elm_bootstrap$Bootstrap$Form$Textarea$textarea(
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$rows(7),
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$value(caption),
								$rundis$elm_bootstrap$Bootstrap$Form$Textarea$attrs(
								_List_fromArray(
									[
										$author$project$Helper$onChange(
										function (new_caption) {
											return $author$project$Types$GotRunMsg(
												A4($author$project$Types$EditItemFile, item_id, new_caption, maybe_item_file, maybe_file));
										}),
										$elm$html$Html$Attributes$placeholder('Kommentar')
									]))
							])));
				var cancel_msg = $author$project$Types$GotCommonMsg($author$project$Types$PopupCancel);
				var actions = _List_fromArray(
					[
						_Utils_Tuple2('Abbrechen', cancel_msg),
						_Utils_Tuple2(
						function () {
							if (maybe_item_file.$ === 1) {
								return 'Hochladen';
							} else {
								return 'Speichern';
							}
						}(),
						send_msg)
					]);
				return A2(
					$author$project$Common$showPopup,
					model,
					A3($author$project$Types$MediumPopup, content, actions, cancel_msg));
			case 64:
				var item_id = msg.a;
				var caption = msg.b;
				var maybe_item_file = msg.c;
				var maybe_file = msg.d;
				return _Utils_Tuple2(
					model,
					A5($author$project$Api$sendItemFile, model, item_id, caption, maybe_item_file, maybe_file));
			case 65:
				var item_id = msg.a;
				var caption = msg.b;
				var files = msg.c;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							A4($author$project$Api$sendItemFile, model, item_id, caption, $elm$core$Maybe$Nothing),
							A2($elm$core$List$map, $elm$core$Maybe$Just, files))));
			case 66:
				var item_id = msg.a;
				var item_file = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Api$deleteItemFile, model, item_id, item_file));
			case 67:
				if (msg.b.$ === 1) {
					var item_id = msg.a;
					var error = msg.b.a;
					return A3($author$project$Common$setError, model, error, false);
				} else {
					var item_id = msg.a;
					var item_files = msg.b.a;
					var maybe_old_item = A2(
						$author$project$Helper$getRecordById,
						model.dz,
						$elm$core$Maybe$Just(item_id));
					var _v40 = function () {
						if (maybe_old_item.$ === 1) {
							return _Utils_Tuple2(model.dz, model.bk);
						} else {
							var item = maybe_old_item.a;
							var new_item = _Utils_update(
								item,
								{gK: item_files});
							return _Utils_Tuple2(
								A3($author$project$Helper$replaceOldElemWithNewElem, item, new_item, model.dz),
								$author$project$Types$ItemModal(new_item));
						}
					}();
					var new_items = _v40.a;
					var new_modal = _v40.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dz: new_items, he: model.he + 1, bk: new_modal}),
						$elm$core$Platform$Cmd$none);
				}
			case 19:
				var item = msg.a;
				var history = function () {
					var _v42 = model.aR;
					if (_v42.$ === 1) {
						return model.i;
					} else {
						var old_item = _v42.a;
						return A4(
							$author$project$Run$Main$newHistoryIf,
							!_Utils_eq(item, old_item),
							model.i,
							model.eI,
							A3($author$project$Helper$replaceOldElemWithNewElem, item, old_item, model.dz));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i: history,
							aR: $elm$core$Maybe$Nothing,
							P: $rundis$elm_bootstrap$Bootstrap$Tab$customInitialState('run-item-planning-edit'),
							bk: $author$project$Types$NoneModal
						}),
					$author$project$Ports$modalOpen(false));
			case 23:
				var new_items = function () {
					var _v45 = model.p;
					switch (_v45.$) {
						case 3:
							var g = _v45.a;
							var old = _v45.b;
							return A2(
								$elm$core$List$map,
								A3(
									$author$project$Run$Main$copyItemsAndPlanningParamValues,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Run$ItemHelper$hasDoneReservation),
									g,
									old),
								model.dz);
						case 4:
							var g = _v45.a;
							var old = _v45.b;
							return A2(
								$elm$core$List$map,
								A3(
									$author$project$Run$Main$copyItemsAndPlanningParamValues,
									$elm$core$Basics$always(true),
									g,
									old),
								model.dz);
						default:
							return model.dz;
					}
				}();
				var _v43 = function () {
					var _v44 = model.p;
					switch (_v44.$) {
						case 0:
							return _Utils_Tuple2(false, model.eI);
						case 1:
							var g = _v44.a;
							return _Utils_Tuple2(
								true,
								_Utils_ap(
									model.eI,
									_List_fromArray(
										[g])));
						case 3:
							var g = _v44.a;
							var old = _v44.b;
							return _Utils_Tuple2(
								true,
								A3($author$project$Helper$insertGroupAfter, old, g, model.eI));
						case 4:
							var g = _v44.a;
							var old = _v44.b;
							return _Utils_Tuple2(
								true,
								A3(
									$author$project$Helper$insertGroupAfter,
									old,
									g,
									A2($author$project$Helper$updateOrInsertGroup, old, model.eI)));
						default:
							var g = _v44.a;
							var frozen = _v44.b;
							return _Utils_Tuple2(
								A2($author$project$Helper$groupChanged, g, model.eI),
								A2($author$project$Helper$updateOrInsertGroup, g, model.eI));
					}
				}();
				var changed = _v43.a;
				var new_groups = _v43.b;
				return A2(
					$author$project$Run$Main$updateGroupsAndItems,
					_Utils_update(
						model,
						{
							p: $author$project$Types$NoGroupInEdit,
							eI: new_groups,
							i: A4($author$project$Run$Main$newHistoryIf, changed, model.i, model.eI, model.dz),
							dz: new_items,
							bk: $author$project$Types$NoneModal
						}),
					_List_fromArray(
						[
							$author$project$Ports$modalOpen(false)
						]));
			case 20:
				var item = msg.a;
				var group = msg.b;
				var new_item = function () {
					var _v47 = A2($elm$core$List$member, group.an, item.gS);
					if (!_v47) {
						return _Utils_update(
							item,
							{
								gS: A2($elm$core$List$cons, group.an, item.gS)
							});
					} else {
						return _Utils_update(
							item,
							{
								gS: A2(
									$elm$core$List$filter,
									function (id) {
										return !_Utils_eq(id, group.an);
									},
									item.gS)
							});
					}
				}();
				var modal = function () {
					var _v46 = model.bk;
					if (_v46.$ === 3) {
						return $author$project$Types$NoneModal;
					} else {
						return $author$project$Types$ItemModal(new_item);
					}
				}();
				var new_model = _Utils_update(
					model,
					{
						i: A3($author$project$Run$Main$newHistory, model.i, model.eI, model.dz),
						dz: A3($author$project$Helper$replaceOldElemWithNewElem, item, new_item, model.dz),
						bk: modal
					});
				return A4($author$project$Run$Main$updateItem, 1, new_model, new_item, _List_Nil);
			case 5:
				var item = msg.a;
				var new_item = _Utils_update(
					item,
					{
						gS: A2(
							$elm$core$List$map,
							function ($) {
								return $.an;
							},
							model.eI)
					});
				var changed = !_Utils_eq(item.gS, new_item.gS);
				var new_model = _Utils_update(
					model,
					{
						i: A4($author$project$Run$Main$newHistoryIf, changed, model.i, model.eI, model.dz),
						dz: A3($author$project$Helper$replaceOldElemWithNewElem, item, new_item, model.dz)
					});
				return A4($author$project$Run$Main$updateItem, 1, new_model, new_item, _List_Nil);
			case 6:
				var item = msg.a;
				var new_item = _Utils_update(
					item,
					{gS: _List_Nil});
				var new_model = _Utils_update(
					model,
					{
						i: A3($author$project$Run$Main$newHistory, model.i, model.eI, model.dz),
						dz: A3($author$project$Helper$replaceOldElemWithNewElem, item, new_item, model.dz)
					});
				return A4($author$project$Run$Main$updateItem, 1, new_model, new_item, _List_Nil);
			case 15:
				var group = msg.a;
				var force = msg.b;
				if (A2($author$project$Run$ItemHelper$isGroupUsed, model.dz, group) && (!force)) {
					return A2(
						$author$project$Common$showPopup,
						model,
						A2(
							$author$project$Types$ConfirmPopup,
							'Gruppe bereits zugeordnet. Trotzdem löschen?',
							$author$project$Types$GotRunMsg(
								A2($author$project$Types$DeleteGroup, group, true))));
				} else {
					var new_items = A2(
						$elm$core$List$map,
						function (item) {
							return _Utils_update(
								item,
								{
									gS: A2(
										$elm$core$List$filter,
										function (id) {
											return !_Utils_eq(id, group.an);
										},
										item.gS)
								});
						},
						model.dz);
					var new_groups = A2(
						$elm$core$List$filter,
						function (g) {
							return !_Utils_eq(g.an, group.an);
						},
						model.eI);
					return A2(
						$author$project$Run$Main$updateGroupsAndItems,
						_Utils_update(
							model,
							{
								eI: new_groups,
								i: A3($author$project$Run$Main$newHistory, model.i, model.eI, model.dz),
								dz: new_items,
								bk: $author$project$Types$NoneModal
							}),
						_List_fromArray(
							[
								$author$project$Ports$modalOpen(false)
							]));
				}
			case 10:
				var frozen = msg.a;
				var group = msg.b;
				var new_model = _Utils_update(
					model,
					{
						p: A2($author$project$Types$GroupAlter, group, frozen)
					});
				return A2(
					$author$project$Common$showModal,
					new_model,
					$author$project$Types$GroupModal(new_model.p));
			case 7:
				var new_group = A6(
					$author$project$Types$Group,
					$author$project$Helper$nextId(model.eI),
					model.a9.an,
					'G',
					'Neue Gruppe',
					0,
					'');
				var new_model = _Utils_update(
					model,
					{
						p: $author$project$Types$GroupNew(new_group)
					});
				return A2(
					$author$project$Common$showModal,
					new_model,
					$author$project$Types$GroupModal(new_model.p));
			case 9:
				var group = msg.a;
				var new_group = _Utils_update(
					group,
					{
						an: $author$project$Helper$nextId(model.eI),
						dG: $author$project$Run$ItemHelper$newGroupName(group.dG),
						hX: $author$project$Run$ItemHelper$newGroupShortname(group.hX)
					});
				var new_model = _Utils_update(
					model,
					{
						p: A2($author$project$Types$GroupCopy, new_group, group)
					});
				return A2(
					$author$project$Common$showModal,
					new_model,
					$author$project$Types$GroupModal(new_model.p));
			case 8:
				var group = msg.a;
				var new_group = _Utils_update(
					group,
					{
						an: $author$project$Helper$nextId(model.eI),
						dG: $author$project$Run$ItemHelper$newGroupName(group.dG),
						hX: $author$project$Run$ItemHelper$newGroupShortname(group.hX),
						ih: (group.ih / 2) | 0
					});
				var old_group = _Utils_update(
					group,
					{ih: group.ih - new_group.ih});
				var new_model = _Utils_update(
					model,
					{
						p: A2($author$project$Types$GroupSplit, new_group, old_group)
					});
				return A2(
					$author$project$Common$showModal,
					new_model,
					$author$project$Types$GroupModal(new_model.p));
			case 22:
				var group = msg.a;
				var attr = msg.b;
				var value = msg.c;
				var new_editing_group = function () {
					var _v49 = model.p;
					switch (_v49.$) {
						case 0:
							return $author$project$Types$NoGroupInEdit;
						case 1:
							var g = _v49.a;
							return $author$project$Types$GroupNew(
								A3($author$project$Run$Main$updateGroup, g, attr, value));
						case 2:
							var g = _v49.a;
							var frozen = _v49.b;
							return (frozen && (attr === 'wafer_count')) ? A2($author$project$Types$GroupAlter, g, frozen) : A2(
								$author$project$Types$GroupAlter,
								A3($author$project$Run$Main$updateGroup, g, attr, value),
								frozen);
						case 3:
							var g = _v49.a;
							var old_g = _v49.b;
							return A2(
								$author$project$Types$GroupCopy,
								A3($author$project$Run$Main$updateGroup, g, attr, value),
								old_g);
						default:
							var g = _v49.a;
							var old_g = _v49.b;
							if (_Utils_eq(g.an, group.an)) {
								if (attr === 'wafer_count') {
									var sum = g.ih + old_g.ih;
									var new_value = A3(
										$elm$core$Basics$clamp,
										1,
										sum - 1,
										$author$project$Run$Main$parseWaferCount(value));
									return A2(
										$author$project$Types$GroupSplit,
										_Utils_update(
											g,
											{ih: new_value}),
										_Utils_update(
											old_g,
											{ih: sum - new_value}));
								} else {
									return A2(
										$author$project$Types$GroupSplit,
										A3($author$project$Run$Main$updateGroup, g, attr, value),
										old_g);
								}
							} else {
								if (attr === 'wafer_count') {
									var sum = g.ih + old_g.ih;
									var new_value = A3(
										$elm$core$Basics$clamp,
										1,
										sum - 1,
										$author$project$Run$Main$parseWaferCount(value));
									return A2(
										$author$project$Types$GroupSplit,
										_Utils_update(
											g,
											{ih: sum - new_value}),
										_Utils_update(
											old_g,
											{ih: new_value}));
								} else {
									return A2(
										$author$project$Types$GroupSplit,
										g,
										A3($author$project$Run$Main$updateGroup, old_g, attr, value));
								}
							}
					}
				}();
				if (!new_editing_group.$) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var g = new_editing_group;
					return A2(
						$author$project$Common$showModal,
						_Utils_update(
							model,
							{p: g}),
						$author$project$Types$GroupModal(g));
				}
			case 11:
				var dndmsg = msg.a;
				var pre = $author$project$Common$groupDndSystem.eP(model.dv);
				var _v50 = A3($author$project$Common$groupDndSystem.h9, dndmsg, model.dv, model.eI);
				var dnd = _v50.a;
				var groups = _v50.b;
				var cmd = A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Types$GotRunMsg,
					$author$project$Common$groupDndSystem.gk(dnd));
				var post = $author$project$Common$groupDndSystem.eP(dnd);
				var new_model = _Utils_update(
					model,
					{dv: dnd, eI: groups});
				var _v51 = _Utils_Tuple2(pre, post);
				if ((!_v51.a.$) && (_v51.b.$ === 1)) {
					var _v52 = _v51.b;
					return A2(
						$author$project$Run$Main$updateGroups,
						new_model,
						_List_fromArray(
							[cmd]));
				} else {
					return _Utils_Tuple2(new_model, cmd);
				}
			case 21:
				var _v53 = $elm$core$List$head(model.i.dW);
				if (_v53.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var h = _v53.a;
					var new_model = _Utils_update(
						model,
						{
							eI: h.eI,
							i: $author$project$Types$History(
								A2($elm$core$List$drop, 1, model.i.dW)),
							dz: h.dz
						});
					return (!_Utils_eq(model.dz, h.dz)) ? A2($author$project$Run$Main$updateItems, new_model, _List_Nil) : A2($author$project$Run$Main$updateGroups, new_model, _List_Nil);
				}
			case 17:
				return $author$project$Run$Main$nextOrRetryItemsQueue(model);
			case 4:
				var key = msg.a;
				var state = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fi: A3($elm$core$Dict$insert, key, state, model.fi)
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var item = msg.a;
				var res_id = function () {
					var _v54 = item.hN;
					if (_v54.$ === 1) {
						return 0;
					} else {
						var res = _v54.a;
						return res.an;
					}
				}();
				return _Utils_Tuple2(
					model,
					$author$project$Ports$showReservation(res_id));
			case 51:
				var parameter_type = msg.a;
				var item = msg.b;
				var param_id = msg.c;
				var group_id = msg.d;
				var param_properties = msg.e;
				var material_type_name = msg.f;
				var parameter_type_string = function () {
					switch (parameter_type) {
						case 2:
							return 'planning';
						case 3:
							return 'execution';
						default:
							return '';
					}
				}();
				var filter = function () {
					if (!param_properties.$) {
						return '';
					} else {
						var props = param_properties.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							$elm$core$List$head(
								A2(
									$elm$core$List$map,
									function ($) {
										return $.gL;
									},
									A2(
										$elm$core$List$filter,
										function (w) {
											return _Utils_eq(w.eH, group_id);
										},
										props.gO))));
					}
				}();
				return _Utils_Tuple2(
					model,
					$author$project$Ports$showMaterialList(
						A7($author$project$Types$MaterialListParams, model.a9.an, parameter_type_string, item.an, param_id, group_id, material_type_name, filter)));
			case 52:
				var url = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Ports$openMaterialLot(url));
			case 54:
				var item_id = msg.a;
				var param_id = msg.b;
				var filter = msg.c;
				var items = A7($author$project$Run$ItemHelper$updateItemParamProperty, model.dz, item_id, param_id, filter.eH, 'properties', 'filters', filter.gL);
				var _v57 = A2(
					$author$project$Helper$getRecordById,
					items,
					$elm$core$Maybe$Just(item_id));
				if (_v57.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var item = _v57.a;
					return A4(
						$author$project$Run$Main$updateItem,
						0,
						_Utils_update(
							model,
							{dz: items}),
						item,
						_List_Nil);
				}
			case 53:
				var item_id = msg.a;
				var param_id = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Api$refreshWithdrawals, item_id, param_id, model.a9.gD));
			case 55:
				if (msg.c.$ === 1) {
					var item_id = msg.a;
					var param_id = msg.b;
					var error = msg.c.a;
					return A3($author$project$Common$setError, model, error, false);
				} else {
					var item_id = msg.a;
					var param_id = msg.b;
					var withdrawals = msg.c.a;
					return _Utils_Tuple2(
						A4($author$project$Run$Main$setWithdrawals, model, item_id, param_id, withdrawals),
						$elm$core$Platform$Cmd$none);
				}
			case 56:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a6: _Utils_eq(model.a6, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(_List_Nil) : $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 57:
				var id = msg.a;
				var checked = msg.b;
				var new_bulk_copy_ids = function () {
					var _v58 = model.a6;
					if (_v58.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var list = _v58.a;
						return checked ? $elm$core$Maybe$Just(
							A2($elm$core$List$cons, id, list)) : $elm$core$Maybe$Just(
							A2(
								$elm$core$List$filter,
								function (i) {
									return !_Utils_eq(i, id);
								},
								list));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a6: new_bulk_copy_ids}),
					$elm$core$Platform$Cmd$none);
			case 58:
				var item_index = msg.a;
				var new_item_index = item_index + 1;
				var ids_to_copy = function () {
					var _v59 = model.a6;
					if (_v59.$ === 1) {
						return _List_Nil;
					} else {
						var list = _v59.a;
						return list;
					}
				}();
				var copied_items = A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, item) {
							return A3(
								$author$project$Run$Main$createItemCopy,
								model,
								item,
								$author$project$Helper$nextId(model.dz) + index);
						}),
					A2(
						$elm$core$List$filter,
						function (item) {
							return A2($elm$core$List$member, item.an, ids_to_copy);
						},
						model.dz));
				var new_items = A3($author$project$Helper$insertManyAt, new_item_index, copied_items, model.dz);
				return A4(
					$author$project$Run$Main$createItems,
					_Utils_update(
						model,
						{dz: new_items}),
					new_item_index,
					copied_items,
					_List_Nil);
			case 59:
				var column = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eJ: A2($author$project$Helper$listToggle, column, model.eJ)
						}),
					$elm$core$Platform$Cmd$none);
			case 68:
				var run_caption = function () {
					var _v60 = model.fA;
					if (_v60.b && (!_v60.b.b)) {
						var run = _v60.a;
						return 'RUN_' + run.hn;
					} else {
						return 'UNKNOWN_RUN';
					}
				}();
				var lines = A2(
					$elm$core$List$concatMap,
					function (group) {
						var _short = $elm$core$String$trim(group.hX);
						var _long = $elm$core$String$trim(group.dG);
						return A2(
							$elm$core$List$map,
							function (label) {
								return _List_fromArray(
									[
										_short,
										_long,
										$elm$core$String$trim(label)
									]);
							},
							A2(
								$elm_community$list_extra$List$Extra$filterNot,
								$elm$core$String$isEmpty,
								$elm$core$String$lines(group.ii)));
					},
					model.eI);
				var headers = _List_fromArray(
					['Gruppe (kurz)', 'Gruppe (lang)', 'Probenbezeichnung']);
				var filename = run_caption + '_wafer_labels.csv';
				var csv_bytes = $commonmind$elm_csv_encode$Csv$Encode$toBytes(
					A2($commonmind$elm_csv_encode$Csv$Encode$Csv, headers, lines));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, filename, 'text/csv', csv_bytes));
			case 71:
				var hiddenFlag = msg.a;
				var item_ids = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dz: A2(
								$elm$core$List$map,
								function (item) {
									return _Utils_update(
										item,
										{
											gY: A2($elm$core$List$member, item.an, item_ids) ? hiddenFlag : item.gY
										});
								},
								model.dz)
						}),
					$elm$core$Platform$Cmd$none);
			case 72:
				var showFlag = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hZ: showFlag}),
					$elm$core$Platform$Cmd$none);
			default:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{g8: string}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$RunEditor$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var subMsg = msg.a;
				return A2($author$project$Run$Main$update, subMsg, model);
			case 2:
				var subMsg = msg.a;
				return A2($author$project$Queue$Main$update, subMsg, model);
			default:
				var subMsg = msg.a;
				return A3($author$project$Common$update, subMsg, model, $author$project$RunEditor$update);
		}
	});
var $author$project$Types$SendData = {$: 17};
var $perzanko$elm_loading$Loading$Off = 1;
var $perzanko$elm_loading$Loading$On = 0;
var $perzanko$elm_loading$Loading$Spinner = 1;
var $perzanko$elm_loading$Loading$defaultConfig = {el: '', en: '#74b4c9', fI: 30, fL: 1};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var newStyles = _v0.b;
		var classname = _v0.c;
		return $elm$core$List$isEmpty(newStyles) ? styles : A3($elm$core$Dict$insert, classname, newStyles, styles);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_v0) {
	var val = _v0.a;
	return val;
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				var _v1 = properties.a;
				var styles = _v1.b;
				var classname = _v1.c;
				var rest = properties.b;
				if ($elm$core$String$isEmpty(classname)) {
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var $temp$candidate = $elm$core$Maybe$Just(
						_Utils_Tuple2(classname, styles)),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _v0 = A2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, $elm$core$Maybe$Nothing, properties);
	if (_v0.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var _v1 = _v0.a;
		var classname = _v1.a;
		var styles = _v1.b;
		return A2($elm$core$Dict$singleton, classname, styles);
	}
};
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.b;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.gr) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.dG, record.gr, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{gr: decl, dG: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.ek;
	var imports = _v0.eN;
	var namespaces = _v0.e8;
	var declarations = _v0.gs;
	var _v1 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v1.a;
	var compactedDeclarations = _v1.b;
	var finalDeclarations = A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {ek: charset, gs: finalDeclarations, eN: imports, e8: namespaces};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.eE + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.id)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A2(
				$elm$core$String$join,
				' and ',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
			mediaQueries));
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
var $rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
	return _Utils_ap($rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
};
var $rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
var $rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
	return str + ';';
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Css$Structure$Output$indent, $rtfeldman$elm_css$Css$Structure$Output$emitProperty),
			properties));
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
				$elm$core$String$join,
				'',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
				$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
			]));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
			]));
	return A2(
		$elm$core$String$append,
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				segments)),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		var selectorStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
				A2($elm$core$List$cons, firstSelector, otherSelectors)));
		return A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					selectorStr,
					' {\n',
					indentLevel,
					$rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
					'\n',
					indentLevel,
					'}'
				]));
	});
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return A2($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, $rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A2(
				$elm$core$String$join,
				',\n',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
			var blocks = A2(
				$elm$core$String$join,
				'\n\n',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$rtfeldman$elm_css$Css$Structure$Output$indent,
						$rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock($rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
					styleBlocks));
			return '@media ' + (query + (' {\n' + (blocks + '\n}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.dG;
			var declaration = decl.a.gr;
			return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.ek;
	var imports = _v0.eN;
	var namespaces = _v0.e8;
	var declarations = _v0.gs;
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
					A2(
					$elm$core$String$join,
					'\n\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
				])));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							var _v9 = declarations.a;
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {aF: charsProcessed, aN: hash, at: seed, aY: shift};
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
	var acc = (!(!data.aN)) ? (data.at ^ A2(
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
		A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
			15,
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.aN)))) : data.at;
	var h0 = acc ^ data.aF;
	var h1 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			5,
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
					A2(
						$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
						15,
						A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.aN | ((255 & $elm$core$Char$toCode(c)) << data.aY);
		var _v0 = data.aY;
		if (_v0 === 24) {
			return {
				aF: data.aF + 1,
				aN: 0,
				at: A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.at, res),
				aY: 0
			};
		} else {
			return {aF: data.aF + 1, aN: res, at: data.at, aY: data.aY + 8};
		}
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
	function (seed, str) {
		return $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
				A4($rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$murmurSeed = 15739;
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, $rtfeldman$elm_css$Hash$murmurSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{gr: str, dG: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.ek;
	var imports = _v0.eN;
	var namespaces = _v0.e8;
	var snippets = _v0.fJ;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {ek: charset, gs: declarations, eN: imports, e8: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_v0) {
	var classname = _v0.a;
	var styles = _v0.b;
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
				])));
};
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {ek: $elm$core$Maybe$Nothing, eN: _List_Nil, e8: _List_Nil, fJ: snippets};
};
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
		$elm$core$List$singleton(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
					$elm$core$Dict$toList(dict)))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		$elm$virtual_dom$VirtualDom$node,
		'style',
		_List_Nil,
		$elm$core$List$singleton(
			$elm$virtual_dom$VirtualDom$text(
				$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			d4: 0,
			ei: 0,
			aK: 0,
			r: 0,
			bh: 0,
			aS: 0,
			aa: 0,
			aT: 0,
			aU: 0,
			ap: 0,
			aq: 0,
			Q: 0,
			ab: numericValue,
			a$: 0,
			a1: unitLabel,
			bv: units,
			id: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$Preprocess$WithKeyframes = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.id);
	});
var $rtfeldman$elm_css$Css$animationName = function (arg) {
	return ((arg.id === 'none') || ((arg.id === 'inherit') || ((arg.id === 'unset') || (arg.id === 'initial')))) ? A2($rtfeldman$elm_css$Css$prop1, 'animation-name', arg) : $rtfeldman$elm_css$Css$Preprocess$WithKeyframes(arg.id);
};
var $rtfeldman$elm_css$Css$auto = {f7: 0, c: 0, aK: 0, cd: 0, g9: 0, aS: 0, aa: 0, Q: 0, aW: 0, L: 0, c0: 0, a0: 0, A: 0, id: 'auto'};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.id);
};
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
var $rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
	return $elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
				$rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
					$elm$core$List$singleton(
						$rtfeldman$elm_css$Css$Preprocess$stylesheet(
							$elm$core$List$singleton(
								A2(
									$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
									styles,
									$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var classname = $rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classProperty = A2(
		$elm$virtual_dom$VirtualDom$property,
		'className',
		$elm$json$Json$Encode$string(classname));
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		aA: 1,
		dh: 0,
		en: 0,
		du: 0,
		dS: 0,
		id: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$String$toLower = _String_toLower;
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				aA: alpha / 255,
				dh: blue,
				en: 0,
				du: green,
				dS: red,
				id: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$Internal$printKeyframeSelector = function (_v0) {
	var percentage = _v0.a;
	var properties = _v0.b;
	var propertiesStr = A2(
		$elm$core$String$join,
		'',
		A2(
			$elm$core$List$map,
			function (_v1) {
				var prop = _v1;
				return prop + ';';
			},
			properties));
	var percentageStr = $elm$core$String$fromInt(percentage) + '%';
	return percentageStr + (' {' + (propertiesStr + '}'));
};
var $rtfeldman$elm_css$Css$Internal$compileKeyframes = function (tuples) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Internal$printKeyframeSelector, tuples));
};
var $rtfeldman$elm_css$Css$Animations$keyframes = function (tuples) {
	return $elm$core$List$isEmpty(tuples) ? {dA: 0, dH: 0, id: 'none'} : {
		dA: 0,
		dH: 0,
		id: $rtfeldman$elm_css$Css$Internal$compileKeyframes(tuples)
	};
};
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.id, argB.id])));
	});
var $rtfeldman$elm_css$Css$margin2 = $rtfeldman$elm_css$Css$prop2('margin');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$Internal$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Animations$property = F2(
	function (key, value) {
		return key + (':' + value);
	});
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $rtfeldman$elm_css$Css$relative = {bo: 0, id: 'relative'};
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $perzanko$elm_loading$Loading$Bars$view = function (config) {
	var withSpeed = function (x) {
		return $elm$core$String$fromFloat(x / config.fL);
	};
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto),
			A2($rtfeldman$elm_css$Css$property, 'display', 'flex'),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexEnd)
		]);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.fI / 3.5)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.fI / 3.5)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex(config.en)),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			withSpeed(1.5) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'ease-in-out'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'height',
								$elm$core$String$fromFloat(config.fI / 3.5) + 'px'),
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0)')
							])),
						_Utils_Tuple2(
						50,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'height',
								$elm$core$String$fromFloat(config.fI) + 'px'),
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0)')
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'height',
								$elm$core$String$fromFloat(config.fI / 3.5) + 'px'),
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0)')
							]))
					])))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.el)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(1) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.5) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.0000001) + 's')
								])))
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$block = {k: 0, id: 'block'};
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $perzanko$elm_loading$Loading$BouncingBalls$view = function (config) {
	var withSpeed = function (x) {
		return $elm$core$String$fromFloat(x / config.fL);
	};
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto),
			A2($rtfeldman$elm_css$Css$property, 'display', 'flex'),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.fI / 3.5)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.fI / 3.5)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex(config.en)),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			withSpeed(0.6) + 's'),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-delay',
			withSpeed(0.1) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'linear'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) translateZ(0) translate(0,0)')
							])),
						_Utils_Tuple2(
						50,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'transform',
								'translate3d(0,0,0) translateZ(0) translate(0,' + ($elm$core$String$fromFloat(config.fI / 3.5) + 'px)'))
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) translateZ(0) translate(0,0)')
							]))
					])))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.el)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.1) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.2) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.3) + 's')
								])))
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$absolute = {bo: 0, id: 'absolute'};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		aq: 0,
		Q: 0,
		hn: 0,
		cn: 0,
		ab: val,
		a1: '',
		bv: 0,
		id: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $perzanko$elm_loading$Loading$Circle$view = function (config) {
	var withSpeed = function (x) {
		return $elm$core$String$fromFloat(x / config.fL);
	};
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.fI * 0.95)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto)
		]);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.fI - (2 * (config.fI * 0.17)))),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.fI - (2 * (config.fI * 0.17)))),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(0)),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			withSpeed(1.33) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'cubic-bezier(.51,.92,.24,1.15)'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) rotate(0deg)')
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) rotate(720deg)')
							]))
					])))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.el)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$elm$core$List$concat(
							_List_fromArray(
								[
									childStyle,
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$property,
										'border',
										$elm$core$String$fromFloat(config.fI * 0.17) + ('px ' + (config.en + ' solid'))),
										$rtfeldman$elm_css$Css$opacity(
										$rtfeldman$elm_css$Css$num(0.25))
									])
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$elm$core$List$concat(
							_List_fromArray(
								[
									childStyle,
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$property,
										'border',
										$elm$core$String$fromFloat(config.fI * 0.17) + 'px transparent solid'),
										A2(
										$rtfeldman$elm_css$Css$property,
										'border-top',
										$elm$core$String$fromFloat(config.fI * 0.17) + ('px ' + (config.en + ' solid'))),
										$rtfeldman$elm_css$Css$opacity(
										$rtfeldman$elm_css$Css$num(0.8))
									])
								])))
					]),
				_List_Nil)
			]));
};
var $perzanko$elm_loading$Loading$DoubleBounce$view = function (config) {
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto)
		]);
	var innerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex(config.en)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.6)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
							])),
						_Utils_Tuple2(
						50,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1.0)')
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
							]))
					]))),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			$elm$core$String$fromFloat(2 / config.fL) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'ease-in-out'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite')
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.el)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(innerStyle)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$elm$core$List$concat(
							_List_fromArray(
								[
									innerStyle,
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$property,
										'animation-delay',
										'-' + ($elm$core$String$fromFloat(1 / config.fL) + 's'))
									])
								])))
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
};
var $rtfeldman$elm_css$Css$after = $rtfeldman$elm_css$Css$pseudoElement('after');
var $rtfeldman$elm_css$Css$before = $rtfeldman$elm_css$Css$pseudoElement('before');
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.id, argB.id, argC.id])));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$Animations$opacity = function (_v0) {
	var value = _v0.id;
	return 'opacity:' + value;
};
var $rtfeldman$elm_css$Css$solid = {v: 0, au: 0, id: 'solid'};
var $perzanko$elm_loading$Loading$Sonar$view = function (config) {
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$before(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\' \''),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(50)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(config.fI / 3)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(config.fI / 3)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'top',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.fI / 6) + 'px)')),
					A2(
					$rtfeldman$elm_css$Css$property,
					'left',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.fI / 6) + 'px)')),
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex(config.en)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'animation-duration',
					$elm$core$String$fromFloat(3 / config.fL) + 's'),
					A2($rtfeldman$elm_css$Css$property, 'animation-timing-funtion', 'linear'),
					A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
					$rtfeldman$elm_css$Css$animationName(
					$rtfeldman$elm_css$Css$Animations$keyframes(
						_List_fromArray(
							[
								_Utils_Tuple2(
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1))
									])),
								_Utils_Tuple2(
								15,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.5)')
									])),
								_Utils_Tuple2(
								60,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(4)'),
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0))
									])),
								_Utils_Tuple2(
								90,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(3)')
									])),
								_Utils_Tuple2(
								95,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1))
									])),
								_Utils_Tuple2(
								100,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1)')
									]))
							])))
				])),
			$rtfeldman$elm_css$Css$after(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\' \''),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(50)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(config.fI / 3)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(config.fI / 3)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'top',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.fI / 6) + 'px)')),
					A2(
					$rtfeldman$elm_css$Css$property,
					'left',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.fI / 6) + 'px)')),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$rtfeldman$elm_css$Css$hex(config.en)),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'animation-duration',
					$elm$core$String$fromFloat(3 / config.fL) + 's'),
					A2($rtfeldman$elm_css$Css$property, 'animation-timing-funtion', 'linear'),
					A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
					$rtfeldman$elm_css$Css$animationName(
					$rtfeldman$elm_css$Css$Animations$keyframes(
						_List_fromArray(
							[
								_Utils_Tuple2(
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1)')
									])),
								_Utils_Tuple2(
								30,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1)')
									])),
								_Utils_Tuple2(
								60,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0.3))
									])),
								_Utils_Tuple2(
								90,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(3)')
									])),
								_Utils_Tuple2(
								100,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0))
									]))
							])))
				]))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.el)
			]),
		_List_Nil);
};
var $perzanko$elm_loading$Loading$Spinner$view = function (config) {
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.fI)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto)
		]);
	var childs = A2($elm$core$List$range, 1, 12);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100))
		]);
	var calcAnimationDelay = function (x) {
		return (x === 1) ? '0s' : ($elm$core$String$fromFloat(-((1.1 - (x / 10)) / config.fL)) + 's');
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.el)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
					]),
				A2(
					$elm$core$List$map,
					function (x) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$pct(100)),
											$rtfeldman$elm_css$Css$height(
											$rtfeldman$elm_css$Css$pct(100)),
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$left(
											$rtfeldman$elm_css$Css$px(0)),
											$rtfeldman$elm_css$Css$top(
											$rtfeldman$elm_css$Css$px(0)),
											A2(
											$rtfeldman$elm_css$Css$property,
											'transform',
											'rotate(' + ($elm$core$String$fromInt((30 * x) - 30) + 'deg)')),
											$rtfeldman$elm_css$Css$before(
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Css$property,
													'animation-delay',
													calcAnimationDelay(x)),
													A2($rtfeldman$elm_css$Css$property, 'content', '\' \''),
													$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
													A2(
													$rtfeldman$elm_css$Css$margin2,
													$rtfeldman$elm_css$Css$px(0),
													$rtfeldman$elm_css$Css$auto),
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$pct(15)),
													$rtfeldman$elm_css$Css$height(
													$rtfeldman$elm_css$Css$pct(15)),
													$rtfeldman$elm_css$Css$backgroundColor(
													$rtfeldman$elm_css$Css$hex(config.en)),
													$rtfeldman$elm_css$Css$borderRadius(
													$rtfeldman$elm_css$Css$pct(100)),
													A2(
													$rtfeldman$elm_css$Css$property,
													'animation-duration',
													$elm$core$String$fromFloat(1.2 / config.fL) + 's'),
													A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
													A2($rtfeldman$elm_css$Css$property, 'animation-fill-mode', 'both'),
													$rtfeldman$elm_css$Css$animationName(
													$rtfeldman$elm_css$Css$Animations$keyframes(
														_List_fromArray(
															[
																_Utils_Tuple2(
																0,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
																	])),
																_Utils_Tuple2(
																40,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1.0)')
																	])),
																_Utils_Tuple2(
																80,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
																	])),
																_Utils_Tuple2(
																100,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
																	]))
															])))
												]))
										]))
								]),
							_List_Nil);
					},
					childs))
			]));
};
var $perzanko$elm_loading$Loading$render = F3(
	function (loaderType, config, loadingState) {
		var loader = function () {
			switch (loaderType) {
				case 0:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$DoubleBounce$view(config));
				case 1:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Spinner$view(config));
				case 2:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$BouncingBalls$view(config));
				case 3:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Bars$view(config));
				case 4:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Circle$view(config));
				default:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Sonar$view(config));
			}
		}();
		if (!loadingState) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading')
					]),
				_List_fromArray(
					[loader]));
		} else {
			return $elm$html$Html$text(' ');
		}
	});
var $author$project$RunEditor$busyOverlay = function (busy) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('busy-overlay'),
				A2(
				$elm$html$Html$Attributes$style,
				'display',
				busy ? 'block' : 'none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('overlay-content')
					]),
				_List_fromArray(
					[
						A3(
						$perzanko$elm_loading$Loading$render,
						1,
						_Utils_update(
							$perzanko$elm_loading$Loading$defaultConfig,
							{en: '#77f', fI: 50}),
						busy ? 0 : 1)
					]))
			]));
};
var $author$project$RunEditor$debugView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('DEBUG xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
					]))
			]));
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Success = 2;
var $rundis$elm_bootstrap$Bootstrap$Button$success = $rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled(2));
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs = function (a) {
	return {$: 4, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Button$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs(attrs_);
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size = modifier.a;
				return _Utils_update(
					options,
					{
						fI: $elm$core$Maybe$Just(size)
					});
			case 1:
				var coloring = modifier.a;
				return _Utils_update(
					options,
					{
						V: $elm$core$Maybe$Just(coloring)
					});
			case 2:
				return _Utils_update(
					options,
					{bQ: true});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{b2: val});
			default:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions = {bN: _List_Nil, bQ: false, V: $elm$core$Maybe$Nothing, b2: false, fI: $elm$core$Maybe$Nothing};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass = function (role) {
	switch (role) {
		case 0:
			return 'primary';
		case 1:
			return 'secondary';
		case 2:
			return 'success';
		case 3:
			return 'info';
		case 4:
			return 'warning';
		case 5:
			return 'danger';
		case 6:
			return 'dark';
		case 7:
			return 'light';
		default:
			return 'link';
	}
};
var $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('sm');
		case 2:
			return $elm$core$Maybe$Just('md');
		case 3:
			return $elm$core$Maybe$Just('lg');
		default:
			return $elm$core$Maybe$Just('xl');
	}
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier, $rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('btn', true),
						_Utils_Tuple2('btn-block', options.bQ),
						_Utils_Tuple2('disabled', options.b2)
					])),
				$elm$html$Html$Attributes$disabled(options.b2)
			]),
		_Utils_ap(
			function () {
				var _v0 = A2($elm$core$Maybe$andThen, $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption, options.fI);
				if (!_v0.$) {
					var s = _v0.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn-' + s)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = options.V;
					if (!_v1.$) {
						if (!_v1.a.$) {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									'btn-' + $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						} else {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									'btn-outline-' + $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						}
					} else {
						return _List_Nil;
					}
				}(),
				options.bN)));
};
var $rundis$elm_bootstrap$Bootstrap$Button$button = F2(
	function (options, children) {
		return A2(
			$elm$html$Html$button,
			$rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes(options),
			children);
	});
var $rundis$elm_bootstrap$Bootstrap$General$Internal$SM = 1;
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Size = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Button$small = $rundis$elm_bootstrap$Bootstrap$Internal$Button$Size(1);
var $author$project$CommonView$textButtonStyle = F4(
	function (style, disabled, text, click) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Button$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Button$small,
						$rundis$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(click),
								$elm$html$Html$Attributes$class('text-nowrap'),
								$elm$html$Html$Attributes$disabled(disabled),
								$elm$html$Html$Attributes$class('text-btn-run-editor')
							]))
					]),
				style),
			_List_fromArray(
				[
					$elm$html$Html$text(text)
				]));
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$RunEditor$errorDiv = F2(
	function (err_msgs, retry_msg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('error-box'),
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-12')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('alert alert-danger')
										]),
									_List_fromArray(
										[
											function () {
											if (err_msgs.b && (!err_msgs.b.b)) {
												var one = err_msgs.a;
												return $elm$html$Html$text(one);
											} else {
												return A2(
													$elm$html$Html$ul,
													_List_Nil,
													A2(
														$elm$core$List$map,
														function (m) {
															return A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(m)
																	]));
														},
														err_msgs));
											}
										}(),
											function () {
											if (!retry_msg.$) {
												var msg = retry_msg.a;
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('float-right')
														]),
													_List_fromArray(
														[
															A4(
															$author$project$CommonView$textButtonStyle,
															_List_fromArray(
																[$rundis$elm_bootstrap$Bootstrap$Button$success]),
															false,
															'Daten erneut senden',
															msg)
														]));
											} else {
												return $elm$html$Html$text('');
											}
										}()
										]))
								]))
						]))
				]));
	});
var $author$project$Types$CloseModalGroup = {$: 23};
var $rundis$elm_bootstrap$Bootstrap$Grid$Column = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Grid$col = F2(
	function (options, children) {
		return $rundis$elm_bootstrap$Bootstrap$Grid$Column(
			{gi: children, hs: options});
	});
var $author$project$Types$UpdateEditingGroup = F3(
	function (a, b, c) {
		return {$: 22, a: a, b: b, c: c};
	});
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Run$View$FormsHelper$bsFormGroup = F5(
	function (label, help, required, has_error, input) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-group', true),
							_Utils_Tuple2('has-error', has_error)
						]))
				]),
			_List_fromArray(
				[
					(label === '') ? $elm$html$Html$text('') : A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('required', required)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					input,
					function () {
					if (help.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var h = help.a;
						var container = has_error ? $elm$html$Html$div : $elm$html$Html$small;
						return A2(
							container,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-text', true),
											_Utils_Tuple2('text-muted', !has_error)
										]))
								]),
							_List_fromArray(
								[h]));
					}
				}()
				]));
	});
var $author$project$Helper$onInput = function (msgCreator) {
	return A2(
		$elm$html$Html$Events$on,
		'input',
		A2($elm$json$Json$Decode$map, msgCreator, $elm$html$Html$Events$targetValue));
};
var $author$project$Run$View$GroupEdit$form_ = F2(
	function (frozen, group) {
		return _List_fromArray(
			[
				A5(
				$author$project$Run$View$FormsHelper$bsFormGroup,
				'Kurzname',
				$elm$core$Maybe$Nothing,
				false,
				false,
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(group.hX),
							$author$project$Helper$onChange(
							$author$project$Helper$passValueToRunMsg(
								A2($author$project$Types$UpdateEditingGroup, group, 'shortname'))),
							$elm$html$Html$Attributes$class('form-control')
						]),
					_List_Nil)),
				A5(
				$author$project$Run$View$FormsHelper$bsFormGroup,
				'Name',
				$elm$core$Maybe$Nothing,
				false,
				false,
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(group.dG),
							$author$project$Helper$onChange(
							$author$project$Helper$passValueToRunMsg(
								A2($author$project$Types$UpdateEditingGroup, group, 'name'))),
							$elm$html$Html$Attributes$class('form-control')
						]),
					_List_Nil)),
				A5(
				$author$project$Run$View$FormsHelper$bsFormGroup,
				'Anzahl Proben',
				frozen ? $elm$core$Maybe$Just(
					$elm$html$Html$text('Diese Gruppe ist bereits gebuchten Prozess-Schritten zugeordnet.')) : $elm$core$Maybe$Nothing,
				false,
				false,
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromInt(group.ih)),
							$elm$html$Html$Attributes$type_('number'),
							A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
							$elm$html$Html$Attributes$disabled(frozen),
							$author$project$Helper$onInput(
							$author$project$Helper$passValueToRunMsg(
								A2($author$project$Types$UpdateEditingGroup, group, 'wafer_count'))),
							$elm$html$Html$Attributes$class('form-control')
						]),
					_List_Nil)),
				A5(
				$author$project$Run$View$FormsHelper$bsFormGroup,
				'Bezeichnungen der Proben',
				$elm$core$Maybe$Just(
					$elm$html$Html$text('Bitte jede Bezeichnung in eine eigene Zeile schreiben, weil in einer späteren ibook-Version diese Liste exportierbar (CSV) sein wird und die einzelnen Proben in den Prozessschritten als entnommen / zerstört markiert werden sollen!')),
				false,
				false,
				$rundis$elm_bootstrap$Bootstrap$Form$Textarea$textarea(
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Form$Textarea$id('operator-note-input'),
							$rundis$elm_bootstrap$Bootstrap$Form$Textarea$rows(7),
							$rundis$elm_bootstrap$Bootstrap$Form$Textarea$value(group.ii),
							$rundis$elm_bootstrap$Bootstrap$Form$Textarea$attrs(
							_List_fromArray(
								[
									$author$project$Helper$onChange(
									$author$project$Helper$passValueToRunMsg(
										A2($author$project$Types$UpdateEditingGroup, group, 'wafer_labels'))),
									$elm$html$Html$Attributes$class('form-control')
								]))
						])))
			]);
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$Col = 0;
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$Width = F2(
	function (screenSize, columnCount) {
		return {eo: columnCount, fD: screenSize};
	});
var $rundis$elm_bootstrap$Bootstrap$General$Internal$XS = 0;
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColAlign = F2(
	function (align_, options) {
		var _v0 = align_.fD;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						bJ: $elm$core$Maybe$Just(align_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						bH: $elm$core$Maybe$Just(align_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						bG: $elm$core$Maybe$Just(align_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						bF: $elm$core$Maybe$Just(align_)
					});
			default:
				return _Utils_update(
					options,
					{
						bI: $elm$core$Maybe$Just(align_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOffset = F2(
	function (offset_, options) {
		var _v0 = offset_.fD;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						ct: $elm$core$Maybe$Just(offset_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						cq: $elm$core$Maybe$Just(offset_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						cp: $elm$core$Maybe$Just(offset_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						co: $elm$core$Maybe$Just(offset_)
					});
			default:
				return _Utils_update(
					options,
					{
						cs: $elm$core$Maybe$Just(offset_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOrder = F2(
	function (order_, options) {
		var _v0 = order_.fD;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						cE: $elm$core$Maybe$Just(order_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						cC: $elm$core$Maybe$Just(order_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						cB: $elm$core$Maybe$Just(order_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						cA: $elm$core$Maybe$Just(order_)
					});
			default:
				return _Utils_update(
					options,
					{
						cD: $elm$core$Maybe$Just(order_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPull = F2(
	function (pull_, options) {
		var _v0 = pull_.fD;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						cN: $elm$core$Maybe$Just(pull_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						cL: $elm$core$Maybe$Just(pull_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						cK: $elm$core$Maybe$Just(pull_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						cJ: $elm$core$Maybe$Just(pull_)
					});
			default:
				return _Utils_update(
					options,
					{
						cM: $elm$core$Maybe$Just(pull_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPush = F2(
	function (push_, options) {
		var _v0 = push_.fD;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						cS: $elm$core$Maybe$Just(push_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						cQ: $elm$core$Maybe$Just(push_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						cP: $elm$core$Maybe$Just(push_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						cO: $elm$core$Maybe$Just(push_)
					});
			default:
				return _Utils_update(
					options,
					{
						cR: $elm$core$Maybe$Just(push_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColWidth = F2(
	function (width_, options) {
		var _v0 = width_.fD;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						bB: $elm$core$Maybe$Just(width_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						bz: $elm$core$Maybe$Just(width_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						by: $elm$core$Maybe$Just(width_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						bx: $elm$core$Maybe$Just(width_)
					});
			default:
				return _Utils_update(
					options,
					{
						bA: $elm$core$Maybe$Just(width_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOption = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 6:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs)
					});
			case 0:
				var width_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColWidth, width_, options);
			case 1:
				var offset_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOffset, offset_, options);
			case 2:
				var pull_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPull, pull_, options);
			case 3:
				var push_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPush, push_, options);
			case 4:
				var order_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOrder, order_, options);
			case 5:
				var align = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColAlign, align, options);
			default:
				var align = modifier.a;
				return _Utils_update(
					options,
					{
						c1: $elm$core$Maybe$Just(align)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$columnCountOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('1');
		case 2:
			return $elm$core$Maybe$Just('2');
		case 3:
			return $elm$core$Maybe$Just('3');
		case 4:
			return $elm$core$Maybe$Just('4');
		case 5:
			return $elm$core$Maybe$Just('5');
		case 6:
			return $elm$core$Maybe$Just('6');
		case 7:
			return $elm$core$Maybe$Just('7');
		case 8:
			return $elm$core$Maybe$Just('8');
		case 9:
			return $elm$core$Maybe$Just('9');
		case 10:
			return $elm$core$Maybe$Just('10');
		case 11:
			return $elm$core$Maybe$Just('11');
		case 12:
			return $elm$core$Maybe$Just('12');
		default:
			return $elm$core$Maybe$Just('auto');
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthClass = function (_v0) {
	var screenSize = _v0.fD;
	var columnCount = _v0.eo;
	return $elm$html$Html$Attributes$class(
		'col' + (A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return '-' + v;
				},
				$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))) + A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return '-' + v;
				},
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$columnCountOption(columnCount)))));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthsToAttributes = function (widths) {
	var width_ = function (w) {
		return A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthClass, w);
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, width_, widths));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultColOptions = {bF: $elm$core$Maybe$Nothing, bG: $elm$core$Maybe$Nothing, bH: $elm$core$Maybe$Nothing, bI: $elm$core$Maybe$Nothing, bJ: $elm$core$Maybe$Nothing, bN: _List_Nil, co: $elm$core$Maybe$Nothing, cp: $elm$core$Maybe$Nothing, cq: $elm$core$Maybe$Nothing, cs: $elm$core$Maybe$Nothing, ct: $elm$core$Maybe$Nothing, cA: $elm$core$Maybe$Nothing, cB: $elm$core$Maybe$Nothing, cC: $elm$core$Maybe$Nothing, cD: $elm$core$Maybe$Nothing, cE: $elm$core$Maybe$Nothing, cJ: $elm$core$Maybe$Nothing, cK: $elm$core$Maybe$Nothing, cL: $elm$core$Maybe$Nothing, cM: $elm$core$Maybe$Nothing, cN: $elm$core$Maybe$Nothing, cO: $elm$core$Maybe$Nothing, cP: $elm$core$Maybe$Nothing, cQ: $elm$core$Maybe$Nothing, cR: $elm$core$Maybe$Nothing, cS: $elm$core$Maybe$Nothing, c1: $elm$core$Maybe$Nothing, bx: $elm$core$Maybe$Nothing, by: $elm$core$Maybe$Nothing, bz: $elm$core$Maybe$Nothing, bA: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetCountOption = function (size) {
	switch (size) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		default:
			return '11';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString = function (screenSize) {
	var _v0 = $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize);
	if (!_v0.$) {
		var s = _v0.a;
		return '-' + (s + '-');
	} else {
		return '-';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetClass = function (_v0) {
	var screenSize = _v0.fD;
	var offsetCount = _v0.fb;
	return $elm$html$Html$Attributes$class(
		'offset' + ($rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetCountOption(offsetCount)));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetsToAttributes = function (offsets) {
	var offset_ = function (m) {
		return A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetClass, m);
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, offset_, offsets));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderColOption = function (size) {
	switch (size) {
		case 0:
			return 'first';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		case 11:
			return '11';
		case 12:
			return '12';
		default:
			return 'last';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderToAttributes = function (orders) {
	var order_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.fD;
			var moveCount = m.a.aV;
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class(
					'order' + ($rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderColOption(moveCount))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, order_, orders));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption = function (size) {
	switch (size) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		case 11:
			return '11';
		default:
			return '12';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$pullsToAttributes = function (pulls) {
	var pull_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.fD;
			var moveCount = m.a.aV;
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class(
					'pull' + ($rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $rundis$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption(moveCount))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, pull_, pulls));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$pushesToAttributes = function (pushes) {
	var push_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.fD;
			var moveCount = m.a.aV;
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class(
					'push' + ($rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $rundis$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption(moveCount))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, push_, pushes));
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignDirOption = function (dir) {
	switch (dir) {
		case 1:
			return 'center';
		case 0:
			return 'left';
		default:
			return 'right';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass = function (_v0) {
	var dir = _v0.eu;
	var size = _v0.fI;
	return $elm$html$Html$Attributes$class(
		'text' + (A2(
			$elm$core$Maybe$withDefault,
			'-',
			A2(
				$elm$core$Maybe$map,
				function (s) {
					return '-' + (s + '-');
				},
				$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size))) + $rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignDirOption(dir)));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$verticalAlignOption = function (align) {
	switch (align) {
		case 0:
			return 'start';
		case 1:
			return 'center';
		default:
			return 'end';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignClass = F2(
	function (prefix, _v0) {
		var align = _v0.d7;
		var screenSize = _v0.fD;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(
				prefix,
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function (v) {
								return v + '-';
							},
							$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))),
					$rundis$elm_bootstrap$Bootstrap$Grid$Internal$verticalAlignOption(align))));
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes = F2(
	function (prefix, aligns) {
		var align = function (a) {
			return A2(
				$elm$core$Maybe$map,
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignClass(prefix),
				a);
		};
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2($elm$core$List$map, align, aligns));
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOption, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultColOptions, modifiers);
	var shouldAddDefaultXs = !$elm$core$List$length(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[options.bB, options.bz, options.by, options.bx, options.bA])));
	return _Utils_ap(
		$rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthsToAttributes(
			_List_fromArray(
				[
					shouldAddDefaultXs ? $elm$core$Maybe$Just(
					A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$Width, 0, 0)) : options.bB,
					options.bz,
					options.by,
					options.bx,
					options.bA
				])),
		_Utils_ap(
			$rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetsToAttributes(
				_List_fromArray(
					[options.ct, options.cq, options.cp, options.co, options.cs])),
			_Utils_ap(
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$pullsToAttributes(
					_List_fromArray(
						[options.cN, options.cL, options.cK, options.cJ, options.cM])),
				_Utils_ap(
					$rundis$elm_bootstrap$Bootstrap$Grid$Internal$pushesToAttributes(
						_List_fromArray(
							[options.cS, options.cQ, options.cP, options.cO, options.cR])),
					_Utils_ap(
						$rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderToAttributes(
							_List_fromArray(
								[options.cE, options.cC, options.cB, options.cA, options.cD])),
						_Utils_ap(
							A2(
								$rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes,
								'align-self-',
								_List_fromArray(
									[options.bJ, options.bH, options.bG, options.bF, options.bI])),
							_Utils_ap(
								function () {
									var _v0 = options.c1;
									if (!_v0.$) {
										var a = _v0.a;
										return _List_fromArray(
											[
												$rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass(a)
											]);
									} else {
										return _List_Nil;
									}
								}(),
								options.bN)))))));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $rundis$elm_bootstrap$Bootstrap$Grid$renderCol = function (column) {
	switch (column.$) {
		case 0:
			var options = column.a.hs;
			var children = column.a.gi;
			return A2(
				$elm$html$Html$div,
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes(options),
				children);
		case 1:
			var e = column.a;
			return e;
		default:
			var options = column.a.hs;
			var children = column.a.gi;
			return A3(
				$elm$html$Html$Keyed$node,
				'div',
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes(options),
				children);
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowHAlign = F2(
	function (align, options) {
		var _v0 = align.fD;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						ca: $elm$core$Maybe$Just(align)
					});
			case 1:
				return _Utils_update(
					options,
					{
						b8: $elm$core$Maybe$Just(align)
					});
			case 2:
				return _Utils_update(
					options,
					{
						b7: $elm$core$Maybe$Just(align)
					});
			case 3:
				return _Utils_update(
					options,
					{
						b6: $elm$core$Maybe$Just(align)
					});
			default:
				return _Utils_update(
					options,
					{
						b9: $elm$core$Maybe$Just(align)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowVAlign = F2(
	function (align_, options) {
		var _v0 = align_.fD;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						da: $elm$core$Maybe$Just(align_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						c8: $elm$core$Maybe$Just(align_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						c7: $elm$core$Maybe$Just(align_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						c6: $elm$core$Maybe$Just(align_)
					});
			default:
				return _Utils_update(
					options,
					{
						c9: $elm$core$Maybe$Just(align_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowOption = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 2:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs)
					});
			case 0:
				var align = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowVAlign, align, options);
			default:
				var align = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowHAlign, align, options);
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultRowOptions = {bN: _List_Nil, b6: $elm$core$Maybe$Nothing, b7: $elm$core$Maybe$Nothing, b8: $elm$core$Maybe$Nothing, b9: $elm$core$Maybe$Nothing, ca: $elm$core$Maybe$Nothing, c6: $elm$core$Maybe$Nothing, c7: $elm$core$Maybe$Nothing, c8: $elm$core$Maybe$Nothing, c9: $elm$core$Maybe$Nothing, da: $elm$core$Maybe$Nothing};
var $rundis$elm_bootstrap$Bootstrap$General$Internal$horizontalAlignOption = function (align) {
	switch (align) {
		case 0:
			return 'start';
		case 1:
			return 'center';
		case 2:
			return 'end';
		case 3:
			return 'around';
		default:
			return 'between';
	}
};
var $rundis$elm_bootstrap$Bootstrap$General$Internal$hAlignClass = function (_v0) {
	var align = _v0.d7;
	var screenSize = _v0.fD;
	return $elm$html$Html$Attributes$class(
		'justify-content-' + (A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return v + '-';
				},
				$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))) + $rundis$elm_bootstrap$Bootstrap$General$Internal$horizontalAlignOption(align)));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$hAlignsToAttributes = function (aligns) {
	var align = function (a) {
		return A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$General$Internal$hAlignClass, a);
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, align, aligns));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$rowAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowOption, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultRowOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_Utils_ap(
			A2(
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes,
				'align-items-',
				_List_fromArray(
					[options.da, options.c8, options.c7, options.c6, options.c9])),
			_Utils_ap(
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$hAlignsToAttributes(
					_List_fromArray(
						[options.ca, options.b8, options.b7, options.b6, options.b9])),
				options.bN)));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$row = F2(
	function (options, cols) {
		return A2(
			$elm$html$Html$div,
			$rundis$elm_bootstrap$Bootstrap$Grid$Internal$rowAttributes(options),
			A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Grid$renderCol, cols));
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$simpleRow = function (cols) {
	return A2($rundis$elm_bootstrap$Bootstrap$Grid$row, _List_Nil, cols);
};
var $author$project$Run$View$GroupEdit$groupForm = F2(
	function (frozen, group) {
		return $rundis$elm_bootstrap$Bootstrap$Grid$simpleRow(
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$col,
					_List_Nil,
					A2($author$project$Run$View$GroupEdit$form_, frozen, group))
				]));
	});
var $author$project$Helper$htmlEmpty = $elm$html$Html$text('');
var $author$project$Types$HideModal = {$: 4};
var $rundis$elm_bootstrap$Bootstrap$Modal$Config = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$General$Internal$LG = 3;
var $rundis$elm_bootstrap$Bootstrap$Modal$large = function (_v0) {
	var conf = _v0;
	var options = conf.hs;
	return _Utils_update(
		conf,
		{
			hs: _Utils_update(
				options,
				{
					bl: $elm$core$Maybe$Just(3)
				})
		});
};
var $rundis$elm_bootstrap$Bootstrap$Modal$Body = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Modal$body = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				E: $elm$core$Maybe$Just(
					{bN: attributes, gi: children})
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$centered = F2(
	function (val, _v0) {
		var conf = _v0;
		var options = conf.hs;
		return _Utils_update(
			conf,
			{
				hs: _Utils_update(
					options,
					{bU: val})
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$config = function (closeMsg) {
	return {
		E: $elm$core$Maybe$Nothing,
		a7: closeMsg,
		dt: $elm$core$Maybe$Nothing,
		cc: $elm$core$Maybe$Nothing,
		hs: {bO: _List_Nil, bU: true, bb: true, bl: $elm$core$Maybe$Nothing, cY: false},
		az: $elm$core$Maybe$Nothing
	};
};
var $rundis$elm_bootstrap$Bootstrap$Modal$Footer = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Modal$footer = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				dt: $elm$core$Maybe$Just(
					{bN: attributes, gi: children})
			});
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $rundis$elm_bootstrap$Bootstrap$Modal$Header = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Modal$header = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				cc: $elm$core$Maybe$Just(
					{bN: attributes, gi: children})
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$titledHeader = F3(
	function (itemFn, attributes, children) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Modal$header,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					itemFn,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('modal-title'),
						attributes),
					children)
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$h4 = $rundis$elm_bootstrap$Bootstrap$Modal$titledHeader($elm$html$Html$h4);
var $rundis$elm_bootstrap$Bootstrap$Modal$hideOnBackdropClick = F2(
	function (hide, _v0) {
		var conf = _v0;
		var options = conf.hs;
		return _Utils_update(
			conf,
			{
				hs: _Utils_update(
					options,
					{bb: hide})
			});
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Modal$makeActionButton = function (_v0) {
	var option = _v0.a;
	var caption = _v0.b;
	var action = _v0.c;
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Button$button,
		_List_fromArray(
			[
				option,
				$rundis$elm_bootstrap$Bootstrap$Button$attrs(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(action),
						$elm$html$Html$Attributes$disabled(
						_Utils_eq(
							action,
							$author$project$Types$GotCommonMsg($author$project$Types$NoAction))),
						$elm$html$Html$Attributes$class('m-1')
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(caption)
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Primary = 0;
var $rundis$elm_bootstrap$Bootstrap$Button$primary = $rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled(0));
var $rundis$elm_bootstrap$Bootstrap$Modal$scrollableBody = F2(
	function (scrollable, _v0) {
		var conf = _v0;
		var options = conf.hs;
		return _Utils_update(
			conf,
			{
				hs: _Utils_update(
					options,
					{cY: scrollable})
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Secondary = 1;
var $rundis$elm_bootstrap$Bootstrap$Button$secondary = $rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled(1));
var $rundis$elm_bootstrap$Bootstrap$Modal$Show = 0;
var $rundis$elm_bootstrap$Bootstrap$Modal$shown = 0;
var $rundis$elm_bootstrap$Bootstrap$Modal$StartClose = 1;
var $rundis$elm_bootstrap$Bootstrap$Modal$getCloseMsg = function (config_) {
	var _v0 = config_.az;
	if (!_v0.$) {
		var animationMsg = _v0.a;
		return animationMsg(1);
	} else {
		return config_.a7;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Modal$isFade = function (conf) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return true;
			},
			conf.az));
};
var $rundis$elm_bootstrap$Bootstrap$Modal$backdrop = F2(
	function (visibility, conf) {
		var attributes = function () {
			switch (visibility) {
				case 0:
					return _Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('modal-backdrop', true),
										_Utils_Tuple2(
										'fade',
										$rundis$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
										_Utils_Tuple2('show', true)
									]))
							]),
						conf.hs.bb ? _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$rundis$elm_bootstrap$Bootstrap$Modal$getCloseMsg(conf))
							]) : _List_Nil);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('fade', true),
									_Utils_Tuple2('show', true)
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('fade', true),
									_Utils_Tuple2('show', false)
								]))
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', false),
									_Utils_Tuple2(
									'fade',
									$rundis$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
									_Utils_Tuple2('show', false)
								]))
						]);
			}
		}();
		return _List_fromArray(
			[
				A2($elm$html$Html$div, attributes, _List_Nil)
			]);
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['className']),
	$elm$json$Json$Decode$string);
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $rundis$elm_bootstrap$Bootstrap$Modal$containerClickDecoder = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (c) {
			return A2($elm$core$String$contains, 'elm-bootstrap-modal', c) ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignoring');
		},
		$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$target($rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className));
};
var $rundis$elm_bootstrap$Bootstrap$Modal$display = F2(
	function (visibility, conf) {
		switch (visibility) {
			case 0:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2(
								'fade',
								$rundis$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
								_Utils_Tuple2('show', true)
							]))
					]);
			case 1:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('fade', true),
								_Utils_Tuple2('show', true)
							]))
					]);
			case 2:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('fade', true),
								_Utils_Tuple2('show', false)
							])),
						A2(
						$elm$html$Html$Events$on,
						'transitionend',
						$elm$json$Json$Decode$succeed(conf.a7))
					]);
			default:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'height', '0px'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2(
								'fade',
								$rundis$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
								_Utils_Tuple2('show', false)
							]))
					]);
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$modalClass = function (size) {
	var _v0 = $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size);
	if (!_v0.$) {
		var s = _v0.a;
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-' + s)
			]);
	} else {
		return _List_Nil;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Modal$modalAttributes = function (options) {
	return _Utils_ap(
		options.bO,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal-dialog', true),
							_Utils_Tuple2('modal-dialog-centered', options.bU),
							_Utils_Tuple2('modal-dialog-scrollable', options.cY)
						])),
					A2($elm$html$Html$Attributes$style, 'pointer-events', 'auto')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Modal$modalClass, options.bl))));
};
var $rundis$elm_bootstrap$Bootstrap$Modal$renderBody = function (maybeBody) {
	if (!maybeBody.$) {
		var cfg = maybeBody.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('modal-body'),
					cfg.bN),
				cfg.gi));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Modal$renderFooter = function (maybeFooter) {
	if (!maybeFooter.$) {
		var cfg = maybeFooter.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('modal-footer'),
					cfg.bN),
				cfg.gi));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Modal$closeButton = function (closeMsg) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('close'),
				$elm$html$Html$Events$onClick(closeMsg)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('×')
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Modal$renderHeader = function (conf_) {
	var _v0 = conf_.cc;
	if (!_v0.$) {
		var cfg = _v0.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('modal-header'),
					cfg.bN),
				_Utils_ap(
					cfg.gi,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Modal$closeButton(
							$rundis$elm_bootstrap$Bootstrap$Modal$getCloseMsg(conf_))
						]))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $rundis$elm_bootstrap$Bootstrap$Modal$view = F2(
	function (visibility, _v0) {
		var conf = _v0;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$tabindex(-1)
								]),
							A2($rundis$elm_bootstrap$Bootstrap$Modal$display, visibility, conf)),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_Utils_ap(
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'role', 'document'),
											$elm$html$Html$Attributes$class('elm-bootstrap-modal')
										]),
									_Utils_ap(
										$rundis$elm_bootstrap$Bootstrap$Modal$modalAttributes(conf.hs),
										conf.hs.bb ? _List_fromArray(
											[
												A2(
												$elm$html$Html$Events$on,
												'click',
												$rundis$elm_bootstrap$Bootstrap$Modal$containerClickDecoder(conf.a7))
											]) : _List_Nil)),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('modal-content')
											]),
										A2(
											$elm$core$List$filterMap,
											$elm$core$Basics$identity,
											_List_fromArray(
												[
													$rundis$elm_bootstrap$Bootstrap$Modal$renderHeader(conf),
													$rundis$elm_bootstrap$Bootstrap$Modal$renderBody(conf.E),
													$rundis$elm_bootstrap$Bootstrap$Modal$renderFooter(conf.dt)
												])))
									]))
							]))
					]),
				A2($rundis$elm_bootstrap$Bootstrap$Modal$backdrop, visibility, conf)));
	});
var $author$project$Modal$makeModal = F7(
	function (modal, maybe_special_header, size, centered, left_actions, right_actions, maybe_hide_msg) {
		var left_buttons = A2($elm$core$List$map, $author$project$Modal$makeActionButton, left_actions);
		var _v0 = function () {
			if (maybe_hide_msg.$ === 1) {
				return _Utils_Tuple2(
					$author$project$Types$GotCommonMsg($author$project$Types$NoAction),
					false);
			} else {
				var m = maybe_hide_msg.a;
				return _Utils_Tuple2(m, true);
			}
		}();
		var hide_msg = _v0.a;
		var hide_on_backdrop_click = _v0.b;
		var right_buttons = function () {
			if (!right_actions.b) {
				return _List_fromArray(
					[
						A2(
						$rundis$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Button$primary,
								$rundis$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(hide_msg)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Schließen')
							]))
					]);
			} else {
				return A2(
					$elm$core$List$map,
					function (_v5) {
						var caption = _v5.a;
						var action = _v5.b;
						var option = _Utils_eq(
							$elm_community$list_extra$List$Extra$last(right_actions),
							$elm$core$Maybe$Just(
								_Utils_Tuple2(caption, action))) ? $rundis$elm_bootstrap$Bootstrap$Button$primary : $rundis$elm_bootstrap$Bootstrap$Button$secondary;
						return $author$project$Modal$makeActionButton(
							_Utils_Tuple3(option, caption, action));
					},
					right_actions);
			}
		}();
		var footer = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-100 m-0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('float-left')
							]),
						left_buttons),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('float-right')
							]),
						right_buttons)
					]))
			]);
		var _v2 = function () {
			if (maybe_special_header.$ === 1) {
				return _Utils_Tuple2(
					A2(
						$rundis$elm_bootstrap$Bootstrap$Modal$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(modal.h7)
							])),
					modal.E);
			} else {
				var h = maybe_special_header.a;
				return _Utils_Tuple2(
					A2(
						$rundis$elm_bootstrap$Bootstrap$Modal$header,
						_List_Nil,
						_List_fromArray(
							[h])),
					modal.E);
			}
		}();
		var header = _v2.a;
		var body = _v2.b;
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Modal$view,
			$rundis$elm_bootstrap$Bootstrap$Modal$shown,
			A3(
				$rundis$elm_bootstrap$Bootstrap$Modal$footer,
				_List_Nil,
				footer,
				A3(
					$rundis$elm_bootstrap$Bootstrap$Modal$body,
					_List_Nil,
					_List_fromArray(
						[modal.E]),
					header(
						A2(
							$rundis$elm_bootstrap$Bootstrap$Modal$scrollableBody,
							true,
							A2(
								$rundis$elm_bootstrap$Bootstrap$Modal$hideOnBackdropClick,
								hide_on_backdrop_click,
								A2(
									$rundis$elm_bootstrap$Bootstrap$Modal$centered,
									centered,
									size(
										$rundis$elm_bootstrap$Bootstrap$Modal$config(hide_msg)))))))));
	});
var $author$project$Modal$makeModalLarge = F2(
	function (modal, actions) {
		return A7(
			$author$project$Modal$makeModal,
			modal,
			$elm$core$Maybe$Nothing,
			$rundis$elm_bootstrap$Bootstrap$Modal$large,
			true,
			_List_Nil,
			actions,
			$elm$core$Maybe$Just(
				$author$project$Types$GotCommonMsg($author$project$Types$HideModal)));
	});
var $author$project$Run$View$GroupEdit$splitForm = F2(
	function (group1, group2) {
		return $rundis$elm_bootstrap$Bootstrap$Grid$simpleRow(
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$col,
					_List_Nil,
					A2($author$project$Run$View$GroupEdit$form_, false, group1)),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$col,
					_List_Nil,
					A2($author$project$Run$View$GroupEdit$form_, false, group2))
				]));
	});
var $author$project$Run$View$GroupEdit$groupEdit = function (group) {
	return A2(
		$author$project$Modal$makeModalLarge,
		function () {
			switch (group.$) {
				case 2:
					var g = group.a;
					var frozen = group.b;
					return A2(
						$author$project$Types$Modal,
						'Gruppe bearbeiten',
						A2($author$project$Run$View$GroupEdit$groupForm, frozen, g));
				case 3:
					var g = group.a;
					return A2(
						$author$project$Types$Modal,
						'Gruppe kopieren',
						A2($author$project$Run$View$GroupEdit$groupForm, false, g));
				case 1:
					var g = group.a;
					return A2(
						$author$project$Types$Modal,
						'Neue Gruppe',
						A2($author$project$Run$View$GroupEdit$groupForm, false, g));
				case 4:
					var g = group.a;
					var old_group = group.b;
					return A2(
						$author$project$Types$Modal,
						'Gruppe splitten',
						A2($author$project$Run$View$GroupEdit$splitForm, old_group, g));
				default:
					return A2($author$project$Types$Modal, 'Keine Gruppe zu editieren', $author$project$Helper$htmlEmpty);
			}
		}(),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'Annehmen',
				$author$project$Types$GotRunMsg($author$project$Types$CloseModalGroup))
			]));
};
var $author$project$Types$CloseModalItem = function (a) {
	return {$: 19, a: a};
};
var $author$project$Types$CreateItemForUnprocessedSamples = function (a) {
	return {$: 14, a: a};
};
var $author$project$Types$DiscardItemChange = function (a) {
	return {$: 18, a: a};
};
var $author$project$Types$OpenConfirm = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Run$ItemHelper$isOperator = F2(
	function (model, item) {
		var _v0 = item.hN;
		if (_v0.$ === 1) {
			return false;
		} else {
			var res = _v0.a;
			var _v1 = res.hr;
			if (!_v1.$) {
				var id = _v1.a;
				return _Utils_eq(id, model.a9.gq.an);
			} else {
				return false;
			}
		}
	});
var $author$project$Run$ItemHelper$canCreateItemForUnprocessedSamples = F2(
	function (model, item) {
		var not_yet_created = !A2(
			$elm$core$List$any,
			function (i) {
				return _Utils_eq(
					i.hE,
					$elm$core$Maybe$Just(item.an));
			},
			model.dz);
		var has_unprocessend_samples = function (sum) {
			return sum > 0;
		}(
			$elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.h8;
					},
					$elm$core$Dict$values(item.gR))));
		return ((!model.fq) || A2($author$project$Run$ItemHelper$isOperator, model, item)) && (has_unprocessend_samples && not_yet_created);
	});
var $author$project$Types$UpdateItemState = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Danger = 5;
var $rundis$elm_bootstrap$Bootstrap$Button$danger = $rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled(5));
var $author$project$Run$ItemHelper$wasExecutionStarted = function (item) {
	if (!item.h1) {
		var _v0 = $elm$core$List$head(item.hA);
		if (_v0.$ === 1) {
			return (!A2($author$project$Run$ItemHelper$isParamEmpty, item.gH, 'Operator')) || (!A2($author$project$Run$ItemHelper$isParamEmpty, item.gH, 'Start'));
		} else {
			var param = _v0.a;
			return !_Utils_eq(param.hv, $elm$core$Maybe$Nothing);
		}
	} else {
		return true;
	}
};
var $author$project$Run$View$ItemEditTabs$changeItemStateButtons = F2(
	function (item, errors) {
		return A2(
			$elm$core$List$map,
			function (_v4) {
				var option = _v4.a;
				var caption = _v4.b;
				var action = _v4.c;
				return _Utils_Tuple3(option, caption, action);
			},
			function () {
				var _v0 = _Utils_Tuple2(item.h1, errors);
				if (_v0.b) {
					return _List_fromArray(
						[
							_Utils_Tuple3(
							$rundis$elm_bootstrap$Bootstrap$Button$danger,
							'Fehler im Formular',
							$author$project$Types$GotCommonMsg($author$project$Types$NoAction))
						]);
				} else {
					switch (_v0.a) {
						case 0:
							var _v1 = _v0.a;
							return _List_fromArray(
								[
									$author$project$Run$ItemHelper$wasExecutionStarted(item) ? ($author$project$Run$ItemHelper$isStopParamEmpty(item) ? _Utils_Tuple3(
									$rundis$elm_bootstrap$Bootstrap$Button$secondary,
									'Durchführung fortsetzen',
									$author$project$Types$GotRunMsg(
										A2($author$project$Types$UpdateItemState, item, 1))) : _Utils_Tuple3(
									$rundis$elm_bootstrap$Bootstrap$Button$success,
									'Prozessschritt abschließen',
									$author$project$Types$GotRunMsg(
										A2($author$project$Types$UpdateItemState, item, 2)))) : _Utils_Tuple3(
									$rundis$elm_bootstrap$Bootstrap$Button$secondary,
									'Durchführung starten',
									$author$project$Types$GotRunMsg(
										A2($author$project$Types$UpdateItemState, item, 1)))
								]);
						case 1:
							var _v2 = _v0.a;
							return _List_fromArray(
								[
									_Utils_Tuple3(
									$rundis$elm_bootstrap$Bootstrap$Button$success,
									'Prozessschritt abschließen',
									$author$project$Types$GotRunMsg(
										A2($author$project$Types$UpdateItemState, item, 2)))
								]);
						default:
							var _v3 = _v0.a;
							return _List_fromArray(
								[
									_Utils_Tuple3(
									$rundis$elm_bootstrap$Bootstrap$Button$secondary,
									'Durchführung erneut bearbeiten',
									$author$project$Types$GotRunMsg(
										A2($author$project$Types$UpdateItemState, item, 1)))
								]);
					}
				}
			}());
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$attrs = F2(
	function (values, _v0) {
		var conf = _v0;
		var options = conf.hs;
		return _Utils_update(
			conf,
			{
				hs: _Utils_update(
					options,
					{bO: values})
			});
	});
var $author$project$Modal$itemEditing = F4(
	function (header, body, left_actions, right_actions) {
		return A7(
			$author$project$Modal$makeModal,
			{E: body, h7: ''},
			$elm$core$Maybe$Just(header),
			$rundis$elm_bootstrap$Bootstrap$Modal$attrs(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-item-editing modal-no-close')
					])),
			false,
			left_actions,
			right_actions,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Run$View$ItemEditTabs$getAdjacentItems = F2(
	function (items, item) {
		getAdjacentItems:
		while (true) {
			if (!items.b) {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			} else {
				if (!items.b.b) {
					var a = items.a;
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				} else {
					if (!items.b.b.b) {
						var a = items.a;
						var _v1 = items.b;
						var b = _v1.a;
						return _Utils_eq(a.an, item.an) ? _Utils_Tuple2(
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(b)) : (_Utils_eq(b.an, item.an) ? _Utils_Tuple2(
							$elm$core$Maybe$Just(a),
							$elm$core$Maybe$Nothing) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
					} else {
						var a = items.a;
						var _v2 = items.b;
						var b = _v2.a;
						var _v3 = _v2.b;
						var c = _v3.a;
						var rest = _v3.b;
						if (_Utils_eq(a.an, item.an)) {
							return _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(b));
						} else {
							if (_Utils_eq(b.an, item.an)) {
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(a),
									$elm$core$Maybe$Just(c));
							} else {
								var $temp$items = A2(
									$elm$core$List$cons,
									b,
									A2($elm$core$List$cons, c, rest)),
									$temp$item = item;
								items = $temp$items;
								item = $temp$item;
								continue getAdjacentItems;
							}
						}
					}
				}
			}
		}
	});
var $author$project$Run$ItemHelper$getPageNo = F2(
	function (items, item) {
		if (!items.b) {
			return 0;
		} else {
			var first_item = items.a;
			var rest = items.b;
			return _Utils_eq(first_item.an, item.an) ? 1 : (1 + A2($author$project$Run$ItemHelper$getPageNo, rest, item));
		}
	});
var $author$project$Helper$getProcessName = function (process) {
	var _v0 = A2($elm$core$String$split, ':', process.dG);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var _v1 = _v0.b;
		var _v2 = _v1.b;
		var name = _v2.a;
		return name;
	} else {
		return '';
	}
};
var $author$project$Helper$getProcessWithCategory = F2(
	function (processes, process_id) {
		var _v0 = A2(
			$author$project$Helper$getRecordById,
			processes,
			$elm$core$Maybe$Just(process_id));
		if (_v0.$ === 1) {
			return 'PROZESS NICHT GEFUNDEN!';
		} else {
			var p = _v0.a;
			var _v1 = $author$project$Helper$getProcessCategory(p);
			var main_category = _v1.a;
			var sub_category = _v1.b;
			return main_category + (' > ' + (sub_category + (' > ' + $author$project$Helper$getProcessName(p))));
		}
	});
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$CommonView$iconButtonBase = F5(
	function (tooltip_direction, style, icon, tooltip, events) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Button$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Button$small,
						$rundis$elm_bootstrap$Bootstrap$Button$attrs(
						_Utils_ap(
							events,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn-run-editor'),
										$elm$html$Html$Attributes$type_('button')
									]),
								(tooltip === '') ? _List_Nil : _List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'css-tooltip' + ((tooltip_direction === '') ? '' : ('-' + tooltip_direction))),
										A2($elm$html$Html$Attributes$attribute, 'data-tooltip', tooltip)
									]))))
					]),
				style),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fas fa-' + icon)
						]),
					_List_Nil)
				]));
	});
var $author$project$CommonView$iconButtonStyle = $author$project$CommonView$iconButtonBase('right');
var $author$project$CommonView$iconButton = function (icon) {
	return A3(
		$author$project$CommonView$iconButtonStyle,
		_List_fromArray(
			[$rundis$elm_bootstrap$Bootstrap$Button$secondary]),
		icon,
		'');
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$CommonView$warningMessageStyle = F3(
	function (icon, color_style, text) {
		return $elm$core$String$isEmpty(text) ? $author$project$Helper$htmlEmpty : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('css-tooltip-right mr-1'),
					A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
					A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle'),
					A2($elm$html$Html$Attributes$attribute, 'data-tooltip', text)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fa fa-' + (icon + (' text-' + color_style)))
						]),
					_List_Nil)
				]));
	});
var $author$project$CommonView$warningMessage = A2($author$project$CommonView$warningMessageStyle, 'exclamation-triangle', 'danger');
var $author$project$CommonView$add_on_warning = function (item) {
	return item.g5 ? $elm$core$Maybe$Just(
		$author$project$CommonView$warningMessage('Prozessschritt wurde nachträglich eingefügt!')) : $elm$core$Maybe$Nothing;
};
var $author$project$Helper$htmlIf = F2(
	function (cond, html) {
		return cond ? html : $author$project$Helper$htmlEmpty;
	});
var $author$project$CommonView$highlightIcon = function (highlight) {
	return A2(
		$author$project$Helper$htmlIf,
		highlight,
		A3($author$project$CommonView$warningMessageStyle, 'exclamation-circle', 'warning', 'Bei diesem Schritt Obacht geben!'));
};
var $author$project$CommonView$item_during_execution = function (item) {
	var _v0 = item.h1;
	if (_v0 === 1) {
		return $elm$core$Maybe$Just(
			A3($author$project$CommonView$warningMessageStyle, 'hourglass-half', 'dark', 'Durchführung läuft'));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$CommonView$item_has_attachment = function (item) {
	var _v0 = item.gK;
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Just(
			A3($author$project$CommonView$warningMessageStyle, 'paperclip', 'dark', 'Anhänge angefügt'));
	}
};
var $author$project$CommonView$rating_warning = function (rating) {
	switch (rating) {
		case 0:
			return A3($author$project$CommonView$warningMessageStyle, 'thumbs-up', 'success', 'Erfolgreich');
		case 1:
			return A3($author$project$CommonView$warningMessageStyle, 'thumbs-up', 'warning', 'Kommentare beachten');
		default:
			return A3($author$project$CommonView$warningMessageStyle, 'thumbs-down', 'danger', 'Fehlgeschlagen');
	}
};
var $author$project$CommonView$unprocessed_warning = function (item) {
	return (!_Utils_eq(item.hE, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
		A3($author$project$CommonView$warningMessageStyle, 'exclamation-triangle', 'warning', 'Fortsetzung nach Abbruch')) : $elm$core$Maybe$Nothing;
};
var $author$project$CommonView$itemWarnings = function (item) {
	return $elm_community$maybe_extra$Maybe$Extra$values(
		A2(
			$elm$core$List$map,
			$elm$core$Basics$apR(item),
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$CommonView$highlightIcon),
					function ($) {
						return $.gZ;
					}),
					$author$project$CommonView$item_has_attachment,
					$author$project$CommonView$item_during_execution,
					A2(
					$elm$core$Basics$composeL,
					$elm$core$Maybe$map($author$project$CommonView$rating_warning),
					function ($) {
						return $.hJ;
					}),
					$author$project$CommonView$add_on_warning,
					$author$project$CommonView$unprocessed_warning,
					A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Maybe$Just,
						A2($author$project$CommonView$warningMessageStyle, 'trash-alt', 'danger')),
					function ($) {
						return $.g4;
					}),
					A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Maybe$Just,
						A2($author$project$CommonView$warningMessageStyle, 'sync-alt', 'danger')),
					function ($) {
						return $.hL;
					})
				])));
};
var $author$project$CommonView$runCaption = function (run) {
	if (run.$ === 1) {
		return 'Unbekannter RUN';
	} else {
		var r = run.a;
		return 'RUN ' + r.dG;
	}
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Run$View$ItemEditTabs$makeItemHeader = F3(
	function (model, item, errors) {
		var run = A2(
			$author$project$Helper$getRecordById,
			model.fA,
			$elm$core$Maybe$Just(item.bp));
		var process_with_category = _List_fromArray(
			[
				$elm$html$Html$text(
				A2($author$project$Helper$getProcessWithCategory, model.dP, item.hD) + ' ')
			]);
		var page_no = A2($author$project$Run$ItemHelper$getPageNo, model.dz, item);
		var machine_caption = function () {
			var _v3 = A2($author$project$Helper$getRecordById, model.dD, item.hh);
			if (_v3.$ === 1) {
				return 'Unbekanntes Gerät';
			} else {
				var m = _v3.a;
				return m.dG;
			}
		}();
		var _v0 = A2($author$project$Run$View$ItemEditTabs$getAdjacentItems, model.dz, item);
		var maybe_previous_item = _v0.a;
		var maybe_next_item = _v0.b;
		var next_button = function () {
			var _v2 = _Utils_Tuple2(maybe_next_item, errors);
			if ((!_v2.a.$) && (!_v2.b)) {
				var next_item = _v2.a.a;
				return A2(
					$author$project$CommonView$iconButton,
					'arrow-right',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Types$GotRunMsg(
								$author$project$Types$EditItem(next_item)))
						]));
			} else {
				return A2(
					$author$project$CommonView$iconButton,
					'arrow-right',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true)
						]));
			}
		}();
		var previous_button = function () {
			var _v1 = _Utils_Tuple2(maybe_previous_item, errors);
			if ((!_v1.a.$) && (!_v1.b)) {
				var previous_item = _v1.a.a;
				return A2(
					$author$project$CommonView$iconButton,
					'arrow-left',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Types$GotRunMsg(
								$author$project$Types$EditItem(previous_item)))
						]));
			} else {
				return A2(
					$author$project$CommonView$iconButton,
					'arrow-left',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true)
						]));
			}
		}();
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('item-edit-modal-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(model.a9.hf)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$CommonView$runCaption(run))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_Utils_ap(
								process_with_category,
								$author$project$CommonView$itemWarnings(item))),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(machine_caption)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item-pager')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											previous_button,
											$elm$html$Html$text(
											$elm$core$String$fromInt(page_no) + (' / ' + $elm$core$String$fromInt(
												$elm$core$List$length(model.dz)))),
											next_button
										]))
								]))
						]))
				]));
	});
var $author$project$Run$ItemHelper$isOperatorOfUnprocessedItem = F2(
	function (model, item) {
		var _v0 = A2($author$project$Run$ItemHelper$unprocessedItem, model, item);
		if (_v0.$ === 1) {
			return false;
		} else {
			var it = _v0.a;
			return A2($author$project$Run$ItemHelper$isOperator, model, it);
		}
	});
var $author$project$Run$ItemHelper$mayPerformExecution = F2(
	function (model, item) {
		return (!model.fq) || (A2($author$project$Run$ItemHelper$isOperator, model, item) || (A2($author$project$Run$ItemHelper$isOperatorOfUnprocessedItem, model, item) || (item.g5 && _Utils_eq(item.ib.an, model.a9.gq.an))));
	});
var $author$project$Types$ChangeItemTab = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$Config = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Tab$config = function (toMsg) {
	return {bN: _List_Nil, aQ: false, dz: _List_Nil, o: $elm$core$Maybe$Nothing, d0: toMsg, c5: false, az: false};
};
var $author$project$Run$ItemHelper$isExecutionDisabled = F2(
	function (model, item) {
		return (item.h1 !== 1) || ((!A2($author$project$Run$ItemHelper$mayPerformExecution, model, item)) || (!(model.a9.fz === 'accepted')));
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$ColAttrs = function (a) {
	return {$: 6, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Col$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Grid$Internal$ColAttrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$Table$Bordered = {$: 2};
var $rundis$elm_bootstrap$Bootstrap$Table$bordered = $rundis$elm_bootstrap$Bootstrap$Table$Bordered;
var $author$project$Run$ItemHelper$execParamsNotPerBatch = function (item) {
	return A2(
		$elm_community$list_extra$List$Extra$filterNot,
		function ($) {
			return $.hz;
		},
		item.gH);
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Types$TypeExecutionParam = 3;
var $author$project$Types$EditOperatorNote = F3(
	function (a, b, c) {
		return {$: 39, a: a, b: b, c: c};
	});
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$CommonView$createOperatorNote = F5(
	function (readonly, item, object_id, object_type, note) {
		var action = readonly ? $author$project$Types$GotCommonMsg($author$project$Types$NoAction) : $author$project$Types$GotRunMsg(
			A3($author$project$Types$EditOperatorNote, item, object_id, object_type));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('w-100', true),
							_Utils_Tuple2('clearfix', true),
							_Utils_Tuple2('clickable', !readonly)
						])),
					$elm$html$Html$Events$onClick(action)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Helper$htmlIf,
					!readonly,
					A5(
						$author$project$CommonView$iconButtonBase,
						'left',
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Button$secondary,
								$rundis$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('float-right border-0 text-secondary')
									]))
							]),
						'pen',
						'Anmerkung bearbeiten',
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(action)
							]))),
				A2(
					$elm$core$List$intersperse,
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
						$elm$core$List$map,
						$elm$html$Html$text,
						$elm$core$String$lines(note)))));
	});
var $author$project$Run$View$FormsHelper$formatValidationErrors = function (validation_errors) {
	if (!validation_errors.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		if (!validation_errors.b.b) {
			var e = validation_errors.a;
			return $elm$core$Maybe$Just(
				$elm$html$Html$text(e.e3));
		} else {
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$elm$html$Html$li(_List_Nil),
						A2(
							$elm$core$List$map,
							$elm$core$List$singleton,
							A2(
								$elm$core$List$map,
								$elm$html$Html$text,
								A2(
									$elm$core$List$map,
									function (e) {
										return e.e3;
									},
									validation_errors))))));
		}
	}
};
var $author$project$Run$View$FormsHelper$paramInputDate = F5(
	function (value, placeholder, required, disabled, update_fct) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'value', value),
					$elm$html$Html$Attributes$placeholder(placeholder),
					$elm$html$Html$Attributes$type_('date'),
					$author$project$Helper$onChange(update_fct),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-control form-control-sm', true),
							_Utils_Tuple2('required', required)
						])),
					$elm$html$Html$Attributes$disabled(disabled)
				]),
			_List_Nil);
	});
var $author$project$Run$View$FormsHelper$paramInputInteractive = function (value) {
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(value),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-control form-control-sm', true)
					])),
				$elm$html$Html$Attributes$disabled(true)
			]),
		_List_Nil);
};
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Helper$attrEmpty = A2($elm$html$Html$Attributes$property, '', $elm$json$Json$Encode$null);
var $author$project$Helper$attrIf = F2(
	function (cond, attr) {
		return cond ? attr : $author$project$Helper$attrEmpty;
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Attrs = function (a) {
	return {$: 6, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Select$Attrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Custom = {$: 2};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Select = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Select$create = F2(
	function (options, items) {
		return {dz: items, hs: options};
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $rundis$elm_bootstrap$Bootstrap$Form$Select$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size_ = modifier.a;
				return _Utils_update(
					options,
					{
						fI: $elm$core$Maybe$Just(size_)
					});
			case 1:
				var id_ = modifier.a;
				return _Utils_update(
					options,
					{
						an: $elm$core$Maybe$Just(id_)
					});
			case 2:
				return _Utils_update(
					options,
					{w: true});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{b2: val});
			case 4:
				var onChange_ = modifier.a;
				return _Utils_update(
					options,
					{
						cu: $elm$core$Maybe$Just(onChange_)
					});
			case 5:
				var validation_ = modifier.a;
				return _Utils_update(
					options,
					{
						db: $elm$core$Maybe$Just(validation_)
					});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Select$customEventOnChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$defaultOptions = {bN: _List_Nil, w: false, b2: false, an: $elm$core$Maybe$Nothing, cu: $elm$core$Maybe$Nothing, fI: $elm$core$Maybe$Nothing, db: $elm$core$Maybe$Nothing};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$sizeAttribute = F2(
	function (isCustom, size_) {
		var prefix = isCustom ? 'custom-select-' : 'form-control-';
		return A2(
			$elm$core$Maybe$map,
			function (s) {
				return $elm$html$Html$Attributes$class(
					_Utils_ap(prefix, s));
			},
			$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size_));
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Select$validationAttribute = function (validation_) {
	return $elm$html$Html$Attributes$class(
		$rundis$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(validation_));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$Select$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$Select$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-control', !options.w),
						_Utils_Tuple2('custom-select', options.w)
					])),
				$elm$html$Html$Attributes$disabled(options.b2)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, options.an),
						A2(
						$elm$core$Maybe$andThen,
						$rundis$elm_bootstrap$Bootstrap$Form$Select$sizeAttribute(options.w),
						options.fI),
						A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Form$Select$customEventOnChange, options.cu),
						A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Form$Select$validationAttribute, options.db)
					])),
			options.bN));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$view = function (_v0) {
	var options = _v0.hs;
	var items = _v0.dz;
	return A2(
		$elm$html$Html$select,
		$rundis$elm_bootstrap$Bootstrap$Form$Select$toAttributes(options),
		A2(
			$elm$core$List$map,
			function (_v1) {
				var e = _v1;
				return e;
			},
			items));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$custom = function (options) {
	return A2(
		$elm$core$Basics$composeL,
		$rundis$elm_bootstrap$Bootstrap$Form$Select$view,
		$rundis$elm_bootstrap$Bootstrap$Form$Select$create(
			A2($elm$core$List$cons, $rundis$elm_bootstrap$Bootstrap$Form$Select$Custom, options)));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Item = $elm$core$Basics$identity;
var $elm$html$Html$option = _VirtualDom_node('option');
var $rundis$elm_bootstrap$Bootstrap$Form$Select$item = F2(
	function (attributes, children) {
		return A2($elm$html$Html$option, attributes, children);
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Select$OnChange = function (a) {
	return {$: 4, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$onChange = function (toMsg) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Select$OnChange(toMsg);
};
var $author$project$Run$View$FormsHelper$paramInputSelect = F7(
	function (value, placeholder, required, disabled, show_default, allowed_values, update_fct) {
		var values = show_default ? A2($elm$core$List$cons, '', allowed_values) : allowed_values;
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Form$Select$custom,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Form$Select$onChange(update_fct),
					$rundis$elm_bootstrap$Bootstrap$Form$Select$attrs(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-control form-control-sm', true),
									_Utils_Tuple2('required', required)
								])),
							$elm$html$Html$Attributes$disabled(disabled)
						]))
				]),
			A2(
				$elm$core$List$map,
				function (o) {
					return A2(
						$rundis$elm_bootstrap$Bootstrap$Form$Select$item,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'value', o),
								A2(
								$author$project$Helper$attrIf,
								_Utils_eq(value, o),
								A2($elm$html$Html$Attributes$attribute, 'selected', 'selected'))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								(o === '') ? '(wie Standard)' : o)
							]));
				},
				values));
	});
var $author$project$Run$View$FormsHelper$paramInputText = F7(
	function (value, placeholder, inputmode, pattern, required, disabled, update_fct) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'value', value),
					$elm$html$Html$Attributes$placeholder(placeholder),
					$author$project$Helper$onChange(update_fct),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-control form-control-sm', true),
							_Utils_Tuple2('required', required)
						])),
					$elm$html$Html$Attributes$disabled(disabled),
					A2($elm$html$Html$Attributes$attribute, 'inputmode', inputmode),
					A2($elm$html$Html$Attributes$attribute, 'pattern', pattern)
				]),
			_List_Nil);
	});
var $author$project$Run$View$FormsHelper$paramInputTime = F5(
	function (value, placeholder, required, disabled, update_fct) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'value', value),
					$elm$html$Html$Attributes$placeholder(placeholder),
					$elm$html$Html$Attributes$type_('time'),
					$author$project$Helper$onChange(update_fct),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-control form-control-sm', true),
							_Utils_Tuple2('required', required)
						])),
					$elm$html$Html$Attributes$disabled(disabled)
				]),
			_List_Nil);
	});
var $author$project$Run$View$FormsHelper$paramInputs = F7(
	function (item, param, required, disabled, group_values, group_id, update_function) {
		return A2(
			$elm$core$List$map,
			function (index) {
				var param_value = A2($author$project$Helper$aget, index, param.f2);
				var value = function () {
					if (group_id.$ === 1) {
						return param_value;
					} else {
						var g_id = group_id.a;
						var key_value = $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (kv) {
									return _Utils_eq(kv.a, g_id);
								},
								group_values));
						if (key_value.$ === 1) {
							return '';
						} else {
							var kv = key_value.a;
							return A2($author$project$Helper$aget, index, kv.b);
						}
					}
				}();
				var fct = update_function(index);
				var _default = ((!_Utils_eq(group_id, $elm$core$Maybe$Nothing)) && (param_value !== '')) ? param_value : A2($author$project$Run$ItemHelper$getParamDefaultValueString, param, index);
				var _v0 = param.f1;
				switch (_v0) {
					case 'select_list':
						return A7(
							$author$project$Run$View$FormsHelper$paramInputSelect,
							value,
							_default,
							required,
							disabled,
							!_Utils_eq(group_id, $elm$core$Maybe$Nothing),
							param.ea,
							fct);
					case 'date':
						return A5($author$project$Run$View$FormsHelper$paramInputDate, value, _default, required, disabled, fct);
					case 'time':
						return A5($author$project$Run$View$FormsHelper$paramInputTime, value, _default, required, disabled, fct);
					case 'interactive':
						return $author$project$Run$View$FormsHelper$paramInputInteractive(value);
					case 'integer':
						return A7($author$project$Run$View$FormsHelper$paramInputText, value, _default, 'numeric', '^[-+]?\\d+$', required, disabled, fct);
					case 'float':
						return A7($author$project$Run$View$FormsHelper$paramInputText, value, _default, 'decimal', '^[-+]?\\d*[.,]?\\d+$', required, disabled, fct);
					case 'duration':
						return A7($author$project$Run$View$FormsHelper$paramInputText, value, _default, '', '^\\d+:[0-5]?\\d(:[0-5]?\\d)?$', required, disabled, fct);
					default:
						return A7($author$project$Run$View$FormsHelper$paramInputText, value, _default, '', '', required, disabled, fct);
				}
			},
			$author$project$Run$ItemHelper$getValueIndexRange(param));
	});
var $author$project$Run$ItemHelper$paramLabel = function (param) {
	return _Utils_ap(
		param.dG,
		$elm$core$String$isEmpty(param.f$) ? '' : (' [' + (param.f$ + ']')));
};
var $rundis$elm_bootstrap$Bootstrap$Table$Td = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$td = F2(
	function (options, children) {
		return $rundis$elm_bootstrap$Bootstrap$Table$Td(
			{gi: children, hs: options});
	});
var $rundis$elm_bootstrap$Bootstrap$Table$Th = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$th = F2(
	function (options, children) {
		return $rundis$elm_bootstrap$Bootstrap$Table$Th(
			{gi: children, hs: options});
	});
var $rundis$elm_bootstrap$Bootstrap$Table$Row = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$tr = F2(
	function (options, cells) {
		return $rundis$elm_bootstrap$Bootstrap$Table$Row(
			{gg: cells, hs: options});
	});
var $author$project$Types$ShowMaterialList = F6(
	function (a, b, c, d, e, f) {
		return {$: 51, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$Run$ItemHelper$getMaterialFilters = function (params) {
	if (params.$ === 1) {
		var props = params.a;
		return props.gO;
	} else {
		return _List_Nil;
	}
};
var $author$project$Run$ItemHelper$getMaterialWithdrawals = function (params) {
	if (params.$ === 1) {
		var props = params.a;
		return props.dd;
	} else {
		return _List_Nil;
	}
};
var $author$project$Types$OpenMaterialLot = function (a) {
	return {$: 52, a: a};
};
var $author$project$CommonView$withdrawalEntry = function (withdrawal) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'line-height', '1')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(withdrawal.hH) + ' x '),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Types$GotRunMsg(
							$author$project$Types$OpenMaterialLot(withdrawal.t))),
						$elm$html$Html$Attributes$class('btn-link'),
						A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(withdrawal.hg)
					]))
			]));
};
var $author$project$CommonView$withdrawalsList = F4(
	function (param_type, item, param, group_id) {
		var withdrawals = A2(
			$elm$core$List$filter,
			function (w) {
				return _Utils_eq(w.eH, group_id);
			},
			$author$project$Run$ItemHelper$getMaterialWithdrawals(param.hF));
		var props = function () {
			switch (param_type) {
				case 2:
					return param.hF;
				case 3:
					var _v1 = A2(
						$author$project$Helper$getRecordById,
						item.hA,
						$elm$core$Maybe$Just(param.an));
					if (!_v1.$) {
						var p = _v1.a;
						return p.hF;
					} else {
						return $author$project$Types$EmptyParamProperties;
					}
				default:
					return $author$project$Types$EmptyParamProperties;
			}
		}();
		var filters = A2(
			$elm$core$List$filter,
			function (w) {
				return _Utils_eq(w.eH, group_id);
			},
			$author$project$Run$ItemHelper$getMaterialFilters(param.hF));
		var content = ($elm$core$List$length(withdrawals) > 0) ? A2($elm$core$List$map, $author$project$CommonView$withdrawalEntry, withdrawals) : (($elm$core$List$length(filters) > 0) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Filter gesetzt')
					]))
			]) : _List_Nil);
		var action = $author$project$Types$GotRunMsg(
			A6($author$project$Types$ShowMaterialList, param_type, item, param.an, group_id, props, param.f$));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-top', '3px')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('float-right')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$CommonView$iconButton,
							'plus',
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(action)
								]))
						])),
				content));
	});
var $author$project$Run$View$ExecutionParamsEdit$itemEditExecParamNotPerBatchRow = F3(
	function (model, item, param) {
		var validation_errors = A2(
			$elm$core$List$filter,
			function (e) {
				return _Utils_eq(e.hw, param.an);
			},
			item.d1);
		var help = (param.f1 === 'material') ? $elm$core$Maybe$Just(
			A4($author$project$CommonView$withdrawalsList, 3, item, param, $elm$core$Maybe$Nothing)) : $author$project$Run$View$FormsHelper$formatValidationErrors(validation_errors);
		var disabled = A2($author$project$Run$ItemHelper$isExecutionDisabled, model, item) || param.fq;
		var update_function = disabled ? F2(
			function (_v0, _v1) {
				return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
			}) : function (index) {
			return $author$project$Helper$passValueToRunMsg(
				A3($author$project$Types$UpdateItemExecParamValue, item, param.an, index));
		};
		var inputs = A2(
			$elm$html$Html$div,
			_List_Nil,
			A7($author$project$Run$View$FormsHelper$paramInputs, item, param, false, disabled, _List_Nil, $elm$core$Maybe$Nothing, update_function));
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Run$ItemHelper$paramLabel(param))
								]))
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_Nil,
					_List_fromArray(
						[
							A5(
							$author$project$Run$View$FormsHelper$bsFormGroup,
							'',
							help,
							param.fv,
							!_Utils_eq(validation_errors, _List_Nil),
							inputs)
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_Nil,
					_List_fromArray(
						[
							A5($author$project$CommonView$createOperatorNote, disabled, item, param.an, 3, param.cy)
						]))
				]));
	});
var $author$project$Run$ItemHelper$maxValueCount = function (params) {
	return A2(
		$elm$core$Maybe$withDefault,
		1,
		$elm$core$List$maximum(
			A2(
				$elm$core$List$map,
				$elm$core$List$length,
				A2(
					$elm$core$List$map,
					$elm$core$Array$toList,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.f2;
						},
						params)))));
};
var $author$project$Run$View$ExecutionParamsEdit$itemEditExecParamPerBatchHeadersRow = function (execution_params) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Table$tr,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Parameter')
					])),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (batch_no) {
						return A2(
							$rundis$elm_bootstrap$Bootstrap$Table$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Batch ' + batch_no)
								]));
					},
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						A2(
							$elm$core$List$range,
							1,
							$author$project$Run$ItemHelper$maxValueCount(execution_params)))),
				_List_fromArray(
					[
						A2(
						$rundis$elm_bootstrap$Bootstrap$Table$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Anmerkung')
							]))
					]))));
};
var $author$project$Run$View$ExecutionParamsEdit$itemEditExecParamPerBatchCell = F4(
	function (item, param, index, input) {
		var validation_errors = A2(
			$elm$core$List$filter,
			function (e) {
				return _Utils_eq(e.hw, param.an) && _Utils_eq(e.g1, index);
			},
			item.d1);
		var help = $author$project$Run$View$FormsHelper$formatValidationErrors(validation_errors);
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$td,
			_List_Nil,
			$elm$core$List$singleton(
				A5(
					$author$project$Run$View$FormsHelper$bsFormGroup,
					'',
					help,
					param.fv,
					!_Utils_eq(validation_errors, _List_Nil),
					input)));
	});
var $author$project$Run$View$ExecutionParamsEdit$itemEditExecParamPerBatchRow = F3(
	function (model, item, param) {
		var label_text = $author$project$Run$ItemHelper$paramLabel(param);
		var label = _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('required', param.fv)
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label_text)
					]))
			]);
		var disabled = A2($author$project$Run$ItemHelper$isExecutionDisabled, model, item) || param.fq;
		var update_function = disabled ? F2(
			function (_v0, _v1) {
				return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
			}) : function (index) {
			return $author$project$Helper$passValueToRunMsg(
				A3($author$project$Types$UpdateItemExecParamValue, item, param.an, index));
		};
		var inputs = A7($author$project$Run$View$FormsHelper$paramInputs, item, param, false, disabled, _List_Nil, $elm$core$Maybe$Nothing, update_function);
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2($rundis$elm_bootstrap$Bootstrap$Table$th, _List_Nil, label),
				_Utils_ap(
					A2(
						$elm$core$List$indexedMap,
						A2($author$project$Run$View$ExecutionParamsEdit$itemEditExecParamPerBatchCell, item, param),
						inputs),
					_List_fromArray(
						[
							A2(
							$rundis$elm_bootstrap$Bootstrap$Table$td,
							_List_Nil,
							_List_fromArray(
								[
									A5($author$project$CommonView$createOperatorNote, disabled, item, param.an, 3, param.cy)
								]))
						]))));
	});
var $rundis$elm_bootstrap$Bootstrap$Table$Small = {$: 4};
var $rundis$elm_bootstrap$Bootstrap$Table$small = $rundis$elm_bootstrap$Bootstrap$Table$Small;
var $rundis$elm_bootstrap$Bootstrap$Table$Inversed = {$: 0};
var $rundis$elm_bootstrap$Bootstrap$Table$isResponsive = function (option) {
	if (option.$ === 5) {
		return true;
	} else {
		return false;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Table$KeyedTBody = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$TBody = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$InversedRow = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$KeyedRow = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$InversedCell = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$mapInversedCell = function (cell) {
	var inverseOptions = function (options) {
		return A2(
			$elm$core$List$map,
			function (opt) {
				if (!opt.$) {
					var role = opt.a;
					return $rundis$elm_bootstrap$Bootstrap$Table$InversedCell(role);
				} else {
					return opt;
				}
			},
			options);
	};
	if (cell.$ === 1) {
		var cellCfg = cell.a;
		return $rundis$elm_bootstrap$Bootstrap$Table$Th(
			_Utils_update(
				cellCfg,
				{
					hs: inverseOptions(cellCfg.hs)
				}));
	} else {
		var cellCfg = cell.a;
		return $rundis$elm_bootstrap$Bootstrap$Table$Td(
			_Utils_update(
				cellCfg,
				{
					hs: inverseOptions(cellCfg.hs)
				}));
	}
};
var $rundis$elm_bootstrap$Bootstrap$Table$mapInversedRow = function (row) {
	var inversedOptions = function (options) {
		return A2(
			$elm$core$List$map,
			function (opt) {
				if (!opt.$) {
					var role = opt.a;
					return $rundis$elm_bootstrap$Bootstrap$Table$InversedRow(role);
				} else {
					return opt;
				}
			},
			options);
	};
	if (!row.$) {
		var options = row.a.hs;
		var cells = row.a.gg;
		return $rundis$elm_bootstrap$Bootstrap$Table$Row(
			{
				gg: A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Table$mapInversedCell, cells),
				hs: inversedOptions(options)
			});
	} else {
		var options = row.a.hs;
		var cells = row.a.gg;
		return $rundis$elm_bootstrap$Bootstrap$Table$KeyedRow(
			{
				gg: A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var cell = _v1.b;
						return _Utils_Tuple2(
							key,
							$rundis$elm_bootstrap$Bootstrap$Table$mapInversedCell(cell));
					},
					cells),
				hs: inversedOptions(options)
			});
	}
};
var $rundis$elm_bootstrap$Bootstrap$Table$maybeMapInversedTBody = F2(
	function (isTableInversed, tbody_) {
		var _v0 = _Utils_Tuple2(isTableInversed, tbody_);
		if (!_v0.a) {
			return tbody_;
		} else {
			if (!_v0.b.$) {
				var body = _v0.b.a;
				return $rundis$elm_bootstrap$Bootstrap$Table$TBody(
					_Utils_update(
						body,
						{
							hR: A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Table$mapInversedRow, body.hR)
						}));
			} else {
				var keyedBody = _v0.b.a;
				return $rundis$elm_bootstrap$Bootstrap$Table$KeyedTBody(
					_Utils_update(
						keyedBody,
						{
							hR: A2(
								$elm$core$List$map,
								function (_v1) {
									var key = _v1.a;
									var row = _v1.b;
									return _Utils_Tuple2(
										key,
										$rundis$elm_bootstrap$Bootstrap$Table$mapInversedRow(row));
								},
								keyedBody.hR)
						}));
			}
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Table$InversedHead = {$: 0};
var $rundis$elm_bootstrap$Bootstrap$Table$THead = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Table$maybeMapInversedTHead = F2(
	function (isTableInversed, _v0) {
		var thead_ = _v0;
		var isHeadInversed = A2(
			$elm$core$List$any,
			function (opt) {
				return _Utils_eq(opt, $rundis$elm_bootstrap$Bootstrap$Table$InversedHead);
			},
			thead_.hs);
		return (isTableInversed || isHeadInversed) ? _Utils_update(
			thead_,
			{
				hR: A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Table$mapInversedRow, thead_.hR)
			}) : thead_;
	});
var $rundis$elm_bootstrap$Bootstrap$Table$maybeWrapResponsive = F2(
	function (options, table_) {
		var responsiveClass = $elm$html$Html$Attributes$class(
			'table-responsive' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return '-' + v;
					},
					A2(
						$elm$core$Maybe$andThen,
						$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption,
						A2(
							$elm$core$Maybe$andThen,
							function (opt) {
								if (opt.$ === 5) {
									var val = opt.a;
									return val;
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							$elm$core$List$head(
								A2($elm$core$List$filter, $rundis$elm_bootstrap$Bootstrap$Table$isResponsive, options)))))));
		return A2($elm$core$List$any, $rundis$elm_bootstrap$Bootstrap$Table$isResponsive, options) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[responsiveClass]),
			_List_fromArray(
				[table_])) : table_;
	});
var $rundis$elm_bootstrap$Bootstrap$Table$CellAttr = function (a) {
	return {$: 2, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$cellAttr = function (attr_) {
	return $rundis$elm_bootstrap$Bootstrap$Table$CellAttr(attr_);
};
var $elm$html$Html$Attributes$scope = $elm$html$Html$Attributes$stringProperty('scope');
var $rundis$elm_bootstrap$Bootstrap$Table$addScopeIfTh = function (cell) {
	if (cell.$ === 1) {
		var cellConfig = cell.a;
		return $rundis$elm_bootstrap$Bootstrap$Table$Th(
			_Utils_update(
				cellConfig,
				{
					hs: A2(
						$elm$core$List$cons,
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$scope('row')),
						cellConfig.hs)
				}));
	} else {
		return cell;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Table$maybeAddScopeToFirstCell = function (row) {
	if (!row.$) {
		var options = row.a.hs;
		var cells = row.a.gg;
		if (!cells.b) {
			return row;
		} else {
			var first = cells.a;
			var rest = cells.b;
			return $rundis$elm_bootstrap$Bootstrap$Table$Row(
				{
					gg: A2(
						$elm$core$List$cons,
						$rundis$elm_bootstrap$Bootstrap$Table$addScopeIfTh(first),
						rest),
					hs: options
				});
		}
	} else {
		var options = row.a.hs;
		var cells = row.a.gg;
		if (!cells.b) {
			return row;
		} else {
			var _v3 = cells.a;
			var firstKey = _v3.a;
			var first = _v3.b;
			var rest = cells.b;
			return $rundis$elm_bootstrap$Bootstrap$Table$KeyedRow(
				{
					gg: A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							firstKey,
							$rundis$elm_bootstrap$Bootstrap$Table$addScopeIfTh(first)),
						rest),
					hs: options
				});
		}
	}
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Role$toClass = F2(
	function (prefix, role) {
		return $elm$html$Html$Attributes$class(
			prefix + ('-' + function () {
				switch (role) {
					case 0:
						return 'primary';
					case 1:
						return 'secondary';
					case 2:
						return 'success';
					case 3:
						return 'info';
					case 4:
						return 'warning';
					case 5:
						return 'danger';
					case 6:
						return 'light';
					default:
						return 'dark';
				}
			}()));
	});
var $rundis$elm_bootstrap$Bootstrap$Table$cellAttribute = function (option) {
	switch (option.$) {
		case 0:
			if (!option.a.$) {
				var role = option.a.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'table', role);
			} else {
				var _v1 = option.a;
				return $elm$html$Html$Attributes$class('table-active');
			}
		case 1:
			if (!option.a.$) {
				var role = option.a.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'bg-', role);
			} else {
				var _v2 = option.a;
				return $elm$html$Html$Attributes$class('bg-active');
			}
		default:
			var attr_ = option.a;
			return attr_;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Table$cellAttributes = function (options) {
	return A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Table$cellAttribute, options);
};
var $elm$html$Html$th = _VirtualDom_node('th');
var $rundis$elm_bootstrap$Bootstrap$Table$renderCell = function (cell) {
	if (!cell.$) {
		var options = cell.a.hs;
		var children = cell.a.gi;
		return A2(
			$elm$html$Html$td,
			$rundis$elm_bootstrap$Bootstrap$Table$cellAttributes(options),
			children);
	} else {
		var options = cell.a.hs;
		var children = cell.a.gi;
		return A2(
			$elm$html$Html$th,
			$rundis$elm_bootstrap$Bootstrap$Table$cellAttributes(options),
			children);
	}
};
var $rundis$elm_bootstrap$Bootstrap$Table$rowClass = function (option) {
	switch (option.$) {
		case 0:
			if (!option.a.$) {
				var role_ = option.a.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'table', role_);
			} else {
				var _v1 = option.a;
				return $elm$html$Html$Attributes$class('table-active');
			}
		case 1:
			if (!option.a.$) {
				var role_ = option.a.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'bg', role_);
			} else {
				var _v2 = option.a;
				return $elm$html$Html$Attributes$class('bg-active');
			}
		default:
			var attr_ = option.a;
			return attr_;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Table$rowAttributes = function (options) {
	return A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Table$rowClass, options);
};
var $rundis$elm_bootstrap$Bootstrap$Table$renderRow = function (row) {
	if (!row.$) {
		var options = row.a.hs;
		var cells = row.a.gg;
		return A2(
			$elm$html$Html$tr,
			$rundis$elm_bootstrap$Bootstrap$Table$rowAttributes(options),
			A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Table$renderCell, cells));
	} else {
		var options = row.a.hs;
		var cells = row.a.gg;
		return A3(
			$elm$html$Html$Keyed$node,
			'tr',
			$rundis$elm_bootstrap$Bootstrap$Table$rowAttributes(options),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var key = _v1.a;
					var cell = _v1.b;
					return _Utils_Tuple2(
						key,
						$rundis$elm_bootstrap$Bootstrap$Table$renderCell(cell));
				},
				cells));
	}
};
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $rundis$elm_bootstrap$Bootstrap$Table$renderTBody = function (body) {
	if (!body.$) {
		var attributes = body.a.bN;
		var rows = body.a.hR;
		return A2(
			$elm$html$Html$tbody,
			attributes,
			A2(
				$elm$core$List$map,
				function (row) {
					return $rundis$elm_bootstrap$Bootstrap$Table$renderRow(
						$rundis$elm_bootstrap$Bootstrap$Table$maybeAddScopeToFirstCell(row));
				},
				rows));
	} else {
		var attributes = body.a.bN;
		var rows = body.a.hR;
		return A3(
			$elm$html$Html$Keyed$node,
			'tbody',
			attributes,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var key = _v1.a;
					var row = _v1.b;
					return _Utils_Tuple2(
						key,
						$rundis$elm_bootstrap$Bootstrap$Table$renderRow(
							$rundis$elm_bootstrap$Bootstrap$Table$maybeAddScopeToFirstCell(row)));
				},
				rows));
	}
};
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $rundis$elm_bootstrap$Bootstrap$Table$theadAttribute = function (option) {
	switch (option.$) {
		case 0:
			return $elm$html$Html$Attributes$class('thead-dark');
		case 1:
			return $elm$html$Html$Attributes$class('thead-default');
		default:
			var attr_ = option.a;
			return attr_;
	}
};
var $rundis$elm_bootstrap$Bootstrap$Table$theadAttributes = function (options) {
	return A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Table$theadAttribute, options);
};
var $rundis$elm_bootstrap$Bootstrap$Table$renderTHead = function (_v0) {
	var options = _v0.hs;
	var rows = _v0.hR;
	return A2(
		$elm$html$Html$thead,
		$rundis$elm_bootstrap$Bootstrap$Table$theadAttributes(options),
		A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Table$renderRow, rows));
};
var $rundis$elm_bootstrap$Bootstrap$Table$tableClass = function (option) {
	switch (option.$) {
		case 0:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('table-dark'));
		case 1:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('table-striped'));
		case 2:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('table-bordered'));
		case 3:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('table-hover'));
		case 4:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('table-sm'));
		case 5:
			return $elm$core$Maybe$Nothing;
		case 6:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('table-reflow'));
		default:
			var attr_ = option.a;
			return $elm$core$Maybe$Just(attr_);
	}
};
var $rundis$elm_bootstrap$Bootstrap$Table$tableAttributes = function (options) {
	return A2(
		$elm$core$List$cons,
		$elm$html$Html$Attributes$class('table'),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Table$tableClass, options)));
};
var $rundis$elm_bootstrap$Bootstrap$Table$table = function (rec) {
	var isInversed = A2(
		$elm$core$List$any,
		function (opt) {
			return _Utils_eq(opt, $rundis$elm_bootstrap$Bootstrap$Table$Inversed);
		},
		rec.hs);
	var classOptions = A2(
		$elm$core$List$filter,
		function (opt) {
			return !$rundis$elm_bootstrap$Bootstrap$Table$isResponsive(opt);
		},
		rec.hs);
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Table$maybeWrapResponsive,
		rec.hs,
		A2(
			$elm$html$Html$table,
			$rundis$elm_bootstrap$Bootstrap$Table$tableAttributes(classOptions),
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$renderTHead(
					A2($rundis$elm_bootstrap$Bootstrap$Table$maybeMapInversedTHead, isInversed, rec.h5)),
					$rundis$elm_bootstrap$Bootstrap$Table$renderTBody(
					A2($rundis$elm_bootstrap$Bootstrap$Table$maybeMapInversedTBody, isInversed, rec.h4))
				])));
};
var $rundis$elm_bootstrap$Bootstrap$Table$tbody = F2(
	function (attributes, rows) {
		return $rundis$elm_bootstrap$Bootstrap$Table$TBody(
			{bN: attributes, hR: rows});
	});
var $rundis$elm_bootstrap$Bootstrap$Table$thead = F2(
	function (options, rows) {
		return {hs: options, hR: rows};
	});
var $author$project$Run$View$ExecutionParamsEdit$itemEditExecutionParams = F2(
	function (model, item) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('execution-params')
				]),
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rundis$elm_bootstrap$Bootstrap$Grid$col,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Grid$Col$attrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('not-per-batch')
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Parameter allgemein')
										])),
									$rundis$elm_bootstrap$Bootstrap$Table$table(
									{
										hs: _List_fromArray(
											[$rundis$elm_bootstrap$Bootstrap$Table$small, $rundis$elm_bootstrap$Bootstrap$Table$bordered]),
										h4: A2(
											$rundis$elm_bootstrap$Bootstrap$Table$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A2($author$project$Run$View$ExecutionParamsEdit$itemEditExecParamNotPerBatchRow, model, item),
												$author$project$Run$ItemHelper$execParamsNotPerBatch(item))),
										h5: A2(
											$rundis$elm_bootstrap$Bootstrap$Table$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rundis$elm_bootstrap$Bootstrap$Table$tr,
													_List_Nil,
													A2(
														$elm$core$List$map,
														$rundis$elm_bootstrap$Bootstrap$Table$th(_List_Nil),
														A2(
															$elm$core$List$map,
															$elm$core$List$singleton,
															A2(
																$elm$core$List$map,
																$elm$html$Html$text,
																_List_fromArray(
																	['Parameter', 'Wert', 'Anmerkung'])))))
												]))
									})
								]))
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var exec_params_per_batch = $author$project$Run$ItemHelper$execParamsPerBatch(item);
							return A2(
								$rundis$elm_bootstrap$Bootstrap$Grid$col,
								_List_fromArray(
									[
										$rundis$elm_bootstrap$Bootstrap$Grid$Col$attrs(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('per-batch')
											]))
									]),
								$elm$core$List$isEmpty(
									$author$project$Run$ItemHelper$execParamsPerBatch(item)) ? _List_Nil : _List_fromArray(
									[
										A2(
										$elm$html$Html$h3,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Parameter pro Batch')
											])),
										$rundis$elm_bootstrap$Bootstrap$Table$table(
										{
											hs: _List_fromArray(
												[$rundis$elm_bootstrap$Bootstrap$Table$small, $rundis$elm_bootstrap$Bootstrap$Table$bordered]),
											h4: A2(
												$rundis$elm_bootstrap$Bootstrap$Table$tbody,
												_List_Nil,
												A2(
													$elm$core$List$map,
													A2($author$project$Run$View$ExecutionParamsEdit$itemEditExecParamPerBatchRow, model, item),
													exec_params_per_batch)),
											h5: A2(
												$rundis$elm_bootstrap$Bootstrap$Table$thead,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Run$View$ExecutionParamsEdit$itemEditExecParamPerBatchHeadersRow(exec_params_per_batch)
													]))
										})
									]));
						}()
						]))
				]));
	});
var $author$project$Types$TypeItem = 0;
var $author$project$Run$View$ExecutionParamsEdit$operatorNoteForItem = F2(
	function (readonly, item) {
		return (readonly && $elm$core$String$isEmpty(item.cy)) ? $author$project$Helper$htmlEmpty : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Anmerkung des Operators')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-body')
								]),
							_List_fromArray(
								[
									A5($author$project$CommonView$createOperatorNote, readonly, item, item.an, 0, item.cy)
								]))
						]))
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Table$simpleThead = function (cells) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Table$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2($rundis$elm_bootstrap$Bootstrap$Table$tr, _List_Nil, cells)
			]));
};
var $author$project$Run$View$ExecutionParamsEdit$recipeDetails = F2(
	function (model, item) {
		var recipe = A2($author$project$Helper$getRecordById, model.dQ, item.hM);
		var recipe_name = function () {
			if (recipe.$ === 1) {
				return 'Standard';
			} else {
				var r = recipe.a;
				return r.dG;
			}
		}();
		var _v0 = function () {
			var _v1 = item.hJ;
			if (_v1.$ === 1) {
				return _Utils_Tuple2('', 'keine Bewertung');
			} else {
				switch (_v1.a) {
					case 0:
						var _v2 = _v1.a;
						return _Utils_Tuple2('good', 'Erfolgreich');
					case 1:
						var _v3 = _v1.a;
						return _Utils_Tuple2('medium', 'Kommentare beachten');
					default:
						var _v4 = _v1.a;
						return _Utils_Tuple2('bad', 'Fehlgeschlagen');
				}
			}
		}();
		var class_ = _v0.a;
		var rating_text = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Details')
						])),
					$rundis$elm_bootstrap$Bootstrap$Table$table(
					{
						hs: _List_fromArray(
							[$rundis$elm_bootstrap$Bootstrap$Table$small, $rundis$elm_bootstrap$Bootstrap$Table$bordered]),
						h4: A2(
							$rundis$elm_bootstrap$Bootstrap$Table$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rundis$elm_bootstrap$Bootstrap$Table$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rundis$elm_bootstrap$Bootstrap$Table$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Rezept')
												])),
											A2(
											$rundis$elm_bootstrap$Bootstrap$Table$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(recipe_name)
												]))
										])),
									A2(
									$rundis$elm_bootstrap$Bootstrap$Table$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rundis$elm_bootstrap$Bootstrap$Table$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Anmerkung')
												])),
											A2(
											$rundis$elm_bootstrap$Bootstrap$Table$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(item.gl)
												]))
										])),
									A2(
									$rundis$elm_bootstrap$Bootstrap$Table$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rundis$elm_bootstrap$Bootstrap$Table$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Geschätzte Zeit')
												])),
											A2(
											$rundis$elm_bootstrap$Bootstrap$Table$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(item.gF))
												]))
										])),
									A2(
									$rundis$elm_bootstrap$Bootstrap$Table$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rundis$elm_bootstrap$Bootstrap$Table$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Bewertung')
												])),
											A2(
											$rundis$elm_bootstrap$Bootstrap$Table$td,
											_List_fromArray(
												[
													$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
													$elm$html$Html$Attributes$class('item-rating'))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(class_)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(rating_text)
														]))
												]))
										]))
								])),
						h5: $rundis$elm_bootstrap$Bootstrap$Table$simpleThead(_List_Nil)
					})
				]));
	});
var $author$project$Run$View$ExecutionParamsEdit$executionParamsEdit = F2(
	function (model, item) {
		var warning_text = (model.a9.e4 === 'RunTemplateEditor') ? 'Die Durchführung kann in RUN-Vorlagen nicht aktiviert werden.' : ((!A2($author$project$Run$ItemHelper$mayPerformExecution, model, item)) ? 'Dieser RUN kann nicht bearbeitet werden.' : ((!model.a9.gG) ? 'Die elektronische Durchführung ist für diesen RUN nicht aktiviert.' : ((model.a9.fz !== 'accepted') ? 'Der RUN ist nicht freigegeben.' : ($author$project$Run$ItemHelper$hasDoneReservation(item) ? 'Die Reservierung zu diesem Prozessschritt ist bereits erledigt.' : (((!item.h1) && $author$project$Run$ItemHelper$wasExecutionStarted(item)) ? 'Bitte setzen Sie die Durchführung fort zur Eingabe der Durchführungsparameter!' : ((!item.h1) ? 'Bitte starten Sie die Durchführung zur Eingabe der Durchführungsparameter!' : ((item.h1 === 2) ? 'Bitte starten Sie die Durchführung erneut zur Eingabe der Durchführungsparameter!' : '')))))));
		var execution_disabled = A2($author$project$Run$ItemHelper$isExecutionDisabled, model, item);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					execution_disabled ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('alert alert-warning')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(warning_text)
						])) : $author$project$Helper$htmlEmpty,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col')
								]),
							_List_fromArray(
								[
									A2($author$project$Run$View$ExecutionParamsEdit$recipeDetails, model, item)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col')
								]),
							_List_fromArray(
								[
									A2($author$project$Run$View$ExecutionParamsEdit$operatorNoteForItem, execution_disabled, item)
								]))
						])),
					$elm$core$List$isEmpty(item.gH) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('alert alert-secondary')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Für diesen Prozessschritt sind keine Durchführungsparameter hinterlegt.')
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-6')
								]),
							_List_fromArray(
								[
									A2($author$project$Run$View$ExecutionParamsEdit$itemEditExecutionParams, model, item)
								]))
						]))
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$Item = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Tab$item = function (rec) {
	return {an: rec.an, e$: rec.e$, fe: rec.fe};
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$RowAttrs = function (a) {
	return {$: 2, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Row$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Grid$Internal$RowAttrs(attrs_);
};
var $author$project$Types$CaptureDrawing = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Types$CaptureItemFile = function (a) {
	return {$: 60, a: a};
};
var $author$project$Types$DeleteItemFile = F2(
	function (a, b) {
		return {$: 66, a: a, b: b};
	});
var $author$project$Helper$actionNone = $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
var $author$project$Helper$actionIf = F2(
	function (cond, action) {
		return cond ? action : $author$project$Helper$actionNone;
	});
var $rundis$elm_bootstrap$Bootstrap$Card$Config = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$CardBlock = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$applyBlockModifier = F2(
	function (option, options) {
		switch (option.$) {
			case 0:
				var align = option.a;
				return _Utils_update(
					options,
					{
						S: $elm$core$Maybe$Just(align)
					});
			case 1:
				var role = option.a;
				return _Utils_update(
					options,
					{
						V: $elm$core$Maybe$Just(role)
					});
			case 2:
				var color = option.a;
				return _Utils_update(
					options,
					{
						ad: $elm$core$Maybe$Just(color)
					});
			default:
				var attrs = option.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$defaultBlockOptions = {S: $elm$core$Maybe$Nothing, bN: _List_Nil, V: $elm$core$Maybe$Nothing, ad: $elm$core$Maybe$Nothing};
var $rundis$elm_bootstrap$Bootstrap$Internal$Text$textColorClass = function (color) {
	if (color.$ === 1) {
		return $elm$html$Html$Attributes$class('text-white');
	} else {
		var role = color.a;
		return A2($rundis$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'text', role);
	}
};
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$blockAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Card$Internal$applyBlockModifier, $rundis$elm_bootstrap$Bootstrap$Card$Internal$defaultBlockOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card-body')
			]),
		_Utils_ap(
			function () {
				var _v0 = options.S;
				if (!_v0.$) {
					var align = _v0.a;
					return _List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass(align)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = options.V;
					if (!_v1.$) {
						var role = _v1.a;
						return _List_fromArray(
							[
								A2($rundis$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'bg', role)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v2 = options.ad;
						if (!_v2.$) {
							var color = _v2.a;
							return _List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Internal$Text$textColorClass(color)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					options.bN))));
};
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$block = F2(
	function (options, items) {
		return $rundis$elm_bootstrap$Bootstrap$Card$Internal$CardBlock(
			A2(
				$elm$html$Html$div,
				$rundis$elm_bootstrap$Bootstrap$Card$Internal$blockAttributes(options),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var e = _v0;
						return e;
					},
					items)));
	});
var $rundis$elm_bootstrap$Bootstrap$Card$block = F3(
	function (options, items, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				dg: _Utils_ap(
					conf.dg,
					_List_fromArray(
						[
							A2($rundis$elm_bootstrap$Bootstrap$Card$Internal$block, options, items)
						]))
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Card$config = function (options) {
	return {dg: _List_Nil, dt: $elm$core$Maybe$Nothing, cc: $elm$core$Maybe$Nothing, dw: $elm$core$Maybe$Nothing, dx: $elm$core$Maybe$Nothing, hs: options};
};
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$BlockItem = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Card$Block$custom = function (element) {
	return element;
};
var $author$project$Run$View$ItemFiles$fileType = function (item_file) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, '/', item_file.go)));
};
var $rundis$elm_bootstrap$Bootstrap$Card$Footer = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Card$footer = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				dt: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('card-footer'),
							attributes),
						children))
			});
	});
var $author$project$CommonView$iconButtonTooltip = F3(
	function (icon, tooltip, disabled) {
		var style = _List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Button$secondary,
				$rundis$elm_bootstrap$Bootstrap$Button$attrs(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(disabled)
					]))
			]);
		return A3($author$project$CommonView$iconButtonStyle, style, icon, tooltip);
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$audio = _VirtualDom_node('audio');
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$Run$View$ItemFiles$itemFileCardPreview = function (item_file) {
	var preview = function () {
		var _v0 = $author$project$Run$View$ItemFiles$fileType(item_file);
		switch (_v0) {
			case 'audio':
				return A2(
					$elm$html$Html$audio,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$controls(true),
							$elm$html$Html$Attributes$src(item_file.b3)
						]),
					_List_Nil);
			case 'image':
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(item_file.hC)
						]),
					_List_Nil);
			case 'video':
				return A2(
					$elm$html$Html$video,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$controls(true),
							$elm$html$Html$Attributes$src(item_file.b3)
						]),
					_List_Nil);
			default:
				return A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-file-download')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(item_file.gJ + ': Klicken zum Herunterladen')
						]));
		}
	}();
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(item_file.b3),
				$elm$html$Html$Attributes$target('_blank')
			]),
		_List_fromArray(
			[preview]));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $rundis$elm_bootstrap$Bootstrap$Card$Block$text = F2(
	function (attributes, children) {
		return A2(
			$elm$html$Html$p,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-text')
					]),
				attributes),
			children);
	});
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$applyModifier = F2(
	function (option, options) {
		switch (option.$) {
			case 0:
				var align = option.a;
				return _Utils_update(
					options,
					{
						S: $elm$core$Maybe$Just(align)
					});
			case 1:
				var coloring = option.a;
				return _Utils_update(
					options,
					{
						V: $elm$core$Maybe$Just(coloring)
					});
			case 2:
				var coloring = option.a;
				return _Utils_update(
					options,
					{
						ad: $elm$core$Maybe$Just(coloring)
					});
			default:
				var attrs = option.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$defaultOptions = {S: $elm$core$Maybe$Nothing, bN: _List_Nil, V: $elm$core$Maybe$Nothing, ad: $elm$core$Maybe$Nothing};
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$cardAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Card$Internal$applyModifier, $rundis$elm_bootstrap$Bootstrap$Card$Internal$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card')
			]),
		_Utils_ap(
			function () {
				var _v0 = options.V;
				if (!_v0.$) {
					if (!_v0.a.$) {
						var role = _v0.a.a;
						return _List_fromArray(
							[
								A2($rundis$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'bg', role)
							]);
					} else {
						var role = _v0.a.a;
						return _List_fromArray(
							[
								A2($rundis$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'border', role)
							]);
					}
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = options.ad;
					if (!_v1.$) {
						var color = _v1.a;
						return _List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Internal$Text$textColorClass(color)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v2 = options.S;
						if (!_v2.$) {
							var align = _v2.a;
							return _List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass(align)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					options.bN))));
};
var $rundis$elm_bootstrap$Bootstrap$Card$Internal$renderBlocks = function (blocks) {
	return A2(
		$elm$core$List$map,
		function (block_) {
			if (!block_.$) {
				var e = block_.a;
				return e;
			} else {
				var e = block_.a;
				return e;
			}
		},
		blocks);
};
var $rundis$elm_bootstrap$Bootstrap$Card$view = function (_v0) {
	var conf = _v0;
	return A2(
		$elm$html$Html$div,
		$rundis$elm_bootstrap$Bootstrap$Card$Internal$cardAttributes(conf.hs),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var e = _v1;
							return e;
						},
						conf.cc),
						A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var e = _v2;
							return e;
						},
						conf.dx)
					])),
			_Utils_ap(
				$rundis$elm_bootstrap$Bootstrap$Card$Internal$renderBlocks(conf.dg),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (_v3) {
								var e = _v3;
								return e;
							},
							conf.dt),
							A2(
							$elm$core$Maybe$map,
							function (_v4) {
								var e = _v4;
								return e;
							},
							conf.dw)
						])))));
};
var $author$project$Run$View$ItemFiles$itemFileCard = F3(
	function (readwrite, item, item_file) {
		var readonly = !readwrite;
		var edit_image_action = A2(
			$author$project$Helper$actionIf,
			readwrite,
			$author$project$Types$GotRunMsg(
				$author$project$Types$CaptureItemFile(
					A2(
						$author$project$Types$CaptureDrawing,
						item,
						$elm$core$Maybe$Just(item_file)))));
		var edit_action = A2(
			$author$project$Helper$actionIf,
			readwrite,
			$author$project$Types$GotRunMsg(
				A4(
					$author$project$Types$EditItemFile,
					item.an,
					item_file.dj,
					$elm$core$Maybe$Just(item_file),
					$elm$core$Maybe$Nothing)));
		var delete_action = A2(
			$author$project$Helper$actionIf,
			readwrite,
			$author$project$Types$GotCommonMsg(
				A2(
					$author$project$Types$OpenConfirm,
					'Diese Datei endgültig löschen?',
					$author$project$Types$GotRunMsg(
						A2($author$project$Types$DeleteItemFile, item.an, item_file)))));
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Grid$col,
			_List_Nil,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Card$view(
					A3(
						$rundis$elm_bootstrap$Bootstrap$Card$footer,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$CommonView$iconButtonTooltip,
								'edit',
								'Anmerkung bearbeiten',
								readonly,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(edit_action)
									])),
								A4(
								$author$project$CommonView$iconButtonTooltip,
								'trash',
								'Datei löschen',
								readonly,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(delete_action)
									])),
								A2(
								$author$project$Helper$htmlIf,
								$author$project$Run$View$ItemFiles$fileType(item_file) === 'image',
								A4(
									$author$project$CommonView$iconButtonTooltip,
									'paint-brush',
									'Bild bearbeiten',
									readonly,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(edit_image_action)
										])))
							]),
						A3(
							$rundis$elm_bootstrap$Bootstrap$Card$block,
							_List_Nil,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Card$Block$custom(
									$author$project$Run$View$ItemFiles$itemFileCardPreview(item_file)),
									A2(
									$rundis$elm_bootstrap$Bootstrap$Card$Block$text,
									_List_Nil,
									A2(
										$elm$core$List$intersperse,
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
											$elm$core$List$map,
											$elm$html$Html$text,
											$elm$core$String$lines(item_file.dj))))
								]),
							$rundis$elm_bootstrap$Bootstrap$Card$config(_List_Nil))))
				]));
	});
var $author$project$Types$CaptureAudio = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$CapturePhoto = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$CaptureVideo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$SelectItemFiles = F2(
	function (a, b) {
		return {$: 62, a: a, b: b};
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$CommonView$iconButtonSimple = F4(
	function (icon, tooltip, style, attributes) {
		var tooltip_attr = function () {
			if (tooltip.$ === 1) {
				return _List_Nil;
			} else {
				var text = tooltip.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('css-tooltip'),
						A2($elm$html$Html$Attributes$attribute, 'data-tooltip', text)
					]);
			}
		}();
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Button$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Button$attrs(
						_Utils_ap(
							attributes,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button')
									]),
								tooltip_attr)))
					]),
				style),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fas fa-' + icon)
						]),
					_List_Nil)
				]));
	});
var $author$project$Run$View$ItemFiles$uploadButton = F3(
	function (icon, tooltip, runmsg) {
		return A4(
			$author$project$CommonView$iconButtonSimple,
			icon,
			$elm$core$Maybe$Just(tooltip),
			_List_fromArray(
				[$rundis$elm_bootstrap$Bootstrap$Button$primary]),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mr-3'),
					$elm$html$Html$Events$onClick(runmsg)
				]));
	});
var $author$project$Run$View$ItemFiles$itemFileUpload = F2(
	function (model, item) {
		return A2(
			$elm$html$Html$map,
			$author$project$Types$GotRunMsg,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-3')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Datei hochladen')
									])),
								A3(
								$author$project$Run$View$ItemFiles$uploadButton,
								'file-image',
								'Bild',
								A2($author$project$Types$SelectItemFiles, 'image/*', item.an)),
								A3(
								$author$project$Run$View$ItemFiles$uploadButton,
								'file-video',
								'Video',
								A2($author$project$Types$SelectItemFiles, 'video/*', item.an)),
								A3(
								$author$project$Run$View$ItemFiles$uploadButton,
								'file-audio',
								'Audio',
								A2($author$project$Types$SelectItemFiles, 'audio/*', item.an)),
								A3(
								$author$project$Run$View$ItemFiles$uploadButton,
								'file',
								'Andere',
								A2($author$project$Types$SelectItemFiles, '*/*', item.an)),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-3')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Aufnahme starten')
									])),
								A3(
								$author$project$Run$View$ItemFiles$uploadButton,
								'camera',
								'Foto',
								$author$project$Types$CaptureItemFile(
									$author$project$Types$CapturePhoto(item))),
								A3(
								$author$project$Run$View$ItemFiles$uploadButton,
								'video',
								'Video',
								$author$project$Types$CaptureItemFile(
									$author$project$Types$CaptureVideo(item))),
								A3(
								$author$project$Run$View$ItemFiles$uploadButton,
								'microphone',
								'Audio',
								$author$project$Types$CaptureItemFile(
									$author$project$Types$CaptureAudio(item))),
								A3(
								$author$project$Run$View$ItemFiles$uploadButton,
								'paint-brush',
								'Zeichnung',
								$author$project$Types$CaptureItemFile(
									A2($author$project$Types$CaptureDrawing, item, $elm$core$Maybe$Nothing)))
							]))
					])));
	});
var $author$project$Types$CaptureClose = {$: 61};
var $elm$file$File$decoder = _File_decoder;
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Run$View$ItemFiles$liveCaptureNode = F3(
	function (format, id, item_file) {
		return A2(
			$elm$html$Html$map,
			$author$project$Types$GotRunMsg,
			function () {
				if (item_file.$ === 1) {
					return A3(
						$elm$html$Html$node,
						'live-capture',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-format', format),
								A2(
								$elm$html$Html$Events$on,
								'capturetaken',
								A2(
									$elm$json$Json$Decode$map,
									A3($author$project$Types$EditItemFile, id, '', $elm$core$Maybe$Nothing),
									$elm$json$Json$Decode$maybe(
										A2(
											$elm$json$Json$Decode$field,
											'detail',
											A2($elm$json$Json$Decode$field, 'file', $elm$file$File$decoder))))),
								A2(
								$elm$html$Html$Events$on,
								'captureclosed',
								$elm$json$Json$Decode$succeed($author$project$Types$CaptureClose))
							]),
						_List_Nil);
				} else {
					var file = item_file.a;
					return A3(
						$elm$html$Html$node,
						'live-capture',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-format', format),
								A2($elm$html$Html$Attributes$attribute, 'data-src', file.b3),
								A2(
								$elm$html$Html$Events$on,
								'capturetaken',
								A2(
									$elm$json$Json$Decode$map,
									A3(
										$author$project$Types$UploadItemFile,
										id,
										file.dj,
										$elm$core$Maybe$Just(file)),
									$elm$json$Json$Decode$maybe(
										A2(
											$elm$json$Json$Decode$field,
											'detail',
											A2($elm$json$Json$Decode$field, 'file', $elm$file$File$decoder))))),
								A2(
								$elm$html$Html$Events$on,
								'captureclosed',
								$elm$json$Json$Decode$succeed($author$project$Types$CaptureClose))
							]),
						_List_Nil);
				}
			}());
	});
var $author$project$Run$View$ItemFiles$liveCaptureView = function (live_capture) {
	switch (live_capture.$) {
		case 0:
			return $author$project$Helper$htmlEmpty;
		case 2:
			var it = live_capture.a;
			return A3($author$project$Run$View$ItemFiles$liveCaptureNode, 'video', it.an, $elm$core$Maybe$Nothing);
		case 1:
			var it = live_capture.a;
			return A3($author$project$Run$View$ItemFiles$liveCaptureNode, 'image', it.an, $elm$core$Maybe$Nothing);
		case 3:
			var it = live_capture.a;
			return A3($author$project$Run$View$ItemFiles$liveCaptureNode, 'audio', it.an, $elm$core$Maybe$Nothing);
		default:
			var it = live_capture.a;
			var item_file = live_capture.b;
			return A3($author$project$Run$View$ItemFiles$liveCaptureNode, 'drawing', it.an, item_file);
	}
};
var $author$project$Run$View$ItemFiles$itemFiles = F2(
	function (model, item) {
		var readwrite = !(model.fq && (!A2($author$project$Run$ItemHelper$isOperator, model, item)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('item-file-list row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-3')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Helper$htmlIf,
							readwrite,
							A2($author$project$Run$View$ItemFiles$itemFileUpload, model, item))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-9')
						]),
					_List_fromArray(
						[
							A2(
							$rundis$elm_bootstrap$Bootstrap$Grid$row,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Grid$Row$attrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-row item-file-card')
										]))
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Run$View$ItemFiles$itemFileCard, readwrite, item),
								item.gK))
						])),
					$author$project$Run$View$ItemFiles$liveCaptureView(model.e1)
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$items = F2(
	function (items_, _v0) {
		var configRec = _v0;
		return _Utils_update(
			configRec,
			{dz: items_});
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$Link = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Tab$link = F2(
	function (attributes, children) {
		return {bN: attributes, gi: children};
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$Pane = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Tab$pane = F2(
	function (attributes, children) {
		return {bN: attributes, gi: children};
	});
var $author$project$Types$ResetRecipe = function (a) {
	return {$: 40, a: a};
};
var $author$project$Types$UpdateItem = F4(
	function (a, b, c, d) {
		return {$: 29, a: a, b: b, c: c, d: d};
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Checkbox = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$create = F2(
	function (options, label_) {
		return {eZ: label_, hs: options};
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Label = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$label = F2(
	function (attributes, children) {
		return {bN: attributes, gi: children};
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var val = modifier.a;
				return _Utils_update(
					options,
					{
						an: $elm$core$Maybe$Just(val)
					});
			case 1:
				var val = modifier.a;
				return _Utils_update(
					options,
					{h1: val});
			case 2:
				return _Utils_update(
					options,
					{bd: true});
			case 3:
				var toMsg = modifier.a;
				return _Utils_update(
					options,
					{
						cv: $elm$core$Maybe$Just(toMsg)
					});
			case 4:
				return _Utils_update(
					options,
					{w: true});
			case 5:
				var val = modifier.a;
				return _Utils_update(
					options,
					{b2: val});
			case 6:
				var validation = modifier.a;
				return _Utils_update(
					options,
					{
						db: $elm$core$Maybe$Just(validation)
					});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Off = 1;
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$defaultOptions = {bN: _List_Nil, w: false, b2: false, an: $elm$core$Maybe$Nothing, bd: false, cv: $elm$core$Maybe$Nothing, h1: 1, db: $elm$core$Maybe$Nothing};
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$stateAttribute = function (state) {
	switch (state) {
		case 0:
			return $elm$html$Html$Attributes$checked(true);
		case 1:
			return $elm$html$Html$Attributes$checked(false);
		default:
			return A2($elm$html$Html$Attributes$attribute, 'indeterminate', 'true');
	}
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$toAttributes = function (options) {
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-check-input', !options.w),
						_Utils_Tuple2('custom-control-input', options.w)
					])),
				$elm$html$Html$Attributes$type_('checkbox'),
				$elm$html$Html$Attributes$disabled(options.b2),
				$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$stateAttribute(options.h1)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onCheck, options.cv),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, options.an)
					])),
			_Utils_ap(
				function () {
					var _v0 = options.db;
					if (!_v0.$) {
						var v = _v0.a;
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								$rundis$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(v))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				options.bN)));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$view = function (_v0) {
	var chk = _v0;
	var opts = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$applyModifier, $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$defaultOptions, chk.hs);
	var _v1 = chk.eZ;
	var label_ = _v1;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-check', !opts.w),
						_Utils_Tuple2('form-check-inline', (!opts.w) && opts.bd),
						_Utils_Tuple2('custom-control', opts.w),
						_Utils_Tuple2('custom-checkbox', opts.w),
						_Utils_Tuple2('custom-control-inline', opts.bd && opts.w)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$toAttributes(opts),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_Utils_ap(
					label_.bN,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('form-check-label', !opts.w),
										_Utils_Tuple2('custom-control-label', opts.w)
									]))
							]),
						function () {
							var _v2 = opts.an;
							if (!_v2.$) {
								var v = _v2.a;
								return _List_fromArray(
									[
										$elm$html$Html$Attributes$for(v)
									]);
							} else {
								return _List_Nil;
							}
						}())),
				label_.gi)
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox = F2(
	function (options, labelText) {
		return $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$view(
			A2(
				$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$create,
				options,
				A2(
					$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						]))));
	});
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$On = 0;
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Value = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checked = function (isCheck) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Value(
		isCheck ? 0 : 1);
};
var $author$project$CommonView$estimatedTimeRulesView = F2(
	function (rules, title) {
		return $elm$core$String$isEmpty(rules) ? _List_Nil : _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						]))
				]),
			A2(
				$elm$core$List$map,
				function (rule) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(rule)
							]));
				},
				$elm$core$String$lines(rules)));
	});
var $author$project$CommonView$estimatedTimeRulesProcessView = function (process) {
	if (process.$ === 1) {
		return _List_Nil;
	} else {
		var p = process.a;
		return A2($author$project$CommonView$estimatedTimeRulesView, p.eB, 'Gewählter Prozess');
	}
};
var $author$project$CommonView$estimatedTimeRulesRecipeView = function (recipe) {
	if (recipe.$ === 1) {
		return _List_Nil;
	} else {
		var r = recipe.a;
		return A2($author$project$CommonView$estimatedTimeRulesView, r.eB, 'Gewähltes Rezept');
	}
};
var $author$project$Run$ItemHelper$getParamDefaultValueStrings = function (param) {
	return A2(
		$elm$core$List$map,
		$author$project$Run$ItemHelper$getParamDefaultValueString(param),
		$author$project$Run$ItemHelper$getValueIndexRange(param));
};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			n: _List_Nil,
			l: 0,
			m: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.l * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						n: A2($elm$core$List$cons, mappedLeaf, builder.n),
						l: builder.l + 1,
						m: builder.m
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $author$project$Run$ItemHelper$valuesOrDefaults = F2(
	function (default_values, values) {
		return A2(
			$elm$core$List$map,
			function (val) {
				return $elm$core$String$isEmpty(val) ? '-' : val;
			},
			$elm$core$Array$toList(
				A2(
					$elm$core$Array$indexedMap,
					F2(
						function (index, val) {
							return $elm$core$String$isEmpty(val) ? A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm_community$list_extra$List$Extra$getAt, index, default_values)) : val;
						}),
					values)));
	});
var $author$project$Run$ItemHelper$formatVariableParam = function (param) {
	var default_values = $author$project$Run$ItemHelper$getParamDefaultValueStrings(param);
	var values = A2($author$project$Run$ItemHelper$valuesOrDefaults, default_values, param.f2);
	var original_values = function () {
		var _v0 = param.hv;
		if (_v0.$ === 1) {
			return values;
		} else {
			var original = _v0.a;
			return A2($author$project$Run$ItemHelper$valuesOrDefaults, default_values, original);
		}
	}();
	return _Utils_Tuple3(
		$author$project$Run$ItemHelper$paramLabel(param),
		values,
		original_values);
};
var $author$project$Run$ItemHelper$formatFixedParam = function (param) {
	return $author$project$Run$ItemHelper$formatVariableParam(param);
};
var $rundis$elm_bootstrap$Bootstrap$Table$TableAttr = function (a) {
	return {$: 7, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$attr = function (attr_) {
	return $rundis$elm_bootstrap$Bootstrap$Table$TableAttr(attr_);
};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Run$ItemHelper$getGroupValue = F4(
	function (group_id, index, param_value, group_values) {
		var kv = function () {
			if (group_id.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var g_id = group_id.a;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v4) {
							var k = _v4.a;
							var v = _v4.b;
							return _Utils_eq(k, g_id);
						},
						group_values));
			}
		}();
		if (kv.$ === 1) {
			return param_value;
		} else {
			var _v1 = kv.a;
			var key = _v1.a;
			var values = _v1.b;
			var _v2 = A2($author$project$Helper$aget, index, values);
			if (_v2 === '') {
				return param_value;
			} else {
				var val = _v2;
				return val;
			}
		}
	});
var $author$project$Run$ItemHelper$withdrawalsString = F2(
	function (param, group_id) {
		var _v0 = param.hF;
		if (_v0.$ === 1) {
			var props = _v0.a;
			return A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function ($) {
						return $.hg;
					},
					A2(
						$elm$core$List$filter,
						function (w) {
							return _Utils_eq(w.eH, group_id);
						},
						props.dd)));
		} else {
			return '';
		}
	});
var $author$project$Run$ItemHelper$getParamValueOrDefaultWithOriginals = F3(
	function (param, group_id, index) {
		var param_value = A2($author$project$Helper$aget, index, param.f2);
		var value = A4($author$project$Run$ItemHelper$getGroupValue, group_id, index, param_value, param.gT);
		var original_param_value = function () {
			var _v3 = param.hv;
			if (_v3.$ === 1) {
				return param_value;
			} else {
				var o_vals = _v3.a;
				return A2($author$project$Helper$aget, index, o_vals);
			}
		}();
		var original_value = function () {
			var _v2 = param.hu;
			if (_v2.$ === 1) {
				return value;
			} else {
				var o_group_vals = _v2.a;
				return A4($author$project$Run$ItemHelper$getGroupValue, group_id, index, original_param_value, o_group_vals);
			}
		}();
		var default_value = A2($author$project$Run$ItemHelper$getParamDefaultValueString, param, index);
		if ($elm$core$String$isEmpty(value)) {
			var withdrawals = A2($author$project$Run$ItemHelper$withdrawalsString, param, group_id);
			if ($elm$core$String$isEmpty(withdrawals)) {
				if (default_value === '') {
					var _v1 = A2($author$project$Run$ItemHelper$withdrawalsString, param, $elm$core$Maybe$Nothing);
					if (_v1 === '') {
						return _Utils_Tuple2('-', '-');
					} else {
						var v = _v1;
						return _Utils_Tuple2(v, v);
					}
				} else {
					var v = default_value;
					return _Utils_Tuple2(v, v);
				}
			} else {
				return _Utils_Tuple2(withdrawals, withdrawals);
			}
		} else {
			return _Utils_Tuple2(value, original_value);
		}
	});
var $author$project$Run$ItemHelper$getParamValueOrDefault = F3(
	function (param, group_id, index) {
		return A3($author$project$Run$ItemHelper$getParamValueOrDefaultWithOriginals, param, group_id, index).a;
	});
var $author$project$CommonView$showParamClass = function (param) {
	var value_missing = A3(
		$elm$core$List$foldl,
		F2(
			function (v, o) {
				return o || (v === '-');
			}),
		false,
		A2(
			$elm$core$List$map,
			A2($author$project$Run$ItemHelper$getParamValueOrDefault, param, $elm$core$Maybe$Nothing),
			$author$project$Run$ItemHelper$getValueIndexRange(param)));
	var _v0 = _Utils_Tuple3(param.fq, value_missing, param.fv);
	if (_v0.a) {
		return '';
	} else {
		if (_v0.b) {
			if (_v0.c) {
				return 'text-danger';
			} else {
				return 'text-warning';
			}
		} else {
			return 'text-success';
		}
	}
};
var $author$project$CommonView$paramRow = F3(
	function (cols_max, format_func, param) {
		var ncolspan = _Utils_eq(
			$elm$core$Array$length(param.f2),
			cols_max) ? 1 : cols_max;
		var _v0 = format_func(param);
		var label = _v0.a;
		var values = _v0.b;
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rundis$elm_bootstrap$Bootstrap$Table$td,
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
								$elm$html$Html$Attributes$class(
									$author$project$CommonView$showParamClass(param)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))
					]),
				A2(
					$elm$core$List$map,
					function (v) {
						return A2(
							$rundis$elm_bootstrap$Bootstrap$Table$td,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									A2($elm$html$Html$Attributes$style, 'text-align', 'right')),
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									$elm$html$Html$Attributes$colspan(ncolspan))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(v)
								]));
					},
					values)));
	});
var $author$project$CommonView$paramsTable = F2(
	function (format_func, params) {
		var cols_max = A2(
			$elm$core$Maybe$withDefault,
			1,
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					function (v) {
						return $elm$core$Array$length(v);
					},
					A2(
						$elm$core$List$map,
						function ($) {
							return $.f2;
						},
						params))));
		return $rundis$elm_bootstrap$Bootstrap$Table$table(
			{
				hs: _List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$small,
						$rundis$elm_bootstrap$Bootstrap$Table$attr(
						$elm$html$Html$Attributes$class('small mb-0 params-table table-bordered'))
					]),
				h4: A2(
					$rundis$elm_bootstrap$Bootstrap$Table$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$CommonView$paramRow, cols_max, format_func),
						params)),
				h5: $rundis$elm_bootstrap$Bootstrap$Table$simpleThead(_List_Nil)
			});
	});
var $author$project$Run$View$PlanningParamsEdit$fixedParamsList = function (fixed_params) {
	return $elm$core$List$isEmpty(fixed_params) ? $elm$html$Html$text('') : A5(
		$author$project$Run$View$FormsHelper$bsFormGroup,
		'Fixe Parameter',
		$elm$core$Maybe$Nothing,
		false,
		false,
		A2($author$project$CommonView$paramsTable, $author$project$Run$ItemHelper$formatFixedParam, fixed_params));
};
var $author$project$CommonView$displayElementName = function (el) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('deleted', el.dn)
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(el.dG)
			]));
};
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$CommonView$getHtmlOption = F2(
	function (selected_value, el) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(el.an)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						selected_value,
						$elm$core$Maybe$Just(el.an)))
				]),
			_List_fromArray(
				[
					$author$project$CommonView$displayElementName(el)
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mb2 = $elm$html$Html$Attributes$class('mb-2');
var $author$project$CommonView$getHtmlSelect = F5(
	function (onInputMsg, records, selected_value, prompt, disabled) {
		var empty_option = (($elm$core$List$length(records) > 1) || $elm$core$List$isEmpty(records)) ? A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(''),
					$elm$html$Html$Attributes$selected(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(prompt)
				])) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Events$onInput(onInputMsg),
					$elm$html$Html$Attributes$class('form-control input-sm custom-select'),
					$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mb2,
					$elm$html$Html$Attributes$disabled(disabled)
				]),
			A2(
				$elm$core$List$cons,
				empty_option,
				A2(
					$elm$core$List$map,
					$author$project$CommonView$getHtmlOption(selected_value),
					records)));
	});
var $author$project$Helper$getRecordsByIds = F2(
	function (records, ids) {
		return A2(
			$elm$core$List$filter,
			function (m) {
				return A2($elm$core$List$member, m.an, ids);
			},
			records);
	});
var $author$project$Run$ItemHelper$hasReservation = function (item) {
	return !_Utils_eq(item.hN, $elm$core$Maybe$Nothing);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Id = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$id = function (theId) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Id(theId);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Inline = {$: 2};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$inline = $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$Inline;
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$OnChecked = function (a) {
	return {$: 3, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck = function (toMsg) {
	return $rundis$elm_bootstrap$Bootstrap$Form$Checkbox$OnChecked(toMsg);
};
var $author$project$Run$ItemHelper$isGroupParamSet = function (param) {
	return A2(
		$elm$core$List$any,
		function (values) {
			return A2(
				$elm$core$List$any,
				function (index) {
					return A2($author$project$Helper$aget, index, values) !== '';
				},
				$author$project$Run$ItemHelper$getValueIndexRange(param));
		},
		A2($elm$core$List$map, $elm$core$Tuple$second, param.gT));
};
var $author$project$Run$ItemHelper$paramValuesExist = F2(
	function (params_per_group, planning_params) {
		if (!planning_params.b) {
			return false;
		} else {
			var p = planning_params.a;
			var rest = planning_params.b;
			return (!_Utils_eq(
				p.f2,
				$author$project$Run$ItemHelper$getParamInitValues(p))) || ((params_per_group && $author$project$Run$ItemHelper$isGroupParamSet(p)) || A2($author$project$Run$ItemHelper$paramValuesExist, params_per_group, rest));
		}
	});
var $author$project$Run$View$PlanningParamsEdit$recipeComment = function (recipe) {
	if (recipe.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var r = recipe.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					(r.gl === '') ? $elm$html$Html$text('') : A5(
					$author$project$Run$View$FormsHelper$bsFormGroup,
					'Rezeptkommentar',
					$elm$core$Maybe$Nothing,
					false,
					false,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small'),
								A2($elm$html$Html$Attributes$style, 'white-space', 'pre-line')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(r.gl)
							])))
				]));
	}
};
var $elm$core$List$sortBy = _List_sortBy;
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$Col3 = 3;
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$ColWidth = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$width = F2(
	function (size, count) {
		return $rundis$elm_bootstrap$Bootstrap$Grid$Internal$ColWidth(
			A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$Width, size, count));
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Col$xs3 = A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$width, 0, 3);
var $author$project$Run$View$PlanningParamsEdit$baseAttributes = F2(
	function (model, item) {
		var was_execution_started = $author$project$Run$ItemHelper$wasExecutionStarted(item);
		var recipes = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.dG;
			},
			A2(
				$elm$core$List$filter,
				function (r) {
					return (!r.dn) || _Utils_eq(
						$elm$core$Maybe$Just(r.an),
						item.hM);
				},
				A2(
					$author$project$Helper$getRecordsByIds,
					model.dQ,
					A2(
						$author$project$Helper$insertIfNotMember,
						item.hM,
						A4($author$project$Run$ItemHelper$recipeIdsForProcessAndMachine, model.dB, model.dC, item.hD, item.hh)))));
		var recipe = A2($author$project$Helper$getRecordById, model.dQ, item.hM);
		var process = A2(
			$author$project$Helper$getRecordById,
			model.dP,
			$elm$core$Maybe$Just(item.hD));
		var param_values_exist = A2($author$project$Run$ItemHelper$paramValuesExist, item.hy, item.hA);
		var machines = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.dG;
			},
			A2(
				$elm$core$List$filter,
				function (m) {
					return (!m.dn) || _Utils_eq(
						$elm$core$Maybe$Just(m.an),
						item.hh);
				},
				A2(
					$author$project$Helper$getRecordsByIds,
					model.dD,
					A2(
						$author$project$Helper$insertIfNotMember,
						item.hh,
						A2($author$project$Run$ItemHelper$machineIdsForProcess, model.dB, item.hD)))));
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$col,
					_List_fromArray(
						[$rundis$elm_bootstrap$Bootstrap$Grid$Col$xs3]),
					_List_fromArray(
						[
							A5(
							$author$project$Run$View$FormsHelper$bsFormGroup,
							'Gerät',
							$elm$core$Maybe$Nothing,
							false,
							false,
							A5(
								$author$project$CommonView$getHtmlSelect,
								$author$project$Helper$passValueToRunMsg(
									A3($author$project$Types$UpdateItem, 0, item, 'machine_id')),
								machines,
								item.hh,
								'Gerät wählen',
								$author$project$Run$ItemHelper$hasReservation(item) || (param_values_exist || was_execution_started)))
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$col,
					_List_fromArray(
						[$rundis$elm_bootstrap$Bootstrap$Grid$Col$xs3]),
					_List_fromArray(
						[
							A5(
							$author$project$Run$View$FormsHelper$bsFormGroup,
							'Rezept',
							$elm$core$Maybe$Nothing,
							false,
							false,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('input-group')
									]),
								_List_fromArray(
									[
										A5(
										$author$project$CommonView$getHtmlSelect,
										$author$project$Helper$passValueToRunMsg(
											A3($author$project$Types$UpdateItem, 0, item, 'recipe_id')),
										recipes,
										item.hM,
										'Rezept wählen',
										param_values_exist || was_execution_started),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('input-group-btn')
											]),
										_List_fromArray(
											[
												function () {
												var icon = (param_values_exist || was_execution_started) ? 'lock' : 'lock-open';
												var disabled_ = (!param_values_exist) || was_execution_started;
												return A2(
													$rundis$elm_bootstrap$Bootstrap$Button$button,
													_List_fromArray(
														[
															$rundis$elm_bootstrap$Bootstrap$Button$secondary,
															$rundis$elm_bootstrap$Bootstrap$Button$small,
															$rundis$elm_bootstrap$Bootstrap$Button$attrs(
															_Utils_ap(
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2('btn-run-editor', true),
																				_Utils_Tuple2('css-tooltip', !disabled_)
																			])),
																		$elm$html$Html$Attributes$type_('button'),
																		$elm$html$Html$Events$onClick(
																		$author$project$Types$GotCommonMsg(
																			A2(
																				$author$project$Types$OpenConfirm,
																				'Alle eingegebenen Parameter werden gelöscht. Rezept zurücksetzen?',
																				$author$project$Types$GotRunMsg(
																					$author$project$Types$ResetRecipe(item))))),
																		$elm$html$Html$Attributes$disabled(disabled_),
																		A2($elm$html$Html$Attributes$style, 'height', '33px')
																	]),
																(!disabled_) ? _List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'Rezept bearbeiten')
																	]) : _List_Nil))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('fas fa-' + icon)
																]),
															_List_Nil)
														]));
											}()
											]))
									]))),
							$author$project$Run$View$PlanningParamsEdit$recipeComment(recipe),
							$author$project$Run$View$PlanningParamsEdit$fixedParamsList(
							A2(
								$elm$core$List$filter,
								function (p) {
									return p.fq;
								},
								item.hA))
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$col,
					_List_fromArray(
						[$rundis$elm_bootstrap$Bootstrap$Grid$Col$xs3]),
					_List_fromArray(
						[
							A5(
							$author$project$Run$View$FormsHelper$bsFormGroup,
							'Anmerkung',
							$elm$core$Maybe$Nothing,
							false,
							false,
							A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('...'),
										$elm$html$Html$Attributes$value(item.gl),
										$author$project$Helper$onChange(
										$author$project$Helper$passValueToRunMsg(
											A3($author$project$Types$UpdateItem, 1, item, 'comment'))),
										$elm$html$Html$Attributes$class('form-control form-control-sm')
									]),
								_List_Nil)),
							A2(
							$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$id('highlight'),
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checked(item.gZ),
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									function (_v0) {
										return $author$project$Types$GotRunMsg(
											A4($author$project$Types$UpdateItem, 1, item, 'highlight', ''));
									}),
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$inline
								]),
							'Prozessschritt hervorheben')
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$col,
					_List_fromArray(
						[$rundis$elm_bootstrap$Bootstrap$Grid$Col$xs3]),
					_List_fromArray(
						[
							A5(
							$author$project$Run$View$FormsHelper$bsFormGroup,
							'Geschätzte Zeit [min]',
							$elm$core$Maybe$Just(
								$elm$html$Html$text('Vielfaches von 30; Scrollrad verwenden')),
							false,
							false,
							A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$Attributes$attribute,
												'value',
												$elm$core$String$fromInt(item.gF)),
												$elm$html$Html$Attributes$type_('number'),
												A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
												$elm$html$Html$Attributes$step('30'),
												$elm$html$Html$Attributes$min('0'),
												$author$project$Helper$onChange(
												$author$project$Helper$passValueToRunMsg(
													A3($author$project$Types$UpdateItem, 1, item, 'estimated_time'))),
												$elm$html$Html$Attributes$class('form-control form-control-sm')
											]),
										_List_Nil)
									]))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small')
								]),
							_Utils_ap(
								$author$project$CommonView$estimatedTimeRulesProcessView(process),
								$author$project$CommonView$estimatedTimeRulesRecipeView(recipe)))
						]))
				]));
	});
var $author$project$Types$ToggleGroupForItem = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$Attrs = function (a) {
	return {$: 2, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$ButtonGroup$Attrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$ButtonItem = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$button = F2(
	function (options, children) {
		return A2($rundis$elm_bootstrap$Bootstrap$Button$button, options, children);
	});
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$GroupItem = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size = modifier.a;
				return _Utils_update(
					options,
					{
						fI: $elm$core$Maybe$Just(size)
					});
			case 1:
				return _Utils_update(
					options,
					{dc: true});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						bN: _Utils_ap(options.bN, attrs_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$defaultOptions = {bN: _List_Nil, fI: $elm$core$Maybe$Nothing, dc: false};
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$groupAttributes = F2(
	function (toggle, modifiers) {
		var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$ButtonGroup$applyModifier, $rundis$elm_bootstrap$Bootstrap$ButtonGroup$defaultOptions, modifiers);
		return _Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'role', 'group'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('btn-group', true),
							_Utils_Tuple2('btn-group-toggle', toggle),
							_Utils_Tuple2('btn-group-vertical', options.dc)
						])),
					A2($elm$html$Html$Attributes$attribute, 'data-toggle', 'buttons')
				]),
			_Utils_ap(
				function () {
					var _v0 = A2($elm$core$Maybe$andThen, $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption, options.fI);
					if (!_v0.$) {
						var s = _v0.a;
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn-group-' + s)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				options.bN));
	});
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$buttonGroupItem = F2(
	function (options, items) {
		return A2(
			$elm$html$Html$div,
			A2($rundis$elm_bootstrap$Bootstrap$ButtonGroup$groupAttributes, false, options),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var elem = _v0;
					return elem;
				},
				items));
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mr2 = $elm$html$Html$Attributes$class('mr-2');
var $rundis$elm_bootstrap$Bootstrap$Badge$Light = 6;
var $rundis$elm_bootstrap$Bootstrap$Badge$Pill = {$: 1};
var $rundis$elm_bootstrap$Bootstrap$Badge$Roled = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Badge$roleOption = function (role) {
	switch (role) {
		case 0:
			return 'badge-primary';
		case 1:
			return 'badge-secondary';
		case 2:
			return 'badge-success';
		case 3:
			return 'badge-info';
		case 4:
			return 'badge-warning';
		case 5:
			return 'badge-danger';
		case 6:
			return 'badge-light';
		default:
			return 'badge-dark';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Badge$badgeClass = function (option) {
	return $elm$html$Html$Attributes$class(
		function () {
			if (option.$ === 1) {
				return 'badge-pill';
			} else {
				var role = option.a;
				return $rundis$elm_bootstrap$Bootstrap$Badge$roleOption(role);
			}
		}());
};
var $rundis$elm_bootstrap$Bootstrap$Badge$badgeAttributes = function (options) {
	return A2(
		$elm$core$List$cons,
		$elm$html$Html$Attributes$class('badge'),
		A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Badge$badgeClass, options));
};
var $rundis$elm_bootstrap$Bootstrap$Badge$badgeInternal = F3(
	function (options, attributes, children) {
		return A2(
			$elm$html$Html$span,
			_Utils_ap(
				$rundis$elm_bootstrap$Bootstrap$Badge$badgeAttributes(options),
				attributes),
			children);
	});
var $rundis$elm_bootstrap$Bootstrap$Badge$pillLight = $rundis$elm_bootstrap$Bootstrap$Badge$badgeInternal(
	_List_fromArray(
		[
			$rundis$elm_bootstrap$Bootstrap$Badge$Roled(6),
			$rundis$elm_bootstrap$Bootstrap$Badge$Pill
		]));
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Run$ItemHelper$waferCountPerItemAndGroup = F3(
	function (model, item, group) {
		var _v0 = A2($author$project$Run$ItemHelper$unprocessedItem, model, item);
		if (_v0.$ === 1) {
			return group.ih - $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function (i) {
						var _v1 = A2($elm$core$Dict$get, group.an, i.gR);
						if (_v1.$ === 1) {
							return 0;
						} else {
							var ga = _v1.a;
							return ga.gv + (i.hY ? ga.gt : 0);
						}
					},
					A2(
						$elm$core$List$filter,
						function (i) {
							return A2($elm$core$List$member, group.an, i.gS);
						},
						A2(
							$elm$core$List$take,
							A2($author$project$Helper$elemIndex, item, model.dz),
							model.dz))));
		} else {
			var unpr_it = _v0.a;
			var _v2 = A2($elm$core$Dict$get, group.an, unpr_it.gR);
			if (_v2.$ === 1) {
				return 0;
			} else {
				var gal = _v2.a;
				return gal.h8;
			}
		}
	});
var $author$project$Run$View$PlanningParamsEdit$groupButton = F3(
	function (model, item, group) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$ButtonGroup$buttonGroupItem,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$ButtonGroup$attrs(
					_List_fromArray(
						[$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mr2, $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mb2]))
				]),
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$ButtonGroup$button,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Button$attrs(
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Types$GotRunMsg(
										A2($author$project$Types$ToggleGroupForItem, item, group))),
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$title(group.dG)
								])),
							A2($elm$core$List$member, group.an, item.gS) ? $rundis$elm_bootstrap$Bootstrap$Button$success : $rundis$elm_bootstrap$Bootstrap$Button$secondary
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(group.hX),
							$elm$html$Html$text(' '),
							A2(
							$rundis$elm_bootstrap$Bootstrap$Badge$pillLight,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A3($author$project$Run$ItemHelper$waferCountPerItemAndGroup, model, item, group)))
								]))
						]))
				]));
	});
var $author$project$Run$ItemHelper$variableParams = function (item) {
	return A2(
		$elm_community$list_extra$List$Extra$filterNot,
		function ($) {
			return $.fq;
		},
		item.hA);
};
var $author$project$Run$ItemHelper$hasVariableParams = function (item) {
	return !$elm$core$List$isEmpty(
		$author$project$Run$ItemHelper$variableParams(item));
};
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$renderGroup = function (_v0) {
	var elem = _v0;
	return elem;
};
var $rundis$elm_bootstrap$Bootstrap$ButtonGroup$toolbar = F2(
	function (attributes, items) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'role', 'toolbar'),
						$elm$html$Html$Attributes$class('btn-toolbar')
					]),
				attributes),
			A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$ButtonGroup$renderGroup, items));
	});
var $author$project$Run$View$PlanningParamsEdit$groupSelect = F2(
	function (model, item) {
		var no_vars = !$author$project$Run$ItemHelper$hasVariableParams(item);
		var no_groups = $elm$core$List$isEmpty(item.gS);
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$col,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rundis$elm_bootstrap$Bootstrap$ButtonGroup$toolbar,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Run$View$PlanningParamsEdit$groupButton, model, item),
								model.eI)),
							(no_groups || no_vars) ? $elm$html$Html$text('') : A2(
							$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$id('params-per-group'),
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checked(item.hy),
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									function (_v0) {
										return $author$project$Types$GotRunMsg(
											A4($author$project$Types$UpdateItem, 1, item, 'params_per_group', ''));
									}),
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$inline
								]),
							'Parameter pro Gruppe eingeben'),
							no_groups ? $elm$html$Html$text('') : A2(
							$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$id('show-group-attrs'),
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$checked(item.hY),
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									function (_v1) {
										return $author$project$Types$GotRunMsg(
											A4($author$project$Types$UpdateItem, 1, item, 'show_group_attrs', ''));
									}),
									$rundis$elm_bootstrap$Bootstrap$Form$Checkbox$inline
								]),
							'Probenentnahme')
						]))
				]));
	});
var $author$project$Types$GroupAttrDestructedSamples = 0;
var $author$project$Types$GroupAttrDestructedSamplesComment = 1;
var $author$project$Types$UpdateItemGroupAttrs = F4(
	function (a, b, c, d) {
		return {$: 34, a: a, b: b, c: c, d: d};
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mt2 = $elm$html$Html$Attributes$class('mt-2');
var $author$project$Run$View$PlanningParamsEdit$itemEditGroupAttrForm = F3(
	function (item, group_id, group_attrs) {
		return _List_fromArray(
			[
				A5(
				$author$project$Run$View$FormsHelper$bsFormGroup,
				'',
				$elm$core$Maybe$Nothing,
				false,
				false,
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromInt(group_attrs.gt)),
							$elm$html$Html$Attributes$placeholder('0'),
							$elm$html$Html$Attributes$type_('number'),
							A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
							$author$project$Helper$onChange(
							function (value) {
								return $author$project$Types$GotRunMsg(
									A4($author$project$Types$UpdateItemGroupAttrs, item, group_id, 0, value));
							}),
							$elm$html$Html$Attributes$class('form-control form-control-sm')
						]),
					_List_Nil)),
				A5(
				$author$project$Run$View$FormsHelper$bsFormGroup,
				'',
				$elm$core$Maybe$Nothing,
				false,
				false,
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(group_attrs.gu),
							$author$project$Helper$onChange(
							function (value) {
								return $author$project$Types$GotRunMsg(
									A4($author$project$Types$UpdateItemGroupAttrs, item, group_id, 1, value));
							}),
							$elm$html$Html$Attributes$placeholder('Kommentar'),
							$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mt2,
							$elm$html$Html$Attributes$class('form-control form-control-sm')
						]),
					_List_Nil))
			]);
	});
var $author$project$Run$View$PlanningParamsEdit$itemEditGroupAttrs = F2(
	function (item, selected_groups) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$rundis$elm_bootstrap$Bootstrap$Table$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Probenentnahme')
								]))
						])),
				A2(
					$elm$core$List$map,
					function (content) {
						return A2($rundis$elm_bootstrap$Bootstrap$Table$td, _List_Nil, content);
					},
					_Utils_ap(
						$author$project$Run$ItemHelper$hasVariableParams(item) ? _List_fromArray(
							[
								_List_fromArray(
								[
									$elm$html$Html$text('')
								])
							]) : _List_Nil,
						A2(
							$elm$core$List$map,
							function (g) {
								return A3(
									$author$project$Run$View$PlanningParamsEdit$itemEditGroupAttrForm,
									item,
									g.an,
									A2($author$project$Run$ItemHelper$getGroupAttrsOrNew, item, g.an));
							},
							selected_groups)))));
	});
var $author$project$Run$View$PlanningParamsEdit$itemEditPlanningParamHeadersRow = F2(
	function (selected_groups, all_groups_header) {
		var group_headers = A2(
			$elm$core$List$map,
			function (g) {
				return g.hX + (': ' + g.dG);
			},
			selected_groups);
		var all_headers = function () {
			if (all_groups_header.$ === 1) {
				return group_headers;
			} else {
				var text = all_groups_header.a;
				return A2($elm$core$List$cons, text, group_headers);
			}
		}();
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$rundis$elm_bootstrap$Bootstrap$Table$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('-')
								]))
						])),
				A2(
					$elm$core$List$map,
					function (h) {
						return A2(
							$rundis$elm_bootstrap$Bootstrap$Table$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(h)
								]));
					},
					all_headers)));
	});
var $author$project$Types$TypePlanningParam = 2;
var $author$project$Types$UpdateItemPlanningParamValue = F5(
	function (a, b, c, d, e) {
		return {$: 35, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Run$View$PlanningParamsEdit$itemEditPlanningParamCell = F4(
	function (show_withdrawals, item, param, group_id) {
		var validation_errors = A2(
			$elm$core$List$filter,
			function (e) {
				return _Utils_eq(e.hw, param.an) && _Utils_eq(e.eH, group_id);
			},
			item.d1);
		var update_function = function (index) {
			return $author$project$Helper$passValueToRunMsg(
				A4($author$project$Types$UpdateItemPlanningParamValue, item, param.an, group_id, index));
		};
		var inputs = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'input-matrix',
							$elm$core$Array$length(param.es) > 1)
						]))
				]),
			A7($author$project$Run$View$FormsHelper$paramInputs, item, param, param.fv, false, param.gT, group_id, update_function));
		var help = ((param.f1 === 'material') && show_withdrawals) ? $elm$core$Maybe$Just(
			A4($author$project$CommonView$withdrawalsList, 2, item, param, group_id)) : $author$project$Run$View$FormsHelper$formatValidationErrors(validation_errors);
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$td,
			_List_Nil,
			$elm$core$List$singleton(
				A5(
					$author$project$Run$View$FormsHelper$bsFormGroup,
					'',
					help,
					param.fv,
					!_Utils_eq(validation_errors, _List_Nil),
					inputs)));
	});
var $author$project$Run$View$PlanningParamsEdit$itemEditPlanningParamRow = F4(
	function (show_withdrawals, item, selected_groups, param) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$rundis$elm_bootstrap$Bootstrap$Table$th,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('required', param.fv)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Run$ItemHelper$paramLabel(param))
								]))
						])),
				_Utils_ap(
					_List_fromArray(
						[
							A4($author$project$Run$View$PlanningParamsEdit$itemEditPlanningParamCell, show_withdrawals, item, param, $elm$core$Maybe$Nothing)
						]),
					item.hy ? A2(
						$elm$core$List$map,
						A3($author$project$Run$View$PlanningParamsEdit$itemEditPlanningParamCell, show_withdrawals, item, param),
						A2(
							$elm$core$List$map,
							$elm$core$Maybe$Just,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.an;
								},
								selected_groups))) : A2(
						$elm$core$List$map,
						function (_v0) {
							return A2($rundis$elm_bootstrap$Bootstrap$Table$td, _List_Nil, _List_Nil);
						},
						selected_groups))));
	});
var $author$project$Run$View$PlanningParamsEdit$planningParamsTable = F2(
	function (model, item) {
		var selected_groups = (item.hy || item.hY) ? A2(
			$elm$core$List$filter,
			function (g) {
				return A2($elm$core$List$member, g.an, item.gS);
			},
			model.eI) : _List_Nil;
		var planning_params = $author$project$Run$ItemHelper$variableParams(item);
		var all_groups_header = $elm$core$List$isEmpty(planning_params) ? $elm$core$Maybe$Nothing : (item.hy ? $elm$core$Maybe$Just('Standardwerte') : $elm$core$Maybe$Just('Alle Gruppen'));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('horizontally-scrollable')
				]),
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$table(
					{
						hs: _List_fromArray(
							[$rundis$elm_bootstrap$Bootstrap$Table$small, $rundis$elm_bootstrap$Bootstrap$Table$bordered]),
						h4: A2(
							$rundis$elm_bootstrap$Bootstrap$Table$tbody,
							_List_Nil,
							_Utils_ap(
								item.hY ? _List_fromArray(
									[
										A2($author$project$Run$View$PlanningParamsEdit$itemEditGroupAttrs, item, selected_groups)
									]) : _List_Nil,
								A2(
									$elm$core$List$map,
									A3($author$project$Run$View$PlanningParamsEdit$itemEditPlanningParamRow, model.a9.e4 === 'RunEditor', item, selected_groups),
									planning_params))),
						h5: A2(
							$rundis$elm_bootstrap$Bootstrap$Table$thead,
							_List_Nil,
							((!item.hY) && $elm$core$List$isEmpty(planning_params)) ? _List_Nil : _List_fromArray(
								[
									A2($author$project$Run$View$PlanningParamsEdit$itemEditPlanningParamHeadersRow, selected_groups, all_groups_header)
								]))
					})
				]));
	});
var $author$project$Run$View$PlanningParamsEdit$planningParamsEdit = F2(
	function (model, item) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Run$View$PlanningParamsEdit$baseAttributes, model, item),
					A2($author$project$Run$View$PlanningParamsEdit$groupSelect, model, item),
					A2($author$project$Run$View$PlanningParamsEdit$planningParamsTable, model, item)
				]));
	});
var $author$project$Run$ItemHelper$isGroupParam = F2(
	function (item, param) {
		if (item.hy) {
			var group_withdrawals = A2(
				$elm_community$list_extra$List$Extra$filterNot,
				$elm$core$String$isEmpty,
				A2(
					$elm$core$List$map,
					$author$project$Run$ItemHelper$withdrawalsString(param),
					A2($elm$core$List$map, $elm$core$Maybe$Just, item.gS)));
			return (!_Utils_eq(group_withdrawals, _List_Nil)) || A2(
				$elm$core$List$any,
				function (_v0) {
					var key = _v0.a;
					var values = _v0.b;
					return A2($elm$core$List$member, key, item.gS) && A2(
						$elm$core$List$any,
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
						$elm$core$Array$toList(values));
				},
				param.gT);
		} else {
			return false;
		}
	});
var $author$project$Run$ItemHelper$getGroupParams = function (item) {
	return item.hy ? A2(
		$elm$core$List$filter,
		$author$project$Run$ItemHelper$isGroupParam(item),
		item.hA) : _List_Nil;
};
var $author$project$Types$GroupMatrixTable = F2(
	function (groups, rows) {
		return {eI: groups, hR: rows};
	});
var $author$project$Run$View$PlanningParamsOverview$getMatrixTableData = F3(
	function (table_data_per_group, groups, matrix_tables) {
		getMatrixTableData:
		while (true) {
			var _v0 = $elm$core$List$head(groups);
			if (_v0.$ === 1) {
				return matrix_tables;
			} else {
				var group = _v0.a;
				var table_data = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, group.an, table_data_per_group));
				var identic_groups = A2(
					$elm$core$List$filter,
					function (g) {
						var other_table_data = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Dict$get, g.an, table_data_per_group));
						return _Utils_eq(table_data, other_table_data);
					},
					groups);
				var new_groups = A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (g) {
						return A2($elm$core$List$member, g, identic_groups);
					},
					groups);
				var new_matrix_table = A2($author$project$Types$GroupMatrixTable, identic_groups, table_data);
				var new_matrix_tables = _Utils_ap(
					matrix_tables,
					_List_fromArray(
						[new_matrix_table]));
				var $temp$table_data_per_group = table_data_per_group,
					$temp$groups = new_groups,
					$temp$matrix_tables = new_matrix_tables;
				table_data_per_group = $temp$table_data_per_group;
				groups = $temp$groups;
				matrix_tables = $temp$matrix_tables;
				continue getMatrixTableData;
			}
		}
	});
var $author$project$Types$TogglePlanningParamChecked = F4(
	function (a, b, c, d) {
		return {$: 36, a: a, b: b, c: c, d: d};
	});
var $author$project$Helper$faIcon = function (name) {
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mr-2 fa fa-' + name)
			]),
		_List_Nil);
};
var $author$project$Run$View$PlanningParamsOverview$formatCellWithOriginal = F7(
	function (cell_fct, colspan, maybe_background_color, maybe_toggle_checked_fct, value, original_value, checked) {
		return A2(
			cell_fct,
			_Utils_ap(
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$colspan(
							A2($elm$core$Maybe$withDefault, 1, colspan)))
					]),
				_Utils_ap(
					function () {
						if (maybe_background_color.$ === 1) {
							return _List_Nil;
						} else {
							var background_color = maybe_background_color.a;
							return _List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									A2($elm$html$Html$Attributes$style, 'background-color', background_color))
								]);
						}
					}(),
					_Utils_ap(
						function () {
							if (maybe_toggle_checked_fct.$ === 1) {
								return _List_Nil;
							} else {
								var fct = maybe_toggle_checked_fct.a;
								return _List_fromArray(
									[
										$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
										$elm$html$Html$Attributes$class('clickable')),
										$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
										$elm$html$Html$Events$onClick(
											$author$project$Types$GotRunMsg(fct)))
									]);
							}
						}(),
						_Utils_ap(
							checked ? _List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									$elm$html$Html$Attributes$class('checked'))
								]) : _List_Nil,
							function () {
								if (_Utils_eq(value, original_value)) {
									return _List_Nil;
								} else {
									var msg = $elm$core$String$isEmpty(original_value) ? 'Ursprünglich ohne Wert' : ('Ursprünglicher Wert: ' + original_value);
									return _List_fromArray(
										[
											$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
											$elm$html$Html$Attributes$class('css-tooltip')),
											$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
											A2($elm$html$Html$Attributes$attribute, 'data-tooltip', msg))
										]);
								}
							}())))),
			_List_fromArray(
				[
					A2(
					$author$project$Helper$htmlIf,
					checked,
					$author$project$Helper$faIcon('check')),
					A2(
					$author$project$Helper$htmlIf,
					!_Utils_eq(value, original_value),
					$author$project$Helper$faIcon('info-circle')),
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Run$ItemHelper$getGroupValueChecked = F3(
	function (param, group_id, index) {
		var checked_values = $elm$core$List$head(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					function (_v1) {
						var g_id = _v1.a;
						var values = _v1.b;
						return _Utils_eq(g_id, group_id);
					},
					param.gU)));
		if (checked_values.$ === 1) {
			return false;
		} else {
			var values = checked_values.a;
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Array$get, index, values));
		}
	});
var $author$project$Run$View$PlanningParamsOverview$groupMatrixTable = F2(
	function (item, table) {
		var is_planning = !item.h1;
		var caption = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.hX;
				},
				table.eI));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(caption)
						])),
					$rundis$elm_bootstrap$Bootstrap$Table$table(
					{
						hs: _List_fromArray(
							[$rundis$elm_bootstrap$Bootstrap$Table$small, $rundis$elm_bootstrap$Bootstrap$Table$bordered]),
						h4: A2(
							$rundis$elm_bootstrap$Bootstrap$Table$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (row) {
									return A2(
										$rundis$elm_bootstrap$Bootstrap$Table$tr,
										_List_Nil,
										A2(
											$elm$core$List$indexedMap,
											F2(
												function (index, _v0) {
													var value = _v0.a;
													var original_value = _v0.b;
													var group_values_checked_index = index - 1;
													var group_ids = A2(
														$elm$core$List$map,
														function ($) {
															return $.an;
														},
														table.eI);
													var toggle_checked_fct = is_planning ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
														A4($author$project$Types$TogglePlanningParamChecked, item, row.ff.an, group_ids, group_values_checked_index));
													var checked = function () {
														var _v1 = $elm$core$List$head(group_ids);
														if (_v1.$ === 1) {
															return false;
														} else {
															var g_id = _v1.a;
															return (group_values_checked_index < 0) ? false : A3($author$project$Run$ItemHelper$getGroupValueChecked, row.ff, g_id, group_values_checked_index);
														}
													}();
													return A7($author$project$Run$View$PlanningParamsOverview$formatCellWithOriginal, $rundis$elm_bootstrap$Bootstrap$Table$td, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, toggle_checked_fct, value, original_value, checked);
												}),
											row.gg));
								},
								table.hR)),
						h5: A2($rundis$elm_bootstrap$Bootstrap$Table$thead, _List_Nil, _List_Nil)
					})
				]));
	});
var $author$project$Types$GroupMatrixTableRow = F2(
	function (param, cells) {
		return {gg: cells, ff: param};
	});
var $author$project$Run$View$PlanningParamsOverview$tableDataPerGroup = F2(
	function (params, g_id) {
		return A2(
			$elm$core$List$map,
			function (param) {
				var label = $author$project$Run$ItemHelper$paramLabel(param);
				return A2(
					$author$project$Types$GroupMatrixTableRow,
					param,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(label, label),
						A2(
							$elm$core$List$map,
							A2(
								$author$project$Run$ItemHelper$getParamValueOrDefaultWithOriginals,
								param,
								$elm$core$Maybe$Just(g_id)),
							$author$project$Run$ItemHelper$getValueIndexRange(param))));
			},
			params);
	});
var $author$project$Run$View$PlanningParamsOverview$groupMatrixTables = F3(
	function (selected_groups, group_params, item) {
		var group_params_with_matrix = A2(
			$elm$core$List$filter,
			function (param) {
				return $elm$core$Array$length(param.es) > 1;
			},
			group_params);
		if ($elm$core$List$isEmpty(group_params_with_matrix)) {
			return $elm$html$Html$text('');
		} else {
			var table_data_per_group = $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (g) {
						return _Utils_Tuple2(
							g.an,
							A2($author$project$Run$View$PlanningParamsOverview$tableDataPerGroup, group_params_with_matrix, g.an));
					},
					selected_groups));
			var tables = A3($author$project$Run$View$PlanningParamsOverview$getMatrixTableData, table_data_per_group, selected_groups, _List_Nil);
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Run$View$PlanningParamsOverview$groupMatrixTable(item),
					tables));
		}
	});
var $author$project$Types$GroupAttrDestructedSamplesExecution = 2;
var $author$project$CommonView$getIntegerInput = F3(
	function (string_value, onchange_action, readonly) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(string_value),
					$elm$html$Html$Attributes$placeholder('0'),
					$elm$html$Html$Attributes$type_('number'),
					A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
					$elm$html$Html$Attributes$disabled(readonly),
					$author$project$Helper$onChange(onchange_action),
					$elm$html$Html$Attributes$class('form-control form-control-sm')
				]),
			_List_Nil);
	});
var $author$project$Run$View$PlanningParamsOverview$destructedSamplesExecution = F3(
	function (readonly, item, selected_groups) {
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.gv;
				},
				A2(
					$elm$core$List$map,
					$author$project$Run$ItemHelper$getGroupAttrsOrNew(item),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.an;
						},
						selected_groups))));
		return _List_fromArray(
			[
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$tr,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$rundis$elm_bootstrap$Bootstrap$Table$th,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Zerstörte Proben Durchführung')
									]))
							])),
					A2(
						$elm$core$List$map,
						$rundis$elm_bootstrap$Bootstrap$Table$td(_List_Nil),
						A2(
							$elm$core$List$map,
							$elm$core$List$singleton,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (g) {
										var string_value = $elm$core$String$fromInt(
											A2($author$project$Run$ItemHelper$getGroupAttrsOrNew, item, g.an).gv);
										var onchange_action = readonly ? function (_v0) {
											return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
										} : function (value) {
											return $author$project$Types$GotRunMsg(
												A4($author$project$Types$UpdateItemGroupAttrs, item, g.an, 2, value));
										};
										return A3($author$project$CommonView$getIntegerInput, string_value, onchange_action, readonly);
									},
									selected_groups),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(total))
									]))))))
			]);
	});
var $author$project$Types$GroupAttrUnprocessedSamples = 3;
var $author$project$Run$View$PlanningParamsOverview$unprocessedSamples = F3(
	function (readonly, item, selected_groups) {
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.h8;
				},
				A2(
					$elm$core$List$map,
					$author$project$Run$ItemHelper$getGroupAttrsOrNew(item),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.an;
						},
						selected_groups))));
		return _List_fromArray(
			[
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$tr,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$rundis$elm_bootstrap$Bootstrap$Table$th,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Unprozessierte Proben')
									]))
							])),
					A2(
						$elm$core$List$map,
						$rundis$elm_bootstrap$Bootstrap$Table$td(_List_Nil),
						A2(
							$elm$core$List$map,
							$elm$core$List$singleton,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (g) {
										var string_value = $elm$core$String$fromInt(
											A2($author$project$Run$ItemHelper$getGroupAttrsOrNew, item, g.an).h8);
										var onchange_action = readonly ? function (_v0) {
											return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
										} : function (value) {
											return $author$project$Types$GotRunMsg(
												A4($author$project$Types$UpdateItemGroupAttrs, item, g.an, 3, value));
										};
										return A3($author$project$CommonView$getIntegerInput, string_value, onchange_action, readonly);
									},
									selected_groups),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(total))
									]))))))
			]);
	});
var $author$project$Run$View$PlanningParamsOverview$groupAttrsExecutionRows = F3(
	function (readonly, item, selected_groups) {
		return _Utils_ap(
			A3($author$project$Run$View$PlanningParamsOverview$destructedSamplesExecution, readonly, item, selected_groups),
			A3($author$project$Run$View$PlanningParamsOverview$unprocessedSamples, readonly, item, selected_groups));
	});
var $author$project$Run$View$PlanningParamsOverview$groupsTableRow = F6(
	function (values_colors, caption, values_and_original_values, toggle_checked_fcts, cell_fct, total) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$rundis$elm_bootstrap$Bootstrap$Table$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(caption)
						])),
				_Utils_ap(
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, _v0) {
								var value = _v0.a;
								var original_value = _v0.b;
								var checked = _v0.c;
								var toggle_checked_fct = A2($elm_community$list_extra$List$Extra$getAt, index, toggle_checked_fcts);
								var background_color = $elm$core$List$head(
									A2(
										$elm$core$List$map,
										$elm$core$Tuple$second,
										A2(
											$elm$core$List$filter,
											function (_v1) {
												var val = _v1.a;
												return _Utils_eq(val, value);
											},
											values_colors)));
								return A7($author$project$Run$View$PlanningParamsOverview$formatCellWithOriginal, cell_fct, $elm$core$Maybe$Nothing, background_color, toggle_checked_fct, value, original_value, checked);
							}),
						values_and_original_values),
					_List_fromArray(
						[
							A2(
							cell_fct,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(total)
								]))
						]))));
	});
var $elm$core$List$map3 = _List_map3;
var $author$project$Run$View$PlanningParamsOverview$groupAttrsPlanningRows = F2(
	function (item, selected_groups) {
		if (item.hY) {
			var group_attrs_per_groups = A2(
				$elm$core$List$map,
				$elm$core$Maybe$withDefault(
					A6($author$project$Types$GroupAttrs, 0, 0, '', 0, 0, '')),
				A2(
					$elm$core$List$map,
					function (g) {
						return A2($elm$core$Dict$get, g.an, item.gR);
					},
					selected_groups));
			var original_group_attrs_per_groups = function () {
				var _v0 = item.ht;
				if (_v0.$ === 1) {
					return group_attrs_per_groups;
				} else {
					var original = _v0.a;
					return A2(
						$elm$core$List$map,
						$elm$core$Maybe$withDefault(
							A6($author$project$Types$GroupAttrs, 0, 0, '', 0, 0, '')),
						A2(
							$elm$core$List$map,
							function (g) {
								return A2($elm$core$Dict$get, g.an, original);
							},
							selected_groups));
				}
			}();
			var original_comments = A2(
				$elm$core$List$map,
				function ($) {
					return $.gu;
				},
				original_group_attrs_per_groups);
			var original_destructed_samples = A2(
				$elm$core$List$map,
				$elm$core$String$fromInt,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.gt;
					},
					original_group_attrs_per_groups));
			var destructed_samples_total = $elm$core$String$fromInt(
				$elm$core$List$sum(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.gt;
						},
						group_attrs_per_groups)));
			var destructed_samples = A2(
				$elm$core$List$map,
				$elm$core$String$fromInt,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.gt;
					},
					group_attrs_per_groups));
			var destructed_samples_and_originals = A4(
				$elm$core$List$map3,
				F3(
					function (val, orig, check) {
						return _Utils_Tuple3(val, orig, check);
					}),
				destructed_samples,
				original_destructed_samples,
				A2(
					$elm$core$List$repeat,
					$elm$core$List$length(destructed_samples),
					false));
			var comments = A2(
				$elm$core$List$map,
				function ($) {
					return $.gu;
				},
				group_attrs_per_groups);
			var comments_and_originals = A4(
				$elm$core$List$map3,
				F3(
					function (val, orig, check) {
						return _Utils_Tuple3(val, orig, check);
					}),
				comments,
				original_comments,
				A2(
					$elm$core$List$repeat,
					$elm$core$List$length(comments),
					false));
			return _List_fromArray(
				[
					A6($author$project$Run$View$PlanningParamsOverview$groupsTableRow, _List_Nil, 'Entnommene Proben', destructed_samples_and_originals, _List_Nil, $rundis$elm_bootstrap$Bootstrap$Table$td, destructed_samples_total),
					A6($author$project$Run$View$PlanningParamsOverview$groupsTableRow, _List_Nil, 'Kommentar', comments_and_originals, _List_Nil, $rundis$elm_bootstrap$Bootstrap$Table$td, '')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Run$View$PlanningParamsOverview$groupParamsHeading = function (length) {
	return _List_fromArray(
		[
			A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$colspan(length + 1))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Gruppenparameter*')
								]))
						]))
				]))
		]);
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$Run$ItemHelper$createColorClassList = F2(
	function (item, group_params) {
		var values = $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm_community$list_extra$List$Extra$filterNot,
				function (v) {
					return v === '';
				},
				_Utils_ap(
					A3(
						$elm$core$List$foldr,
						$elm$core$Basics$append,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (p) {
								return A2(
									$elm$core$List$map,
									function (g_id) {
										return A2(
											$elm$core$String$join,
											'|',
											A2(
												$elm$core$List$map,
												A2(
													$author$project$Run$ItemHelper$getParamValueOrDefault,
													p,
													$elm$core$Maybe$Just(g_id)),
												$author$project$Run$ItemHelper$getValueIndexRange(p)));
									},
									item.gS);
							},
							group_params)),
					A2(
						$elm$core$List$map,
						function (p) {
							return A2(
								$elm$core$String$join,
								'|',
								$elm$core$Array$toList(p.f2));
						},
						item.hA))));
		var possible_colors = $elm$core$Array$fromList(
			_List_fromArray(
				['rgb(12,192,170)', 'rgb(243,118,142)', 'rgb(168,249,79)', 'rgb(238,132,236)', 'rgb(9,245,76)', 'rgb(251,120,16)', 'rgb(121,193,239)', 'rgb(98,176,61)', 'rgb(146,150,238)', 'rgb(226,217,35)', 'rgb(252,214,255)', 'rgb(216,251,201)', 'rgb(199,144,141)', 'rgb(161,178,125)', 'rgb(254,186,83)', 'rgb(250,143,235)']));
		var colors = A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$elm$core$Maybe$withDefault,
					'darkred',
					A2(
						$elm$core$Array$get,
						A2(
							$elm$core$Basics$modBy,
							$elm$core$Array$length(possible_colors),
							i),
						possible_colors));
			},
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(values) - 1));
		return A3($elm$core$List$map2, $elm$core$Tuple$pair, values, colors);
	});
var $author$project$Run$View$PlanningParamsOverview$groupParamsWithoutMatrix = F4(
	function (readonly, item, selected_groups, group_params) {
		var values_colors = A2($author$project$Run$ItemHelper$createColorClassList, item, group_params);
		var params = A2(
			$elm$core$List$filter,
			function (param) {
				return $elm$core$Array$length(param.es) === 1;
			},
			group_params);
		return A2(
			$elm$core$List$map,
			function (param) {
				var values_with_originals_and_checks = A2(
					$elm$core$List$map,
					function (g) {
						var checked = A3($author$project$Run$ItemHelper$getGroupValueChecked, param, g.an, 0);
						var _v1 = A3(
							$author$project$Run$ItemHelper$getParamValueOrDefaultWithOriginals,
							param,
							$elm$core$Maybe$Just(g.an),
							0);
						var val = _v1.a;
						var orig = _v1.b;
						return _Utils_Tuple3(val, orig, checked);
					},
					selected_groups);
				var toggle_checked_fcts = function () {
					if (readonly) {
						return _List_Nil;
					} else {
						var _v0 = item.h1;
						if (_v0 === 1) {
							return A2(
								$elm$core$List$map,
								function (g) {
									return A4(
										$author$project$Types$TogglePlanningParamChecked,
										item,
										param.an,
										_List_fromArray(
											[g.an]),
										0);
								},
								selected_groups);
						} else {
							return _List_Nil;
						}
					}
				}();
				return A6(
					$author$project$Run$View$PlanningParamsOverview$groupsTableRow,
					values_colors,
					$author$project$Run$ItemHelper$paramLabel(param),
					values_with_originals_and_checks,
					toggle_checked_fcts,
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					'');
			},
			params);
	});
var $author$project$Run$View$PlanningParamsOverview$groupsTableHeader = function (selected_groups) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Table$thead,
		_List_Nil,
		_List_fromArray(
			[
				A6(
				$author$project$Run$View$PlanningParamsOverview$groupsTableRow,
				_List_Nil,
				'Gruppe',
				A2(
					$elm$core$List$map,
					function (v) {
						return _Utils_Tuple3(v, v, false);
					},
					A2(
						$elm$core$List$map,
						function ($) {
							return $.hX;
						},
						selected_groups)),
				_List_Nil,
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				'Gesamt')
			]));
};
var $author$project$Run$View$PlanningParamsOverview$groupsTableNames = function (selected_groups) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Table$tr,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					])),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$rundis$elm_bootstrap$Bootstrap$Table$td(_List_Nil),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2(
							$elm$core$List$map,
							$elm$html$Html$text,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.dG;
								},
								selected_groups)))),
				_List_fromArray(
					[
						A2($rundis$elm_bootstrap$Bootstrap$Table$td, _List_Nil, _List_Nil)
					]))));
};
var $author$project$Types$TypeGroup = 1;
var $author$project$Run$View$PlanningParamsOverview$groupsTableOperatorNotesRow = F3(
	function (readonly, item, selected_groups) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$rundis$elm_bootstrap$Bootstrap$Table$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Anmerkung')
						])),
				A2(
					$elm$core$List$map,
					function (g) {
						var note = A2($author$project$Run$ItemHelper$getGroupAttrsOrNew, item, g.an).cy;
						return A2(
							$rundis$elm_bootstrap$Bootstrap$Table$td,
							_List_Nil,
							_List_fromArray(
								[
									A5($author$project$CommonView$createOperatorNote, readonly, item, g.an, 1, note)
								]));
					},
					selected_groups)));
	});
var $author$project$Run$View$PlanningParamsOverview$groupsTableUnprocessedSamplesCountRow = F3(
	function (model, item, selected_groups) {
		var unprocessed_item = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (i) {
					return _Utils_eq(
						$elm$core$Maybe$Just(i.an),
						item.hE);
				},
				model.dz));
		var _v0 = function () {
			if (unprocessed_item.$ === 1) {
				return _Utils_Tuple2(
					'0',
					A2(
						$elm$core$List$map,
						function (g) {
							return 0;
						},
						selected_groups));
			} else {
				var it = unprocessed_item.a;
				return _Utils_Tuple2(
					$elm$core$String$fromInt(
						A2($author$project$Run$ItemHelper$getPageNo, model.dz, it)),
					A2(
						$elm$core$List$map,
						function (maybe_gal) {
							if (maybe_gal.$ === 1) {
								return 0;
							} else {
								var gal = maybe_gal.a;
								return gal.h8;
							}
						},
						A2(
							$elm$core$List$map,
							function (g) {
								return A2($elm$core$Dict$get, g.an, it.gR);
							},
							selected_groups)));
			}
		}();
		var page_no = _v0.a;
		var counts = _v0.b;
		return A6(
			$author$project$Run$View$PlanningParamsOverview$groupsTableRow,
			_List_Nil,
			'Unprozessierte Proben aus Schritt ' + page_no,
			A2(
				$elm$core$List$map,
				function (v) {
					return _Utils_Tuple3(v, v, false);
				},
				A2($elm$core$List$map, $elm$core$String$fromInt, counts)),
			_List_Nil,
			$rundis$elm_bootstrap$Bootstrap$Table$td,
			$elm$core$String$fromInt(
				A2($author$project$Run$ItemHelper$totalWaferCountPerItem, model, item)));
	});
var $author$project$Run$View$PlanningParamsOverview$groupsTableWaferCountRow = F3(
	function (model, item, selected_groups) {
		return A6(
			$author$project$Run$View$PlanningParamsOverview$groupsTableRow,
			_List_Nil,
			'Anzahl Proben',
			A2(
				$elm$core$List$map,
				function (v) {
					return _Utils_Tuple3(v, v, false);
				},
				A2(
					$elm$core$List$map,
					$elm$core$String$fromInt,
					A2(
						$elm$core$List$map,
						A2($author$project$Run$ItemHelper$waferCountPerItemAndGroup, model, item),
						selected_groups))),
			_List_Nil,
			$rundis$elm_bootstrap$Bootstrap$Table$td,
			$elm$core$String$fromInt(
				A2($author$project$Run$ItemHelper$totalWaferCountPerItem, model, item)));
	});
var $rundis$elm_bootstrap$Bootstrap$Table$RowAttr = function (a) {
	return {$: 2, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$rowAttr = function (attr_) {
	return $rundis$elm_bootstrap$Bootstrap$Table$RowAttr(attr_);
};
var $author$project$Run$View$PlanningParamsOverview$groupsTableWaferLabels = function (selected_groups) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Table$tr,
		_List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
				$elm$html$Html$Attributes$class('group-comments-row'))
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Bezeichnungen')
					])),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$rundis$elm_bootstrap$Bootstrap$Table$td(_List_Nil),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2(
							$elm$core$List$map,
							$elm$html$Html$div(_List_Nil),
							A2(
								$elm$core$List$map,
								$elm$core$List$intersperse(
									A2($elm$html$Html$br, _List_Nil, _List_Nil)),
								A2(
									$elm$core$List$map,
									$elm$core$List$map($elm$html$Html$text),
									A2(
										$elm$core$List$map,
										$elm$core$String$split('\n'),
										A2(
											$elm$core$List$map,
											function ($) {
												return $.ii;
											},
											selected_groups))))))),
				_List_fromArray(
					[
						A2($rundis$elm_bootstrap$Bootstrap$Table$td, _List_Nil, _List_Nil)
					]))));
};
var $author$project$Run$View$PlanningParamsOverview$groupsTable = F4(
	function (model, selected_groups, group_params, item) {
		var readonly = A2($author$project$Run$ItemHelper$isExecutionDisabled, model, item);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Gruppen')
						])),
					$rundis$elm_bootstrap$Bootstrap$Table$table(
					{
						hs: _List_fromArray(
							[$rundis$elm_bootstrap$Bootstrap$Table$small, $rundis$elm_bootstrap$Bootstrap$Table$bordered]),
						h4: A2(
							$rundis$elm_bootstrap$Bootstrap$Table$tbody,
							_List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Run$View$PlanningParamsOverview$groupsTableNames(selected_groups),
										$author$project$Run$View$PlanningParamsOverview$groupsTableWaferLabels(selected_groups)
									]),
								_Utils_ap(
									_Utils_eq(item.hE, $elm$core$Maybe$Nothing) ? _List_fromArray(
										[
											A3($author$project$Run$View$PlanningParamsOverview$groupsTableWaferCountRow, model, item, selected_groups)
										]) : _List_fromArray(
										[
											A3($author$project$Run$View$PlanningParamsOverview$groupsTableUnprocessedSamplesCountRow, model, item, selected_groups)
										]),
									_Utils_ap(
										A2($author$project$Run$View$PlanningParamsOverview$groupAttrsPlanningRows, item, selected_groups),
										_Utils_ap(
											A3($author$project$Run$View$PlanningParamsOverview$groupAttrsExecutionRows, readonly, item, selected_groups),
											_Utils_ap(
												$author$project$Run$View$PlanningParamsOverview$groupParamsHeading(
													$elm$core$List$length(selected_groups)),
												_Utils_ap(
													A4($author$project$Run$View$PlanningParamsOverview$groupParamsWithoutMatrix, readonly, item, selected_groups, group_params),
													_List_fromArray(
														[
															A3($author$project$Run$View$PlanningParamsOverview$groupsTableOperatorNotesRow, readonly, item, selected_groups)
														])))))))),
						h5: $author$project$Run$View$PlanningParamsOverview$groupsTableHeader(selected_groups)
					})
				]));
	});
var $author$project$Run$ItemHelper$isParamWithWithdrawals = function (param) {
	var _v0 = param.hF;
	if (_v0.$ === 1) {
		var props = _v0.a;
		return !$elm$core$List$isEmpty(props.dd);
	} else {
		return false;
	}
};
var $author$project$Run$View$PlanningParamsOverview$withdrawalsTable = function (param) {
	var withdrawals = $author$project$Run$ItemHelper$getMaterialWithdrawals(param.hF);
	var keys = function () {
		var _v0 = param.hF;
		if (_v0.$ === 1) {
			var props = _v0.a;
			var _v1 = $elm$core$List$head(props.dd);
			if (_v1.$ === 1) {
				return _List_Nil;
			} else {
				var w = _v1.a;
				return A2($elm$core$List$map, $elm$core$Tuple$first, w.hF);
			}
		} else {
			return _List_Nil;
		}
	}();
	return $rundis$elm_bootstrap$Bootstrap$Table$table(
		{
			hs: _List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$small,
					$rundis$elm_bootstrap$Bootstrap$Table$attr(
					$elm$html$Html$Attributes$class('withdrawals-table'))
				]),
			h4: A2(
				$rundis$elm_bootstrap$Bootstrap$Table$tbody,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (key) {
						return A2(
							$rundis$elm_bootstrap$Bootstrap$Table$tr,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$rundis$elm_bootstrap$Bootstrap$Table$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(key)
										])),
								A2(
									$elm$core$List$map,
									$rundis$elm_bootstrap$Bootstrap$Table$td(_List_Nil),
									A2(
										$elm$core$List$map,
										$elm$core$List$singleton,
										A2(
											$elm$core$List$map,
											$elm$html$Html$text,
											A2(
												$elm$core$List$map,
												$elm$core$Maybe$withDefault(''),
												A2(
													$elm$core$List$map,
													$elm$core$Dict$get(key),
													A2(
														$elm$core$List$map,
														$elm$core$Dict$fromList,
														A2(
															$elm$core$List$map,
															function ($) {
																return $.hF;
															},
															withdrawals)))))))));
					},
					keys)),
			h5: A2(
				$rundis$elm_bootstrap$Bootstrap$Table$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rundis$elm_bootstrap$Bootstrap$Table$tr,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$rundis$elm_bootstrap$Bootstrap$Table$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(param.f$)
									])),
							A2(
								$elm$core$List$map,
								$rundis$elm_bootstrap$Bootstrap$Table$th(_List_Nil),
								A2(
									$elm$core$List$map,
									$elm$core$List$singleton,
									A2(
										$elm$core$List$map,
										function (w) {
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														$author$project$Types$GotRunMsg(
															$author$project$Types$OpenMaterialLot(w.t))),
														$elm$html$Html$Attributes$class('btn-link clickable')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(w.hH) + (' * ' + w.hg))
													]));
										},
										withdrawals)))))
					]))
		});
};
var $author$project$Run$View$PlanningParamsOverview$withdrawalsTableInRow = F2(
	function (param, max_val_count) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_Nil,
			$elm$core$List$singleton(
				A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$colspan(max_val_count + 2)),
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('withdrawals-table-container'))
						]),
					$elm$core$List$singleton(
						$author$project$Run$View$PlanningParamsOverview$withdrawalsTable(param)))));
	});
var $author$project$Run$View$PlanningParamsOverview$insertWithdrawalRows = F4(
	function (rows, planning_params, max_val_count, result) {
		insertWithdrawalRows:
		while (true) {
			var _v0 = _Utils_Tuple2(rows, planning_params);
			if (!_v0.a.b) {
				return result;
			} else {
				if (!_v0.b.b) {
					return result;
				} else {
					var _v1 = _v0.a;
					var row = _v1.a;
					var rows_rest = _v1.b;
					var _v2 = _v0.b;
					var param = _v2.a;
					var params_rest = _v2.b;
					var new_row = $author$project$Run$ItemHelper$isParamWithWithdrawals(param) ? _List_fromArray(
						[
							row,
							A2($author$project$Run$View$PlanningParamsOverview$withdrawalsTableInRow, param, max_val_count)
						]) : _List_fromArray(
						[row]);
					var $temp$rows = rows_rest,
						$temp$planning_params = params_rest,
						$temp$max_val_count = max_val_count,
						$temp$result = _Utils_ap(result, new_row);
					rows = $temp$rows;
					planning_params = $temp$planning_params;
					max_val_count = $temp$max_val_count;
					result = $temp$result;
					continue insertWithdrawalRows;
				}
			}
		}
	});
var $author$project$Run$ItemHelper$formatGroupParam = function (param) {
	return _Utils_Tuple3(
		$author$project$Run$ItemHelper$paramLabel(param),
		_List_fromArray(
			['siehe Gruppenparameter']),
		_List_fromArray(
			['siehe Gruppenparameter']));
};
var $author$project$Run$View$PlanningParamsOverview$overviewTableRow = F4(
	function (readonly, item, max_val_count, planning_param) {
		var _v0 = planning_param.fq ? $author$project$Run$ItemHelper$formatFixedParam(planning_param) : (A2($author$project$Run$ItemHelper$isGroupParam, item, planning_param) ? $author$project$Run$ItemHelper$formatGroupParam(planning_param) : $author$project$Run$ItemHelper$formatVariableParam(planning_param));
		var label = _v0.a;
		var values = _v0.b;
		var original_values = _v0.c;
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('variable', !planning_param.fq)
							])))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
				_Utils_ap(
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, _v1) {
								var value = _v1.a;
								var original_value = _v1.b;
								var toggle_checked_fct = function () {
									if (readonly) {
										return $elm$core$Maybe$Nothing;
									} else {
										var _v2 = item.h1;
										if (!_v2) {
											return $elm$core$Maybe$Nothing;
										} else {
											return $elm$core$Maybe$Just(
												A4($author$project$Types$TogglePlanningParamChecked, item, planning_param.an, _List_Nil, index));
										}
									}
								}();
								var colspan = (($elm$core$List$length(values) === 1) && (max_val_count !== 1)) ? $elm$core$Maybe$Just(max_val_count) : $elm$core$Maybe$Nothing;
								var checked = A2(
									$elm$core$Maybe$withDefault,
									false,
									A2($elm$core$Array$get, index, planning_param.ie));
								return A7($author$project$Run$View$PlanningParamsOverview$formatCellWithOriginal, $rundis$elm_bootstrap$Bootstrap$Table$td, colspan, $elm$core$Maybe$Nothing, toggle_checked_fct, value, original_value, checked);
							}),
						A3($elm$core$List$map2, $elm$core$Tuple$pair, values, original_values)),
					_List_fromArray(
						[
							A2(
							$rundis$elm_bootstrap$Bootstrap$Table$td,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									A2($elm$html$Html$Attributes$style, 'max-width', '23rem')),
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									A2($elm$html$Html$Attributes$style, 'min-width', '10rem'))
								]),
							_List_fromArray(
								[
									A5($author$project$CommonView$createOperatorNote, readonly, item, planning_param.an, 2, planning_param.cy)
								]))
						]))));
	});
var $author$project$Run$View$PlanningParamsOverview$overviewTable = F2(
	function (readonly, item) {
		var max_val_count = A2(
			$elm$core$Maybe$withDefault,
			1,
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					$elm$core$Array$length,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.f2;
						},
						item.hA))));
		var table_rows = A2(
			$elm$core$List$map,
			A3($author$project$Run$View$PlanningParamsOverview$overviewTableRow, readonly, item, max_val_count),
			item.hA);
		var params_and_withdrawals = A4($author$project$Run$View$PlanningParamsOverview$insertWithdrawalRows, table_rows, item.hA, max_val_count, _List_Nil);
		return $elm$core$List$isEmpty(params_and_withdrawals) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Planungsparameter (variabel in fett)')
						])),
					$rundis$elm_bootstrap$Bootstrap$Table$table(
					{
						hs: _List_fromArray(
							[$rundis$elm_bootstrap$Bootstrap$Table$small, $rundis$elm_bootstrap$Bootstrap$Table$bordered]),
						h4: A2($rundis$elm_bootstrap$Bootstrap$Table$tbody, _List_Nil, params_and_withdrawals),
						h5: A2(
							$rundis$elm_bootstrap$Bootstrap$Table$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rundis$elm_bootstrap$Bootstrap$Table$tr,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										A2(
											$rundis$elm_bootstrap$Bootstrap$Table$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Parameter')
												])),
										_Utils_ap(
											(max_val_count === 1) ? _List_fromArray(
												[
													A2(
													$rundis$elm_bootstrap$Bootstrap$Table$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Wert*')
														]))
												]) : A2(
												$elm$core$List$map,
												function (step) {
													return A2(
														$rundis$elm_bootstrap$Bootstrap$Table$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																'Schritt ' + $elm$core$String$fromInt(step))
															]));
												},
												A2($elm$core$List$range, 1, max_val_count)),
											_List_fromArray(
												[
													A2(
													$rundis$elm_bootstrap$Bootstrap$Table$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Anmerkung')
														]))
												]))))
								]))
					})
				]));
	});
var $author$project$Run$View$PlanningParamsOverview$resetToPlanningAction = function (item) {
	return $author$project$Types$GotCommonMsg(
		A2(
			$author$project$Types$OpenConfirm,
			'Die Planung sollte nur in Ausnahmefällen im Nachhinein korrigiert werden. Bitte im Anschluss die Durchführung direkt fortsetzen!',
			$author$project$Types$GotRunMsg(
				A2($author$project$Types$UpdateItemState, item, 0))));
};
var $author$project$Run$View$PlanningParamsOverview$planningParamsOverview = F2(
	function (model, item) {
		var selected_groups = A2(
			$elm$core$List$filter,
			function (g) {
				return A2($elm$core$List$member, g.an, item.gS);
			},
			model.eI);
		var is_execution_disabled = A2($author$project$Run$ItemHelper$isExecutionDisabled, model, item);
		var group_params = $author$project$Run$ItemHelper$getGroupParams(item);
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Grid$row,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Grid$Row$attrs(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('planning-param-overview')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Grid$col,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						((model.a9.e4 === 'RunTemplateEditor') || is_execution_disabled) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('alert alert-info')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('clearfix')
										]),
									_Utils_eq(item.hE, $elm$core$Maybe$Nothing) ? _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('float-right')
												]),
											_List_fromArray(
												[
													A2(
													$rundis$elm_bootstrap$Bootstrap$Button$button,
													_List_fromArray(
														[
															$rundis$elm_bootstrap$Bootstrap$Button$secondary,
															$rundis$elm_bootstrap$Bootstrap$Button$attrs(
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Run$View$PlanningParamsOverview$resetToPlanningAction(item)),
																	$elm$html$Html$Attributes$class('m-1')
																]))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Planung erneut bearbeiten')
														]))
												])),
											$elm$html$Html$text('Wenn Sie die Planung erneut bearbeiten, werden die ursprünglichen Werte für die Planungsparameter hier angezeigt.')
										]) : _List_Nil)
								])),
						_List_fromArray(
							[
								A4($author$project$Run$View$PlanningParamsOverview$groupsTable, model, selected_groups, group_params, item),
								A3($author$project$Run$View$PlanningParamsOverview$groupMatrixTables, selected_groups, group_params, item),
								A2($author$project$Run$View$PlanningParamsOverview$overviewTable, is_execution_disabled, item),
								$elm$html$Html$text('* Parameterwerte anklicken, um sie als \'erledigt\' zu markieren')
							])))
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$getActiveItem = F2(
	function (_v0, configRec) {
		var activeTab = _v0.bE;
		if (activeTab.$ === 1) {
			return $elm$core$List$head(configRec.dz);
		} else {
			var id = activeTab.a;
			return function (found) {
				if (!found.$) {
					var f = found.a;
					return $elm$core$Maybe$Just(f);
				} else {
					return $elm$core$List$head(configRec.dz);
				}
			}(
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v2) {
							var item_ = _v2;
							return _Utils_eq(item_.an, id);
						},
						configRec.dz)));
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$Hidden = 0;
var $rundis$elm_bootstrap$Bootstrap$Tab$Start = 1;
var $rundis$elm_bootstrap$Bootstrap$Tab$visibilityTransition = F2(
	function (withAnimation_, visibility) {
		var _v0 = _Utils_Tuple2(withAnimation_, visibility);
		_v0$2:
		while (true) {
			if (_v0.a) {
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.b;
						return 1;
					case 1:
						var _v2 = _v0.b;
						return 2;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return 2;
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$renderLink = F4(
	function (id, active, _v0, configRec) {
		var attributes = _v0.bN;
		var children = _v0.gi;
		var commonClasses = _List_fromArray(
			[
				_Utils_Tuple2('nav-link', true),
				_Utils_Tuple2('active', active)
			]);
		var clickHandler = $elm$html$Html$Events$onClick(
			configRec.d0(
				{
					bE: $elm$core$Maybe$Just(id),
					bw: A2($rundis$elm_bootstrap$Bootstrap$Tab$visibilityTransition, configRec.az && (!active), 0)
				}));
		var linkItem = configRec.c5 ? A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(commonClasses),
						clickHandler,
						$elm$html$Html$Attributes$href('#' + id)
					]),
				attributes),
			children) : A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_Utils_ap(
							commonClasses,
							_List_fromArray(
								[
									_Utils_Tuple2('btn', true),
									_Utils_Tuple2('btn-link', true)
								]))),
						clickHandler
					]),
				attributes),
			children);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-item')
				]),
			_List_fromArray(
				[linkItem]));
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$transitionStyles = function (opacity) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$style,
			'opacity',
			$elm$core$String$fromInt(opacity)),
			A2($elm$html$Html$Attributes$style, '-webkit-transition', 'opacity 0.15s linear'),
			A2($elm$html$Html$Attributes$style, '-o-transition', 'opacity 0.15s linear'),
			A2($elm$html$Html$Attributes$style, 'transition', 'opacity 0.15s linear')
		]);
};
var $rundis$elm_bootstrap$Bootstrap$Tab$activeTabAttributes = F2(
	function (_v0, configRec) {
		var visibility = _v0.bw;
		switch (visibility) {
			case 0:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'none')
					]);
			case 1:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						A2($elm$html$Html$Attributes$style, 'opacity', '0')
					]);
			default:
				return _Utils_ap(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'block')
						]),
					$rundis$elm_bootstrap$Bootstrap$Tab$transitionStyles(1));
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$renderTabPane = F5(
	function (id, active, _v0, state, configRec) {
		var attributes = _v0.bN;
		var children = _v0.gi;
		var displayAttrs = active ? A2($rundis$elm_bootstrap$Bootstrap$Tab$activeTabAttributes, state, configRec) : _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'none')
			]);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(id),
						$elm$html$Html$Attributes$class('tab-pane')
					]),
				_Utils_ap(displayAttrs, attributes)),
			children);
	});
var $rundis$elm_bootstrap$Bootstrap$Tab$tabAttributes = function (configRec) {
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('nav', true),
						_Utils_Tuple2('nav-tabs', !configRec.aQ),
						_Utils_Tuple2('nav-pills', configRec.aQ)
					]))
			]),
		_Utils_ap(
			function () {
				var _v0 = configRec.o;
				if (!_v0.$) {
					switch (_v0.a) {
						case 3:
							var _v1 = _v0.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class('nav-justified')
								]);
						case 2:
							var _v2 = _v0.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class('nav-fill')
								]);
						case 0:
							var _v3 = _v0.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class('justify-content-center')
								]);
						default:
							var _v4 = _v0.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class('justify-content-end')
								]);
					}
				} else {
					return _List_Nil;
				}
			}(),
			configRec.bN));
};
var $rundis$elm_bootstrap$Bootstrap$Tab$view = F2(
	function (state, _v0) {
		var configRec = _v0;
		var _v1 = A2($rundis$elm_bootstrap$Bootstrap$Tab$getActiveItem, state, configRec);
		if (_v1.$ === 1) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						$rundis$elm_bootstrap$Bootstrap$Tab$tabAttributes(configRec),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tab-content')
							]),
						_List_Nil)
					]));
		} else {
			var currentItem = _v1.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						$rundis$elm_bootstrap$Bootstrap$Tab$tabAttributes(configRec),
						A2(
							$elm$core$List$map,
							function (_v2) {
								var item_ = _v2;
								return A4(
									$rundis$elm_bootstrap$Bootstrap$Tab$renderLink,
									item_.an,
									_Utils_eq(item_.an, currentItem.an),
									item_.e$,
									configRec);
							},
							configRec.dz)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tab-content')
							]),
						A2(
							$elm$core$List$map,
							function (_v3) {
								var item_ = _v3;
								return A5(
									$rundis$elm_bootstrap$Bootstrap$Tab$renderTabPane,
									item_.an,
									_Utils_eq(item_.an, currentItem.an),
									item_.fe,
									state,
									configRec);
							},
							configRec.dz))
					]));
		}
	});
var $author$project$Run$View$ItemEditTabs$tabView = F3(
	function (model, item, errors) {
		var editable_add_on_item = ((model.a9.fz === 'new') || (model.a9.fz === 'accepted')) && (item.g5 && _Utils_eq(item.ib.an, model.a9.gq.an));
		var show_planning = ((!model.fq) || editable_add_on_item) && (_Utils_eq(item.hE, $elm$core$Maybe$Nothing) && ((!item.h1) && ((model.a9.fz === 'new') || ($author$project$Run$ItemHelper$wasExecutionStarted(item) || editable_add_on_item))));
		var action = errors ? function (_v0) {
			return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
		} : function (state) {
			return $author$project$Types$GotRunMsg(
				A2($author$project$Types$ChangeItemTab, item, state));
		};
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Tab$view,
			model.P,
			A2(
				$rundis$elm_bootstrap$Bootstrap$Tab$items,
				_Utils_ap(
					show_planning ? _List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Tab$item(
							{
								an: 'run-item-planning-edit',
								e$: A2(
									$rundis$elm_bootstrap$Bootstrap$Tab$link,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Planung bearbeiten')
										])),
								fe: A2(
									$rundis$elm_bootstrap$Bootstrap$Tab$pane,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Run$View$PlanningParamsEdit$planningParamsEdit, model, item)
										]))
							})
						]) : _List_Nil,
					_Utils_ap(
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Tab$item(
								{
									an: 'run-item-execution',
									e$: A2(
										$rundis$elm_bootstrap$Bootstrap$Tab$link,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Durchführung')
											])),
									fe: A2(
										$rundis$elm_bootstrap$Bootstrap$Tab$pane,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Run$View$ExecutionParamsEdit$executionParamsEdit, model, item)
											]))
								}),
								$rundis$elm_bootstrap$Bootstrap$Tab$item(
								{
									an: 'run-item-planning-overview',
									e$: A2(
										$rundis$elm_bootstrap$Bootstrap$Tab$link,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Planungsübersicht')
											])),
									fe: A2(
										$rundis$elm_bootstrap$Bootstrap$Tab$pane,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Run$View$PlanningParamsOverview$planningParamsOverview, model, item)
											]))
								})
							]),
						(model.a9.e4 === 'RunEditor') ? _List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Tab$item(
								{
									an: 'run-item-files',
									e$: A2(
										$rundis$elm_bootstrap$Bootstrap$Tab$link,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Zusätzliche Dateien')
											])),
									fe: A2(
										$rundis$elm_bootstrap$Bootstrap$Tab$pane,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Run$View$ItemFiles$itemFiles, model, item)
											]))
								})
							]) : _List_Nil)),
				$rundis$elm_bootstrap$Bootstrap$Tab$config(action)));
	});
var $author$project$Run$View$ItemEditTabs$itemEditTabs = F2(
	function (model, unvalidated_item) {
		var processing = model.dT;
		var item = $author$project$Run$ItemHelper$validateItem(unvalidated_item);
		var show_buttons = A2($author$project$Run$ItemHelper$mayPerformExecution, model, item) && (model.a9.gG && (model.a9.fz === 'accepted'));
		var errors = !$elm$core$List$isEmpty(item.d1);
		var header = A3($author$project$Run$View$ItemEditTabs$makeItemHeader, model, item, errors);
		var changed = !_Utils_eq(
			$elm$core$Maybe$Just(item),
			model.aR);
		var actions = function () {
			var _v0 = _Utils_Tuple3(changed, errors, processing);
			if (_v0.c) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'Speichern…',
						$author$project$Types$GotCommonMsg($author$project$Types$NoAction))
					]);
			} else {
				if (!_v0.a) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Schließen',
							$author$project$Types$GotRunMsg(
								$author$project$Types$CloseModalItem(item)))
						]);
				} else {
					if (_v0.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'Abbrechen',
								$author$project$Types$GotCommonMsg(
									A2(
										$author$project$Types$OpenConfirm,
										'Änderungen verwerfen?',
										$author$project$Types$GotRunMsg(
											$author$project$Types$DiscardItemChange(item))))),
								_Utils_Tuple2(
								'Schließen',
								$author$project$Types$GotCommonMsg($author$project$Types$NoAction))
							]);
					} else {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'Abbrechen',
								$author$project$Types$GotCommonMsg(
									A2(
										$author$project$Types$OpenConfirm,
										'Änderungen verwerfen?',
										$author$project$Types$GotRunMsg(
											$author$project$Types$DiscardItemChange(item))))),
								_Utils_Tuple2(
								'Schließen',
								$author$project$Types$GotRunMsg(
									$author$project$Types$CloseModalItem(item)))
							]);
					}
				}
			}
		}();
		return A4(
			$author$project$Modal$itemEditing,
			header,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3($author$project$Run$View$ItemEditTabs$tabView, model, item, errors)
					])),
			_Utils_ap(
				show_buttons ? A2($author$project$Run$View$ItemEditTabs$changeItemStateButtons, item, errors) : _List_Nil,
				A2($author$project$Run$ItemHelper$canCreateItemForUnprocessedSamples, model, item) ? _List_fromArray(
					[
						_Utils_Tuple3(
						$rundis$elm_bootstrap$Bootstrap$Button$secondary,
						'Schritt für unprozessierte Proben anlegen',
						$author$project$Types$GotRunMsg(
							$author$project$Types$CreateItemForUnprocessedSamples(item)))
					]) : _List_Nil),
			actions);
	});
var $author$project$Types$CreateNewItem = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Types$NewItemSelectProcessCategory = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $rundis$elm_bootstrap$Bootstrap$Table$Hover = {$: 3};
var $rundis$elm_bootstrap$Bootstrap$Table$hover = $rundis$elm_bootstrap$Bootstrap$Table$Hover;
var $rundis$elm_bootstrap$Bootstrap$Utilities$Border$none = $elm$html$Html$Attributes$class('border-0');
var $rundis$elm_bootstrap$Bootstrap$Table$Active = {$: 1};
var $rundis$elm_bootstrap$Bootstrap$Table$RoledRow = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Table$rowActive = $rundis$elm_bootstrap$Bootstrap$Table$RoledRow($rundis$elm_bootstrap$Bootstrap$Table$Active);
var $author$project$Run$View$ItemNew$createCategorySelection = F3(
	function (categories, selected_category, new_item_index) {
		return A5(
			$author$project$Run$View$FormsHelper$bsFormGroup,
			'Kategorie',
			$elm$core$Maybe$Nothing,
			false,
			false,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('process-selection categories')
					]),
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$table(
						{
							hs: _List_fromArray(
								[$rundis$elm_bootstrap$Bootstrap$Table$small, $rundis$elm_bootstrap$Bootstrap$Table$hover]),
							h4: A2(
								$rundis$elm_bootstrap$Bootstrap$Table$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (c) {
										return A2(
											$rundis$elm_bootstrap$Bootstrap$Table$tr,
											_Utils_ap(
												_List_fromArray(
													[
														$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
														$elm$html$Html$Attributes$class('clickable')),
														$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
														$elm$html$Html$Events$onClick(
															$author$project$Types$GotRunMsg(
																A2(
																	$author$project$Types$NewItemSelectProcessCategory,
																	new_item_index,
																	$elm$core$Maybe$Just(c)))))
													]),
												function () {
													if (selected_category.$ === 1) {
														return _List_Nil;
													} else {
														var sel_cat = selected_category.a;
														return _Utils_eq(c, sel_cat) ? _List_fromArray(
															[$rundis$elm_bootstrap$Bootstrap$Table$rowActive]) : _List_Nil;
													}
												}()),
											_List_fromArray(
												[
													A2(
													$rundis$elm_bootstrap$Bootstrap$Table$td,
													_List_fromArray(
														[
															$rundis$elm_bootstrap$Bootstrap$Table$cellAttr($rundis$elm_bootstrap$Bootstrap$Utilities$Border$none),
															$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
															$elm$html$Html$Attributes$class('small'))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(c.a)
														])),
													A2(
													$rundis$elm_bootstrap$Bootstrap$Table$td,
													_List_fromArray(
														[
															$rundis$elm_bootstrap$Bootstrap$Table$cellAttr($rundis$elm_bootstrap$Bootstrap$Utilities$Border$none),
															$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
															$elm$html$Html$Attributes$class('small'))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(c.b)
														]))
												]));
									},
									categories)),
							h5: $rundis$elm_bootstrap$Bootstrap$Table$simpleThead(_List_Nil)
						})
					])));
	});
var $author$project$Types$NewItemSelectProcess = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$m0 = $elm$html$Html$Attributes$class('m-0');
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$p0 = $elm$html$Html$Attributes$class('p-0');
var $rundis$elm_bootstrap$Bootstrap$Form$Select$select = F2(
	function (options, items) {
		return $rundis$elm_bootstrap$Bootstrap$Form$Select$view(
			A2($rundis$elm_bootstrap$Bootstrap$Form$Select$create, options, items));
	});
var $elm$html$Html$Attributes$size = function (n) {
	return A2(
		_VirtualDom_attribute,
		'size',
		$elm$core$String$fromInt(n));
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$Size = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Form$Select$small = $rundis$elm_bootstrap$Bootstrap$Form$Select$Size(1);
var $author$project$Run$View$ItemNew$createProcessSelection = F3(
	function (processes, selected_process, new_item_index) {
		return A5(
			$author$project$Run$View$FormsHelper$bsFormGroup,
			'Prozess',
			$elm$core$Maybe$Nothing,
			false,
			false,
			A2(
				$rundis$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Form$Select$onChange(
						function (v) {
							return $author$project$Types$GotRunMsg(
								A2($author$project$Types$NewItemSelectProcess, new_item_index, v));
						}),
						$rundis$elm_bootstrap$Bootstrap$Form$Select$small,
						$rundis$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('process-selection processes'),
								$elm$html$Html$Attributes$size(10),
								$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$p0
							]))
					]),
				A2(
					$elm$core$List$map,
					function (p) {
						return A2(
							$rundis$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromInt(p.an)),
									$elm$html$Html$Attributes$selected(
									function () {
										if (selected_process.$ === 1) {
											return false;
										} else {
											var process = selected_process.a;
											return _Utils_eq(p.an, process.an);
										}
									}()),
									$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$p0,
									$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$m0
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Helper$getProcessName(p))
								]));
					},
					processes)));
	});
var $elm$html$Html$form = _VirtualDom_node('form');
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$Col5 = 5;
var $rundis$elm_bootstrap$Bootstrap$Grid$Col$xs5 = A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$width, 0, 5);
var $author$project$Run$View$ItemNew$itemNew = F4(
	function (processes, selected_category, selected_process, new_item_index) {
		var possible_processes = A2(
			$elm$core$List$filter,
			function (p) {
				return !p.dn;
			},
			processes);
		var confirm_action = function () {
			if (selected_process.$ === 1) {
				return $author$project$Types$GotCommonMsg($author$project$Types$NoAction);
			} else {
				var p = selected_process.a;
				return $author$project$Types$GotRunMsg(
					A2($author$project$Types$CreateNewItem, p.an, new_item_index));
			}
		}();
		var categories = $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$filter,
				function (c) {
					return !_Utils_eq(
						c,
						_Utils_Tuple2('', ''));
				},
				A2($elm$core$List$map, $author$project$Helper$getProcessCategory, possible_processes)));
		return A2(
			$author$project$Modal$makeModalLarge,
			A2(
				$author$project$Types$Modal,
				'Prozess-Schritt erstellen',
				A2(
					$elm$html$Html$form,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rundis$elm_bootstrap$Bootstrap$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rundis$elm_bootstrap$Bootstrap$Grid$col,
									_List_fromArray(
										[$rundis$elm_bootstrap$Bootstrap$Grid$Col$xs5]),
									_List_fromArray(
										[
											A3($author$project$Run$View$ItemNew$createCategorySelection, categories, selected_category, new_item_index)
										])),
									A2(
									$rundis$elm_bootstrap$Bootstrap$Grid$col,
									_List_fromArray(
										[$rundis$elm_bootstrap$Bootstrap$Grid$Col$xs5]),
									_List_fromArray(
										[
											function () {
											if (selected_category.$ === 1) {
												return $elm$html$Html$text('');
											} else {
												var c = selected_category.a;
												var processes_in_category = A2(
													$elm$core$List$filter,
													function (p) {
														return _Utils_eq(
															$author$project$Helper$getProcessCategory(p),
															c);
													},
													possible_processes);
												return A3($author$project$Run$View$ItemNew$createProcessSelection, processes_in_category, selected_process, new_item_index);
											}
										}()
										]))
								]))
						]))),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Verwerfen',
					$author$project$Types$GotCommonMsg($author$project$Types$HideModal)),
					_Utils_Tuple2('Prozess-Schritt erstellen', confirm_action)
				]));
	});
var $author$project$RunEditor$makeModal = function (model) {
	var _v0 = model.bk;
	switch (_v0.$) {
		case 3:
			return $author$project$Helper$htmlEmpty;
		case 1:
			var category = _v0.a;
			var process = _v0.b;
			var index = _v0.c;
			return A4($author$project$Run$View$ItemNew$itemNew, model.dP, category, process, index);
		case 0:
			var item = _v0.a;
			return A2($author$project$Run$View$ItemEditTabs$itemEditTabs, model, item);
		default:
			var group = _v0.a;
			return $author$project$Run$View$GroupEdit$groupEdit(group);
	}
};
var $author$project$Types$CopyItem = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Run$View$TableView$askRenewItem = function (item) {
	return A2(
		$author$project$Modal$makeModalLarge,
		A2(
			$author$project$Types$Modal,
			'Prozessschritt kopieren',
			A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Soll das Rezept aktualisiert werden?')
					]))),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'Ja',
				$author$project$Types$GotRunMsg(
					A2($author$project$Types$CopyItem, item, true))),
				_Utils_Tuple2(
				'Nein',
				$author$project$Types$GotRunMsg(
					A2($author$project$Types$CopyItem, item, false)))
			]));
};
var $author$project$Modal$makeAlert = function (alert_text) {
	return A2(
		$author$project$Modal$makeModalLarge,
		A2(
			$author$project$Types$Modal,
			'Funktion kann nicht ausgeführt werden!',
			A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-danger')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(alert_text)
					]))),
		_List_Nil);
};
var $author$project$Modal$makeConfirm = F2(
	function (confirm_text, action) {
		return A7(
			$author$project$Modal$makeModal,
			A2(
				$author$project$Types$Modal,
				'Bitte bestätigen!',
				A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(confirm_text)
						]))),
			$elm$core$Maybe$Nothing,
			$rundis$elm_bootstrap$Bootstrap$Modal$attrs(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal')
					])),
			true,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Abbrechen',
					$author$project$Types$GotCommonMsg($author$project$Types$PopupCancel)),
					_Utils_Tuple2(
					'Ok',
					$author$project$Types$GotCommonMsg(
						$author$project$Types$PopupOk(action)))
				]),
			$elm$core$Maybe$Just(
				$author$project$Types$GotCommonMsg($author$project$Types$PopupCancel)));
	});
var $author$project$Modal$makeModalMedium = F3(
	function (modal, actions, hide_msg) {
		return A7(
			$author$project$Modal$makeModal,
			modal,
			$elm$core$Maybe$Nothing,
			$rundis$elm_bootstrap$Bootstrap$Modal$attrs(_List_Nil),
			true,
			_List_Nil,
			actions,
			$elm$core$Maybe$Just(hide_msg));
	});
var $rundis$elm_bootstrap$Bootstrap$Modal$small = function (_v0) {
	var conf = _v0;
	var options = conf.hs;
	return _Utils_update(
		conf,
		{
			hs: _Utils_update(
				options,
				{
					bl: $elm$core$Maybe$Just(1)
				})
		});
};
var $author$project$Modal$makeModalSmall = F2(
	function (modal, hide_msg) {
		return A7(
			$author$project$Modal$makeModal,
			modal,
			$elm$core$Maybe$Nothing,
			$rundis$elm_bootstrap$Bootstrap$Modal$small,
			true,
			_List_Nil,
			_List_Nil,
			$elm$core$Maybe$Just(hide_msg));
	});
var $author$project$RunEditor$makePopup = function (model) {
	var _v0 = model.cI;
	switch (_v0.$) {
		case 5:
			return $author$project$Helper$htmlEmpty;
		case 0:
			var item = _v0.a;
			return $author$project$Run$View$TableView$askRenewItem(item);
		case 1:
			var text = _v0.a;
			var action = _v0.b;
			return A2($author$project$Modal$makeConfirm, text, action);
		case 2:
			var text = _v0.a;
			var action = _v0.b;
			return A2($author$project$Modal$makeModalSmall, text, action);
		case 3:
			var text = _v0.a;
			var buttons = _v0.b;
			var action = _v0.c;
			return A3($author$project$Modal$makeModalMedium, text, buttons, action);
		default:
			var text = _v0.a;
			return $author$project$Modal$makeAlert(text);
	}
};
var $author$project$RunEditor$processingOverlay = function (busy) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('processing-overlay'),
				A2(
				$elm$html$Html$Attributes$style,
				'display',
				busy ? 'block' : 'none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('overlay-content')
					]),
				_List_fromArray(
					[
						A3(
						$perzanko$elm_loading$Loading$render,
						1,
						_Utils_update(
							$perzanko$elm_loading$Loading$defaultConfig,
							{en: '#77f', fI: 50}),
						busy ? 0 : 1)
					]))
			]));
};
var $author$project$RunEditor$container = F4(
	function (model, show_errors, class_name, content) {
		var recipe_change_warning = A2(
			$elm$core$List$any,
			function (i) {
				return i.hL !== '';
			},
			model.dz);
		var invalid_warning = A2(
			$elm$core$List$any,
			function (i) {
				return i.g4 !== '';
			},
			model.dz);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('run-editor-container'),
					$elm$html$Html$Attributes$class(class_name)
				]),
			_List_fromArray(
				[
					$author$project$RunEditor$busyOverlay(model.di),
					$author$project$RunEditor$processingOverlay(model.dT),
					(show_errors && invalid_warning) ? A2(
					$author$project$RunEditor$errorDiv,
					_List_fromArray(
						['Es existieren Prozess-Schritte mit ungültigen Zuordnungen!']),
					$elm$core$Maybe$Nothing) : $elm$html$Html$text(''),
					(show_errors && recipe_change_warning) ? A2(
					$author$project$RunEditor$errorDiv,
					_List_fromArray(
						['Ein oder mehrere Rezepte wurden geändert. Erstellen Sie einen neuen Prozess-Schritt, um das Rezept zu aktualisieren!']),
					$elm$core$Maybe$Nothing) : $elm$html$Html$text(''),
					function () {
					var _v0 = model.dq;
					if (_v0.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						if (_v0.a.b) {
							var _v1 = _v0.a;
							var err_msg = _v1.a;
							return A2(
								$author$project$RunEditor$errorDiv,
								err_msg,
								$elm$core$Maybe$Just(
									$author$project$Types$GotRunMsg($author$project$Types$SendData)));
						} else {
							var _v2 = _v0.a;
							var err_msg = _v2.a;
							return A2($author$project$RunEditor$errorDiv, err_msg, $elm$core$Maybe$Nothing);
						}
					}
				}(),
					A2($elm$html$Html$div, _List_Nil, content),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$RunEditor$makeModal(model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('second-modal')
						]),
					_List_fromArray(
						[
							$author$project$RunEditor$makePopup(model)
						])),
					model.a9.eq ? $author$project$RunEditor$debugView(model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Types$QShowPopover = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Types$RemoveItemFromClipboard = function (a) {
	return {$: 3, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Popover$Bottom = 2;
var $rundis$elm_bootstrap$Bootstrap$Popover$Config = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Popover$bottom = function (_v0) {
	var conf = _v0;
	return _Utils_update(
		conf,
		{W: 2});
};
var $rundis$elm_bootstrap$Bootstrap$Popover$Top = 0;
var $rundis$elm_bootstrap$Bootstrap$Popover$config = function (triggerElement) {
	return {gn: $elm$core$Maybe$Nothing, W: 0, h7: $elm$core$Maybe$Nothing, f_: triggerElement};
};
var $rundis$elm_bootstrap$Bootstrap$Popover$Content = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Popover$content = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				gn: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('popover-body'),
							attributes),
						children))
			});
	});
var $elm$html$Html$em = _VirtualDom_node('em');
var $author$project$CommonView$getHtmlForRecord = function (record) {
	if (record.$ === 1) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('-')
				]));
	} else {
		var element = record.a;
		return $author$project$CommonView$displayElementName(element);
	}
};
var $author$project$Helper$splitIsoDate = function (isoDate) {
	var _v0 = A2($elm$core$String$split, 'T', isoDate);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var date_part = _v0.a;
		var _v1 = _v0.b;
		var time_part = _v1.a;
		var time = function () {
			var _v5 = A2($elm$core$String$split, ':', time_part);
			if (_v5.b && _v5.b.b) {
				var hours = _v5.a;
				var _v6 = _v5.b;
				var minutes = _v6.a;
				return $elm$core$Maybe$Just(hours + (':' + minutes));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var date = function () {
			var _v2 = A2($elm$core$String$split, '-', date_part);
			if (((_v2.b && _v2.b.b) && _v2.b.b.b) && (!_v2.b.b.b.b)) {
				var year = _v2.a;
				var _v3 = _v2.b;
				var month = _v3.a;
				var _v4 = _v3.b;
				var day = _v4.a;
				return $elm$core$Maybe$Just(
					day + ('.' + (month + ('.' + A2($elm$core$String$right, 2, year)))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return _Utils_Tuple2(date, time);
	} else {
		return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	}
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$CommonView$getReservationTime = F3(
	function (reservation, least_reservation_time, reservation_queue_name) {
		var _v0 = _Utils_Tuple2(reservation, least_reservation_time);
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm$html$Html$text('');
			} else {
				var least = _v0.b.a;
				var _v7 = $author$project$Helper$splitIsoDate(least);
				var least_date = _v7.a;
				var least_time = _v7.b;
				var result = function () {
					var _v9 = _Utils_Tuple2(least_date, least_time);
					if ((!_v9.a.$) && (!_v9.b.$)) {
						var ld = _v9.a.a;
						var lt = _v9.b.a;
						return ld + (' ' + lt);
					} else {
						return 'Parse error';
					}
				}();
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_Utils_ap(
						function () {
							if (reservation_queue_name.$ === 1) {
								return _List_Nil;
							} else {
								var q_name = reservation_queue_name.a;
								return _List_fromArray(
									[
										$elm$html$Html$text('Warteschlange: '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(q_name)
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil)
									]);
							}
						}(),
						_List_fromArray(
							[
								$elm$html$Html$text('Frühestens ab: '),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(result)
							])));
			}
		} else {
			var res = _v0.a.a;
			var _v3 = $author$project$Helper$splitIsoDate(res.h0);
			var start_date = _v3.a;
			var start_time = _v3.b;
			var _v4 = $author$project$Helper$splitIsoDate(res.gB);
			var end_date = _v4.a;
			var end_time = _v4.b;
			var _v5 = function () {
				var _v6 = _Utils_Tuple3(start_date, start_time, end_time);
				if (((!_v6.a.$) && (!_v6.b.$)) && (!_v6.c.$)) {
					var sd = _v6.a.a;
					var st = _v6.b.a;
					var et = _v6.c.a;
					return _Utils_Tuple2(
						$elm$html$Html$text(sd),
						$elm$html$Html$text(st + ('-' + et)));
				} else {
					return _Utils_Tuple2(
						$elm$html$Html$text('Parse error'),
						$elm$html$Html$text('Parse error'));
				}
			}();
			var result_date = _v5.a;
			var result_time = _v5.b;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						result_date,
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						result_time
					]));
		}
	});
var $author$project$Helper$stateToColorClass = function (state) {
	switch (state) {
		case 'new':
			return 'warning';
		case 'accepted':
			return 'info';
		case 'rejected':
			return 'danger';
		case 'done':
			return 'success';
		default:
			return 'default';
	}
};
var $author$project$Helper$itemColorClass = function (item) {
	var _v0 = item.hN;
	if (_v0.$ === 1) {
		return 'table-default';
	} else {
		var res = _v0.a;
		return 'table-' + $author$project$Helper$stateToColorClass(res.h1);
	}
};
var $author$project$CommonView$itemEventAttribute = function (item) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'duration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'minutes',
								$elm$json$Json$Encode$int(item.gF))
							]))),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(item.h7)),
					_Utils_Tuple2(
					'extendedProps',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'machine_id',
								$elm$json$Json$Encode$int(
									A2($elm$core$Maybe$withDefault, 0, item.hh))),
								_Utils_Tuple2(
								'run_id',
								$elm$json$Json$Encode$int(item.bp)),
								_Utils_Tuple2(
								'run_item_id',
								$elm$json$Json$Encode$int(item.an))
							])))
				])));
};
var $author$project$Helper$itemReservationStateBadge = function (reservation) {
	if (reservation.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var res = reservation.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'badge badge-' + $author$project$Helper$stateToColorClass(res.h1))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					function () {
						var _v1 = res.h1;
						switch (_v1) {
							case 'new':
								return 'neu';
							case 'accepted':
								return 'angenommen';
							case 'rejected':
								return 'abgelehnt';
							case 'done':
								return 'erledigt';
							default:
								return '';
						}
					}())
				]));
	}
};
var $rundis$elm_bootstrap$Bootstrap$Popover$State = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Popover$forceClose = F2(
	function (_v0, toMsg) {
		var state = _v0;
		return $elm$json$Json$Decode$succeed(
			toMsg(
				_Utils_update(
					state,
					{aP: false})));
	});
var $rundis$elm_bootstrap$Bootstrap$Popover$DOMState = F3(
	function (rect, offsetWidth, offsetHeight) {
		return {dI: offsetHeight, cr: offsetWidth, dR: rect};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $rundis$elm_bootstrap$Bootstrap$Popover$isPopover = A2(
	$elm$json$Json$Decode$andThen,
	function (_class) {
		return A2($elm$core$String$contains, 'popover', _class) ? $elm$json$Json$Decode$succeed(true) : $elm$json$Json$Decode$succeed(false);
	},
	$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className);
var $rundis$elm_bootstrap$Bootstrap$Popover$popper = F2(
	function (path, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$andThen,
					function (res) {
						return res ? A2(
							$elm$json$Json$Decode$at,
							_Utils_ap(
								path,
								_List_fromArray(
									['nextSibling'])),
							decoder) : $elm$json$Json$Decode$fail('');
					},
					A2(
						$elm$json$Json$Decode$at,
						_Utils_ap(
							path,
							_List_fromArray(
								['nextSibling'])),
						$rundis$elm_bootstrap$Bootstrap$Popover$isPopover)),
					A2(
					$elm$json$Json$Decode$andThen,
					function (_v0) {
						return A2(
							$rundis$elm_bootstrap$Bootstrap$Popover$popper,
							_Utils_ap(
								path,
								_List_fromArray(
									['parentElement'])),
							decoder);
					},
					A2(
						$elm$json$Json$Decode$at,
						_Utils_ap(
							path,
							_List_fromArray(
								['parentElement'])),
						$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className)),
					$elm$json$Json$Decode$fail('No popover found')
				]));
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetParent = F2(
	function (x, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$null(x)),
					A2($elm$json$Json$Decode$field, 'offsetParent', decoder)
				]));
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$scrollTop = A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float);
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$position = F2(
	function (x, y) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var x_ = _v0.a;
				var y_ = _v0.b;
				return A2(
					$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetParent,
					_Utils_Tuple2(x_, y_),
					A2($rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$position, x_, y_));
			},
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (scrollLeft_, scrollTop_, offsetLeft_, offsetTop_) {
						return _Utils_Tuple2((x + offsetLeft_) - scrollLeft_, (y + offsetTop_) - scrollTop_);
					}),
				$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$scrollLeft,
				$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$scrollTop,
				$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetLeft,
				$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetTop));
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$boundingArea = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (_v0, width, height) {
			var x = _v0.a;
			var y = _v0.b;
			return {gW: height, ao: x, aw: y, ik: width};
		}),
	A2($rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$position, 0, 0),
	$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetWidth,
	$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetHeight);
var $rundis$elm_bootstrap$Bootstrap$Popover$isTrigger = A2(
	$elm$json$Json$Decode$andThen,
	function (_class) {
		return A2($elm$core$String$contains, 'popover-trigger', _class) ? $elm$json$Json$Decode$succeed(true) : $elm$json$Json$Decode$succeed(false);
	},
	$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className);
var $rundis$elm_bootstrap$Bootstrap$Popover$trigger = function (path) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (res) {
					return res ? A2($elm$json$Json$Decode$at, path, $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$boundingArea) : $elm$json$Json$Decode$fail('');
				},
				A2($elm$json$Json$Decode$at, path, $rundis$elm_bootstrap$Bootstrap$Popover$isTrigger)),
				A2(
				$elm$json$Json$Decode$andThen,
				function (_v0) {
					return $rundis$elm_bootstrap$Bootstrap$Popover$trigger(
						_Utils_ap(
							path,
							_List_fromArray(
								['parentElement'])));
				},
				A2(
					$elm$json$Json$Decode$at,
					_Utils_ap(
						path,
						_List_fromArray(
							['parentElement'])),
					$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className)),
				$elm$json$Json$Decode$fail('No trigger found')
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Popover$stateDecoder = A4(
	$elm$json$Json$Decode$map3,
	$rundis$elm_bootstrap$Bootstrap$Popover$DOMState,
	$rundis$elm_bootstrap$Bootstrap$Popover$trigger(
		_List_fromArray(
			['target'])),
	A2(
		$rundis$elm_bootstrap$Bootstrap$Popover$popper,
		_List_fromArray(
			['target']),
		$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetWidth),
	A2(
		$rundis$elm_bootstrap$Bootstrap$Popover$popper,
		_List_fromArray(
			['target']),
		$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetHeight));
var $rundis$elm_bootstrap$Bootstrap$Popover$toggleState = F2(
	function (_v0, toMsg) {
		var state = _v0;
		var isActive = state.aP;
		return A2(
			$elm$json$Json$Decode$andThen,
			function (v) {
				return $elm$json$Json$Decode$succeed(
					toMsg(
						(!isActive) ? {$7: v, aP: true} : _Utils_update(
							state,
							{aP: false})));
			},
			$rundis$elm_bootstrap$Bootstrap$Popover$stateDecoder);
	});
var $rundis$elm_bootstrap$Bootstrap$Popover$onHover = F2(
	function (state, toMsg) {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$class('popover-trigger'),
				A2(
				$elm$html$Html$Events$on,
				'mouseenter',
				A2($rundis$elm_bootstrap$Bootstrap$Popover$toggleState, state, toMsg)),
				A2(
				$elm$html$Html$Events$on,
				'mouseleave',
				A2($rundis$elm_bootstrap$Bootstrap$Popover$forceClose, state, toMsg))
			]);
	});
var $elm$html$Html$Events$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $rundis$elm_bootstrap$Bootstrap$Popover$initialState = {
	$7: {
		dI: 0,
		cr: 0,
		dR: {gW: 0, ao: 0, aw: 0, ik: 0}
	},
	aP: false
};
var $author$project$Common$popoverState = F2(
	function (states, key) {
		return A2(
			$elm$core$Maybe$withDefault,
			$rundis$elm_bootstrap$Bootstrap$Popover$initialState,
			A2($elm$core$Dict$get, key, states));
	});
var $author$project$CommonView$showReservationChildren = function (reservation) {
	if (reservation.$ === 1) {
		return _List_fromArray(
			[
				$elm$html$Html$text('')
			]);
	} else {
		var res = reservation.a;
		var _v1 = res.gi;
		var children = _v1;
		return A2(
			$elm$core$List$map,
			function (r) {
				return A3(
					$author$project$CommonView$getReservationTime,
					$elm$core$Maybe$Just(r),
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Nothing);
			},
			children);
	}
};
var $rundis$elm_bootstrap$Bootstrap$Popover$top = function (_v0) {
	var conf = _v0;
	return _Utils_update(
		conf,
		{W: 0});
};
var $rundis$elm_bootstrap$Bootstrap$Popover$calculatePos = F2(
	function (pos, _v0) {
		var rect = _v0.dR;
		var offsetWidth = _v0.cr;
		var offsetHeight = _v0.dI;
		switch (pos) {
			case 3:
				return {
					aB: $elm$core$Maybe$Nothing,
					aC: $elm$core$Maybe$Just((offsetHeight / 2) - 12),
					ao: (-offsetWidth) - 10,
					aw: (rect.gW / 2) - (offsetHeight / 2)
				};
			case 1:
				return {
					aB: $elm$core$Maybe$Nothing,
					aC: $elm$core$Maybe$Just((offsetHeight / 2) - 12),
					ao: rect.ik,
					aw: (rect.gW / 2) - (offsetHeight / 2)
				};
			case 0:
				return {
					aB: $elm$core$Maybe$Just((offsetWidth / 2) - 12),
					aC: $elm$core$Maybe$Nothing,
					ao: (rect.ik / 2) - (offsetWidth / 2),
					aw: (-offsetHeight) - 10
				};
			default:
				return {
					aB: $elm$core$Maybe$Just((offsetWidth / 2) - 12),
					aC: $elm$core$Maybe$Nothing,
					ao: (rect.ik / 2) - (offsetWidth / 2),
					aw: rect.gW
				};
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Popover$directionAttr = function (position) {
	return A2(
		$elm$html$Html$Attributes$attribute,
		'x-placement',
		function () {
			switch (position) {
				case 3:
					return 'left';
				case 1:
					return 'right';
				case 0:
					return 'top';
				default:
					return 'bottom';
			}
		}());
};
var $rundis$elm_bootstrap$Bootstrap$Popover$positionClass = function (position) {
	switch (position) {
		case 3:
			return _Utils_Tuple2('bs-popover-left', true);
		case 1:
			return _Utils_Tuple2('bs-popover-right', true);
		case 0:
			return _Utils_Tuple2('bs-popover-top', true);
		default:
			return _Utils_Tuple2('bs-popover-bottom', true);
	}
};
var $rundis$elm_bootstrap$Bootstrap$Popover$popoverView = F2(
	function (_v0, _v1) {
		var isActive = _v0.aP;
		var domState = _v0.$7;
		var conf = _v1;
		var px = function (f) {
			return $elm$core$String$fromFloat(f) + 'px';
		};
		var pos = A2($rundis$elm_bootstrap$Bootstrap$Popover$calculatePos, conf.W, domState);
		var styles = isActive ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				px(pos.ao)),
				A2(
				$elm$html$Html$Attributes$style,
				'top',
				px(pos.aw)),
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				px(domState.cr))
			]) : _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'left', '-5000px'),
				A2($elm$html$Html$Attributes$style, 'top', '-5000px')
			]);
		var arrowStyles = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (t) {
						return A2(
							$elm$html$Html$Attributes$style,
							'top',
							px(t));
					},
					pos.aC),
					A2(
					$elm$core$Maybe$map,
					function (l) {
						return A2(
							$elm$html$Html$Attributes$style,
							'left',
							px(l));
					},
					pos.aB)
				]));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('popover', true),
								_Utils_Tuple2('fade', true),
								_Utils_Tuple2('show', isActive),
								$rundis$elm_bootstrap$Bootstrap$Popover$positionClass(conf.W)
							])),
						$rundis$elm_bootstrap$Bootstrap$Popover$directionAttr(conf.W)
					]),
				styles),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('arrow'),
								arrowStyles),
							_List_Nil)),
						A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var t = _v2;
							return t;
						},
						conf.h7),
						A2(
						$elm$core$Maybe$map,
						function (_v3) {
							var c = _v3;
							return c;
						},
						conf.gn)
					])));
	});
var $rundis$elm_bootstrap$Bootstrap$Popover$view = F2(
	function (state, conf) {
		var triggerElement = conf.f_;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'relative'),
					A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
				]),
			_List_fromArray(
				[
					triggerElement,
					A2($rundis$elm_bootstrap$Bootstrap$Popover$popoverView, state, conf)
				]));
	});
var $author$project$CommonView$itemSidebarView = F6(
	function (model, remove_fct, click_fct, popover_msg, index, item) {
		var user_may_create_reservation = model.a9.ge || (item.g5 && _Utils_eq(item.ib.an, model.a9.gq.an));
		var selected_groups = A2(
			$elm$core$List$filter,
			function (g) {
				return A2($elm$core$List$member, g.an, item.gS);
			},
			A2(
				$elm$core$List$filter,
				function (g) {
					return _Utils_eq(g.bp, item.bp);
				},
				model.eI));
		var run = A2(
			$author$project$Helper$getRecordById,
			model.fA,
			$elm$core$Maybe$Just(item.bp));
		var recipe = A2($author$project$Helper$getRecordById, model.dQ, item.hM);
		var process = A2(
			$author$project$Helper$getRecordById,
			model.dP,
			$elm$core$Maybe$Just(item.hD));
		var machine = A2($author$project$Helper$getRecordById, model.dD, item.hh);
		var missing_data = _Utils_eq(machine, $elm$core$Maybe$Nothing) || _Utils_eq(process, $elm$core$Maybe$Nothing);
		var item_id = 'run-sequence-item-' + ($elm$core$String$fromInt(item.an) + ('-' + $elm$core$String$fromInt(item.bp)));
		var popover_fct = popover_msg(item_id);
		var popover_state = A2($author$project$Common$popoverState, model.fi, item_id);
		var item_description = _Utils_ap(
			$elm$core$String$isEmpty(item.gl) ? _List_Nil : _List_fromArray(
				[
					$elm$html$Html$text('Anmerkung: ' + item.gl),
					A2($elm$html$Html$br, _List_Nil, _List_Nil)
				]),
			function () {
				if ($elm$core$List$isEmpty(selected_groups)) {
					return _List_Nil;
				} else {
					var joined = A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$map,
							function ($) {
								return $.hX;
							},
							selected_groups));
					return _List_fromArray(
						[
							$elm$html$Html$text('Gruppen: ' + joined),
							A2($elm$html$Html$br, _List_Nil, _List_Nil)
						]);
				}
			}());
		var is_queue_item_and_forbidden = function () {
			if (process.$ === 1) {
				return false;
			} else {
				var p = process.a;
				return p.gV && (model.a9.e4 !== 'QueueEditor');
			}
		}();
		var is_first_or_second_item = index < 2;
		var has_reservation = !_Utils_eq(item.hN, $elm$core$Maybe$Nothing);
		var popover_text = _Utils_eq(click_fct, $elm$core$Maybe$Nothing) ? 'Ziehen, um die Reihenfolge der Elemente zu verändern' : (has_reservation ? 'Reservierung im Kalender anzeigen' : ((!user_may_create_reservation) ? 'Sie haben keine ausreichende Berechtigung, um Reservierungen anzulegen' : (is_queue_item_and_forbidden ? 'Dieser Prozess-Schritt kann nur über eine Warteschlange gebucht werden' : (missing_data ? 'Bitte erst Gerät und Prozess wählen!' : 'Auf den Kalender ziehen um eine Reservierung zu erstellen'))));
		var forbidden = is_queue_item_and_forbidden || (missing_data || (!user_may_create_reservation));
		var attributes = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'run-sequence-item small ' + $author$project$Helper$itemColorClass(item))
				]),
			_Utils_ap(
				A2($rundis$elm_bootstrap$Bootstrap$Popover$onHover, popover_state, popover_fct),
				function () {
					if (click_fct.$ === 1) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$class('cursor-move')
							]);
					} else {
						var c = click_fct.a;
						return _Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Events$onMouseDown(
									c(item)),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('fc-extEvent', (!has_reservation) && (!forbidden)),
											_Utils_Tuple2('cursor-move', (!has_reservation) && (!forbidden)),
											_Utils_Tuple2('cursor-not-allowed', (!has_reservation) && forbidden),
											_Utils_Tuple2('cursor-pointer', has_reservation)
										]))
								]),
							(has_reservation || forbidden) ? _List_Nil : _List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$attribute,
									'data-event',
									$author$project$CommonView$itemEventAttribute(item))
								]));
					}
				}()));
		var popover_content = A2(
			$elm$html$Html$div,
			attributes,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('reservation-details')
							]),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'float', 'right')
										]),
									_List_fromArray(
										[
											$author$project$Helper$itemReservationStateBadge(item.hN)
										]))
								]),
							A2(
								$elm$core$List$intersperse,
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								_Utils_ap(
									_List_fromArray(
										[
											A3($author$project$CommonView$getReservationTime, item.hN, item.hc, item.hO)
										]),
									$author$project$CommonView$showReservationChildren(item.hN)))))
					]),
				_Utils_ap(
					function () {
						if (run.$ === 1) {
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
						} else {
							var r = run.a;
							var _v1 = model.a9.e4;
							if (_v1 === 'RunEditor') {
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(index + 1) + ' ')
											]))
									]);
							} else {
								return _List_fromArray(
									[
										$elm$html$Html$text(r.dG),
										A2($elm$html$Html$br, _List_Nil, _List_Nil)
									]);
							}
						}
					}(),
					_Utils_ap(
						function () {
							if (remove_fct.$ === 1) {
								return _List_Nil;
							} else {
								var rfct = remove_fct.a;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button-run-editor')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$CommonView$iconButton,
												'minus',
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														rfct(item.hI))
													]))
											]))
									]);
							}
						}(),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$CommonView$getHtmlForRecord(machine)
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$author$project$CommonView$getHtmlForRecord(process)
								]),
							_Utils_ap(
								(!_Utils_eq(item.hE, $elm$core$Maybe$Nothing)) ? _List_fromArray(
									[
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text('(Fortsetzung nach Abbruch)')
									]) : _List_Nil,
								_List_fromArray(
									[
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$elm$html$Html$em,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$CommonView$getHtmlForRecord(recipe)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('clearfix')
											]),
										_List_Nil)
									])))))));
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Popover$view,
			popover_state,
			A3(
				$rundis$elm_bootstrap$Bootstrap$Popover$content,
				_List_Nil,
				_Utils_ap(
					item_description,
					_Utils_ap(
						$elm$core$List$isEmpty(item_description) ? _List_Nil : _List_fromArray(
							[
								A2($elm$html$Html$br, _List_Nil, _List_Nil)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(popover_text)
							]))),
				(is_first_or_second_item ? $rundis$elm_bootstrap$Bootstrap$Popover$bottom : $rundis$elm_bootstrap$Bootstrap$Popover$top)(
					$rundis$elm_bootstrap$Bootstrap$Popover$config(popover_content))));
	});
var $author$project$Queue$View$DndView$dndGhostView = function (model) {
	var maybeDragQueueItemId = A2(
		$elm$core$Maybe$andThen,
		function (_v1) {
			var dragIndex = _v1.ew;
			return $elm$core$List$head(
				A2($elm$core$List$drop, dragIndex, model.gj));
		},
		$author$project$Common$dndSystem.eP(model.ev));
	var maybeDragItem = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (i) {
				return _Utils_eq(i.hI, maybeDragQueueItemId);
			},
			model.dz));
	if (!maybeDragItem.$) {
		var item = maybeDragItem.a;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dnd-ghost-view')
					]),
				$author$project$Common$dndSystem.gQ(model.ev)),
			_List_fromArray(
				[
					A6(
					$author$project$CommonView$itemSidebarView,
					model,
					$elm$core$Maybe$Just($author$project$Types$RemoveItemFromClipboard),
					$elm$core$Maybe$Nothing,
					$author$project$Types$QShowPopover,
					-1,
					item)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Types$QChangeTab = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$QDataChanged = {$: 11};
var $author$project$Types$QMachineSelected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Types$ClipboardItemClick = function (a) {
	return {$: 5, a: a};
};
var $author$project$CommonView$card = F3(
	function (class_name, header, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card'),
					$elm$html$Html$Attributes$class(class_name)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-header')
						]),
					header),
					content
				]));
	});
var $author$project$Helper$getClipboardItems = F2(
	function (clipboard_queue_item_ids, items) {
		return $elm_community$maybe_extra$Maybe$Extra$values(
			A2(
				$elm$core$List$map,
				function (queue_item_id) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (i) {
								var _v0 = i.hI;
								if (_v0.$ === 1) {
									return false;
								} else {
									var qid = _v0.a;
									return _Utils_eq(qid, queue_item_id);
								}
							},
							items));
				},
				clipboard_queue_item_ids));
	});
var $author$project$Queue$View$CalendarView$clipboard = function (model) {
	return A3(
		$author$project$CommonView$card,
		'queue-editor-clipboard',
		_List_fromArray(
			[
				$elm$html$Html$text('Prozess-Schritte für Reservierung')
			]),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-clipboard'),
					A2($elm$html$Html$Attributes$attribute, 'data-ext-events', 'queue-view-calendar')
				]),
			A2(
				$elm$core$List$indexedMap,
				A4(
					$author$project$CommonView$itemSidebarView,
					model,
					$elm$core$Maybe$Just($author$project$Types$RemoveItemFromClipboard),
					$elm$core$Maybe$Just($author$project$Types$ClipboardItemClick),
					$author$project$Types$QShowPopover),
				A2($author$project$Helper$getClipboardItems, model.gj, model.dz))));
};
var $author$project$CommonView$fullcalendarView = function (attrs) {
	return A3($elm$html$Html$node, 'fullcalendar-webcomponent', attrs, _List_Nil);
};
var $author$project$Helper$onDataChanged = function (message) {
	return A2(
		$elm$html$Html$Events$on,
		'data-changed',
		$elm$json$Json$Decode$succeed(message));
};
var $author$project$Helper$onMachineSelected = function (message) {
	var decoder = A2(
		$elm$json$Json$Decode$field,
		'detail',
		A2($elm$json$Json$Decode$field, 'machine_id', $elm$json$Json$Decode$int));
	var msgDecoder = A2($elm$json$Json$Decode$map, message, decoder);
	return A2($elm$html$Html$Events$on, 'machine-selected', msgDecoder);
};
var $author$project$Helper$reservationId = function (reservation) {
	if (reservation.$ === 1) {
		return 0;
	} else {
		var res = reservation.a;
		return res.an;
	}
};
var $author$project$Helper$reservationStart = function (reservation) {
	if (reservation.$ === 1) {
		return '';
	} else {
		var res = reservation.a;
		return res.h0;
	}
};
var $author$project$Queue$View$CalendarView$calendarView = function (model) {
	var fullcalendar_view = $author$project$CommonView$fullcalendarView(
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'id', 'queue-view-calendar'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'queue_id',
				$elm$core$String$fromInt(model.a9.an)),
				A2($elm$html$Html$Attributes$attribute, 'config_type', 'queues'),
				A2(
				$elm$html$Html$Attributes$property,
				'reload',
				$elm$json$Json$Encode$int(model.bS)),
				A2(
				$elm$html$Html$Attributes$property,
				'run_id',
				$elm$json$Json$Encode$int(
					A2($elm$core$Maybe$withDefault, 0, model.hV))),
				A2(
				$elm$html$Html$Attributes$property,
				'machine_id',
				$elm$json$Json$Encode$int(
					A2($elm$core$Maybe$withDefault, 0, model.fE))),
				A2(
				$elm$html$Html$Attributes$property,
				'reservation_id',
				$elm$json$Json$Encode$int(
					$author$project$Helper$reservationId(model.fF))),
				A2(
				$elm$html$Html$Attributes$property,
				'reservation_date',
				$elm$json$Json$Encode$string(
					$author$project$Helper$reservationStart(model.fF))),
				$author$project$Helper$onMachineSelected($author$project$Types$QMachineSelected),
				$author$project$Helper$onDataChanged($author$project$Types$QDataChanged)
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-9')
					]),
				_List_fromArray(
					[fullcalendar_view])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-3')
					]),
				_List_fromArray(
					[
						$author$project$Queue$View$CalendarView$clipboard(model)
					]))
			]));
};
var $author$project$Types$ClearClipboard = {$: 4};
var $rundis$elm_bootstrap$Bootstrap$Popover$Left = 3;
var $rundis$elm_bootstrap$Bootstrap$Popover$left = function (_v0) {
	var conf = _v0;
	return _Utils_update(
		conf,
		{W: 3});
};
var $author$project$Queue$View$ListView$clear_button = function (popover_state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('float-right'),
				A2($elm$html$Html$Attributes$style, 'height', '0')
			]),
		_List_fromArray(
			[
				A2(
				$rundis$elm_bootstrap$Bootstrap$Popover$view,
				popover_state,
				A3(
					$rundis$elm_bootstrap$Bootstrap$Popover$content,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Liste leeren')
						]),
					$rundis$elm_bootstrap$Bootstrap$Popover$left(
						$rundis$elm_bootstrap$Bootstrap$Popover$config(
							A2(
								$elm$html$Html$div,
								_Utils_ap(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button-run-editor')
										]),
									A2(
										$rundis$elm_bootstrap$Bootstrap$Popover$onHover,
										popover_state,
										$author$project$Types$QShowPopover('clear-clipboard'))),
								_List_fromArray(
									[
										A2(
										$author$project$CommonView$iconButton,
										'trash',
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$Types$ClearClipboard)
											]))
									]))))))
			]));
};
var $author$project$Queue$View$DndView$dndItemView = F4(
	function (model, contentViewFct, index, item) {
		var itemId = 'frdrag-' + $elm$core$String$fromInt(item.an);
		var attrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$id(itemId)
			]);
		var _v0 = $author$project$Common$dndSystem.eP(model.ev);
		if (!_v0.$) {
			var dragIndex = _v0.a.ew;
			var dropIndex = _v0.a.gz;
			var is_placeholder = _Utils_eq(dragIndex, index);
			var is_drop_target = _Utils_eq(dropIndex, index);
			return A2(
				$elm$html$Html$div,
				_Utils_ap(
					attrs,
					_Utils_ap(
						is_placeholder ? _List_fromArray(
							[
								$elm$html$Html$Attributes$class('dnd-placeholder')
							]) : A2($author$project$Common$dndSystem.gy, index, itemId),
						(is_drop_target && (!is_placeholder)) ? _List_fromArray(
							[
								$elm$html$Html$Attributes$class('dnd-drop-target')
							]) : _List_Nil)),
				_List_fromArray(
					[
						A2(contentViewFct, index, item)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_Utils_ap(
					attrs,
					A2($author$project$Common$dndSystem.gx, index, itemId)),
				_List_fromArray(
					[
						A2(contentViewFct, index, item)
					]));
		}
	});
var $author$project$Queue$View$ListView$clipboard = function (model) {
	var clipboard_items = A2($author$project$Helper$getClipboardItems, model.gj, model.dz);
	return A3(
		$author$project$CommonView$card,
		'queue-editor-clipboard',
		_List_fromArray(
			[
				$elm$html$Html$text('Prozess-Schritte für Reservierung'),
				(model.fq || $elm$core$List$isEmpty(clipboard_items)) ? $elm$html$Html$text('') : $author$project$Queue$View$ListView$clear_button(
				A2($author$project$Common$popoverState, model.fi, 'clear-clipboard'))
			]),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-clipboard')
				]),
			A2(
				$elm$core$List$indexedMap,
				function () {
					var action = model.fq ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Types$RemoveItemFromClipboard);
					return A2(
						$author$project$Queue$View$DndView$dndItemView,
						model,
						A4($author$project$CommonView$itemSidebarView, model, action, $elm$core$Maybe$Nothing, $author$project$Types$QShowPopover));
				}(),
				clipboard_items)));
};
var $author$project$Types$FilterDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Queue$View$ListView$dateFilter = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-group form-inline')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Reservierung bis')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$title('Reservierung bis'),
						$elm$html$Html$Attributes$type_('date'),
						$elm$html$Html$Events$onInput($author$project$Types$FilterDate),
						$elm$html$Html$Attributes$value(model.gM),
						$elm$html$Html$Attributes$class('form-control'),
						A2($elm$html$Html$Attributes$style, 'width', '10em'),
						A2($elm$html$Html$Attributes$style, 'margin-left', '1em'),
						A2($elm$html$Html$Attributes$style, 'margin-right', '1em')
					]),
				_List_Nil)
			]));
};
var $author$project$Types$FilterMachine = function (a) {
	return {$: 7, a: a};
};
var $author$project$Queue$View$ListView$machineSelect = F2(
	function (selected_machine_id, machines) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '20rem')
				]),
			_List_fromArray(
				[
					A5($author$project$CommonView$getHtmlSelect, $author$project$Types$FilterMachine, machines, selected_machine_id, 'Alle Geräte', false)
				]));
	});
var $author$project$Queue$View$ListView$filterView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('float-right')
					]),
				_List_fromArray(
					[
						A2($author$project$Queue$View$ListView$machineSelect, model.gN, model.dD)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('float-right')
					]),
				_List_fromArray(
					[
						$author$project$Queue$View$ListView$dateFilter(model)
					]))
			]));
};
var $author$project$Queue$View$ListView$runItemsTableHead = function (groups) {
	return $rundis$elm_bootstrap$Bootstrap$Table$simpleThead(
		_List_fromArray(
			[
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-actions'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('')
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-reservation'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Reservierung')
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-process'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Prozess/Rezept')
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-machine'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Gerät')
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-recipe'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Rezeptparameter')
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-comment'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Anmerkung')
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-estimated-time'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rotate-270')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Geschätzte'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('Zeit [min]')
							]))
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-wafer-count'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rotate-270')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Anzahl Proben')
							]))
					]))
			]));
};
var $author$project$Helper$filterBySelectedDate = F2(
	function (date, items) {
		if (date === '') {
			return items;
		} else {
			return A2(
				$elm$core$List$filter,
				function (i) {
					var _v1 = i.hc;
					if (_v1.$ === 1) {
						return true;
					} else {
						var lrt = _v1.a;
						var _v2 = $elm$core$List$head(
							A2($elm$core$String$split, 'T', lrt));
						if (_v2.$ === 1) {
							return true;
						} else {
							var lrt_date = _v2.a;
							return _Utils_cmp(lrt_date, date) < 1;
						}
					}
				},
				items);
		}
	});
var $author$project$Helper$filterBySelectedMachine = F2(
	function (machine_id, items) {
		if (machine_id.$ === 1) {
			return items;
		} else {
			var m_id = machine_id.a;
			return A2(
				$elm$core$List$filter,
				function (i) {
					return _Utils_eq(
						i.hh,
						$elm$core$Maybe$Just(m_id));
				},
				items);
		}
	});
var $author$project$Helper$getRecordsByRun = F2(
	function (run, records) {
		return A2(
			$elm$core$List$filter,
			function (r) {
				return _Utils_eq(r.bp, run.an);
			},
			records);
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$pt2 = $elm$html$Html$Attributes$class('pt-2');
var $rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$pt3 = $elm$html$Html$Attributes$class('pt-3');
var $author$project$Types$AddItemToClipboard = function (a) {
	return {$: 2, a: a};
};
var $author$project$Queue$View$ListView$itemRowActions = F2(
	function (clipboard_queue_item_ids, item) {
		var on_clipboard = function () {
			var _v0 = item.hI;
			if (_v0.$ === 1) {
				return false;
			} else {
				var queue_item_id = _v0.a;
				return A2($elm$core$List$member, queue_item_id, clipboard_queue_item_ids);
			}
		}();
		return _List_fromArray(
			[
				on_clipboard ? A2(
				$author$project$CommonView$iconButton,
				'minus',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Types$RemoveItemFromClipboard(item.hI))
					])) : A2(
				$author$project$CommonView$iconButton,
				'plus',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Types$AddItemToClipboard(item.hI))
					])),
				$author$project$Run$ItemHelper$hasReservation(item) ? A2(
				$author$project$CommonView$iconButton,
				'calendar',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Types$ClipboardItemClick(item))
					])) : $elm$html$Html$text('')
			]);
	});
var $rundis$elm_bootstrap$Bootstrap$Popover$Title = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Popover$titlePrivate = F4(
	function (elemFn, attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				h7: $elm$core$Maybe$Just(
					A2(
						elemFn,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('popover-header'),
							attributes),
						children))
			});
	});
var $rundis$elm_bootstrap$Bootstrap$Popover$titleH3 = $rundis$elm_bootstrap$Bootstrap$Popover$titlePrivate($elm$html$Html$h3);
var $author$project$CommonView$createElementWithPopover = F5(
	function (static_html, title, contentElems, state, updateStateFunction) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Popover$view,
			state,
			A3(
				$rundis$elm_bootstrap$Bootstrap$Popover$content,
				_List_Nil,
				contentElems,
				A3(
					$rundis$elm_bootstrap$Bootstrap$Popover$titleH3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						]),
					$rundis$elm_bootstrap$Bootstrap$Popover$bottom(
						$rundis$elm_bootstrap$Bootstrap$Popover$config(
							A2(
								$elm$html$Html$div,
								_Utils_ap(
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'width', '100%')
										]),
									A2($rundis$elm_bootstrap$Bootstrap$Popover$onHover, state, updateStateFunction)),
								_List_fromArray(
									[
										static_html,
										$elm$html$Html$text(' '),
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fa fa-info-circle')
											]),
										_List_Nil)
									])))))));
	});
var $author$project$Helper$itemIdStr = F2(
	function (item, property) {
		return 'item-' + (property + ('-' + $elm$core$String$fromInt(item.an)));
	});
var $author$project$CommonView$showEstimatedTime = F5(
	function (message, popover, process, recipe, item) {
		var id_str = A2($author$project$Helper$itemIdStr, item, 'estimated-time');
		var estimated_time_rules = _Utils_ap(
			$author$project$CommonView$estimatedTimeRulesProcessView(process),
			$author$project$CommonView$estimatedTimeRulesRecipeView(recipe));
		if (!estimated_time_rules.b) {
			return $elm$html$Html$text(
				$elm$core$String$fromInt(item.gF));
		} else {
			return A5(
				$author$project$CommonView$createElementWithPopover,
				$elm$html$Html$text(
					$elm$core$String$fromInt(item.gF)),
				'Regeln für geschätzte Zeit',
				estimated_time_rules,
				A2($author$project$Common$popoverState, popover, id_str),
				message(id_str));
		}
	});
var $author$project$CommonView$fixedParamsPopover = F3(
	function (message, popover, item) {
		var id_str = A2($author$project$Helper$itemIdStr, item, 'fixed-params');
		var fixed_params = A2(
			$elm$core$List$filter,
			function ($) {
				return $.fq;
			},
			item.hA);
		return $elm$core$List$isEmpty(fixed_params) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-1')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$CommonView$createElementWithPopover,
					A2(
						$elm$html$Html$i,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Fixe Parameter')
							])),
					'',
					_List_fromArray(
						[
							A2($author$project$CommonView$paramsTable, $author$project$Run$ItemHelper$formatFixedParam, fixed_params)
						]),
					A2($author$project$Common$popoverState, popover, id_str),
					message(id_str))
				]));
	});
var $author$project$CommonView$variableParamLabelAndValues = function (param) {
	var values = A2(
		$elm$core$List$map,
		A2($author$project$Run$ItemHelper$getParamValueOrDefault, param, $elm$core$Maybe$Nothing),
		$author$project$Run$ItemHelper$getValueIndexRange(param));
	return _Utils_Tuple3(
		$author$project$Run$ItemHelper$paramLabel(param),
		values,
		_List_Nil);
};
var $author$project$CommonView$showRecipe = F4(
	function (message, popover, item, recipe) {
		var group_param_ids = A2(
			$elm$core$List$map,
			function ($) {
				return $.an;
			},
			$author$project$Run$ItemHelper$getGroupParams(item));
		var planning_params = A2(
			$elm_community$list_extra$List$Extra$filterNot,
			function (p) {
				return A2($elm$core$List$member, p.an, group_param_ids);
			},
			A2(
				$elm_community$list_extra$List$Extra$filterNot,
				function ($) {
					return $.fq;
				},
				item.hA));
		if (recipe.$ === 1) {
			return _List_Nil;
		} else {
			var r = recipe.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('params-table-outer')
						]),
					_List_fromArray(
						[
							A2($author$project$CommonView$paramsTable, $author$project$CommonView$variableParamLabelAndValues, planning_params)
						])),
					A3($author$project$CommonView$fixedParamsPopover, message, popover, item)
				]);
		}
	});
var $author$project$Queue$View$ListView$runItemRowView = F4(
	function (model, run, groups, item) {
		var recipe = A2($author$project$Helper$getRecordById, model.dQ, item.hM);
		var process = A2(
			$author$project$Helper$getRecordById,
			model.dP,
			$elm$core$Maybe$Just(item.hD));
		var machine = A2($author$project$Helper$getRecordById, model.dD, item.hh);
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
					$elm$html$Html$Attributes$class(
						$author$project$Helper$itemColorClass(item)))
				]),
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('col-actions'))
						]),
					model.fq ? _List_Nil : A2($author$project$Queue$View$ListView$itemRowActions, model.gj, item)),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('col-reservation'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$CommonView$getReservationTime, item.hN, item.hc, $elm$core$Maybe$Nothing)
								]))
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('col-process'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$CommonView$getHtmlForRecord(process)
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$author$project$CommonView$getHtmlForRecord(recipe)
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('col-machine'))
						]),
					_List_fromArray(
						[
							$author$project$CommonView$getHtmlForRecord(machine)
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('col-recipe'))
						]),
					A4($author$project$CommonView$showRecipe, $author$project$Types$QShowPopover, model.fi, item, recipe)),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('col-comment'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(item.gl)
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('col-estimated-time'))
						]),
					_List_fromArray(
						[
							A5($author$project$CommonView$showEstimatedTime, $author$project$Types$QShowPopover, model.fi, process, recipe, item)
						])),
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('col-wafer-count'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								A2($author$project$Run$ItemHelper$totalWaferCountPerItem, model, item)))
						]))
				]));
	});
var $author$project$Helper$totalWaferCount = function (groups) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.ih;
			},
			groups));
};
var $author$project$Queue$View$ListView$runView = F2(
	function (model, run) {
		var items = A2(
			$author$project$Helper$filterBySelectedDate,
			model.gM,
			A2(
				$author$project$Helper$filterBySelectedMachine,
				model.gN,
				A2($author$project$Helper$getRecordsByRun, run, model.dz)));
		var groups = A2($author$project$Helper$getRecordsByRun, run, model.eI);
		return $elm$core$List$isEmpty(items) ? _List_Nil : _Utils_ap(
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rundis$elm_bootstrap$Bootstrap$Table$th,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									$elm$html$Html$Attributes$colspan(7))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[$rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$pt2]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$target('_blank'),
													$elm$html$Html$Attributes$href(run.h_)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$CommonView$runCaption(
														$elm$core$Maybe$Just(run)))
												]))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('run-responsible-persons')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Mentor: ' + (run.e2.gP + (' ' + (run.e2.hb + (' Verantwortlich: ' + (run.fd.gP + (' ' + (run.fd.hb + A2(
												$elm$core$String$join,
												'',
												A2(
													$elm$core$List$map,
													function (user) {
														return ', ' + (user.gP + (' ' + user.hb));
													},
													run.hG))))))))))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('run-notes')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(run.hm)
										]))
								])),
							A2(
							$rundis$elm_bootstrap$Bootstrap$Table$th,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr($rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$pt3),
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									$elm$html$Html$Attributes$class('max-groups'))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'(max. ' + ($elm$core$String$fromInt(
										$author$project$Helper$totalWaferCount(groups)) + ')'))
								]))
						]))
				]),
			A2(
				$elm$core$List$map,
				A3($author$project$Queue$View$ListView$runItemRowView, model, run, groups),
				items));
	});
var $author$project$Queue$View$ListView$runsTableView = function (model) {
	return $rundis$elm_bootstrap$Bootstrap$Table$table(
		{
			hs: _List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$small,
					$rundis$elm_bootstrap$Bootstrap$Table$bordered,
					$rundis$elm_bootstrap$Bootstrap$Table$hover,
					$rundis$elm_bootstrap$Bootstrap$Table$attr(
					$elm$html$Html$Attributes$class('run-editor small'))
				]),
			h4: A2(
				$rundis$elm_bootstrap$Bootstrap$Table$tbody,
				_List_Nil,
				$elm$core$List$concat(
					A2(
						$elm$core$List$map,
						$author$project$Queue$View$ListView$runView(model),
						model.fA))),
			h5: $author$project$Queue$View$ListView$runItemsTableHead(_List_Nil)
		});
};
var $author$project$Queue$View$ListView$listView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-9')
					]),
				_List_fromArray(
					[
						$author$project$Queue$View$ListView$filterView(model),
						$author$project$Queue$View$ListView$runsTableView(model)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-3')
					]),
				_List_fromArray(
					[
						$author$project$Queue$View$ListView$clipboard(model)
					]))
			]));
};
var $author$project$Queue$View$MainView$tabView = function (model) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Tab$view,
		model.fO,
		A2(
			$rundis$elm_bootstrap$Bootstrap$Tab$items,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Tab$item(
					{
						an: 'queue-list',
						e$: A2(
							$rundis$elm_bootstrap$Bootstrap$Tab$link,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Liste')
								])),
						fe: A2(
							$rundis$elm_bootstrap$Bootstrap$Tab$pane,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Queue$View$ListView$listView(model)
								]))
					}),
					$rundis$elm_bootstrap$Bootstrap$Tab$item(
					{
						an: 'queue-calendar',
						e$: A2(
							$rundis$elm_bootstrap$Bootstrap$Tab$link,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Kalender')
								])),
						fe: A2(
							$rundis$elm_bootstrap$Bootstrap$Tab$pane,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Queue$View$CalendarView$calendarView(model)
								]))
					})
				]),
			$rundis$elm_bootstrap$Bootstrap$Tab$config($author$project$Types$QChangeTab)));
};
var $author$project$Queue$View$MainView$mainContent = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($author$project$Types$GotQueueMsg),
		_List_fromArray(
			[
				$author$project$Queue$View$MainView$tabView(model),
				$author$project$Queue$View$DndView$dndGhostView(model)
			]));
};
var $author$project$Types$RChangeTab = function (a) {
	return {$: 46, a: a};
};
var $author$project$Types$RDataChanged = {$: 50};
var $author$project$Types$RMachineSelected = function (a) {
	return {$: 49, a: a};
};
var $author$project$Types$SelectMachine = function (a) {
	return {$: 48, a: a};
};
var $author$project$Run$View$CalendarView$machineSelect = F2(
	function (machines, selected_machine_id) {
		return A5($author$project$CommonView$getHtmlSelect, $author$project$Types$SelectMachine, machines, selected_machine_id, 'Gerät wählen', false);
	});
var $author$project$Types$RShowPopover = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Types$RunSequenceItemClick = function (a) {
	return {$: 45, a: a};
};
var $author$project$Run$View$CalendarView$runSequenceView = function (model) {
	return A3(
		$author$project$CommonView$card,
		'run-editor-clipboard',
		_List_fromArray(
			[
				$elm$html$Html$text('Prozess-Schritte')
			]),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-clipboard'),
					A2($elm$html$Html$Attributes$attribute, 'data-ext-events', 'run-view-calendar')
				]),
			A2(
				$elm$core$List$indexedMap,
				A4(
					$author$project$CommonView$itemSidebarView,
					model,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just($author$project$Types$RunSequenceItemClick),
					$author$project$Types$RShowPopover),
				model.dz)));
};
var $author$project$Run$View$CalendarView$calendarView = function (model) {
	var fullcalendar_view = $author$project$CommonView$fullcalendarView(
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'id', 'run-view-calendar'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'run_id',
				$elm$core$String$fromInt(model.a9.an)),
				A2($elm$html$Html$Attributes$attribute, 'config_type', 'runs'),
				A2(
				$elm$html$Html$Attributes$property,
				'reload',
				$elm$json$Json$Encode$int(model.bS)),
				A2(
				$elm$html$Html$Attributes$property,
				'machine_id',
				$elm$json$Json$Encode$int(
					A2($elm$core$Maybe$withDefault, 0, model.fE))),
				A2(
				$elm$html$Html$Attributes$property,
				'reservation_id',
				$elm$json$Json$Encode$int(
					$author$project$Helper$reservationId(model.fF))),
				A2(
				$elm$html$Html$Attributes$property,
				'reservation_date',
				$elm$json$Json$Encode$string(
					$author$project$Helper$reservationStart(model.fF))),
				$author$project$Helper$onMachineSelected($author$project$Types$RMachineSelected),
				$author$project$Helper$onDataChanged($author$project$Types$RDataChanged)
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-9')
					]),
				_List_fromArray(
					[fullcalendar_view])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-3')
					]),
				_List_fromArray(
					[
						A2($author$project$Run$View$CalendarView$machineSelect, model.dD, model.fE),
						$author$project$Run$View$CalendarView$runSequenceView(model)
					]))
			]));
};
var $author$project$Run$View$TableView$itemsFilter = F2(
	function (query, _v0) {
		var index = _v0.a;
		var item = _v0.b;
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(query)) ? true : A2(
			$elm$core$List$member,
			true,
			A2(
				$elm$core$List$map,
				function (q) {
					var _v1 = $elm$core$String$toInt(q);
					if (_v1.$ === 1) {
						return A2(
							$elm$core$String$contains,
							q,
							$elm$core$String$toLower(item.h7));
					} else {
						var _int = _v1.a;
						return _Utils_eq(_int, index + 1);
					}
				},
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					A2(
						$elm$core$List$map,
						$elm$core$String$toLower,
						A2(
							$elm$core$List$map,
							$elm$core$String$trim,
							A2($elm$core$String$split, ',', query))))));
	});
var $author$project$Run$View$TableView$colShown = F2(
	function (col, model) {
		return A2($elm$core$List$member, col, model.eJ);
	});
var $author$project$Types$CopyGroup = function (a) {
	return {$: 9, a: a};
};
var $author$project$Types$EditGroup = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Types$SplitGroup = function (a) {
	return {$: 8, a: a};
};
var $author$project$Run$ItemHelper$isGroupFrozen = F3(
	function (run_state, items, group) {
		return (run_state !== 'new') || A2(
			$elm$core$List$any,
			function (item) {
				return $author$project$Run$ItemHelper$hasDoneReservation(item) && A2($elm$core$List$member, group.an, item.gS);
			},
			items);
	});
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Warning = 4;
var $rundis$elm_bootstrap$Bootstrap$Button$warning = $rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled(4));
var $author$project$Run$View$TableView$groupButtons = F4(
	function (model, group, index, itemId) {
		var button_style = A2($author$project$Run$ItemHelper$isGroupUsed, model.dz, group) ? $rundis$elm_bootstrap$Bootstrap$Button$warning : $rundis$elm_bootstrap$Bootstrap$Button$secondary;
		return A2(
			$elm$core$List$intersperse,
			A2($elm$html$Html$br, _List_Nil, _List_Nil),
			_List_fromArray(
				[
					A4(
					$author$project$CommonView$iconButtonStyle,
					_List_fromArray(
						[
							button_style,
							$rundis$elm_bootstrap$Bootstrap$Button$attrs(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$disabled(
									A3($author$project$Run$ItemHelper$isGroupFrozen, model.a9.fz, model.dz, group))
								]))
						]),
					'trash',
					'Gruppe löschen',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2($author$project$Types$DeleteGroup, group, false))
						])),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'percentage',
					'Gruppe splitten',
					group.ih < 2,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Types$SplitGroup(group))
						])),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'copy',
					'Gruppe kopieren',
					model.a9.fz !== 'new',
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Types$CopyGroup(group))
						])),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'arrows-alt-h',
					'Gruppe verschieben',
					false,
					A2($author$project$Common$groupDndSystem.gx, index, itemId)),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'edit',
					'Gruppe bearbeiten',
					false,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2(
								$author$project$Types$EditGroup,
								A3($author$project$Run$ItemHelper$isGroupFrozen, model.a9.fz, model.dz, group),
								group))
						]))
				]));
	});
var $author$project$Run$View$TableView$groupHeaderView = F3(
	function (model, index, group) {
		var itemId = 'id-' + $elm$core$String$fromInt(group.an);
		var headerTextStyles = function () {
			var _v2 = $author$project$Common$groupDndSystem.eP(model.dv);
			if (_v2.$ === 1) {
				return _List_Nil;
			} else {
				var dragIndex = _v2.a.ew;
				return _Utils_eq(dragIndex, index) ? _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'red')
					]) : _List_Nil;
			}
		}();
		var headerAttributes = A2(
			$elm$core$List$map,
			$rundis$elm_bootstrap$Bootstrap$Table$cellAttr,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('group-header-view'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$id(itemId),
					function () {
						var _v1 = $author$project$Common$groupDndSystem.eP(model.dv);
						if (_v1.$ === 1) {
							return _List_Nil;
						} else {
							var dragIndex = _v1.a.ew;
							return A2(
								$elm$core$List$cons,
								A2($elm$html$Html$Attributes$style, 'cursor', 'move'),
								(!_Utils_eq(dragIndex, index)) ? A2($author$project$Common$groupDndSystem.gy, index, itemId) : _List_Nil);
						}
					}())));
		var group_actions_hidden = model.fq || ((!_Utils_eq(model.a6, $elm$core$Maybe$Nothing)) || (!_Utils_eq(
			$author$project$Common$groupDndSystem.eP(model.dv),
			$elm$core$Maybe$Nothing)));
		var buttons = function () {
			if (group_actions_hidden) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('group-header-view-buttons')
							]),
						A4($author$project$Run$View$TableView$groupButtons, model, group, index, itemId))
					]);
			}
		}();
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$th,
			headerAttributes,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$table(
					{
						hs: _List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Table$attr(
								$elm$html$Html$Attributes$class('group-header-view-container'))
							]),
						h4: A2(
							$rundis$elm_bootstrap$Bootstrap$Table$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rundis$elm_bootstrap$Bootstrap$Table$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2($rundis$elm_bootstrap$Bootstrap$Table$td, _List_Nil, buttons)
										])),
									A2(
									$rundis$elm_bootstrap$Bootstrap$Table$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rundis$elm_bootstrap$Bootstrap$Table$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(group.ih))
												]))
										]))
								])),
						h5: $rundis$elm_bootstrap$Bootstrap$Table$simpleThead(
							_List_fromArray(
								[
									A2(
									$rundis$elm_bootstrap$Bootstrap$Table$th,
									_List_fromArray(
										[
											$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
											$elm$html$Html$Attributes$class('rotate-45'))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													headerTextStyles,
													_List_fromArray(
														[
															$elm$html$Html$text(group.hX + (': ' + group.dG))
														]))
												]))
										]))
								]))
					})
				]));
	});
var $author$project$Run$View$TableView$groupHeaders = function (model) {
	return A2(
		$elm$core$List$indexedMap,
		$author$project$Run$View$TableView$groupHeaderView(model),
		model.eI);
};
var $author$project$Types$AddNewGroup = {$: 7};
var $ChristophP$elm_i18next$I18Next$t = F2(
	function (_v0, key) {
		var translations = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, translations));
	});
var $author$project$Run$View$TableView$addNewGroupButton = function (model) {
	return (model.fq || ((model.a9.fz !== 'new') || (!_Utils_eq(model.a6, $elm$core$Maybe$Nothing)))) ? $author$project$Helper$htmlEmpty : A4(
		$author$project$CommonView$textButtonStyle,
		_List_fromArray(
			[$rundis$elm_bootstrap$Bootstrap$Button$success]),
		false,
		A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'button.new_group'),
		$author$project$Types$AddNewGroup);
};
var $author$project$Types$ExportWaferLabels = {$: 68};
var $author$project$Run$View$TableView$exportWaferLabelsButton = function (model) {
	return (!_Utils_eq(model.a6, $elm$core$Maybe$Nothing)) ? $author$project$Helper$htmlEmpty : A4(
		$author$project$CommonView$textButtonStyle,
		_List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Button$secondary,
				$rundis$elm_bootstrap$Bootstrap$Button$attrs(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-tooltip',
						A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'tooltip.export')),
						$elm$html$Html$Attributes$class('css-tooltip-left')
					]))
			]),
		false,
		A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'button.export'),
		$author$project$Types$ExportWaferLabels);
};
var $author$project$Run$View$TableView$groupsButtons = function (model) {
	return _List_fromArray(
		[
			$author$project$Run$View$TableView$exportWaferLabelsButton(model),
			$author$project$Run$View$TableView$addNewGroupButton(model)
		]);
};
var $author$project$Types$GoToCalendar = {$: 47};
var $author$project$Types$ScrollDown = {$: 70};
var $author$project$Types$ScrollUp = {$: 69};
var $author$project$Types$SetItemsFilter = function (a) {
	return {$: 73, a: a};
};
var $author$project$Types$SetItemsVisibilty = F2(
	function (a, b) {
		return {$: 71, a: a, b: b};
	});
var $author$project$Types$SetSubheadingsVisibilty = function (a) {
	return {$: 72, a: a};
};
var $author$project$Types$ToggleBulkCopy = {$: 56};
var $author$project$Types$Undo = {$: 21};
var $author$project$Run$View$TableView$runActions = function (model) {
	var subheadings_icons = function () {
		var _v2 = model.hZ;
		if (_v2) {
			return _List_fromArray(
				[
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'chevron-left',
					'Prozess-Kategorie-Überschriften verbergen',
					false,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Types$SetSubheadingsVisibilty(!model.hZ))
						])),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'chevron-up',
					'Alle einklappen',
					false,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2(
								$author$project$Types$SetItemsVisibilty,
								true,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.an;
									},
									model.dz)))
						])),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'chevron-down',
					'Alle ausklappen',
					false,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2(
								$author$project$Types$SetItemsVisibilty,
								false,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.an;
									},
									model.dz)))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'chevron-right',
					'Prozess-Kategorie-Überschriften anzeigen',
					false,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Types$SetSubheadingsVisibilty(!model.hZ))
						]))
				]);
		}
	}();
	var readonly = model.fq || (model.a9.fz !== 'new');
	var may_add = (!readonly) || ((model.a9.fz === 'accepted') && model.a9.d5);
	var goto_calendar_icon = function () {
		var _v1 = model.a9.e4;
		if (_v1 === 'RunEditor') {
			return A4(
				$author$project$CommonView$iconButtonTooltip,
				'calendar',
				'Zum Kalender wechseln',
				false,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Types$GoToCalendar)
					]));
		} else {
			return $author$project$Helper$htmlEmpty;
		}
	}();
	var bulk_copy_active = !_Utils_eq(model.a6, $elm$core$Maybe$Nothing);
	var _v0 = bulk_copy_active ? _Utils_Tuple2('times', 'Kopieren beenden') : _Utils_Tuple2('layer-group', 'Mehrere Prozessschritte als Gruppe kopieren');
	var bulk_icon = _v0.a;
	var bulk_tooltip = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('run-actions')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					goto_calendar_icon,
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'arrow-up',
					'nach oben',
					false,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Types$ScrollUp)
						])),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'arrow-down',
					'nach unten',
					false,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Types$ScrollDown)
						])),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'plus',
					'Neuen Prozessschritt am Anfang der Liste einfügen',
					(!may_add) || bulk_copy_active,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2($author$project$Types$NewItemSelectProcessCategory, 0, model.ha))
						])),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					'undo',
					'Letzte Aktion rückgängig machen',
					$elm$core$List$isEmpty(model.i.dW),
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Types$Undo)
						])),
					A4(
					$author$project$CommonView$iconButtonTooltip,
					bulk_icon,
					bulk_tooltip,
					readonly,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Types$ToggleBulkCopy)
						]))
				]),
			_Utils_ap(
				subheadings_icons,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(model.g8),
								$elm$html$Html$Attributes$placeholder('Filter: Nummer, Text, …'),
								$elm$html$Html$Attributes$class('form-control form-control-sm'),
								$elm$html$Html$Events$onInput($author$project$Types$SetItemsFilter)
							]),
						_List_Nil)
					]))));
};
var $author$project$Types$ColumnToggle = function (a) {
	return {$: 59, a: a};
};
var $author$project$Run$View$TableView$colVisibilityAttr = function (hidden) {
	return hidden ? $rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
		$elm$html$Html$Attributes$class('col-hidden')) : $rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
		$elm$html$Html$Attributes$class('col-visible'));
};
var $author$project$Run$View$TableView$simpleColumnHead = F3(
	function (model, col, hidden) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$th,
			A2(
				$elm$core$List$cons,
				$author$project$Run$View$TableView$colVisibilityAttr(hidden),
				A2(
					$elm$core$List$map,
					$rundis$elm_bootstrap$Bootstrap$Table$cellAttr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(col),
							$elm$html$Html$Events$onClick(
							$author$project$Types$ColumnToggle(col)),
							$elm$html$Html$Attributes$class('clickable'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'title',
							A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'tooltip.hide_or_show'))
						]))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'table.' + col))
						]))
				]));
	});
var $author$project$Run$View$TableView$runItemsTableHeaders = function (model) {
	return _Utils_ap(
		_List_fromArray(
			[
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-number'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('#')
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-process-machine'))
					]),
				_List_fromArray(
					[
						$author$project$Run$View$TableView$runActions(model),
						$elm$html$Html$text(
						A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'table.col-process-machine'))
					])),
				A3(
				$author$project$Run$View$TableView$simpleColumnHead,
				model,
				'col-reservation',
				A2($author$project$Run$View$TableView$colShown, 'col-reservation', model)),
				A3(
				$author$project$Run$View$TableView$simpleColumnHead,
				model,
				'col-recipe',
				A2($author$project$Run$View$TableView$colShown, 'col-recipe', model)),
				A3(
				$author$project$Run$View$TableView$simpleColumnHead,
				model,
				'col-comment',
				A2($author$project$Run$View$TableView$colShown, 'col-comment', model)),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-estimated-time'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rotate-270')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'table.col-estimated-time-1')),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(
								A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'table.col-estimated-time-2'))
							]))
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-wafer-count'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rotate-270')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'table.col-wafer-count')),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(
								'(max. ' + ($elm$core$String$fromInt(
									$author$project$Helper$totalWaferCount(model.eI)) + ')'))
							]))
					])),
				A2(
				$rundis$elm_bootstrap$Bootstrap$Table$th,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$class('col-group-params'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'table.col-group-params'))
					]))
			]),
		_Utils_ap(
			$author$project$Run$View$TableView$groupHeaders(model),
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$th,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							$elm$html$Html$Attributes$class('col-actions-right'))
						]),
					$author$project$Run$View$TableView$groupsButtons(model))
				])));
};
var $author$project$Helper$accumulateFunctionValues = F3(
	function (f, x, els) {
		if (!els.b) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					f(x),
					_List_fromArray(
						[x]))
				]);
		} else {
			var _v1 = els.a;
			var y = _v1.a;
			var xs = _v1.b;
			var rest = els.b;
			return _Utils_eq(
				f(x),
				y) ? A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					y,
					A2($elm$core$List$cons, x, xs)),
				rest) : A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					f(x),
					_List_fromArray(
						[x])),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(y, xs),
					rest));
		}
	});
var $author$project$Helper$groupByFunctionValues = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$author$project$Helper$accumulateFunctionValues(f),
			_List_Nil,
			xs);
	});
var $author$project$Helper$itemProcessStep = F2(
	function (processes, _v0) {
		var process_id = _v0.hD;
		var _v1 = A2(
			$author$project$Helper$getRecordById,
			processes,
			$elm$core$Maybe$Just(process_id));
		if (_v1.$ === 1) {
			return '';
		} else {
			var p = _v1.a;
			var _v2 = $author$project$Helper$getProcessCategory(p);
			var c0 = _v2.a;
			var c1 = _v2.b;
			return c0 + (':' + c1);
		}
	});
var $author$project$Run$View$TableView$groupedItems = F2(
	function (processes, items) {
		return A2(
			$author$project$Helper$groupByFunctionValues,
			$author$project$Helper$itemProcessStep(processes),
			items);
	});
var $author$project$Run$View$TableView$processStepHeader = F3(
	function (n_cols, process_step, items) {
		var action = $author$project$Types$SetItemsVisibilty(
			A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.gY;
					}),
				items));
		var attributes = A2(
			$elm$core$List$map,
			$rundis$elm_bootstrap$Bootstrap$Table$rowAttr,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					action(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.an;
							},
							items))),
					$elm$html$Html$Attributes$class('clickable')
				]));
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			attributes,
			_List_fromArray(
				[
					A2(
					$rundis$elm_bootstrap$Bootstrap$Table$td,
					_List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
							A2(
								$elm$html$Html$Attributes$attribute,
								'colspan',
								$elm$core$String$fromInt(n_cols)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									process_step + ('\u00A0(' + ($elm$core$String$fromInt(
										$elm$core$List$length(items)) + ')')))
								]))
						]))
				]));
	});
var $author$project$Types$Drag = function (a) {
	return {$: 41, a: a};
};
var $author$project$Types$DragEnd = {$: 42};
var $author$project$Types$DragOver = function (a) {
	return {$: 43, a: a};
};
var $author$project$Types$Drop = function (a) {
	return {$: 44, a: a};
};
var $author$project$Types$RShowReservation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Run$View$TableView$addEditItemOnClick = function (item) {
	return _List_fromArray(
		[
			$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
			$elm$html$Html$Events$onClick(
				$author$project$Types$EditItem(item))),
			$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
			$elm$html$Html$Attributes$class('clickable'))
		]);
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $elm$html$Html$Attributes$draggable = _VirtualDom_attribute('draggable');
var $author$project$Types$AddItemToAllGroups = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$AddItemToNoGroups = function (a) {
	return {$: 6, a: a};
};
var $author$project$Run$View$TableView$groupSelectBtn = F3(
	function (item, hidden, all_groups_selected) {
		return all_groups_selected ? A4(
			$author$project$CommonView$textButtonStyle,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Button$secondary,
					$rundis$elm_bootstrap$Bootstrap$Button$attrs(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', hidden)
								]))
						]))
				]),
			false,
			'keine wählen',
			$author$project$Types$AddItemToNoGroups(item)) : A4(
			$author$project$CommonView$textButtonStyle,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Button$secondary,
					$rundis$elm_bootstrap$Bootstrap$Button$attrs(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', hidden)
								]))
						]))
				]),
			false,
			'alle wählen',
			$author$project$Types$AddItemToAllGroups(item));
	});
var $author$project$Run$View$TableView$groupParamCell = function (param) {
	var title = $author$project$Run$ItemHelper$paramLabel(param);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('group-param'),
				A2($elm$html$Html$Attributes$attribute, 'title', title)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Run$View$TableView$groupParamNames = F2(
	function (model, group_params) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$td,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
					$elm$html$Html$Attributes$class('col-group-params'))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('group-param')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'params.wafer_count_abr'))
							]))
					]),
				A2($elm$core$List$map, $author$project$Run$View$TableView$groupParamCell, group_params)));
	});
var $author$project$CommonView$showWaferCountPerItemAndGroup = F4(
	function (popover_msg, model, group, item) {
		var popover_id = A2(
			$author$project$Helper$itemIdStr,
			item,
			'group-attrs-' + $elm$core$String$fromInt(group.an));
		var group_attrs = A2($elm$core$Dict$get, group.an, item.gR);
		var unprocessed_samples = function () {
			if (group_attrs.$ === 1) {
				return 0;
			} else {
				var ga = group_attrs.a;
				return ga.h8;
			}
		}();
		var destructed_samples_execution = function () {
			if (group_attrs.$ === 1) {
				return 0;
			} else {
				var ga = group_attrs.a;
				return ga.gv;
			}
		}();
		var destructed_samples = function () {
			if (group_attrs.$ === 1) {
				return 0;
			} else {
				var ga = group_attrs.a;
				return ga.gt;
			}
		}();
		var count = A3($author$project$Run$ItemHelper$waferCountPerItemAndGroup, model, item, group);
		var is_danger = (count < 0) || (!_Utils_eq(item.hE, $elm$core$Maybe$Nothing));
		var count_html = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('text-danger', is_danger)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(count))
				]));
		var comment = function () {
			if (group_attrs.$ === 1) {
				return '';
			} else {
				var ga = group_attrs.a;
				return ga.gu;
			}
		}();
		var show_popup = (item.hY && ((destructed_samples > 0) || ($elm$core$String$length(comment) > 0))) || ((destructed_samples_execution > 0) || (unprocessed_samples > 0));
		return show_popup ? A5(
			$author$project$CommonView$createElementWithPopover,
			count_html,
			'Probenentnahme',
			_Utils_ap(
				(item.hY && (destructed_samples > 0)) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Entnommen: ' + $elm$core$String$fromInt(destructed_samples))
							]))
					]) : _List_Nil,
				_Utils_ap(
					(destructed_samples_execution > 0) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Zerstört: ' + $elm$core$String$fromInt(destructed_samples_execution))
								]))
						]) : _List_Nil,
					_Utils_ap(
						(unprocessed_samples > 0) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Nicht prozessiert: ' + $elm$core$String$fromInt(unprocessed_samples))
									]))
							]) : _List_Nil,
						($elm$core$String$length(comment) > 0) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Kommentar: ' + comment)
									]))
							]) : _List_Nil))),
			A2($author$project$Common$popoverState, model.fi, popover_id),
			popover_msg(popover_id)) : count_html;
	});
var $author$project$Run$View$TableView$groupTdForItemWithGroupValues = F5(
	function (model, item, group, group_params, values_colors) {
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$td,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
					$elm$html$Html$Attributes$class('col-group with-group-params'))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center')
						]),
					_List_fromArray(
						[
							A4($author$project$CommonView$showWaferCountPerItemAndGroup, $author$project$Types$RShowPopover, model, group, item)
						])),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, p) {
							var value_string = A2(
								$elm$core$String$join,
								'|',
								A2(
									$elm$core$List$map,
									A2(
										$author$project$Run$ItemHelper$getParamValueOrDefault,
										p,
										$elm$core$Maybe$Just(group.an)),
									$author$project$Run$ItemHelper$getValueIndexRange(p)));
							var color = A2(
								$elm$core$Maybe$withDefault,
								'white',
								$elm$core$List$head(
									A2(
										$elm$core$List$map,
										$elm$core$Tuple$second,
										A2(
											$elm$core$List$filter,
											function (_v0) {
												var value = _v0.a;
												var c = _v0.b;
												return _Utils_eq(value, value_string);
											},
											values_colors))));
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('group-param'),
										A2($elm$html$Html$Attributes$style, 'background-color', color),
										A2($elm$html$Html$Attributes$attribute, 'title', value_string)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(value_string)
									]));
						}),
					group_params)));
	});
var $author$project$Run$View$TableView$groupTdForItemWithoutGroupValues = F3(
	function (model, item, group) {
		var is_readonly = model.fq || ($author$project$Run$ItemHelper$hasDoneReservation(item) || ((!_Utils_eq(model.a6, $elm$core$Maybe$Nothing)) || ($author$project$Run$ItemHelper$wasExecutionStarted(item) || ((model.a9.fz !== 'new') || (!_Utils_eq(item.hE, $elm$core$Maybe$Nothing))))));
		var is_member = A2($elm$core$List$member, group.an, item.gS);
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$td,
			_Utils_ap(
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('text-center', true),
									_Utils_Tuple2('col-group', true),
									_Utils_Tuple2('not-allowed', is_readonly),
									_Utils_Tuple2('clickable', !is_readonly),
									_Utils_Tuple2('click-me', (!is_readonly) && (!is_member))
								])))
					]),
				is_readonly ? _List_Nil : _List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
						$elm$html$Html$Events$onClick(
							A2($author$project$Types$ToggleGroupForItem, item, group)))
					])),
			_List_fromArray(
				[
					is_member ? A4($author$project$CommonView$showWaferCountPerItemAndGroup, $author$project$Types$RShowPopover, model, group, item) : $elm$html$Html$text('')
				]));
	});
var $author$project$Run$View$TableView$groupTdForItem = F5(
	function (model, item, group, group_params, values_colors) {
		return $elm$core$List$isEmpty(group_params) ? A3($author$project$Run$View$TableView$groupTdForItemWithoutGroupValues, model, item, group) : (A2($elm$core$List$member, group.an, item.gS) ? A5($author$project$Run$View$TableView$groupTdForItemWithGroupValues, model, item, group, group_params, values_colors) : A2($rundis$elm_bootstrap$Bootstrap$Table$td, _List_Nil, _List_Nil));
	});
var $author$project$Run$View$TableView$groupTdsForItem = F2(
	function (model, item) {
		var group_params = $author$project$Run$ItemHelper$getGroupParams(item);
		var values_colors = A2($author$project$Run$ItemHelper$createColorClassList, item, group_params);
		return A2(
			$elm$core$List$cons,
			A2($author$project$Run$View$TableView$groupParamNames, model, group_params),
			A2(
				$elm$core$List$map,
				function (g) {
					return A5($author$project$Run$View$TableView$groupTdForItem, model, item, g, group_params, values_colors);
				},
				model.eI));
	});
var $author$project$Run$ItemHelper$isReservationToday = function (item) {
	var _v0 = item.hN;
	if (_v0.$ === 1) {
		return false;
	} else {
		var res = _v0.a;
		return res.g6;
	}
};
var $author$project$Types$AddRemoveItemToBulkCopy = F2(
	function (a, b) {
		return {$: 57, a: a, b: b};
	});
var $author$project$Types$InsertBulkCopyAfter = function (a) {
	return {$: 58, a: a};
};
var $author$project$Run$View$TableView$bulkCopyButtons = F3(
	function (copy_ids, item, item_index) {
		var checked = A2($elm$core$List$member, item.an, copy_ids);
		return _List_fromArray(
			[
				A4(
				$author$project$CommonView$iconButtonStyle,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Button$secondary,
						$rundis$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'hidden',
										!$elm$core$List$length(copy_ids))
									]))
							]))
					]),
				'arrow-circle-down',
				'Kopierte Gruppe einfügen nach diesem Element',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Types$InsertBulkCopyAfter(item_index))
					])),
				A4(
				$author$project$CommonView$iconButtonStyle,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Button$secondary,
						$rundis$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('bulk-copy', true),
										_Utils_Tuple2('btn-not-checked', !checked)
									]))
							]))
					]),
				'check',
				'Auswählen für Gruppen-Kopie',
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2($author$project$Types$AddRemoveItemToBulkCopy, item.an, !checked))
					]))
			]);
	});
var $author$project$Types$AskCopyItem = function (a) {
	return {$: 12, a: a};
};
var $author$project$Types$DeleteItem = function (a) {
	return {$: 16, a: a};
};
var $author$project$CommonView$iconButtonTooltipBottom = F3(
	function (icon, tooltip, disabled) {
		var style = _List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Button$secondary,
				$rundis$elm_bootstrap$Bootstrap$Button$attrs(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(disabled)
					]))
			]);
		return A4($author$project$CommonView$iconButtonBase, 'bottom', style, icon, tooltip);
	});
var $author$project$Run$View$TableView$itemRowButtons = F3(
	function (model, item, item_index) {
		var run_locked = model.fq || (model.a9.fz !== 'new');
		var is_operator_of_unprocessed_item = A2($author$project$Run$ItemHelper$isOperatorOfUnprocessedItem, model, item);
		var can_delete = (!$author$project$Run$ItemHelper$hasReservation(item)) && ((!run_locked) || (((!model.fq) || is_operator_of_unprocessed_item) && (!_Utils_eq(item.hE, $elm$core$Maybe$Nothing))));
		var can_create_item_for_unprocessed = A2($author$project$Run$ItemHelper$canCreateItemForUnprocessedSamples, model, item);
		var can_create_add_on_item = (model.a9.fz === 'accepted') && model.a9.d5;
		var may_add = (!run_locked) || can_create_add_on_item;
		return _List_fromArray(
			[
				A4(
				$author$project$CommonView$iconButtonTooltipBottom,
				'edit',
				'Prozessschritt bearbeiten',
				false,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Types$EditItem(item))
					])),
				A4(
				$author$project$CommonView$iconButtonTooltipBottom,
				'plus',
				can_create_add_on_item ? 'Nachträglichen Prozessschritt eingefügen' : (run_locked ? 'RUN-Planung ist gesperrt, es kann kein neuer Prozessschritt eingefügt werden' : 'Neuen Prozessschritt nach diesem einfügen'),
				!may_add,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2($author$project$Types$NewItemSelectProcessCategory, item_index + 1, model.ha))
					])),
				A4(
				$author$project$CommonView$iconButtonTooltipBottom,
				'copy',
				can_create_item_for_unprocessed ? 'Prozessschritt für unprozessierte Proben anlegen' : (run_locked ? 'RUN-Planung ist gesperrt, es kann kein neuer Prozessschritt eingefügt werden' : 'Prozessschritt kopieren'),
				run_locked && (!can_create_item_for_unprocessed),
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						can_create_item_for_unprocessed ? $author$project$Types$CreateItemForUnprocessedSamples(item) : $author$project$Types$AskCopyItem(item))
					])),
				A4(
				$author$project$CommonView$iconButtonTooltip,
				'trash-alt',
				$author$project$Run$ItemHelper$hasReservation(item) ? 'Prozessschritte mit Reservierung können nicht gelöscht werden!' : (can_delete ? 'Prozessschritt löschen' : 'RUN-Planung ist gesperrt, Prozessschritte können nicht gelöscht werden!'),
				!can_delete,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Types$DeleteItem(item))
					]))
			]);
	});
var $author$project$Run$View$TableView$itemActions = F2(
	function (model, item) {
		var item_index = A2($author$project$Helper$elemIndex, item, model.dz);
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-action-buttons')
				]),
			function () {
				var _v0 = model.a6;
				if (_v0.$ === 1) {
					return A3($author$project$Run$View$TableView$itemRowButtons, model, item, item_index);
				} else {
					var copy_ids = _v0.a;
					return A3($author$project$Run$View$TableView$bulkCopyButtons, copy_ids, item, item_index);
				}
			}());
	});
var $author$project$Helper$itemDragClass = F4(
	function (item_dragged, item_dragged_over, item, items) {
		var _v0 = _Utils_Tuple2(item_dragged, item_dragged_over);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var drag = _v0.a.a;
			var over = _v0.b.a;
			return ((!_Utils_eq(item.an, over.an)) || _Utils_eq(item.an, drag.an)) ? '' : ((_Utils_cmp(
				A2($author$project$Helper$elemIndex, drag, items),
				A2($author$project$Helper$elemIndex, over, items)) > 0) ? 'drop_above' : 'drop_below');
		} else {
			return '';
		}
	});
var $author$project$Helper$onDragEnd = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'dragend',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Helper$onDragOver = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'dragover',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Helper$onDragStart = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'dragstart',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Helper$onDrop = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'drop',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Run$View$TableView$runItemRowView = F2(
	function (model, item) {
		var recipe = A2($author$project$Helper$getRecordById, model.dQ, item.hM);
		var readonly = model.fq || ((model.a9.fz !== 'new') || (!_Utils_eq(model.a6, $elm$core$Maybe$Nothing)));
		var process = function () {
			var _v0 = A2(
				$author$project$Helper$getRecordById,
				model.dP,
				$elm$core$Maybe$Just(item.hD));
			if (_v0.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var p = _v0.a;
				return $elm$core$Maybe$Just(
					_Utils_update(
						p,
						{
							dG: model.hZ ? $author$project$Helper$getProcessName(p) : p.dG
						}));
			}
		}();
		var may_drag = _Utils_eq(model.a6, $elm$core$Maybe$Nothing) && ((!readonly) || ((model.a9.fz === 'accepted') && (item.g5 && _Utils_eq(item.ib.an, model.a9.gq.an))));
		var machine = A2($author$project$Helper$getRecordById, model.dD, item.hh);
		var index = A2($author$project$Helper$elemIndex, item, model.dz);
		var groups_btn_hidden = readonly || ($author$project$Run$ItemHelper$hasDoneReservation(item) || $author$project$Run$ItemHelper$wasExecutionStarted(item));
		var all_groups_selected = _Utils_eq(
			$elm$core$List$length(model.eI),
			$elm$core$List$length(item.gS));
		return A2(
			$rundis$elm_bootstrap$Bootstrap$Table$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
						$elm$html$Html$Attributes$id(
							'item-' + $elm$core$String$fromInt(item.an))),
						$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
						$elm$html$Html$Attributes$class(
							A4($author$project$Helper$itemDragClass, model.cg, model.eW, item, model.dz))),
						$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
						$elm$html$Html$Attributes$class(
							$author$project$Helper$itemColorClass(item))),
						$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
						$author$project$Helper$onDragStart(
							$author$project$Types$Drag(item))),
						$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
						$author$project$Helper$onDragEnd($author$project$Types$DragEnd)),
						$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
						$author$project$Helper$onDragOver(
							$author$project$Types$DragOver(item))),
						$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
						$author$project$Helper$onDrop(
							$author$project$Types$Drop(item)))
					]),
				may_drag ? _List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Table$rowAttr(
						$elm$html$Html$Attributes$draggable('true'))
					]) : _List_Nil),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rundis$elm_bootstrap$Bootstrap$Table$td,
						A2(
							$elm$core$List$cons,
							$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
								$elm$html$Html$Attributes$class('col-number nowrap')),
							$author$project$Run$View$TableView$addEditItemOnClick(item)),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$b,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(index + 1))
									]))
							]))
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rundis$elm_bootstrap$Bootstrap$Table$td,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									$elm$html$Html$Attributes$class('col-process-machine'))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$CommonView$getHtmlForRecord(process)
										])),
									A2($author$project$Run$View$TableView$itemActions, model, item),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									$author$project$CommonView$itemWarnings(item)),
									$author$project$CommonView$getHtmlForRecord(machine),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$author$project$CommonView$getHtmlForRecord(recipe)
								])),
							A2(
							$rundis$elm_bootstrap$Bootstrap$Table$td,
							_Utils_ap(
								_List_fromArray(
									[
										$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('col-reservation', true),
													_Utils_Tuple2(
													'with-click css-tooltip',
													$author$project$Run$ItemHelper$hasReservation(item)),
													_Utils_Tuple2(
													'bg-dark text-light',
													$author$project$Run$ItemHelper$isReservationToday(item))
												]))),
										$author$project$Run$View$TableView$colVisibilityAttr(
										A2($author$project$Run$View$TableView$colShown, 'col-reservation', model))
									]),
								$author$project$Run$ItemHelper$hasReservation(item) ? _List_fromArray(
									[
										$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
										$elm$html$Html$Events$onClick(
											$author$project$Types$RShowReservation(item))),
										$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
										A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'Reservierung öffnen'))
									]) : _List_Nil),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$CommonView$warningMessage(item.hP),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'text-danger',
															!$elm$core$String$isEmpty(item.hP))
														]))
												]),
											A2(
												$elm$core$List$intersperse,
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												_Utils_ap(
													_List_fromArray(
														[
															A3($author$project$CommonView$getReservationTime, item.hN, item.hc, item.hO)
														]),
													$author$project$CommonView$showReservationChildren(item.hN))))
										]))
								])),
							A2(
							$rundis$elm_bootstrap$Bootstrap$Table$td,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									$elm$html$Html$Attributes$class('col-recipe')),
									$author$project$Run$View$TableView$colVisibilityAttr(
									A2($author$project$Run$View$TableView$colShown, 'col-recipe', model))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A4($author$project$CommonView$showRecipe, $author$project$Types$RShowPopover, model.fi, item, recipe))
								])),
							A2(
							$rundis$elm_bootstrap$Bootstrap$Table$td,
							_Utils_ap(
								_List_fromArray(
									[
										$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
										$elm$html$Html$Attributes$class('col-comment')),
										$author$project$Run$View$TableView$colVisibilityAttr(
										A2($author$project$Run$View$TableView$colShown, 'col-comment', model))
									]),
								$author$project$Run$View$TableView$addEditItemOnClick(item)),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(item.gl)
										]))
								])),
							A2(
							$rundis$elm_bootstrap$Bootstrap$Table$td,
							_List_fromArray(
								[
									$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
									$elm$html$Html$Attributes$class('col-estimated-time'))
								]),
							_List_fromArray(
								[
									A5($author$project$CommonView$showEstimatedTime, $author$project$Types$RShowPopover, model.fi, process, recipe, item)
								])),
							function () {
							var count = A2($author$project$Run$ItemHelper$totalWaferCountPerItem, model, item);
							return A2(
								$rundis$elm_bootstrap$Bootstrap$Table$td,
								_List_fromArray(
									[
										$rundis$elm_bootstrap$Bootstrap$Table$cellAttr(
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('col-wafer-count', true),
													_Utils_Tuple2(
													'text-danger',
													(count < 0) || (!_Utils_eq(item.hE, $elm$core$Maybe$Nothing)))
												])))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(count))
									]));
						}()
						]),
					_Utils_ap(
						A2($author$project$Run$View$TableView$groupTdsForItem, model, item),
						_List_fromArray(
							[
								A2(
								$rundis$elm_bootstrap$Bootstrap$Table$td,
								_List_Nil,
								_List_fromArray(
									[
										A3($author$project$Run$View$TableView$groupSelectBtn, item, groups_btn_hidden, all_groups_selected)
									]))
							])))));
	});
var $author$project$Run$View$TableView$tableRowsForSubheading = F4(
	function (model, n_cols, category, items) {
		var _v0 = model.hZ;
		if (_v0) {
			return A2(
				$elm$core$List$cons,
				A3($author$project$Run$View$TableView$processStepHeader, n_cols, category, items),
				A2(
					$elm$core$List$map,
					$author$project$Run$View$TableView$runItemRowView(model),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$not,
							function ($) {
								return $.gY;
							}),
						items)));
		} else {
			return A2(
				$elm$core$List$map,
				$author$project$Run$View$TableView$runItemRowView(model),
				items);
		}
	});
var $author$project$Run$View$TableView$tableRowsWithSubheadings = F4(
	function (model, n_cols, processes, items) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var x = _v0.a;
				var y = _v0.b;
				return A4($author$project$Run$View$TableView$tableRowsForSubheading, model, n_cols, x, y);
			},
			A2($author$project$Run$View$TableView$groupedItems, processes, items));
	});
var $author$project$Run$View$TableView$runItemsTable = function (model) {
	var tableHeaders = $author$project$Run$View$TableView$runItemsTableHeaders(model);
	var n_cols = $elm$core$List$length(tableHeaders);
	var items = A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$filter,
			$author$project$Run$View$TableView$itemsFilter(model.g8),
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, model.dz)));
	return $rundis$elm_bootstrap$Bootstrap$Table$table(
		{
			hs: _List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Table$small,
					$rundis$elm_bootstrap$Bootstrap$Table$bordered,
					$rundis$elm_bootstrap$Bootstrap$Table$hover,
					$rundis$elm_bootstrap$Bootstrap$Table$attr(
					$elm$html$Html$Attributes$class('run-editor small'))
				]),
			h4: A2(
				$rundis$elm_bootstrap$Bootstrap$Table$tbody,
				_List_Nil,
				A4($author$project$Run$View$TableView$tableRowsWithSubheadings, model, n_cols, model.dP, items)),
			h5: $rundis$elm_bootstrap$Bootstrap$Table$simpleThead(tableHeaders)
		});
};
var $author$project$Run$View$TableView$runEditorView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('run-table-top')
					]),
				_List_Nil),
				$author$project$Run$View$TableView$runItemsTable(model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('run-table-bottom')
					]),
				_List_Nil)
			]));
};
var $author$project$Run$View$MainView$tabView = function (model) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Tab$view,
		model.fO,
		A2(
			$rundis$elm_bootstrap$Bootstrap$Tab$items,
			_List_fromArray(
				[
					$rundis$elm_bootstrap$Bootstrap$Tab$item(
					{
						an: 'run-list',
						e$: A2(
							$rundis$elm_bootstrap$Bootstrap$Tab$link,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'tabs.editor'))
								])),
						fe: A2(
							$rundis$elm_bootstrap$Bootstrap$Tab$pane,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Run$View$TableView$runEditorView(model)
								]))
					}),
					$rundis$elm_bootstrap$Bootstrap$Tab$item(
					{
						an: 'run-calendar',
						e$: A2(
							$rundis$elm_bootstrap$Bootstrap$Tab$link,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, model.fZ, 'tabs.calendar'))
								])),
						fe: A2(
							$rundis$elm_bootstrap$Bootstrap$Tab$pane,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Run$View$CalendarView$calendarView(model)
								]))
					})
				]),
			$rundis$elm_bootstrap$Bootstrap$Tab$config($author$project$Types$RChangeTab)));
};
var $author$project$Run$View$MainView$runContent = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Types$GotRunMsg,
			$author$project$Run$View$MainView$tabView(model))
		]);
};
var $author$project$Run$View$MainView$runTemplateContent = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Types$GotRunMsg,
			$author$project$Run$View$TableView$runEditorView(model))
		]);
};
var $author$project$RunEditor$view = function (model) {
	var _v0 = model.a9.e4;
	switch (_v0) {
		case 'RunEditor':
			return A4(
				$author$project$RunEditor$container,
				model,
				true,
				'run-editor-view',
				$author$project$Run$View$MainView$runContent(model));
		case 'RunTemplateEditor':
			return A4(
				$author$project$RunEditor$container,
				model,
				true,
				'run-template-editor-view',
				$author$project$Run$View$MainView$runTemplateContent(model));
		case 'QueueEditor':
			return A4(
				$author$project$RunEditor$container,
				model,
				false,
				'queue-editor-view',
				$author$project$Queue$View$MainView$mainContent(model));
		default:
			return A4(
				$author$project$RunEditor$container,
				model,
				false,
				'',
				_List_fromArray(
					[
						$elm$html$Html$text('no such mode!')
					]));
	}
};
var $author$project$RunEditor$main = $elm$browser$Browser$element(
	{g2: $author$project$RunEditor$init, dZ: $author$project$RunEditor$subscriptions, h9: $author$project$RunEditor$update, $8: $author$project$RunEditor$view});
_Platform_export({'RunEditor':{'init':$author$project$RunEditor$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (translations) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (run_state) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (run_item_id) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (readonly) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (mode) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (logo_path) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (id) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (execution_enabled) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (endpoint_working_data) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (endpoint_run_item) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (endpoint_refresh_withdrawals) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (endpoint_master_data) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (endpoint_item_file_upload) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (debug) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (current_user) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (csrfXhrToken) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (can_create_reservation) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (add_on_items) {
																																					return $elm$json$Json$Decode$succeed(
																																						{d5: add_on_items, ge: can_create_reservation, dl: csrfXhrToken, gq: current_user, eq: debug, gC: endpoint_item_file_upload, ez: endpoint_master_data, gD: endpoint_refresh_withdrawals, dp: endpoint_run_item, gE: endpoint_working_data, gG: execution_enabled, an: id, hf: logo_path, e4: mode, fq: readonly, hS: run_item_id, fz: run_state, fZ: translations});
																																				},
																																				A2($elm$json$Json$Decode$field, 'add_on_items', $elm$json$Json$Decode$bool));
																																		},
																																		A2($elm$json$Json$Decode$field, 'can_create_reservation', $elm$json$Json$Decode$bool));
																																},
																																A2($elm$json$Json$Decode$field, 'csrfXhrToken', $elm$json$Json$Decode$string));
																														},
																														A2(
																															$elm$json$Json$Decode$field,
																															'current_user',
																															A2(
																																$elm$json$Json$Decode$andThen,
																																function (username) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (lastname) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (id) {
																																					return A2(
																																						$elm$json$Json$Decode$andThen,
																																						function (firstname) {
																																							return $elm$json$Json$Decode$succeed(
																																								{gP: firstname, an: id, hb: lastname, ic: username});
																																						},
																																						A2($elm$json$Json$Decode$field, 'firstname', $elm$json$Json$Decode$string));
																																				},
																																				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int));
																																		},
																																		A2($elm$json$Json$Decode$field, 'lastname', $elm$json$Json$Decode$string));
																																},
																																A2($elm$json$Json$Decode$field, 'username', $elm$json$Json$Decode$string))));
																												},
																												A2($elm$json$Json$Decode$field, 'debug', $elm$json$Json$Decode$bool));
																										},
																										A2($elm$json$Json$Decode$field, 'endpoint_item_file_upload', $elm$json$Json$Decode$string));
																								},
																								A2($elm$json$Json$Decode$field, 'endpoint_master_data', $elm$json$Json$Decode$string));
																						},
																						A2($elm$json$Json$Decode$field, 'endpoint_refresh_withdrawals', $elm$json$Json$Decode$string));
																				},
																				A2($elm$json$Json$Decode$field, 'endpoint_run_item', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'endpoint_working_data', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'execution_enabled', $elm$json$Json$Decode$bool));
														},
														A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int));
												},
												A2($elm$json$Json$Decode$field, 'logo_path', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'mode', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'readonly', $elm$json$Json$Decode$bool));
						},
						A2(
							$elm$json$Json$Decode$field,
							'run_item_id',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int)
									]))));
				},
				A2($elm$json$Json$Decode$field, 'run_state', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'translations', $elm$json$Json$Decode$string)))(0)}});

//////////////////// HMR BEGIN ////////////////////

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Original Author: Flux Xu @fluxxu
*/

/*
    A note about the environment that this code runs in...

    assumed globals:
        - `module` (from Node.js module system and webpack)

    assumed in scope after injection into the Elm IIFE:
        - `scope` (has an 'Elm' property which contains the public Elm API)
        - various functions defined by Elm which we have to hook such as `_Platform_initialize` and `_Scheduler_binding`
 */

if (module.hot) {
    (function () {
        "use strict";

        //polyfill for IE: https://github.com/fluxxu/elm-hot-loader/issues/16
        if (typeof Object.assign != 'function') {
            Object.assign = function (target) {
                'use strict';
                if (target == null) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                target = Object(target);
                for (var index = 1; index < arguments.length; index++) {
                    var source = arguments[index];
                    if (source != null) {
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                }
                return target;
            };
        }

        // Elm 0.19.1 introduced a '$' prefix at the beginning of the symbols it emits,
        // and we check for `Maybe.Just` because we expect it to be present in all Elm programs.
        var elmVersion;
        if (typeof elm$core$Maybe$Just !== 'undefined')
            elmVersion = '0.19.0';
        else if (typeof $elm$core$Maybe$Just !== 'undefined')
            elmVersion = '0.19.1';
        else
            throw new Error("Could not determine Elm version");

        function elmSymbol(symbol) {
            try {
                switch (elmVersion) {
                    case '0.19.0':
                        return eval(symbol);
                    case '0.19.1':
                        return eval('$' + symbol);
                    default:
                        throw new Error('Cannot resolve ' + symbol + '. Elm version unknown!')
                }
            } catch (e) {
                if (e instanceof ReferenceError) {
                    return undefined;
                } else {
                    throw e;
                }
            }
        }

        var instances = module.hot.data
            ? module.hot.data.instances || {}
            : {};
        var uid = module.hot.data
            ? module.hot.data.uid || 0
            : 0;

        if (Object.keys(instances).length === 0) {
            log("[elm-hot] Enabled");
        }

        var cancellers = [];

        // These 2 variables act as dynamically-scoped variables which are set only when the
        // Elm module's hooked init function is called.
        var initializingInstance = null;
        var swappingInstance = null;

        module.hot.accept();
        module.hot.dispose(function (data) {
            data.instances = instances;
            data.uid = uid;

            // Cleanup pending async tasks

            // First, make sure that no new tasks can be started until we finish replacing the code
            _Scheduler_binding = function () {
                return _Scheduler_fail(new Error('[elm-hot] Inactive Elm instance.'))
            };

            // Second, kill pending tasks belonging to the old instance
            if (cancellers.length) {
                log('[elm-hot] Killing ' + cancellers.length + ' running processes...');
                try {
                    cancellers.forEach(function (cancel) {
                        cancel();
                    });
                } catch (e) {
                    console.warn('[elm-hot] Kill process error: ' + e.message);
                }
            }
        });

        function log(message) {
            if (module.hot.verbose) {
                console.log(message)
            }
        }

        function getId() {
            return ++uid;
        }

        function findPublicModules(parent, path) {
            var modules = [];
            for (var key in parent) {
                var child = parent[key];
                var currentPath = path ? path + '.' + key : key;
                if ('init' in child) {
                    modules.push({
                        path: currentPath,
                        module: child
                    });
                } else {
                    modules = modules.concat(findPublicModules(child, currentPath));
                }
            }
            return modules;
        }

        function registerInstance(domNode, flags, path, portSubscribes, portSends) {
            var id = getId();

            var instance = {
                id: id,
                path: path,
                domNode: domNode,
                flags: flags,
                portSubscribes: portSubscribes,
                portSends: portSends,
                lastState: null // last Elm app state (root model)
            };

            return instances[id] = instance
        }

        function isFullscreenApp() {
            // Returns true if the Elm app will take over the entire DOM body.
            return typeof elmSymbol("elm$browser$Browser$application") !== 'undefined'
                || typeof elmSymbol("elm$browser$Browser$document") !== 'undefined';
        }

        function wrapDomNode(node) {
            // When embedding an Elm app into a specific DOM node, Elm will replace the provided
            // DOM node with the Elm app's content. When the Elm app is compiled normally, the
            // original DOM node is reused (its attributes and content changes, but the object
            // in memory remains the same). But when compiled using `--debug`, Elm will completely
            // destroy the original DOM node and instead replace it with 2 brand new nodes: one
            // for your Elm app's content and the other for the Elm debugger UI. In this case,
            // if you held a reference to the DOM node provided for embedding, it would be orphaned
            // after Elm module initialization.
            //
            // So in order to make both cases consistent and isolate us from changes in how Elm
            // does this, we will insert a dummy node to wrap the node for embedding and hold
            // a reference to the dummy node.
            //
            // We will also put a tag on the dummy node so that the Elm developer knows who went
            // behind their back and rudely put stuff in their DOM.
            var dummyNode = document.createElement("div");
            dummyNode.setAttribute("data-elm-hot", "true");
            dummyNode.style.height = "inherit";
            var parentNode = node.parentNode;
            parentNode.replaceChild(dummyNode, node);
            dummyNode.appendChild(node);
            return dummyNode;
        }

        function wrapPublicModule(path, module) {
            var originalInit = module.init;
            if (originalInit) {
                module.init = function (args) {
                    var elm;
                    var portSubscribes = {};
                    var portSends = {};
                    var domNode = null;
                    var flags = null;
                    if (typeof args !== 'undefined') {
                        // normal case
                        domNode = args['node'] && !isFullscreenApp()
                            ? wrapDomNode(args['node'])
                            : document.body;
                        flags = args['flags'];
                    } else {
                        // rare case: Elm allows init to be called without any arguments at all
                        domNode = document.body;
                        flags = undefined
                    }
                    initializingInstance = registerInstance(domNode, flags, path, portSubscribes, portSends);
                    elm = originalInit(args);
                    wrapPorts(elm, portSubscribes, portSends);
                    initializingInstance = null;
                    return elm;
                };
            } else {
                console.error("Could not find a public module to wrap at path " + path)
            }
        }

        function swap(Elm, instance) {
            log('[elm-hot] Hot-swapping module: ' + instance.path);

            swappingInstance = instance;

            // remove from the DOM everything that had been created by the old Elm app
            var containerNode = instance.domNode;
            while (containerNode.lastChild) {
                containerNode.removeChild(containerNode.lastChild);
            }

            var m = getAt(instance.path.split('.'), Elm);
            var elm;
            if (m) {
                // prepare to initialize the new Elm module
                var args = {flags: instance.flags};
                if (containerNode === document.body) {
                    // fullscreen case: no additional args needed
                } else {
                    // embed case: provide a new node for Elm to use
                    var nodeForEmbed = document.createElement("div");
                    containerNode.appendChild(nodeForEmbed);
                    args['node'] = nodeForEmbed;
                }

                elm = m.init(args);

                Object.keys(instance.portSubscribes).forEach(function (portName) {
                    if (portName in elm.ports && 'subscribe' in elm.ports[portName]) {
                        var handlers = instance.portSubscribes[portName];
                        if (!handlers.length) {
                            return;
                        }
                        log('[elm-hot] Reconnect ' + handlers.length + ' handler(s) to port \''
                            + portName + '\' (' + instance.path + ').');
                        handlers.forEach(function (handler) {
                            elm.ports[portName].subscribe(handler);
                        });
                    } else {
                        delete instance.portSubscribes[portName];
                        log('[elm-hot] Port was removed: ' + portName);
                    }
                });

                Object.keys(instance.portSends).forEach(function (portName) {
                    if (portName in elm.ports && 'send' in elm.ports[portName]) {
                        log('[elm-hot] Replace old port send with the new send');
                        instance.portSends[portName] = elm.ports[portName].send;
                    } else {
                        delete instance.portSends[portName];
                        log('[elm-hot] Port was removed: ' + portName);
                    }
                });
            } else {
                log('[elm-hot] Module was removed: ' + instance.path);
            }

            swappingInstance = null;
        }

        function wrapPorts(elm, portSubscribes, portSends) {
            var portNames = Object.keys(elm.ports || {});
            //hook ports
            if (portNames.length) {
                // hook outgoing ports
                portNames
                    .filter(function (name) {
                        return 'subscribe' in elm.ports[name];
                    })
                    .forEach(function (portName) {
                        var port = elm.ports[portName];
                        var subscribe = port.subscribe;
                        var unsubscribe = port.unsubscribe;
                        elm.ports[portName] = Object.assign(port, {
                            subscribe: function (handler) {
                                log('[elm-hot] ports.' + portName + '.subscribe called.');
                                if (!portSubscribes[portName]) {
                                    portSubscribes[portName] = [handler];
                                } else {
                                    //TODO handle subscribing to single handler more than once?
                                    portSubscribes[portName].push(handler);
                                }
                                return subscribe.call(port, handler);
                            },
                            unsubscribe: function (handler) {
                                log('[elm-hot] ports.' + portName + '.unsubscribe called.');
                                var list = portSubscribes[portName];
                                if (list && list.indexOf(handler) !== -1) {
                                    list.splice(list.lastIndexOf(handler), 1);
                                } else {
                                    console.warn('[elm-hot] ports.' + portName + '.unsubscribe: handler not subscribed');
                                }
                                return unsubscribe.call(port, handler);
                            }
                        });
                    });

                // hook incoming ports
                portNames
                    .filter(function (name) {
                        return 'send' in elm.ports[name];
                    })
                    .forEach(function (portName) {
                        var port = elm.ports[portName];
                        portSends[portName] = port.send;
                        elm.ports[portName] = Object.assign(port, {
                            send: function (val) {
                                return portSends[portName].call(port, val);
                            }
                        });
                    });
            }
            return portSubscribes;
        }

        /*
        Breadth-first search for a `Browser.Navigation.Key` in the user's app model.
        Returns the key and keypath or null if not found.
        */
        function findNavKey(rootModel) {
            var queue = [];
            if (isDebuggerModel(rootModel)) {
                /*
                 Extract the user's app model from the Elm Debugger's model. The Elm debugger
                 can hold multiple references to the user's model (e.g. in its "history"). So
                 we must be careful to only search within the "state" part of the Debugger.
                */
                queue.push({value: rootModel['state'], keypath: ['state']});
            } else {
                queue.push({value: rootModel, keypath: []});
            }

            while (queue.length !== 0) {
                var item = queue.shift();

                if (typeof item.value === "undefined" || item.value === null) {
                    continue;
                }

                // The nav key is identified by a runtime tag added by the elm-hot injector.
                if (item.value.hasOwnProperty("elm-hot-nav-key")) {
                    // found it!
                    return item;
                }

                if (typeof item.value !== "object") {
                    continue;
                }

                for (var propName in item.value) {
                    if (!item.value.hasOwnProperty(propName)) continue;
                    var newKeypath = item.keypath.slice();
                    newKeypath.push(propName);
                    queue.push({value: item.value[propName], keypath: newKeypath})
                }
            }

            return null;
        }


        function isDebuggerModel(model) {
            // Up until elm/browser 1.0.2, the Elm debugger could be identified by a
            // property named "expando". But in version 1.0.2 that was renamed to "expandoModel"
            return model
                && (model.hasOwnProperty("expando") || model.hasOwnProperty("expandoModel"))
                && model.hasOwnProperty("state");
        }

        function getAt(keyPath, obj) {
            return keyPath.reduce(function (xs, x) {
                return (xs && xs[x]) ? xs[x] : null
            }, obj)
        }

        function removeNavKeyListeners(navKey) {
            window.removeEventListener('popstate', navKey.value);
            window.navigator.userAgent.indexOf('Trident') < 0 || window.removeEventListener('hashchange', navKey.value);
        }

        // hook program creation
        var initialize = _Platform_initialize;
        _Platform_initialize = function (flagDecoder, args, init, update, subscriptions, stepperBuilder) {
            var instance = initializingInstance || swappingInstance;
            var tryFirstRender = !!swappingInstance;

            var hookedInit = function (args) {
                var initialStateTuple = init(args);
                if (swappingInstance) {
                    var oldModel = swappingInstance.lastState;
                    var newModel = initialStateTuple.a;

                    if (typeof elmSymbol("elm$browser$Browser$application") !== 'undefined') {
                        var oldKeyLoc = findNavKey(oldModel);

                        // attempt to find the Browser.Navigation.Key in the newly-constructed model
                        // and bring it along with the rest of the old data.
                        var newKeyLoc = findNavKey(newModel);
                        var error = null;
                        if (newKeyLoc === null) {
                            error = "could not find Browser.Navigation.Key in the new app model";
                        } else if (oldKeyLoc === null) {
                            error = "could not find Browser.Navigation.Key in the old app model.";
                        } else if (newKeyLoc.keypath.toString() !== oldKeyLoc.keypath.toString()) {
                            error = "the location of the Browser.Navigation.Key in the model has changed.";
                        } else {
                            // remove event listeners attached to the old nav key
                            removeNavKeyListeners(oldKeyLoc.value);

                            // insert the new nav key into the old model in the exact same location
                            var parentKeyPath = oldKeyLoc.keypath.slice(0, -1);
                            var lastSegment = oldKeyLoc.keypath.slice(-1)[0];
                            var oldParent = getAt(parentKeyPath, oldModel);
                            oldParent[lastSegment] = newKeyLoc.value;
                        }

                        if (error !== null) {
                            console.error("[elm-hot] Hot-swapping " + instance.path + " not possible: " + error);
                            oldModel = newModel;
                        }
                    }

                    // the heart of the app state hot-swap
                    initialStateTuple.a = oldModel;

                    // ignore any Cmds returned by the init during hot-swap
                    initialStateTuple.b = elmSymbol("elm$core$Platform$Cmd$none");
                } else {
                    // capture the initial state for later
                    initializingInstance.lastState = initialStateTuple.a;
                }

                return initialStateTuple
            };

            var hookedStepperBuilder = function (sendToApp, model) {
                var result;
                // first render may fail if shape of model changed too much
                if (tryFirstRender) {
                    tryFirstRender = false;
                    try {
                        result = stepperBuilder(sendToApp, model)
                    } catch (e) {
                        throw new Error('[elm-hot] Hot-swapping ' + instance.path +
                            ' is not possible, please reload page. Error: ' + e.message)
                    }
                } else {
                    result = stepperBuilder(sendToApp, model)
                }

                return function (nextModel, isSync) {
                    if (instance) {
                        // capture the state after every step so that later we can restore from it during a hot-swap
                        instance.lastState = nextModel
                    }
                    return result(nextModel, isSync)
                }
            };

            return initialize(flagDecoder, args, hookedInit, update, subscriptions, hookedStepperBuilder)
        };

        // hook process creation
        var originalBinding = _Scheduler_binding;
        _Scheduler_binding = function (originalCallback) {
            return originalBinding(function () {
                // start the scheduled process, which may return a cancellation function.
                var cancel = originalCallback.apply(this, arguments);
                if (cancel) {
                    cancellers.push(cancel);
                    return function () {
                        cancellers.splice(cancellers.indexOf(cancel), 1);
                        return cancel();
                    };
                }
                return cancel;
            });
        };

        scope['_elm_hot_loader_init'] = function (Elm) {
            // swap instances
            var removedInstances = [];
            for (var id in instances) {
                var instance = instances[id];
                if (instance.domNode.parentNode) {
                    swap(Elm, instance);
                } else {
                    removedInstances.push(id);
                }
            }

            removedInstances.forEach(function (id) {
                delete instance[id];
            });

            // wrap all public modules
            var publicModules = findPublicModules(Elm);
            publicModules.forEach(function (m) {
                wrapPublicModule(m.path, m.module);
            });
        }
    })();

    scope['_elm_hot_loader_init'](scope['Elm']);
}
//////////////////// HMR END ////////////////////


}(this));